import React, { useEffect, useMemo, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { initializeApp } from "firebase/app";
import { 
  getFirestore, 
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc,
  getDoc,
  setDoc,
  onSnapshot,
  query,
  orderBy,
  where
} from "firebase/firestore";

// ========== FIREBASE CONFIG ==========
const firebaseConfig = {
  apiKey: "AIzaSyDiL_hhEb_WLWI_Jq7IlbfqLhiJ-6oUSZ8",
  authDomain: "nacion-nila-estetica.firebaseapp.com",
  projectId: "nacion-nila-estetica",
  storageBucket: "nacion-nila-estetica.firebasestorage.app",
  messagingSenderId: "239231256226",
  appId: "1:239231256226:web:dbfbcc5d1093f64bdf79fb"
};
// =============================================================

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
// Make Firestore available to components that need it directly
if (typeof window !== "undefined") {
  window.__nilaFirestore = { db, doc, getDoc, setDoc };
}
const RECORDS_COLLECTION = "nila_records";
const USERS_COLLECTION = "nila_users";
const GIFTCARDS_COLLECTION = "nila_giftcards";
const DEPOSITOS_COLLECTION = "nila_depositos";

const BRAND = {
  name: "Experiencia Nila",
  nameEn: "Nila Experience",
  subtitle: "Nación Nila Estética",
  subtitleEn: "Nación Nila Estética",
  address:
    "Centro Comercial Santa María Este, Local #35, Santa Ana, Costa Rica",
  phone: "6064-0414",
  instagram: "@nila_estetic",
  instagramUrl: "https://www.instagram.com/nila_estetic/",
  facebook: "Nación Nila Estética",
  facebookUrl: "https://www.facebook.com/nacionnilaestetica/",
  website: "nacionnila.com",
  websiteUrl: "https://nacionnila.com",
  mission:
    "Brindar tratamientos estéticos personalizados con una experiencia elegante, segura y centrada en el bienestar integral de cada cliente.",
  missionEn:
    "Provide personalized aesthetic treatments with an elegant, safe experience focused on each client's comprehensive well-being.",
};

// USUARIO ADMIN FIJO
const ADMIN_USER = {
  id: "admin1",
  nombreCompleto: "Administrador",
  username: "admin",
  password: "admin",
  role: "owner",
  pin: "0000",
  label: "Owner",
  activo: true,
};

// Helper function to detect client mode from URL
function isClientMode() {
  if (typeof window === 'undefined') return false;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('mode') === 'client';
}

// When a client link targets an existing record: ?mode=client&record=<id>
function getClientRecordId() {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('mode') !== 'client') return null;
  const rid = urlParams.get('record');
  return rid && rid.trim() ? rid.trim() : null;
}

// Translations
const translations = {
  es: {
    // Welcome Screen
    systemTitle: "Sistema de registro",
    startButton: "Iniciar experiencia",
    internalAccess: "Acceso interno",
    address: "Dirección",
    phone: "Teléfono",
    website: "Sitio web",
    
    // Treatment Selection
    selectTreatment: "Selecciona tu tratamiento",
    facial: "Facial",
    body: "Corporal",
    both: "Facial/Corporal",
    lashesBrows: "Pestañas/Cejas",
    
    // Body Categories
    bodyContouring: "Moldeo corporal",
    laserHairRemoval: "Depilación láser",
    waxing: "Depilación con cera",
    massages: "Masajes",
    
    // Form Fields
    fullName: "Nombre completo",
    idNumber: "Cédula",
    dateOfBirth: "Fecha de nacimiento",
    age: "Edad",
    gender: "Género",
    female: "Femenino",
    male: "Masculino",
    profession: "Profesión",
    email: "Correo electrónico",
    phoneNumber: "Teléfono",
    addressLabel: "Dirección",
    
    // Emergency Contact
    emergencyContact: "Contacto de emergencia",
    emergencyName: "Nombre completo",
    emergencyPhone: "Teléfono",
    emergencyEmail: "Correo electrónico",
    emergencyRelation: "Relación",
    
    // Treatment Detail
    facialQuestion: "¿Qué tratamiento facial le interesa? ¿Cuál es su preocupación principal? ¿Qué objetivo busca?",
    bodyQuestion: "¿Qué áreas desea tratar? ¿Cuál es su preocupación principal? ¿Qué objetivo busca?",
    laserQuestion: "¿Qué zonas desea depilar? ¿Cuál es su preocupación?",
    ceraQuestion: "¿Qué zonas desea depilar? ¿Cuál es su preocupación?",
    pestanasQuestion: "¿Qué tipo de pestañas desea? ¿Ha usado extensiones antes? ¿Tiene alguna sensibilidad en los ojos?",
    cejasQuestion: "¿Qué servicio de cejas desea? ¿Cuál es su preocupación? (forma, grosor, alergias a tintes)",
    paquetePCQuestion: "¿Qué paquete le interesa? ¿Cuál es su objetivo?",
    massageQuestion: "¿Qué tipo de masaje desea? ¿Cuál es su molestia o preocupación? ¿Qué objetivo busca?",
    facialPlaceholder: "Ejemplo: Tratamiento para el acné, me preocupan las marcas y quiero mejorar la textura de mi piel.",
    bodyPlaceholder: "Ejemplo: Abdomen, glúteos, celulitis en piernas, quiero reducir medidas y mejorar la apariencia.",
    laserPlaceholder: "Ejemplo: Axilas, piernas completas, bigote, quiero un resultado permanente.",
    ceraPlaceholder: "Ejemplo: Axilas, media pierna, bikini, cejas.",
    pestanasPlaceholder: "Ejemplo: Pestañas híbridas, es mi primera vez, no tengo sensibilidad.",
    cejasPlaceholder: "Ejemplo: Laminado de cejas, las tengo muy delgadas, sin alergias conocidas.",
    paquetePCPlaceholder: "Ejemplo: Pestañas híbridas + laminado de cejas, para un evento.",
    massagePlaceholder: "Ejemplo: Masaje descontracturante para dolor de espalda, busco alivio y relajación.",
    
    // Medical Information
    medicalInfo: "Información médica",
    takingMedication: "¿Está tomando actualmente algún medicamento?",
    whichMedications: "Si sí, ¿cuál(es)?",
    birthControl: "¿Usa anticonceptivos?",
    birthControlType: "Anticonceptivos: ¿Qué tipo?",
    skinType: "Tipo de piel",
    allergies: "Alergias a ingredientes o productos específicos",
    recentProcedures: "Procedimientos estéticos o tratamientos faciales recientes",
    whichProcedures: "¿Cuáles procedimientos?",
    otherConcerns: "Otras preocupaciones médicas",
    authorizeImage: "Autorizo a utilizar mi imagen para fotos y videos",
    yes: "Sí",
    no: "No",
    
    // Medical Conditions
    pregnancy: "Embarazo",
    diabetes: "Diabetes",
    autoimmune: "Enfermedades autoinmunes",
    rosacea: "Rosácea",
    asthma: "Asma",
    hypertension: "Hipertensión",
    enlargedPores: "Poros dilatados",
    epilepsy: "Epilepsia o convulsiones",
    skinAllergies: "Alergias en la piel",
    heartDisease: "Cardiopatía",
    sunDamage: "Daño solar",
    std: "Enfermedades de ETS",
    
    // Consent
    consentTitle: "Consentimiento informado",
    procedure: "Procedimiento",
    procedureText: "El tratamiento consiste en un procedimiento estético personalizado según la necesidad del paciente. Su objetivo es estético y no tiene finalidad médica curativa.",
    importantInfo: "Información importante sobre el tratamiento:",
    punctuality: "• En cada sesión se aplicará una técnica diferente según el protocolo y la necesidad del paciente.",
    attendance: "• El paciente debe presentarse puntualmente a cada cita.",
    cancellation: "• En caso de no poder asistir, debe avisar con al menos 24/12 horas de anticipación.",
    expiration: "• El tratamiento tiene vencimiento y no es transferible a terceras personas.",
    risks: "Riesgos y efectos secundarios:",
    risk1: "• Enrojecimiento temporal, inflamación o dolor localizado.",
    risk2: "• Aparición de hematomas o moretones.",
    risk3: "• Reacciones alérgicas o infecciones en casos excepcionales.",
    recommendations: "Recomendaciones generales:",
    rec1: "• Seguir indicaciones pre y post tratamiento dadas por el profesional.",
    rec2: "• Para tratamientos faciales: no exponerse al sol sin protección, usar bloqueador solar y seguir las recomendaciones indicadas por el centro.",
    declaration: "Declaración del cliente:",
    declarationText: "Declaro que he recibido información clara, suficiente y comprensible sobre el procedimiento estético a realizar, sus beneficios esperados, posibles riesgos, reacciones secundarias, contraindicaciones y cuidados. Comprendo que los resultados pueden variar según mis características individuales y que este procedimiento es de carácter estético y no sustituye diagnósticos ni tratamientos médicos.",
    acceptConsent: "He leído y acepto el consentimiento informado.",
    
    // Signature
    signatureTitle: "Firma del cliente",
    signatureInstruction: "Firme con su dedo o mouse en el recuadro",
    clearSignature: "Borrar firma",
    saveSignature: "Guardar firma",
    signatureSaved: "Firma guardada correctamente",
    date: "Fecha",
    
    // Buttons
    back: "Atrás",
    next: "Siguiente",
    save: "Guardar",
    saving: "Guardando...",
    
    // Validation Errors
    requiredTreatment: "Debes seleccionar al menos una categoría de tratamiento.",
    requiredFacial: "Por favor describa el tratamiento facial que le interesa.",
    requiredBodyCategory: "Debes seleccionar una categoría corporal.",
    requiredBodyAreas: "Por favor indique qué áreas desea tratar.",
    requiredLaserZones: "Por favor indique las zonas que desea depilar.",
    requiredMassageType: "Por favor indique qué tipo de masaje desea.",
    requiredFullName: "Nombre completo es obligatorio.",
    requiredTwoNames: "Debe ingresar nombre y apellido completo (mínimo dos palabras).",
    requiredIdNumber: "Cédula es obligatoria.",
    idNumberOnlyNumbers: "Cédula debe contener solo números.",
    idAlreadyExists: "❌ Esta cédula ya está registrada. Por favor verifique.",
    requiredBirthDate: "Fecha de nacimiento es obligatoria.",
    invalidBirthYear: "El año de nacimiento no es válido. Debe comenzar con 1 o 2 y tener 4 dígitos.",
    invalidAge: "La edad no puede ser mayor a 100 años.",
    requiredGender: "Debes seleccionar si te identificas como femenino o masculino.",
    requiredProfession: "Profesión es obligatoria.",
    requiredEmail: "Correo electrónico es obligatorio.",
    invalidEmail: "El correo electrónico no es válido. Debe incluir @ y un dominio.",
    requiredPhone: "Teléfono es obligatorio.",
    phoneOnlyNumbers: "Teléfono debe contener solo números.",
    requiredAddress: "Dirección es obligatoria.",
    requiredEmergencyName: "Nombre de contacto de emergencia es obligatorio.",
    requiredEmergencyTwoNames: "Debe ingresar nombre y apellido completo del contacto de emergencia.",
    requiredEmergencyPhone: "Teléfono de emergencia es obligatorio.",
    emergencyPhoneOnlyNumbers: "Teléfono de emergencia debe contener solo números.",
    invalidEmergencyEmail: "El correo electrónico de emergencia no es válido.",
    requiredEmergencyRelation: "Relación de emergencia es obligatoria.",
    requiredMedication: "Debe indicar si está tomando actualmente algún medicamento.",
    requiredWhichMedications: "Debes indicar cuáles medicamentos tomas actualmente.",
    requiredBirthControl: "Debes indicar si usas anticonceptivos.",
    requiredBirthControlType: "Debes indicar qué tipo de anticonceptivos usas.",
    requiredWhichProcedures: "Debes indicar cuáles procedimientos estéticos has tenido.",
    requiredAuthorizeImage: "Debes indicar si autorizas o no el uso de tu imagen.",
    requiredAcceptConsent: "Debes aceptar el consentimiento informado para continuar.",
    requiredSignature: "La firma del cliente es obligatoria.",
    
    // Exit Modal
    exitTitle: "¿Salir del registro?",
    exitMessage: "Perderás todo el progreso.",
    continueButton: "Continuar",
    exitButton: "Sí, salir",
    
    // Thank You Screen
    thankYouTitle: "Gracias por completar tu Experiencia Nila",
    thankYouMessage: "Tu información ha sido registrada correctamente.",
    backToHome: "Volver al inicio",
  },
  en: {
    // Welcome Screen
    systemTitle: "Registration System",
    startButton: "Start Experience",
    internalAccess: "Staff Access",
    address: "Address",
    phone: "Phone",
    website: "Website",
    
    // Treatment Selection
    selectTreatment: "Select Your Treatment",
    facial: "Facial",
    body: "Body",
    both: "Facial/Body",
    lashesBrows: "Lashes/Brows",
    
    // Body Categories
    bodyContouring: "Body Contouring",
    laserHairRemoval: "Laser Hair Removal",
    massages: "Massages",
    
    // Form Fields
    fullName: "Full Name",
    idNumber: "ID Number",
    dateOfBirth: "Date of Birth",
    age: "Age",
    gender: "Gender",
    female: "Female",
    male: "Male",
    profession: "Profession",
    email: "Email",
    phoneNumber: "Phone Number",
    addressLabel: "Address",
    
    // Emergency Contact
    emergencyContact: "Emergency Contact",
    emergencyName: "Full Name",
    emergencyPhone: "Phone",
    emergencyEmail: "Email",
    emergencyRelation: "Relationship",
    
    // Treatment Detail
    facialQuestion: "What facial treatment are you interested in? What is your main concern? What goal are you looking to achieve?",
    bodyQuestion: "What areas do you want to treat? What is your main concern? What goal are you looking to achieve?",
    laserQuestion: "What areas do you want to treat with laser? What is your concern?",
    ceraQuestion: "What areas do you want to wax? What is your concern?",
    pestanasQuestion: "What type of lashes do you want? Have you had extensions before? Do you have any eye sensitivity?",
    cejasQuestion: "What brow service do you want? What is your concern? (shape, thickness, dye allergies)",
    paquetePCQuestion: "Which package are you interested in? What is your goal?",
    massageQuestion: "What type of massage do you want? What is your discomfort or concern? What goal are you looking to achieve?",
    facialPlaceholder: "Example: Acne treatment, I'm concerned about marks and want to improve my skin texture.",
    bodyPlaceholder: "Example: Abdomen, glutes, cellulite on legs, I want to reduce measurements and improve appearance.",
    laserPlaceholder: "Example: Underarms, full legs, upper lip, I want permanent results.",
    ceraPlaceholder: "Example: Underarms, half leg, bikini, eyebrows.",
    pestanasPlaceholder: "Example: Hybrid lashes, first time, no sensitivity.",
    cejasPlaceholder: "Example: Brow lamination, very thin brows, no known allergies.",
    paquetePCPlaceholder: "Example: Hybrid lashes + brow lamination, for an event.",
    massagePlaceholder: "Example: Deep tissue massage for back pain, I'm looking for relief and relaxation.",
    
    // Medical Information
    medicalInfo: "Medical Information",
    takingMedication: "Are you currently taking any medication?",
    whichMedications: "If yes, which ones?",
    birthControl: "Do you use birth control?",
    birthControlType: "Birth control: What type?",
    skinType: "Skin Type",
    allergies: "Allergies to specific ingredients or products",
    recentProcedures: "Recent aesthetic procedures or facial treatments",
    whichProcedures: "Which procedures?",
    otherConcerns: "Other medical concerns",
    authorizeImage: "I authorize the use of my image for photos and videos",
    yes: "Yes",
    no: "No",
    
    // Medical Conditions
    pregnancy: "Pregnancy",
    diabetes: "Diabetes",
    autoimmune: "Autoimmune diseases",
    rosacea: "Rosacea",
    asthma: "Asthma",
    hypertension: "Hypertension",
    enlargedPores: "Enlarged pores",
    epilepsy: "Epilepsy or seizures",
    skinAllergies: "Skin allergies",
    heartDisease: "Heart disease",
    sunDamage: "Sun damage",
    std: "STD",
    
    // Consent
    consentTitle: "Informed Consent",
    procedure: "Procedure",
    procedureText: "The treatment consists of a personalized aesthetic procedure according to the patient's needs. Its purpose is aesthetic and not curative medical.",
    importantInfo: "Important information about the treatment:",
    punctuality: "• Each session will apply a different technique according to the protocol and patient needs.",
    attendance: "• The patient must arrive punctually to each appointment.",
    cancellation: "• If unable to attend, must notify at least 24/12 hours in advance.",
    expiration: "• The treatment has an expiration date and is not transferable to third parties.",
    risks: "Risks and side effects:",
    risk1: "• Temporary redness, inflammation or localized pain.",
    risk2: "• Bruising or contusions.",
    risk3: "• Allergic reactions or infections in exceptional cases.",
    recommendations: "General recommendations:",
    rec1: "• Follow pre and post treatment instructions given by the professional.",
    rec2: "• For facial treatments: do not expose yourself to the sun without protection, use sunscreen and follow the center's recommendations.",
    declaration: "Client Declaration:",
    declarationText: "I declare that I have received clear, sufficient and understandable information about the aesthetic procedure to be performed, its expected benefits, possible risks, side effects, contraindications and care. I understand that results may vary according to my individual characteristics and that this procedure is aesthetic in nature and does not replace medical diagnoses or treatments.",
    acceptConsent: "I have read and accept the informed consent.",
    
    // Signature
    signatureTitle: "Client Signature",
    signatureInstruction: "Sign with your finger or mouse in the box",
    clearSignature: "Clear Signature",
    saveSignature: "Save Signature",
    signatureSaved: "Signature saved successfully",
    date: "Date",
    
    // Buttons
    back: "Back",
    next: "Next",
    save: "Save",
    saving: "Saving...",
    
    // Validation Errors
    requiredTreatment: "You must select at least one treatment category.",
    requiredFacial: "Please describe the facial treatment you are interested in.",
    requiredBodyCategory: "You must select a body category.",
    requiredBodyAreas: "Please indicate which areas you want to treat.",
    requiredLaserZones: "Please indicate the areas you want to treat with laser.",
    requiredMassageType: "Please indicate what type of massage you want.",
    requiredFullName: "Full name is required.",
    requiredTwoNames: "You must enter full first and last name (minimum two words).",
    requiredIdNumber: "ID number is required.",
    idNumberOnlyNumbers: "ID number must contain only numbers.",
    idAlreadyExists: "❌ This ID number is already registered. Please verify.",
    requiredBirthDate: "Date of birth is required.",
    invalidBirthYear: "Invalid birth year. Must start with 1 or 2 and have 4 digits.",
    invalidAge: "Age cannot be greater than 100 years.",
    requiredGender: "You must select your gender.",
    requiredProfession: "Profession is required.",
    requiredEmail: "Email is required.",
    invalidEmail: "Invalid email address. Must include @ and a domain.",
    requiredPhone: "Phone number is required.",
    phoneOnlyNumbers: "Phone number must contain only numbers.",
    requiredAddress: "Address is required.",
    requiredEmergencyName: "Emergency contact name is required.",
    requiredEmergencyTwoNames: "You must enter full first and last name for emergency contact.",
    requiredEmergencyPhone: "Emergency phone number is required.",
    emergencyPhoneOnlyNumbers: "Emergency phone number must contain only numbers.",
    invalidEmergencyEmail: "Invalid emergency contact email.",
    requiredEmergencyRelation: "Emergency contact relationship is required.",
    requiredMedication: "You must indicate if you are currently taking any medication.",
    requiredWhichMedications: "You must indicate which medications you are currently taking.",
    requiredBirthControl: "You must indicate if you use birth control.",
    requiredBirthControlType: "You must indicate what type of birth control you use.",
    requiredWhichProcedures: "You must indicate which aesthetic procedures you have had.",
    requiredAuthorizeImage: "You must indicate whether or not you authorize the use of your image.",
    requiredAcceptConsent: "You must accept the informed consent to continue.",
    requiredSignature: "Client signature is required.",
    
    // Exit Modal
    exitTitle: "Exit registration?",
    exitMessage: "You will lose all progress.",
    continueButton: "Continue",
    exitButton: "Yes, exit",
    
    // Thank You Screen
    thankYouTitle: "Thank you for completing your Nila Experience",
    thankYouMessage: "Your information has been successfully registered.",
    backToHome: "Back to Home",
  }
};

function saveLS(key, value) {
  // Do NOT store the large records blob locally — it can blow past
  // iOS Safari's small localStorage quota and crash the whole app.
  // Firestore is the source of truth and syncs across devices anyway.
  if (key === "nila_records") return;
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // Quota exceeded or storage blocked (common on iOS Safari):
    // fail silently instead of crashing the app.
    try {
      // best effort: clear the big cached blob if it exists, then retry once
      localStorage.removeItem("nila_records");
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e2) {
      console.warn("localStorage save skipped (quota/blocked):", key);
    }
  }
}
function loadLS(key, fallback) {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

// eslint-disable-next-line no-unused-vars
function loadUsers() {
  const saved = loadLS("nila_users", null);
  if (saved && saved.length > 0) {
    const hasAdmin = saved.some((u) => u.username === "admin");
    if (!hasAdmin) return [ADMIN_USER, ...saved];
    return saved;
  }
  return [ADMIN_USER];
}

// ========== FIREBASE FUNCTIONS ==========

// Save record to Firestore
async function saveRecordToFirestore(record) {
  try {
    if (record.id && !record.id.startsWith("temp_") && record.id !== "admin1") {
      // GUARD: a client record must always carry its form data. Refusing to write
      // an empty/partial record prevents accidental destruction of client history.
      if (!record.form || !record.form.nombre) {
        console.error("BLOCKED unsafe record write (missing form data):", record.id);
        return record;
      }
      // GUARD: signatures are stripped from the in-memory list for performance.
      // Never let that stripped (empty) value overwrite the real stored signature.
      const toWrite = { ...record };
      if (toWrite.form && toWrite.form._hasFirma && !toWrite.form.firmaCliente) {
        const { firmaCliente, _hasFirma, ...formNoSig } = toWrite.form;
        toWrite.form = formNoSig; // omit the field entirely -> Firestore leaves it untouched
      } else if (toWrite.form && toWrite.form._hasFirma) {
        const { _hasFirma, ...formClean } = toWrite.form;
        toWrite.form = formClean; // don't persist the internal flag
      }
      await updateDoc(doc(db, RECORDS_COLLECTION, record.id), toWrite);
      return record;
    } else {
      const { id, ...recordWithoutId } = record;
      const docRef = await addDoc(collection(db, RECORDS_COLLECTION), recordWithoutId);
      record.id = docRef.id;
      return record;
    }
  } catch (error) {
    console.warn("Firestore save failed, using localStorage", error);
    return record;
  }
}

// Delete record from Firestore
// eslint-disable-next-line no-unused-vars
async function deleteRecordFromFirestore(recordId) {
  try {
    if (recordId && !recordId.startsWith("temp_") && recordId !== "admin1") {
      await deleteDoc(doc(db, RECORDS_COLLECTION, recordId));
    }
  } catch (error) {
    console.warn("Firestore delete failed", error);
  }
}

// Save user to Firestore
async function saveUserToFirestore(user) {
  try {
    const usersQuery = query(collection(db, USERS_COLLECTION), where("username", "==", user.username));
    const querySnapshot = await getDocs(usersQuery);
    
    if (!querySnapshot.empty) {
      const existingDoc = querySnapshot.docs[0];
      await updateDoc(doc(db, USERS_COLLECTION, existingDoc.id), user);
      user.id = existingDoc.id;
    } else {
      const { id, ...userWithoutId } = user;
      const docRef = await addDoc(collection(db, USERS_COLLECTION), userWithoutId);
      user.id = docRef.id;
    }
    return user;
  } catch (error) {
    console.warn("Firestore save failed, using localStorage", error);
    return user;
  }
}

// Delete user from Firestore
// eslint-disable-next-line no-unused-vars
async function deleteUserFromFirestore(userId) {
  try {
    if (userId && userId !== "admin1" && !userId.startsWith("temp_")) {
      await deleteDoc(doc(db, USERS_COLLECTION, userId));
    }
  } catch (error) {
    console.warn("Firestore delete failed", error);
  }
}

// ========== GIFT CARD FUNCTIONS ==========
async function loadGiftCardsFromFirestore() {
  try {
    const snap = await getDocs(collection(db, GIFTCARDS_COLLECTION));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.warn("Failed to load gift cards", error);
    return [];
  }
}

async function saveGiftCardToFirestore(card) {
  try {
    if (card.id && !card.id.startsWith("temp_")) {
      const { id, ...cardWithoutId } = card;
      // GUARD: refuse to overwrite a live card with an object that is missing
      // critical fields — this is how records get silently destroyed.
      if (!cardWithoutId.cardNumber || cardWithoutId.status === undefined) {
        console.error("BLOCKED unsafe gift card write (missing critical fields):", card.id);
        return card;
      }
      await updateDoc(doc(db, GIFTCARDS_COLLECTION, card.id), cardWithoutId);
      return card;
    } else {
      const { id, ...cardWithoutId } = card;
      const docRef = await addDoc(collection(db, GIFTCARDS_COLLECTION), cardWithoutId);
      card.id = docRef.id;
      return card;
    }
  } catch (error) {
    console.warn("Failed to save gift card", error);
    return card;
  }
}

// eslint-disable-next-line no-unused-vars
async function deleteGiftCardFromFirestore(cardId) {
  try {
    if (cardId && !cardId.startsWith("temp_")) {
      await deleteDoc(doc(db, GIFTCARDS_COLLECTION, cardId));
    }
  } catch (error) {
    console.warn("Failed to delete gift card", error);
  }
}

// ========== DEPÓSITO (upfront, pre-registration) FUNCTIONS ==========
async function loadDepositosFromFirestore() {
  try {
    const snap = await getDocs(collection(db, DEPOSITOS_COLLECTION));
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.warn("Failed to load depositos", error);
    return [];
  }
}
async function saveDepositoToFirestore(dep) {
  try {
    if (dep.id && !dep.id.startsWith("temp_")) {
      const { id, ...rest } = dep;
      // GUARD: refuse to overwrite a live deposit with an object missing
      // critical fields. Prevents silent data destruction.
      if (!rest.nombre || rest.montoDeposito === undefined || rest.estado === undefined) {
        console.error("BLOCKED unsafe deposit write (missing critical fields):", dep.id);
        return dep;
      }
      await updateDoc(doc(db, DEPOSITOS_COLLECTION, dep.id), rest);
      return dep;
    } else {
      const { id, ...rest } = dep;
      const docRef = await addDoc(collection(db, DEPOSITOS_COLLECTION), rest);
      dep.id = docRef.id;
      return dep;
    }
  } catch (error) {
    console.warn("Failed to save deposito", error);
    return dep;
  }
}
async function deleteDepositoFromFirestore(depId) {
  try {
    if (depId && !depId.startsWith("temp_")) {
      await deleteDoc(doc(db, DEPOSITOS_COLLECTION, depId));
    }
  } catch (error) {
    console.warn("Failed to delete deposito", error);
  }
}

// Process a gift card redemption: reduce balance, mark completed, append redemption record.
// paymentInfo.giftCard carries { id, amountCovered, clientOwes, ... } from the payment modal.
async function processGiftCardRedemption(paymentInfo, treatmentName) {
  try {
    const gc = paymentInfo && paymentInfo.giftCard;
    if (!gc || !gc.id) return;

    // SAFETY: read the LIVE card from Firestore. Never spread a stale in-memory
    // snapshot back over the real document — that is what previously destroyed
    // deposit records. Update only the fields that actually change.
    const ref = doc(db, GIFTCARDS_COLLECTION, gc.id);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      console.warn("Gift card not found in Firestore, skipping update:", gc.id);
      return;
    }
    const card = snap.data();
    if (card.status === "completada") {
      // Already fully redeemed — do nothing (prevents double redemption).
      return;
    }

    const isTypeA = card.type === "tratamiento";
    const covered = gc.amountCovered || 0;
    // Type A: card is fully consumed regardless of treatment price → balance goes to 0.
    // Type B: subtract what was covered from the remaining balance.
    const newBalance = isTypeA ? 0 : Math.max(0, (card.remainingBalance || 0) - covered);
    const redemption = {
      date: new Date().toISOString().slice(0,10),
      at: new Date().toISOString(),
      amount: isTypeA ? (card.remainingBalance || 0) : covered,
      treatment: treatmentName || "—",
    };
    await updateDoc(ref, {
      remainingBalance: newBalance,
      status: (isTypeA || newBalance === 0) ? "completada" : "activa",
      redemptions: [...(card.redemptions || []), redemption],
    });
  } catch (error) {
    console.warn("Failed to process gift card redemption", error);
  }
}

// Mark an applied upfront deposit as "aplicado" once linked to a client's treatment.
async function processDepositApplication(paymentInfo, clientName) {
  try {
    const da = paymentInfo && paymentInfo.depositoAplicado;
    if (!da || !da.id) return;

    // SAFETY: never write back a stale in-memory snapshot of the deposit.
    // Read the live document first, then update ONLY the three fields that
    // change. This prevents a frozen/incomplete copy from overwriting or
    // corrupting the real record (which previously made deposits disappear).
    const ref = doc(db, DEPOSITOS_COLLECTION, da.id);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      console.warn("Deposit not found in Firestore, skipping update:", da.id);
      return;
    }
    const live = snap.data();
    if (live.estado === "aplicado") {
      // Already applied — do nothing (prevents double-application).
      return;
    }
    await updateDoc(ref, {
      estado: "aplicado",
      appliedToClientName: clientName || live.nombre || "",
      appliedAt: new Date().toISOString(),
    });
  } catch (error) {
    console.warn("Failed to process deposit application", error);
  }
}

// PERFORMANCE: signatures (base64 PNGs) are large. They are stripped from the
// list payload and fetched on demand only when a specific client is opened.
const _signatureCache = {};
async function fetchSignature(recordId) {
  if (!recordId) return "";
  if (_signatureCache[recordId] !== undefined) return _signatureCache[recordId];
  try {
    const snap = await getDoc(doc(db, RECORDS_COLLECTION, recordId));
    const sig = snap.exists() ? (snap.data()?.form?.firmaCliente || "") : "";
    _signatureCache[recordId] = sig;
    return sig;
  } catch (e) {
    console.warn("Failed to fetch signature", e);
    return "";
  }
}

// Displays a client signature, fetching it on demand (keeps app startup fast).
function SignatureBlock({ recordId, hasFirma, inlineSrc, isMobile, labelText }) {
  const [sig, setSig] = useState(inlineSrc || "");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let alive = true;
    if (!inlineSrc && hasFirma && recordId) {
      setLoading(true);
      fetchSignature(recordId).then(s => { if (alive) { setSig(s); setLoading(false); } });
    }
    return () => { alive = false; };
  }, [recordId, hasFirma, inlineSrc]);

  if (!hasFirma && !sig) return null;
  return React.createElement("div",
    { style: { marginTop: "0.5rem", marginBottom: "1rem", width: "100%" } },
    React.createElement("div",
      { style: { backgroundColor: "#F9F9F9", borderRadius: "0.75rem", padding: "0.75rem", border: `1px solid ${colors.gold.light}` } },
      React.createElement("div",
        { style: { fontSize: "0.75rem", color: colors.gold.dark, marginBottom: "0.5rem", fontWeight: "500" } },
        labelText || "Firma del cliente:"),
      loading
        ? React.createElement("div", { style: { fontSize: "0.8rem", color: colors.gray.text, padding: "1rem", textAlign: "center" } }, "Cargando firma...")
        : sig && sig.startsWith("data:image")
          ? React.createElement("img", {
              src: sig,
              alt: "Firma del cliente",
              style: { width: "100%", maxWidth: "100%", height: "auto", maxHeight: isMobile ? "80px" : "100px", objectFit: "contain", border: `1px solid ${colors.gray.medium}`, borderRadius: "0.5rem", backgroundColor: "white" },
            })
          : React.createElement("div", { style: { fontSize: "0.8rem", color: colors.gray.text } }, "No firmado")
    )
  );
}

// Load users from Firestore
async function loadUsersFromFirestore() {
  try {
    const usersSnapshot = await getDocs(collection(db, USERS_COLLECTION));
    if (!usersSnapshot.empty) {
      const users = [];
      usersSnapshot.forEach((doc) => {
        users.push({ id: doc.id, ...doc.data() });
      });
      const hasAdmin = users.some((u) => u.username === "admin");
      if (!hasAdmin) return [ADMIN_USER, ...users];
      return users;
    }
    return [ADMIN_USER];
  } catch (error) {
    console.warn("Firebase not available, using localStorage", error);
    const saved = loadLS("nila_users", null);
    if (saved && saved.length > 0) {
      const hasAdmin = saved.some((u) => u.username === "admin");
      if (!hasAdmin) return [ADMIN_USER, ...saved];
      return saved;
    }
    return [ADMIN_USER];
  }
}

// ========== END FIREBASE FUNCTIONS ==========

const bodyCategories = {
  es: ["Moldeo corporal", "Depilación láser", "Depilación con cera", "Masajes"],
  en: ["Body Contouring", "Laser Hair Removal", "Waxing", "Massages"]
};

const lashBrowCategories = {
  es: ["Pestañas", "Cejas", "Paquete"],
  en: ["Lashes", "Brows", "Package"]
};

const medicalOptions = {
  es: [
    "Embarazo",
    "Diabetes",
    "Enfermedades autoinmunes",
    "Rosácea",
    "Asma",
    "Hipertensión",
    "Poros dilatados",
    "Epilepsia o convulsiones",
    "Alergias en la piel",
    "Cardiopatía",
    "Daño solar",
    "Enfermedades de ETS",
  ],
  en: [
    "Pregnancy",
    "Diabetes",
    "Autoimmune diseases",
    "Rosacea",
    "Asthma",
    "Hypertension",
    "Enlarged pores",
    "Epilepsy or seizures",
    "Skin allergies",
    "Heart disease",
    "Sun damage",
    "STD",
  ]
};

const treatmentProcedureText = {
  es: "El tratamiento consiste en un procedimiento estético personalizado según la necesidad del paciente. Su objetivo es estético y no tiene finalidad médica curativa.",
  en: "The treatment consists of a personalized aesthetic procedure according to the patient's needs. Its purpose is aesthetic and not curative medical."
};

const consentBody = {
  es: `Información importante sobre el tratamiento:

• En cada sesión se aplicará una técnica diferente según el protocolo y la necesidad del paciente.
• El paciente debe presentarse puntualmente a cada cita.
• En caso de no poder asistir, debe avisar con al menos 24/12 horas de anticipación.
• El tratamiento tiene vencimiento y no es transferible a terceras personas.

Riesgos y efectos secundarios:
• Enrojecimiento temporal, inflamación o dolor localizado.
• Aparición de hematomas o moretones.
• Reacciones alérgicas o infecciones en casos excepcionales.

Recomendaciones generales:
• Seguir indicaciones pre y post tratamiento dadas por el profesional.
• Para tratamientos faciales: no exponerse al sol sin protección, usar bloqueador solar y seguir las recomendaciones indicadas por el centro.

Declaración del cliente:
Declaro que he recibido información clara, suficiente y comprensible sobre el procedimiento estético a realizar, sus beneficios esperados, posibles riesgos, reacciones secundarias, contraindicaciones y cuidados. Comprendo que los resultados pueden variar según mis características individuales y que este procedimiento es de carácter estético y no sustituye diagnósticos ni tratamientos médicos.`,
  en: `Important information about the treatment:

• Each session will apply a different technique according to the protocol and patient needs.
• The patient must arrive punctually to each appointment.
• If unable to attend, must notify at least 24/12 hours in advance.
• The treatment has an expiration date and is not transferable to third parties.

Risks and side effects:
• Temporary redness, inflammation or localized pain.
• Bruising or contusions.
• Allergic reactions or infections in exceptional cases.

General recommendations:
• Follow pre and post treatment instructions given by the professional.
• For facial treatments: do not expose yourself to the sun without protection, use sunscreen and follow the center's recommendations.

Client Declaration:
I declare that I have received clear, sufficient and understandable information about the aesthetic procedure to be performed, its expected benefits, possible risks, side effects, contraindications and care. I understand that results may vary according to my individual characteristics and that this procedure is aesthetic in nature and does not replace medical diagnoses or treatments.`
};

const initialForm = {
  treatmentType: "",
  bodyCategory: "",
  moldeoText: "",
  laserText: "",
  ceraText: "",
  massageText: "",
  lashBrowCategory: "",
  pestanasText: "",
  cejasText: "",
  paquetePCText: "",
  facialText: "",
  nombre: "",
  cedula: "",
  fechaNacimiento: "",
  edad: "",
  genero: "",
  direccion: "",
  profesion: "",
  correo: "",
  telefono: "",
  emergenciaNombre: "",
  emergenciaTelefono: "",
  emergenciaCorreo: "",
  emergenciaRelacion: "",
  objetivos: "",
  medical: [],
  medicamentosActuales: "",
  medicamentosCuales: "",
  anticonceptivos: "",
  anticonceptivosCuales: "",
  tipoPiel: "",
  alergiasProductos: "",
  procedimientosRecientes: "",
  procedimientosRecientesCuales: "",
  otrasPreocupaciones: "",
  autorizaImagen: "",
  aceptaConsentimiento: false,
  firmaCliente: "",
  firmaConsentimiento: "",
};

// PALETA DE COLORES LUXURY
const colors = {
  gold: {
    primary: "#C5A028",
    secondary: "#D4AF37",
    dark: "#B8860B",
    light: "#F5E6C4",
    soft: "#FDF8F0",
  },
  dark: {
    primary: "#1A1A1A",
    secondary: "#2C2C2C",
    light: "#3A3A3A",
    card: "#2A2A2A",
  },
  light: {
    primary: "#FEF9F0",
    secondary: "#FFF8F0",
    card: "#FFFFFF",
    background: "#F5F0E8",
  },
  accent: {
    success: "#2C5F4A",
    successLight: "#E8F3EF",
    warning: "#F5A623",
    danger: "#B84C3C",
  },
  gray: {
    warm: "#E8E0D5",
    medium: "#D4C9B8",
    text: "#4A4A4A",
    light: "#F5F0E8",
  },
};

const styles = {
  container: {
    minHeight: "100vh",
    background: `linear-gradient(135deg, ${colors.light.background} 0%, ${colors.gray.warm} 100%)`,
    padding: "2rem",
    position: "relative",
  },
  card: {
    backgroundColor: colors.light.card,
    borderRadius: "1.5rem",
    boxShadow:
      "0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(197, 160, 40, 0.15)",
    border: `1px solid ${colors.gold.light}`,
    padding: "2rem",
  },
  luxuryCard: {
    backgroundColor: colors.light.card,
    borderRadius: "2rem",
    boxShadow:
      "0 30px 60px -15px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(197, 160, 40, 0.2)",
    border: `1px solid ${colors.gold.secondary}`,
    padding: "2rem",
  },
  input: {
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "0.75rem",
    border: `1px solid ${colors.gray.medium}`,
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    outline: "none",
    backgroundColor: colors.light.card,
    transition: "all 0.2s ease",
    ":focus": {
      borderColor: colors.gold.primary,
      boxShadow: `0 0 0 3px ${colors.gold.light}`,
    },
  },
  textarea: {
    width: "100%",
    borderRadius: "0.75rem",
    border: `1px solid ${colors.gray.medium}`,
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    outline: "none",
    fontFamily: "inherit",
    resize: "vertical",
    backgroundColor: colors.light.card,
  },
  button: {
    backgroundColor: colors.gold.primary,
    color: colors.light.primary,
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    transition: "all 0.3s ease",
    boxShadow: "0 2px 8px rgba(197, 160, 40, 0.3)",
    ":hover": {
      backgroundColor: colors.gold.dark,
      transform: "translateY(-1px)",
    },
  },
  buttonSecondary: {
    backgroundColor: colors.dark.primary,
    color: colors.gold.secondary,
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: `1px solid ${colors.gold.secondary}`,
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
  },
  buttonSuccess: {
    backgroundColor: colors.accent.success,
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
  },
  buttonOutline: {
    backgroundColor: "transparent",
    color: colors.dark.primary,
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: `1px solid ${colors.gold.primary}`,
    cursor: "pointer",
    fontSize: "1rem",
  },
  buttonDanger: {
    backgroundColor: colors.accent.danger,
    color: "white",
    padding: "0.5rem 1rem",
    borderRadius: "1.5rem",
    border: "none",
    cursor: "pointer",
    fontSize: "0.75rem",
    fontWeight: "500",
  },
  buttonWarning: {
    backgroundColor: colors.accent.warning,
    color: "white",
    padding: "0.75rem 1.5rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
  },
  errorBox: {
    backgroundColor: colors.accent.successLight,
    border: `1px solid ${colors.accent.danger}`,
    borderRadius: "1rem",
    padding: "1rem",
    marginBottom: "1rem",
    color: colors.accent.danger,
  },
  sectionHeader: {
    fontSize: "1.25rem",
    fontWeight: "500",
    color: colors.gold.dark,
    borderBottom: `2px solid ${colors.gold.secondary}`,
    paddingBottom: "0.5rem",
    marginBottom: "1rem",
    marginTop: "1.5rem",
    letterSpacing: "0.5px",
  },
  infoRow: {
    display: "flex",
    padding: "0.75rem 0",
    borderBottom: `1px solid ${colors.gray.warm}`,
  },
  infoLabel: { width: "180px", fontWeight: "500", color: colors.gold.dark },
  infoValue: { flex: 1, color: colors.dark.primary, fontWeight: "400" },
  badge: {
    display: "inline-block",
    padding: "0.25rem 0.75rem",
    borderRadius: "2rem",
    fontSize: "0.75rem",
    fontWeight: "500",
  },
  badgePending: { backgroundColor: colors.gold.light, color: colors.gold.dark },
  badgeValidated: { backgroundColor: "#E8F0FE", color: "#2C5282" },
  badgeActive: {
    backgroundColor: colors.accent.successLight,
    color: colors.accent.success,
  },
  badgeCompleted: {
    backgroundColor: colors.gray.warm,
    color: colors.gray.text,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: "1rem",
  },
  noteItem: {
    backgroundColor: colors.gray.warm,
    borderRadius: "0.75rem",
    padding: "0.75rem",
    marginBottom: "0.5rem",
    borderLeft: `4px solid ${colors.gold.primary}`,
  },
  selectedTreatmentBadge: {
    backgroundColor: colors.gold.primary,
    color: "white",
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    fontSize: "0.875rem",
    fontWeight: "500",
    display: "inline-block",
    marginBottom: "1rem",
  },
  sessionItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0.75rem 0",
    borderBottom: `1px solid ${colors.gray.warm}`,
    flexWrap: "wrap",
    gap: "0.5rem",
  },
  exitButton: {
    position: "absolute",
    top: "1rem",
    right: "1rem",
    backgroundColor: "white",
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    border: `1px solid ${colors.gold.primary}`,
    cursor: "pointer",
    zIndex: 10,
  },
  tabButton: {
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    border: "none",
    cursor: "pointer",
    fontSize: "0.875rem",
    fontWeight: "500",
    marginRight: "0.5rem",
  },
  chartBar: {
    height: "30px",
    borderRadius: "1rem",
    background: colors.gold.primary,
    marginBottom: "0.5rem",
  },
  reportContainer: {
    marginTop: "1rem",
    padding: "1rem",
    backgroundColor: colors.gray.warm,
    borderRadius: "1rem",
  },
  printPage: {
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: "white",
    padding: "2rem",
    fontFamily: "Georgia, serif",
  },
  printHeader: {
    textAlign: "center",
    marginBottom: "2rem",
    borderBottom: `2px solid ${colors.gold.primary}`,
    paddingBottom: "1rem",
  },
  printTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: colors.gold.dark,
    marginBottom: "0.5rem",
    fontFamily: "Georgia, serif",
  },
  printSubtitle: { fontSize: "0.9rem", color: colors.gray.text },
  printSection: { marginBottom: "1.5rem" },
  printSectionTitle: {
    fontSize: "1.1rem",
    fontWeight: "bold",
    color: colors.gold.dark,
    borderBottom: `1px solid ${colors.gold.primary}`,
    marginBottom: "0.75rem",
    paddingBottom: "0.25rem",
  },
  printRow: {
    display: "flex",
    padding: "0.5rem 0",
    borderBottom: "1px solid #eee",
  },
  printLabel: { width: "180px", fontWeight: "bold", color: colors.gray.text },
  printValue: { flex: 1, color: colors.dark.primary },
  printSignature: {
    marginTop: "2rem",
    paddingTop: "1rem",
    borderTop: `1px solid ${colors.gold.primary}`,
    textAlign: "center",
  },
  printConsent: {
    lineHeight: "1.5",
    fontSize: "0.85rem",
    textAlign: "justify",
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2000,
  },
  modalContainer: {
    backgroundColor: "white",
    borderRadius: "1.5rem",
    padding: "2rem",
    maxWidth: "500px",
    width: "90%",
    boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
    textAlign: "center",
  },
  modalTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: colors.gold.dark,
    marginBottom: "1rem",
  },
  modalButtons: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
    marginTop: "1.5rem",
  },
};

function SectionTitle({ title, subtitle, lang }) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1.25rem" } },
    React.createElement(
      "h2",
      {
        style: {
          fontSize: "1.875rem",
          fontFamily: "Georgia, serif",
          marginBottom: "0.5rem",
          color: colors.gold.dark,
          fontWeight: "500",
          letterSpacing: "-0.5px",
        },
      },
      title
    ),
    subtitle &&
      React.createElement("p", { style: { color: colors.gray.text } }, subtitle)
  );
}

function formatDateCR(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-");
  return `${d}/${m}/${y}`;
}
function formatDateTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return `${d.toLocaleDateString("es-CR")} ${d.toLocaleTimeString("es-CR", {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
}
function formatCurrency(amount) {
  return new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
    minimumFractionDigits: 0,
  }).format(amount);
}
// Same as formatCurrency but with 2 decimal places (for IVA / Ganancia precision in Ingresos)
function formatCurrency2(amount) {
  return new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);
}
function calcAge(dateStr) {
  if (!dateStr) return "";
  const birth = new Date(dateStr);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return String(age);
}
function toggleArray(value, array) {
  return array.includes(value)
    ? array.filter((x) => x !== value)
    : [...array, value];
}
function onlyNumbers(value) {
  return value.replace(/[^0-9]/g, "");
}
function isValidEmail(email) {
  return /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/.test(email);
}
function hasFirstAndLastName(name) {
  return name.trim().split(/\s+/).length >= 2;
}
function isValidBirthDate(date) {
  if (!date) return true;
  const birth = new Date(date);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age <= 100;
}
function isValidBirthYear(dateStr) {
  if (!dateStr) return true;
  const year = parseInt(dateStr.split("-")[0]);
  if (isNaN(year)) return false;
  const currentYear = new Date().getFullYear();
  return (
    year >= 1900 &&
    year <= currentYear &&
    (year.toString()[0] === "1" || year.toString()[0] === "2")
  );
}

// A record counts as a complete/normal client when the five fields that only
// the client can meaningfully provide are all present. If any is missing, the
// record is still a "rápido / pendiente" case that needs client follow-up.
function isClientDataComplete(record) {
  const f = (record && record.form) || {};
  const has = (v) => typeof v === "string" ? v.trim().length > 0 : !!v;
  const hasSignature = has(f.firmaCliente) || f._hasFirma === true;
  return has(f.cedula) && has(f.telefono) && has(f.correo) && has(f.fechaNacimiento) && hasSignature;
}

// True when a record should appear in the follow-up bucket (client hasn't yet
// completed their own required information).
function isPendingClientCompletion(record) {
  return !isClientDataComplete(record);
}

// Builds the completion link a client opens to fill in their own data.
function buildCompletionLink(recordId) {
  const origin = (typeof window !== "undefined" && window.location && window.location.origin)
    ? window.location.origin
    : "https://app.nacionnila.com";
  return `${origin}/?mode=client&record=${recordId}`;
}

function getClientStatus(record) {
  if (record.status !== "validado")
    return { label: "Pendiente", badgeStyle: styles.badgePending, icon: "⏳" };

  // Check if any additional treatment is active
  const hasActiveAdditional = (record.additionalTreatments || []).some(
    (t) => t.status === "activo"
  );

  if (!record.treatmentPlan) {
    if (hasActiveAdditional)
      return { label: "Activo", badgeStyle: styles.badgeActive, icon: "🟢" };
    return { label: "Validado", badgeStyle: styles.badgeValidated, icon: "✅" };
  }

  if (record.treatmentPlan?.status === "finalizado") {
    if (hasActiveAdditional)
      return { label: "Activo", badgeStyle: styles.badgeActive, icon: "🟢" };
    return {
      label: "Finalizado",
      badgeStyle: styles.badgeCompleted,
      icon: "🏁",
    };
  }

  return { label: "Activo", badgeStyle: styles.badgeActive, icon: "🟢" };
}

// eslint-disable-next-line no-unused-vars
function getReportData(records) {
  const meses = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
  ];
  const REPORT_START = new Date(2026, 1, 1);
  const now = new Date();
  const clientesPorMes = [];

  let cursor = new Date(REPORT_START);
  while (
    cursor.getFullYear() < now.getFullYear() ||
    (cursor.getFullYear() === now.getFullYear() &&
      cursor.getMonth() <= now.getMonth())
  ) {
    const year = cursor.getFullYear();
    const month = cursor.getMonth();
    const count = records.filter((r) => {
      const d = new Date(r.createdAt);
      return d.getFullYear() === year && d.getMonth() === month;
    }).length;
    clientesPorMes.push({
      mes: `${meses[month]} ${year}`,
      count,
      year,
      month,
    });
    cursor = new Date(year, month + 1, 1);
  }

  const estados = { Pendiente: 0, Validado: 0, Activo: 0, Finalizado: 0 };
  records.forEach((r) => {
    const s = getClientStatus(r).label;
    estados[s]++;
  });
  const tratamientos = { Facial: 0, Corporal: 0 };
  const corporalDetalle = {
    "Moldeo corporal": 0,
    "Depilación láser": 0,
    Masajes: 0,
  };
  records.forEach((r) => {
    if (r.form.treatmentType === "Facial" || r.form.treatmentType === "Ambos") tratamientos.Facial++;
    if (r.form.treatmentType === "Corporal" || r.form.treatmentType === "Ambos") {
      tratamientos.Corporal++;
      if (
        r.form.bodyCategory &&
        corporalDetalle[r.form.bodyCategory] !== undefined
      )
        corporalDetalle[r.form.bodyCategory]++;
    }
  });
  const sesionesPorEspecialista = {};
  records.forEach((r) => {
    (r.sessions || []).forEach((s) => {
      const nom = s.specialist || "Desconocido";
      sesionesPorEspecialista[nom] = (sesionesPorEspecialista[nom] || 0) + 1;
    });
  });
  return {
    clientesPorMes,
    estados,
    tratamientos,
    corporalDetalle,
    sesionesPorEspecialista,
  };
}

function Field({
  labelText,
  value,
  onChange,
  type = "text",
  inputMode,
  required,
  disabled,
  placeholder,
  lang,
}) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement("input", {
      style: styles.input,
      value: value,
      onChange: (e) => onChange(e.target.value),
      type,
      inputMode,
      disabled,
      placeholder,
    })
  );
}

function TextAreaField({
  labelText,
  value,
  onChange,
  required,
  placeholder,
  rows = 3,
  lang,
}) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement("textarea", {
      style: styles.textarea,
      value: value,
      onChange: (e) => onChange(e.target.value),
      placeholder,
      rows,
    })
  );
}

function DateField({ labelText, value, onChange, required, lang }) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement("input", {
      type: "date",
      style: styles.input,
      value,
      onChange: (e) => onChange(e.target.value),
    })
  );
}

function SelectField({ labelText, value, onChange, options, required, lang }) {
  return React.createElement(
    "div",
    { style: { marginBottom: "1rem" } },
    React.createElement(
      "label",
      {
        style: {
          display: "block",
          marginBottom: "0.5rem",
          fontWeight: "500",
          color: colors.gold.dark,
        },
      },
      labelText,
      required &&
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
    ),
    React.createElement(
      "select",
      { style: styles.input, value, onChange: (e) => onChange(e.target.value) },
      options.map((opt) =>
        React.createElement(
          "option",
          { key: opt, value: opt },
          opt || (lang === "en" ? "Select" : "Seleccionar")
        )
      )
    )
  );
}

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 640);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
}

function WelcomeScreen({ onStart, onLoginClick, hideStaffAccess = false }) {
  const isMobile = useIsMobile();
  const [lang, setLang] = useState(() => loadLS("nila_lang", "es"));
  const t = translations[lang];

  useEffect(() => {
    saveLS("nila_lang", lang);
  }, [lang]);

  const handleStart = () => {
    onStart(lang);
  };

  const handleLoginClick = () => {
    onLoginClick(lang);
  };

  return React.createElement(
    "div",
    { style: styles.container },
    React.createElement(
      "div",
      {
        className: "nila-welcome-grid",
        style: {
          maxWidth: "72rem",
          margin: "0 auto",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "2rem" : "4rem",
          alignItems: "center",
          minHeight: "88vh",
        },
      },
      React.createElement(
        "div",
        { style: { flex: 1, width: "100%" } },
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1rem",
            },
          },
          React.createElement(
            "div",
            {
              style: {
                display: "inline-flex",
                gap: "0.5rem",
                borderRadius: "2rem",
                border: `1px solid ${colors.gold.secondary}`,
                backgroundColor: "rgba(255,255,255,0.9)",
                padding: "0.5rem 1rem",
                fontSize: "0.875rem",
                color: colors.gold.dark,
              },
            },
            t.systemTitle
          ),
          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "0.5rem",
                backgroundColor: "rgba(255,255,255,0.9)",
                borderRadius: "2rem",
                padding: "0.25rem",
                border: `1px solid ${colors.gold.light}`,
              },
            },
            React.createElement(
              "button",
              {
                onClick: () => setLang("es"),
                style: {
                  padding: "0.25rem 0.75rem",
                  borderRadius: "2rem",
                  border: "none",
                  backgroundColor: lang === "es" ? colors.gold.primary : "transparent",
                  color: lang === "es" ? "white" : colors.gold.dark,
                  cursor: "pointer",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                },
              },
              "ES"
            ),
            React.createElement(
              "button",
              {
                onClick: () => setLang("en"),
                style: {
                  padding: "0.25rem 0.75rem",
                  borderRadius: "2rem",
                  border: "none",
                  backgroundColor: lang === "en" ? colors.gold.primary : "transparent",
                  color: lang === "en" ? "white" : colors.gold.dark,
                  cursor: "pointer",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                },
              },
              "EN"
            )
          )
        ),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              marginTop: "1.5rem",
            },
          },
          React.createElement(
            "img",
            {
              src: "./logo.png",
              alt: "Nación Nila Estética",
              style: {
                width: "48px",
                height: "48px",
                borderRadius: "50%",
                objectFit: "cover",
                border: `1px solid ${colors.gold.secondary}`,
              },
            }
          ),
          React.createElement(
            "h1",
            {
              style: {
                fontSize: isMobile ? "2rem" : "4rem",
                fontFamily: "Georgia, serif",
                color: colors.dark.primary,
                fontWeight: "500",
                letterSpacing: "-0.02em",
                margin: 0,
              },
            },
            lang === "en" ? BRAND.nameEn : BRAND.name
          )
        ),
        React.createElement(
          "p",
          {
            style: {
              fontSize: "1.25rem",
              color: colors.gray.text,
              marginTop: "0.5rem",
            },
          },
          BRAND.subtitle
        ),
        React.createElement(
          "p",
          {
            style: {
              color: colors.gray.text,
              maxWidth: "32rem",
              marginTop: "1rem",
              lineHeight: "1.6",
            },
          },
          lang === "en" ? BRAND.missionEn : BRAND.mission
        ),
        React.createElement(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
              gap: "1rem",
              marginTop: "2rem",
            },
          },
          React.createElement(
            "div",
            {
              style: {
                backgroundColor: "rgba(255,255,255,0.8)",
                padding: "1rem",
                borderRadius: "1rem",
                border: `1px solid ${colors.gold.light}`,
              },
            },
            React.createElement(
              "div",
              { style: { fontSize: "0.875rem", color: colors.gold.dark } },
              t.address
            ),
            React.createElement(
              "div",
              { style: { color: colors.dark.primary } },
              BRAND.address
            )
          ),
          React.createElement(
            "div",
            {
              style: {
                backgroundColor: "rgba(255,255,255,0.8)",
                padding: "1rem",
                borderRadius: "1rem",
                border: `1px solid ${colors.gold.light}`,
              },
            },
            React.createElement(
              "div",
              { style: { fontSize: "0.875rem", color: colors.gold.dark } },
              t.phone
            ),
            React.createElement(
              "div",
              { style: { color: colors.dark.primary } },
              BRAND.phone
            )
          ),
          React.createElement(
            "a",
            {
              href: BRAND.instagramUrl,
              target: "_blank",
              style: { textDecoration: "none" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "rgba(255,255,255,0.8)",
                  padding: "1rem",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  border: `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                { style: { fontSize: "0.875rem", color: colors.gold.dark } },
                "Instagram"
              ),
              React.createElement(
                "div",
                { style: { color: colors.gold.primary } },
                BRAND.instagram
              )
            )
          ),
          React.createElement(
            "a",
            {
              href: BRAND.facebookUrl,
              target: "_blank",
              style: { textDecoration: "none" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "rgba(255,255,255,0.8)",
                  padding: "1rem",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  border: `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                { style: { fontSize: "0.875rem", color: colors.gold.dark } },
                "Facebook"
              ),
              React.createElement(
                "div",
                { style: { color: colors.gold.primary } },
                BRAND.facebook
              )
            )
          ),
          React.createElement(
            "a",
            {
              href: BRAND.websiteUrl,
              target: "_blank",
              style: { textDecoration: "none" },
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "rgba(255,255,255,0.8)",
                  padding: "1rem",
                  borderRadius: "1rem",
                  cursor: "pointer",
                  border: `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                { style: { fontSize: "0.875rem", color: colors.gold.dark } },
                t.website
              ),
              React.createElement(
                "div",
                { style: { color: colors.gold.primary } },
                BRAND.website
              )
            )
          )
        ),
        React.createElement(
          "div",
          { style: { display: "flex", gap: "1rem", marginTop: "2rem", flexDirection: isMobile ? "column" : "row" } },
          React.createElement(
            "button",
            { onClick: handleStart, style: { ...styles.button, width: isMobile ? "100%" : "auto" } },
            t.startButton
          ),
          !hideStaffAccess && React.createElement(
            "button",
            { onClick: handleLoginClick, style: { ...styles.buttonSecondary, width: isMobile ? "100%" : "auto" } },
            t.internalAccess
          )
        )
      )
    )
  );
}

function LoginPanel({ onLogin, onBack }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadUsersFromFirestore().then(setUsers).finally(() => setLoading(false));
  }, []);

  const handleLogin = () => {
    const user = users.find(
      (u) =>
        u.username === username && u.password === password && u.activo !== false
    );
    if (user) {
      onLogin(user);
    } else {
      setError("Credenciales inválidas");
    }
  };

  if (loading) {
    return React.createElement("div", { style: styles.container }, 
      React.createElement("div", { style: { textAlign: "center", padding: "2rem" } }, "Cargando...")
    );
  }

  return React.createElement(
    "div",
    { style: styles.container },
    React.createElement(
      "div",
      { style: { maxWidth: "28rem", margin: "0 auto", ...styles.card } },
      React.createElement(
        "h2",
        {
          style: {
            fontSize: "1.5rem",
            marginBottom: "1rem",
            color: colors.gold.dark,
            fontFamily: "Georgia, serif",
          },
        },
        "Acceso interno"
      ),
      React.createElement(Field, {
        labelText: "Usuario",
        value: username,
        onChange: setUsername,
      }),
      React.createElement(Field, {
        labelText: "Contraseña",
        value: password,
        onChange: setPassword,
        type: "password",
      }),
      error &&
        React.createElement(
          "div",
          { style: { color: colors.accent.danger, marginBottom: "1rem" } },
          error
        ),
      React.createElement(
        "button",
        {
          onClick: handleLogin,
          style: { ...styles.button, width: "100%", marginBottom: "0.5rem" },
        },
        "Ingresar"
      ),
      React.createElement(
        "button",
        {
          onClick: onBack,
          style: { ...styles.buttonSecondary, width: "100%" },
        },
        "Volver"
      )
    )
  );
}

function ReportsPanel({ records }) {
  const [activeReport, setActiveReport] = useState("revenue");
  const [period, setPeriod] = useState("monthly");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  const [expandedClient, setExpandedClient] = useState(null);
  const [expandedTreatment, setExpandedTreatment] = useState({});
  const [revenueSearch, setRevenueSearch] = useState("");
  const [revenueMethodFilter, setRevenueMethodFilter] = useState("todos");
  const [outClientSearch, setOutClientSearch] = useState("");
  const [outPaymentTypeFilter, setOutPaymentTypeFilter] = useState("todos");
  const [outStatusFilter, setOutStatusFilter] = useState("todos");
  const [outTreatmentSearch, setOutTreatmentSearch] = useState("");
  const [outMonthFilter, setOutMonthFilter] = useState("todos");
  const [sessClientSearch, setSessClientSearch] = useState("");
  const [sessTreatmentSearch, setSessTreatmentSearch] = useState("");
  // Reporte Financiero states
  const [finMonth, setFinMonth] = useState(() => {
    const t = new Date();
    return `${t.getFullYear()}-${String(t.getMonth()+1).padStart(2,"0")}`;
  });
  const [gastosData, setGastosData] = useState(null);
  const [giftCards, setGiftCards] = useState([]);
  useEffect(() => {
    loadGiftCardsFromFirestore().then(setGiftCards).catch(() => {});
  }, []);
  const [depositos, setDepositos] = useState([]);
  useEffect(() => {
    loadDepositosFromFirestore().then(setDepositos).catch(() => {});
  }, []);
  // Facturado checkmarks for Ingresos report (persisted in Firestore doc nila_meta/facturado_checks)
  const [checkedTxs, setCheckedTxs] = useState({});
  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, "nila_meta", "facturado_checks"));
        if (snap.exists()) setCheckedTxs(snap.data().checks || {});
      } catch (e) { console.error(e); }
    })();
  }, []);
  const txKey = (tx) => `${tx.recordId || "x"}_${tx.date || ""}_${tx.treatmentNum || ""}_${tx.type || ""}_${Math.round(tx.montoCliente || tx.amount || 0)}`;
  const toggleChecked = async (key) => {
    setCheckedTxs(prev => {
      const next = { ...prev };
      if (next[key]) delete next[key]; else next[key] = true;
      // persist
      setDoc(doc(db, "nila_meta", "facturado_checks"), { checks: next, updatedAt: new Date().toISOString() }).catch(e => console.error(e));
      return next;
    });
  };
  const [finIngClientSearch, setFinIngClientSearch] = useState("");
  const [activeClientSearch, setActiveClientSearch] = useState("");
  const [activeTreatmentSearch, setActiveTreatmentSearch] = useState("");
  const [finIngMethodFilter, setFinIngMethodFilter] = useState("todos");
  const [finIngTipoFilter, setFinIngTipoFilter] = useState("todos");
  const [finGastoCatFilter, setFinGastoCatFilter] = useState("Todas");
  const [finGastoEstadoFilter, setFinGastoEstadoFilter] = useState("todos");
  useEffect(() => {
    const load = async () => {
      try {
        const { doc, getDoc, db } = window.__nilaFirestore || {};
        if (!db) return;
        const snap = await getDoc(doc(db, "nila_gastos", finMonth));
        if (snap.exists()) setGastosData(snap.data().expenses);
        else setGastosData(null);
      } catch(e) { console.error(e); }
    };
    load();
  }, [finMonth]);

  const MESES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];

  // ── Helpers ──
  const getAllPayments = (records) => {
    const payments = [];
    records.forEach(r => {
      const clientName = r.form?.nombre || "—";
      const sortedAt = [...(r.additionalTreatments || [])].sort((a,b) => new Date(a.addedAt||0) - new Date(b.addedAt||0));

      const processPlan = (plan, treatmentNum, treatmentName) => {
        if (!plan) return;
        const pi = plan.paymentInfo || {};
        // IVA recalculated on-the-fly from total price (IVA included = total / 1.13).
        // This corrects records saved before the IVA formula fix.
        const planTotal = plan.totalPrice || 1;
        const planIVA = plan.totalPrice ? (plan.totalPrice - (plan.totalPrice / 1.13)) : 0;

        const totalSessions = plan.totalSessions || null;
        const completedSessions = plan.completedSessions || 0;
        const enrichPayment = (p, rawAmount) => {
          const isYuplon = (p.method || "").toLowerCase() === "yuplon";
          if (isYuplon) {
            // Recalculate on-the-fly to handle records saved before new formula
            const yOffer = p.yuplonOfferPrice || rawAmount;
            const yComision = p.yuplonComision || Math.round(yOffer * 0.20);
            const yIvaComision = p.yuplonIVAComision || Math.round(yComision * 0.13);
            const yComercio = p.yuplonComercio || (yOffer - yComision - yIvaComision);
            const yIvaNila = p.yuplonIVANila || Math.round(yComercio * 0.13);
            const yRetBACRenta = p.yuplonRetBACRenta || Math.round(yOffer * 0.0176);
            const yRetBACIVA = p.yuplonRetBACIVA || Math.round(yOffer * 0.0531);
            const yGanancia = yComercio - yIvaNila - yRetBACRenta - yRetBACIVA;
            return {
              clientName, treatmentNum, treatmentName,
              date: p.date, method: p.method || "—",
              type: p.type === "session" ? `Sesión #${p.reference}` : p.type === "upfront" ? "Pago completo" : p.type === "balance" ? "Saldo" : p.type === "Depósito" ? "Depósito" : "Pago",
              status: "pagado", recordId: r.id,
              montoCliente: yOffer,
              iva: yIvaNila,
              comision: yComision + yIvaComision, // total Yuplon commission cost
              retBACRenta: yRetBACRenta,
              retBACIVA: yRetBACIVA,
              amount: yGanancia,
              isYuplon: true,
            };
          }
          const proportion = planTotal > 0 ? rawAmount / planTotal : 0;
          const ivaForPayment = planIVA * proportion;
          // Ganancia = Monto cliente - IVA - Comisión - BAC Renta - BAC IVA Renta
          const ganancia = rawAmount - ivaForPayment;
          return {
            clientName, treatmentNum, treatmentName,
            date: p.date, method: p.method || "—",
            type: p.type === "session" ? `Sesión #${p.reference}` : p.type === "upfront" ? "Pago completo" : p.type === "balance" ? "Saldo" : p.type === "Depósito" ? "Depósito" : "Pago",
            status: "pagado", recordId: r.id,
            totalSessions,
            completedSessions,
            montoCliente: rawAmount,
            iva: ivaForPayment,
            comision: 0,
            retBACRenta: 0,
            retBACIVA: 0,
            amount: ganancia, // Ganancia = Monto - IVA - Comisión - Retenciones
          };
        };

        (pi.deposits || []).forEach(d => payments.push(enrichPayment({ ...d, type: "Depósito" }, d.amount)));
        (pi.payments || []).forEach(p => { if (!p.depositoApplied) payments.push(enrichPayment(p, p.amount)); });
        (pi.paymentSchedule || []).filter(i => i.status === "pagado" || i.status === "parcial").forEach(i => payments.push(enrichPayment({ ...i, method: i.paymentMethod, type: `Cuota #${i.number}` }, i.paidAmount || i.amount)));

        // Include ₡0 treatments so the session appears in the report
        const hasAnyPayment = (pi.deposits || []).length > 0 || (pi.payments || []).length > 0 || (pi.paymentSchedule || []).some(i => i.status === "pagado" || i.status === "parcial");
        if (!hasAnyPayment && (plan.totalPrice === 0 || plan.totalPrice == null)) {
          payments.push({
            clientName, treatmentNum, treatmentName,
            date: plan.startDate || r.createdAt?.slice(0,10) || new Date().toISOString().slice(0,10),
            method: "Sin costo",
            type: "Valoración / Sin costo",
            status: "pagado",
            recordId: r.id,
            montoCliente: 0, iva: 0, comision: 0, retBACRenta: 0, retBACIVA: 0, amount: 0,
            totalSessions, completedSessions,
          });
        }

        // Add a row for EVERY completed session using the actual session date
        // Skip if a payment already exists for the same client/treatment/date (same day payment + session = 1 row)
        const sessions = plan.sessions || r.sessions || [];
        sessions.forEach(s => {
          if (!s.date) return;
          // Skip if session-specific payment exists for this session number
          const alreadyHasSessionPayment = (pi.payments || []).some(p => p.type === "session" && p.reference === s.number);
          if (alreadyHasSessionPayment) return;
          // Skip if ANY payment OR a ₡0 valoración record already exists for the same date
          const paymentOnSameDay = [
            ...(pi.deposits || []),
            ...(pi.payments || []),
          ].some(p => p.date === s.date);
          if (paymentOnSameDay) return;
          // Also skip if a zero-cost record was already pushed for this same date
          const zeroCostOnSameDay = payments.some(p =>
            p.recordId === r.id && p.treatmentNum === treatmentNum && p.date === s.date && p.montoCliente === 0
          );
          if (zeroCostOnSameDay) return;
          payments.push({
            clientName, treatmentNum, treatmentName,
            date: s.date,
            method: "Incluido en paquete",
            type: `Sesión #${s.number}`,
            status: "pagado",
            recordId: r.id,
            montoCliente: 0, iva: 0, comision: 0, retBACRenta: 0, retBACIVA: 0, amount: 0,
            totalSessions, completedSessions,
            sessionNumber: s.number,
            isSessionRecord: true,
          });
        });
      };

      processPlan(r.treatmentPlan, "T1", r.treatmentPlan?.name || r.form?.treatmentType || "Principal");
      sortedAt.forEach((at, i) => processPlan(at, `T${i+2}`, at.treatmentName || at.treatmentType || `Adicional ${i+2}`));
    });
    return payments;
  };

  const getAllSessions = (records) => {
    const sessions = [];
    records.forEach(r => {
      const clientName = r.form?.nombre || "—";
      // Find payment for a session from paymentInfo
      const findSessionPayment = (pi, sessionNum) => {
        return (pi?.payments || []).find(p => p.type === "session" && p.reference === sessionNum) || null;
      };
      const pi1 = r.treatmentPlan?.paymentInfo || {};
      (r.sessions || []).forEach(s => {
        const pmt = s.payment || findSessionPayment(pi1, s.number);
        sessions.push({ clientName, treatmentName: r.treatmentPlan?.name || "Principal", treatmentNum: "T1", sessionNumber: s.number || "—", date: s.date, specialist: s.specialist || "—", recordId: r.id, cobroAmount: pmt?.amount || null, cobroMethod: pmt?.method || null, paymentPending: s.paymentPending || false });
      });
      const sortedAt = [...(r.additionalTreatments || [])].sort((a,b) => new Date(a.addedAt||0) - new Date(b.addedAt||0));
      sortedAt.forEach((at, i) => {
        const atPi = at.paymentInfo || {};
        (at.sessions || []).forEach(s => {
          const pmt = s.payment || findSessionPayment(atPi, s.number);
          sessions.push({ clientName, treatmentName: at.treatmentName || `Adicional ${i+2}`, treatmentNum: `T${i+2}`, sessionNumber: s.number || "—", date: s.date, specialist: s.specialist || "—", recordId: r.id, cobroAmount: pmt?.amount || null, cobroMethod: pmt?.method || null, paymentPending: s.paymentPending || false });
        });
      });
    });
    return sessions;
  };

  const filterByDate = (items, dateField) => items.filter(item => {
    const d = item[dateField];
    if (!d) return false;
    if (dateFrom && d < dateFrom) return false;
    if (dateTo && d > dateTo) return false;
    return true;
  });

  const groupByPeriod = (items, dateField) => {
    const groups = {};
    items.forEach(item => {
      const raw = item[dateField];
      if (!raw) return;
      // Parse date parts directly to avoid timezone shifting
      const parts = raw.slice(0, 10).split("-");
      const year = parseInt(parts[0]);
      const month = parseInt(parts[1]) - 1; // 0-indexed
      const day = parseInt(parts[2]);
      if (isNaN(year) || isNaN(month) || isNaN(day)) return;
      let key;
      if (period === "daily") key = raw.slice(0, 10);
      else if (period === "weekly") {
        const d = new Date(year, month, day);
        const start = new Date(d); start.setDate(d.getDate() - d.getDay());
        key = start.toISOString().slice(0,10);
      } else key = `${MESES[month]} ${year}`;
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    return Object.entries(groups).sort((a, b) => {
      const dateA = a[1][0]?.[dateField] || "";
      const dateB = b[1][0]?.[dateField] || "";
      return dateB.localeCompare(dateA);
    });
  };

  const giftCardSales = (giftCards || []).map(c => ({
    clientName: `🎁 ${c.recipientName} (compró: ${c.buyerName})`,
    treatmentNum: "—",
    treatmentName: c.type === "tratamiento" ? `Tarjeta regalo: ${c.treatmentName}` : "Tarjeta de regalo (monto)",
    date: c.saleDate,
    method: c.payMethod || "—",
    type: "Tarjeta de Regalo",
    status: "pagado",
    recordId: c.id,
    totalSessions: null,
    completedSessions: 0,
    montoCliente: c.originalAmount || 0,
    iva: c.iva || 0,
    comision: 0,
    retBACRenta: 0,
    retBACIVA: 0,
    amount: c.base || 0, // Ganancia = base (sin IVA)
    isGiftCard: true,
  }));
  const depositoRevenue = (depositos || []).map(d => ({
    clientName: `💵 ${d.nombre} (depósito)`,
    treatmentNum: "—",
    treatmentName: `Depósito: ${d.tratamiento}`,
    date: d.fecha,
    method: d.payMethod || "—",
    type: "Depósito adelantado",
    status: "pagado",
    recordId: "dep_" + d.id,
    totalSessions: null,
    completedSessions: 0,
    montoCliente: d.montoDeposito || 0,
    iva: d.iva || 0,
    comision: 0,
    retBACRenta: 0,
    retBACIVA: 0,
    amount: d.base || 0,
    isDeposito: true,
  }));
  const allPayments = [...getAllPayments(records), ...giftCardSales, ...depositoRevenue];
  const allSessions = getAllSessions(records);

  // ── Styles ──
  const tabBtn = (active) => ({
    padding: "0.45rem 0.9rem", borderRadius: "2rem", border: "none", cursor: "pointer",
    fontSize: "0.8rem", fontWeight: active ? "700" : "400",
    backgroundColor: active ? colors.gold.primary : colors.gray.warm,
    color: active ? "white" : colors.gray.text, whiteSpace: "nowrap",
  });
  const card = { backgroundColor: "white", borderRadius: "0.75rem", padding: "1rem", marginBottom: "0.75rem", border: `1px solid ${colors.gold.light}` };
  const thS = { padding: "0.5rem 0.75rem", color: colors.gold.dark, fontWeight: "600", borderBottom: `2px solid ${colors.gold.primary}`, fontSize: "0.78rem", textAlign: "left" };
  const tdS = { padding: "0.45rem 0.75rem", borderBottom: `1px solid ${colors.gray.warm}`, fontSize: "0.8rem" };
  const statBox = (bg, color) => ({ backgroundColor: bg, borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" });

  const reports = [
    { id: "revenue", label: "💰 Ingresos" },
    { id: "outstanding", label: "🔴 Saldos pendientes" },
    { id: "paymentplans", label: "📆 Planes de pago" },
    { id: "bytreatment", label: "💆 Ingresos por tratamiento" },
    { id: "newclients", label: "👥 Clientes nuevos" },
    { id: "clienthistory", label: "📋 Historial por cliente" },
    { id: "sessions", label: "📅 Sesiones realizadas" },
    { id: "popular", label: "🏆 Tratamientos populares" },
    { id: "avgvalue", label: "📊 Valor promedio" },
    { id: "financiero", label: "📈 Reporte Financiero del Mes" },
    { id: "activeclients", label: "🟢 Clientes Activos" },
    { id: "pendientescompletar", label: "⚡ Registros pendientes" },
  ];

  return React.createElement("div", null,
    React.createElement("h2", { style: { fontSize: "1.4rem", fontFamily: "Georgia, serif", color: colors.gold.dark, marginBottom: "1rem" } }, "📊 Reportes — Nación Nila"),

    // Report selector tabs
    React.createElement("div", { style: { display: "flex", gap: "0.4rem", flexWrap: "wrap", marginBottom: "1.25rem" } },
      reports.map(r => React.createElement("button", { key: r.id, style: tabBtn(activeReport === r.id), onClick: () => setActiveReport(r.id) }, r.label))
    ),

    // Date filter (shared)
    activeReport !== "clienthistory" && activeReport !== "popular" && activeReport !== "avgvalue" && React.createElement("div", { style: { display: "flex", gap: "0.75rem", flexWrap: "wrap", alignItems: "center", marginBottom: "1rem", backgroundColor: colors.gray.warm, padding: "0.75rem", borderRadius: "0.75rem" } },
      React.createElement("span", { style: { fontSize: "0.82rem", color: colors.gray.text, fontWeight: "600" } }, "📅 Período:"),
      React.createElement("input", { type: "date", value: dateFrom, onChange: e => setDateFrom(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.82rem" } }),
      React.createElement("span", { style: { color: colors.gray.text } }, "→"),
      React.createElement("input", { type: "date", value: dateTo, onChange: e => setDateTo(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.82rem" } }),
      (dateFrom || dateTo) && React.createElement("button", { onClick: () => { setDateFrom(""); setDateTo(""); }, style: { ...styles.buttonOutline, padding: "0.3rem 0.6rem", fontSize: "0.78rem" } }, "✕ Limpiar"),
      (activeReport === "revenue" || activeReport === "sessions") && React.createElement("select", { value: period, onChange: e => setPeriod(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.82rem" } },
        React.createElement("option", { value: "daily" }, "Por día"),
        React.createElement("option", { value: "weekly" }, "Por semana"),
        React.createElement("option", { value: "monthly" }, "Por mes"),
      )
    ),

    // ══════════════ 1. REVENUE ══════════════
    activeReport === "revenue" && (() => {
      // Apply client/treatment search filter
      const revenueClientSearch = revenueSearch.toLowerCase().trim();
      const filtered = filterByDate(allPayments, "date").filter(tx => {
        if (revenueMethodFilter !== "todos" && tx.method !== revenueMethodFilter) return false;
        if (!revenueClientSearch) return true;
        return tx.clientName.toLowerCase().includes(revenueClientSearch) ||
               tx.treatmentName.toLowerCase().includes(revenueClientSearch) ||
               tx.treatmentNum.toLowerCase().includes(revenueClientSearch);
      });
      const totalCliente = filtered.reduce((s, p) => s + (p.montoCliente || p.amount), 0);
      const totalGanancia = filtered.reduce((s, p) => s + p.amount, 0);
      const byMethod = {};
      filtered.forEach(p => { byMethod[p.method] = (byMethod[p.method] || 0) + p.amount; });
      const grouped = groupByPeriod(filtered, "date");
      return React.createElement("div", null,
        // Summary cards
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "0.75rem", marginBottom: "1rem" } },
          React.createElement("div", { style: statBox("#EFF6FF") },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: "#1D4ED8" } }, formatCurrency(totalCliente)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Monto cobrado al cliente")
          ),
          React.createElement("div", { style: statBox(colors.gold.light) },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.gold.dark } }, filtered.length),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Transacciones")
          ),
          React.createElement("div", { style: statBox(colors.accent.successLight) },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.accent.success } }, formatCurrency(totalGanancia)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Ganancia de NILA")
          ),
          React.createElement("div", { style: statBox("#FEF2F2") },
            React.createElement("div", { style: { fontSize: "0.85rem", fontWeight: "700", color: "#DC2626" } }, Object.entries(byMethod).sort((a,b)=>b[1]-a[1]).slice(0,2).map(([m,v]) => `${m}: ${formatCurrency(v)}`).join(" · ") || "—"),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Top métodos de pago")
          )
        ),
        // By method breakdown
        React.createElement("div", { style: { ...card, marginBottom: "1rem" } },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "0.5rem" } }, "Por método de pago"),
          React.createElement("div", { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap" } },
            Object.entries(byMethod).sort((a,b)=>b[1]-a[1]).map(([m, v]) =>
              React.createElement("div", { key: m, style: { backgroundColor: colors.gold.light, borderRadius: "0.5rem", padding: "0.4rem 0.8rem", fontSize: "0.82rem" } },
                React.createElement("span", { style: { fontWeight: "600", color: colors.gold.dark } }, m), ": ",
                React.createElement("span", { style: { fontWeight: "700" } }, formatCurrency(v))
              )
            )
          )
        ),
        // Search bar + method filter
        React.createElement("div", { style: { marginBottom: "1rem", display: "flex", gap: "0.5rem", alignItems: "center", flexWrap: "wrap" } },
          React.createElement("input", {
            type: "text",
            placeholder: "🔍 Buscar por cliente, tratamiento o T1/T2...",
            value: revenueSearch,
            onChange: e => setRevenueSearch(e.target.value),
            style: { ...styles.input, flex: 1, minWidth: "200px", padding: "0.45rem 0.75rem", fontSize: "0.85rem" },
          }),
          React.createElement("select", {
            value: revenueMethodFilter,
            onChange: e => setRevenueMethodFilter(e.target.value),
            style: { ...styles.input, width: "auto", padding: "0.45rem 0.75rem", fontSize: "0.85rem" },
          },
            React.createElement("option", { value: "todos" }, "Todos los métodos"),
            PAYMENT_METHODS.map(m => React.createElement("option", { key: m, value: m }, m))
          ),
          (revenueSearch || revenueMethodFilter !== "todos") && React.createElement("button", {
            onClick: () => { setRevenueSearch(""); setRevenueMethodFilter("todos"); },
            style: { ...styles.buttonOutline, padding: "0.4rem 0.7rem", fontSize: "0.8rem", whiteSpace: "nowrap" },
          }, "✕ Limpiar")
        ),
        // Grouped by period
        grouped.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No hay pagos con los filtros seleccionados.")
          : grouped.map(([periodKey, txs]) => {
            const periodTotal = txs.reduce((s, t) => s + t.amount, 0);
            const periodCliente = txs.reduce((s, t) => s + (t.montoCliente || t.amount), 0);
            // Sort rows by date descending within each period
            const sortedTxs = [...txs].sort((a,b) => (b.date||"").localeCompare(a.date||""));
            return React.createElement("div", { key: periodKey, style: card },
              React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" } },
                React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, periodKey),
                React.createElement("div", { style: { textAlign: "right" } },
                  React.createElement("div", { style: { fontWeight: "700", color: "#065F46" } }, `Ganancia: ${formatCurrency(periodTotal)}`),
                  periodCliente !== periodTotal && React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280" } }, `Cobrado al cliente: ${formatCurrency(periodCliente)}`)
                )
              ),
              React.createElement("div", { style: { overflowX: "auto" } },
                React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } },
                  React.createElement("thead", null, React.createElement("tr", null,
                    React.createElement("th", { style: thS }, "Fecha de cobro"),
                    React.createElement("th", { style: thS }, "Cliente"),
                    React.createElement("th", { style: thS }, "Tratamiento"),
                    React.createElement("th", { style: { ...thS, textAlign: "center" } }, "# Sesión"),
                    React.createElement("th", { style: thS }, "Tipo"),
                    React.createElement("th", { style: thS }, "Método"),
                    React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Monto cliente"),
                    React.createElement("th", { style: { ...thS, textAlign: "right", color: "#6B7280" } }, "IVA (13%)"),
                    React.createElement("th", { style: { ...thS, textAlign: "right", color: "#DC2626" } }, "Comisión"),
                    React.createElement("th", { style: { ...thS, textAlign: "right", color: "#DC2626" } }, "Ret. BAC Renta"),
                    React.createElement("th", { style: { ...thS, textAlign: "right", color: "#DC2626" } }, "Ret. BAC IVA"),
                    React.createElement("th", { style: { ...thS, textAlign: "right", color: "#065F46" } }, "Ganancia NILA"),
                    React.createElement("th", { style: { ...thS, textAlign: "center" } }, "✓ Facturado"),
                  )),
                  React.createElement("tbody", null,
                    sortedTxs.map((tx, i) =>
                      React.createElement("tr", { key: i, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                        React.createElement("td", { style: { ...tdS, whiteSpace: "nowrap" } }, formatDateCR(tx.date)),
                        React.createElement("td", { style: tdS }, tx.clientName),
                        React.createElement("td", { style: tdS }, `${tx.treatmentNum} — ${tx.treatmentName}`),
                        React.createElement("td", { style: { ...tdS, textAlign: "center", fontWeight: "600", color: colors.gold.dark, whiteSpace: "nowrap" } },
                          tx.type && tx.type.startsWith("Sesión #")
                            ? tx.totalSessions
                              ? `${tx.type.replace("Sesión ", "")} de ${tx.totalSessions}`
                              : tx.type.replace("Sesión ", "")
                            : tx.totalSessions && tx.completedSessions
                              ? `#${tx.completedSessions} de ${tx.totalSessions}`
                              : tx.totalSessions
                                ? `0 de ${tx.totalSessions}`
                                : "—"
                        ),
                        React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, tx.type),
                        React.createElement("td", { style: tdS }, tx.method),
                        React.createElement("td", { style: { ...tdS, textAlign: "right" } }, formatCurrency(tx.montoCliente || tx.amount)),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", color: "#6B7280" } }, tx.iva ? formatCurrency2(tx.iva) : "—"),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", color: "#DC2626" } }, tx.comision ? formatCurrency(tx.comision) : "—"),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", color: "#DC2626" } }, tx.retBACRenta ? formatCurrency(tx.retBACRenta) : "—"),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", color: "#DC2626" } }, tx.retBACIVA ? formatCurrency(tx.retBACIVA) : "—"),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", fontWeight: "700", color: "#065F46" } }, formatCurrency2(tx.amount)),
                        React.createElement("td", { style: { ...tdS, textAlign: "center" } },
                          React.createElement("input", {
                            type: "checkbox",
                            checked: !!checkedTxs[txKey(tx)],
                            onChange: () => toggleChecked(txKey(tx)),
                            style: { width: "1.1rem", height: "1.1rem", cursor: "pointer" },
                          })
                        ),
                      )
                    )
                  )
                )
              )
            );
          })
      );
    })(),

    // ══════════════ 2. OUTSTANDING BALANCES ══════════════
    activeReport === "outstanding" && (() => {
      const outstanding = [];
      records.forEach(r => {
        const clientName = r.form?.nombre || "—";
        const sortedAt = [...(r.additionalTreatments || [])].sort((a,b) => new Date(a.addedAt||0) - new Date(b.addedAt||0));
        const checkPlan = (plan, treatmentNum, treatmentName) => {
          if (!plan) return;
          const pi = plan.paymentInfo || {};
          const total = plan.totalPrice || 0;
          const paid = (pi.deposits||[]).reduce((s,d)=>s+d.amount,0) + (pi.payments||[]).reduce((s,p)=>s+p.amount,0) + (pi.paymentSchedule||[]).filter(i=>i.status==="pagado"||i.status==="parcial").reduce((s,i)=>s+(i.paidAmount||i.amount),0);
          const balance = Math.max(0, total - paid);
          // Yuplon and Tarjeta de Regalo are always fully paid — skip
          const paymentTypeCheck = pi.paymentType || "";
          if (paymentTypeCheck === "yuplon" || paymentTypeCheck === "tarjeta_regalo") return;
          if (balance > 0) {
            const allDates = [...(pi.deposits||[]).map(d=>d.date), ...(pi.payments||[]).map(p=>p.date)].filter(Boolean).sort();
            const lastPaymentDate = allDates[allDates.length - 1] || null;
            const finalizedAt = plan.finalizedAt || (plan.status === "finalizado" ? lastPaymentDate : null);
            const paymentTypeRaw = pi.paymentType || "—";
            const paymentTypeLabel = PAYMENT_TYPES.find(p=>p.value===paymentTypeRaw)?.label || paymentTypeRaw;
            // Derive month key from finalizedAt for grouping
            let monthKey = "Sin fecha";
            if (finalizedAt) {
              const parts = finalizedAt.slice(0,10).split("-");
              monthKey = `${MESES[parseInt(parts[1])-1]} ${parts[0]}`;
            } else if (plan.startDate) {
              const parts = plan.startDate.slice(0,10).split("-");
              monthKey = `${MESES[parseInt(parts[1])-1]} ${parts[0]}`;
            }
            outstanding.push({ clientName, treatmentNum, treatmentName, total, paid, balance, ivaAmount: plan.totalPrice ? (plan.totalPrice - Math.round(plan.totalPrice / 1.13)) : 0, paymentTypeLabel, paymentTypeRaw, status: plan.status, finalizedAt, monthKey });
          }
        };
        checkPlan(r.treatmentPlan, "T1", r.treatmentPlan?.name || "Principal");
        sortedAt.forEach((at, i) => checkPlan(at, `T${i+2}`, at.treatmentName || `Adicional ${i+2}`));
      });

      // Build unique month options
      const monthsSorted = Array.from(new Set(outstanding.map(o=>o.monthKey))).sort((a, b) => {
        const toSort = (mk) => {
          const parts = mk.split(" ");
          if (parts.length !== 2) return mk;
          const m = MESES.indexOf(parts[0]);
          return `${parts[1]}-${String(m+1).padStart(2,"0")}`;
        };
        return toSort(b).localeCompare(toSort(a));
      });
      const months = ["todos", ...monthsSorted];

      // Apply filters
      const filtered = outstanding.filter(o => {
        if (outClientSearch && !o.clientName.toLowerCase().includes(outClientSearch.toLowerCase())) return false;
        if (outTreatmentSearch && !o.treatmentName.toLowerCase().includes(outTreatmentSearch.toLowerCase()) && !o.treatmentNum.toLowerCase().includes(outTreatmentSearch.toLowerCase())) return false;
        if (outPaymentTypeFilter !== "todos" && o.paymentTypeRaw !== outPaymentTypeFilter) return false;
        if (outStatusFilter !== "todos" && o.status !== outStatusFilter) return false;
        if (outMonthFilter !== "todos" && o.monthKey !== outMonthFilter) return false;
        return true;
      });

      const totalOutstanding = filtered.reduce((s, o) => s + o.balance, 0);
      const totalReceived = filtered.reduce((s, o) => s + o.paid, 0);
      const totalCost = filtered.reduce((s, o) => s + o.total, 0);

      const hasFilters = outClientSearch || outTreatmentSearch || outPaymentTypeFilter !== "todos" || outStatusFilter !== "todos" || outMonthFilter !== "todos";
      const clearFilters = () => { setOutClientSearch(""); setOutTreatmentSearch(""); setOutPaymentTypeFilter("todos"); setOutStatusFilter("todos"); setOutMonthFilter("todos"); };

      return React.createElement("div", null,
        // Summary cards
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0.75rem", marginBottom: "1rem" } },
          React.createElement("div", { style: statBox(colors.gold.light) },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.gold.dark } }, formatCurrency(totalCost)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Costo total")
          ),
          React.createElement("div", { style: statBox(colors.accent.successLight) },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.accent.success } }, formatCurrency(totalReceived)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Total recibido")
          ),
          React.createElement("div", { style: statBox("#FEE2E2") },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.accent.danger } }, formatCurrency(totalOutstanding)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Total pendiente")
          ),
        ),

        // Filters row
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "0.5rem" } },
          React.createElement("input", { type: "text", placeholder: "🔍 Buscar cliente...", value: outClientSearch, onChange: e => setOutClientSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
          React.createElement("input", { type: "text", placeholder: "🔍 Buscar tratamiento o T1/T2...", value: outTreatmentSearch, onChange: e => setOutTreatmentSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
        ),
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.5rem", marginBottom: "1rem", alignItems: "center" } },
          React.createElement("select", { value: outPaymentTypeFilter, onChange: e => setOutPaymentTypeFilter(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } },
            React.createElement("option", { value: "todos" }, "Todos los tipos de pago"),
            PAYMENT_TYPES.map(pt => React.createElement("option", { key: pt.value, value: pt.value }, pt.label))
          ),
          React.createElement("select", { value: outStatusFilter, onChange: e => setOutStatusFilter(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } },
            React.createElement("option", { value: "todos" }, "Todos los estados"),
            React.createElement("option", { value: "activo" }, "🟢 Activo"),
            React.createElement("option", { value: "completado" }, "✅ Completado"),
            React.createElement("option", { value: "finalizado" }, "🏁 Finalizado"),
          ),
          React.createElement("select", { value: outMonthFilter, onChange: e => setOutMonthFilter(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } },
            months.map(m => React.createElement("option", { key: m, value: m }, m === "todos" ? "Todos los meses" : m))
          ),
        ),
        hasFilters && React.createElement("button", { onClick: clearFilters, style: { ...styles.buttonOutline, padding: "0.3rem 0.7rem", fontSize: "0.78rem", marginBottom: "1rem" } }, "✕ Limpiar filtros"),

        filtered.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text, marginTop: "1rem" } }, "No hay resultados con los filtros seleccionados.")
          : React.createElement("div", { style: { overflowX: "auto" } },
            React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } },
              React.createElement("thead", null, React.createElement("tr", null,
                React.createElement("th", { style: thS }, "Mes finalización"),
                React.createElement("th", { style: thS }, "Cliente"),
                React.createElement("th", { style: thS }, "Tratamiento"),
                React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Monto cliente"),
                React.createElement("th", { style: { ...thS, textAlign: "right", color: "#6B7280" } }, "IVA (13%)"),
                React.createElement("th", { style: { ...thS, textAlign: "right", color: colors.accent.success } }, "Recibido"),
                React.createElement("th", { style: { ...thS, textAlign: "right", color: colors.accent.danger } }, "Pendiente"),
                React.createElement("th", { style: thS }, "Tipo de pago"),
                React.createElement("th", { style: thS }, "Estado"),
                React.createElement("th", { style: thS }, "Fecha finalización"),
              )),
              React.createElement("tbody", null,
                filtered.sort((a,b) => (b.finalizedAt||"").localeCompare(a.finalizedAt||"")).map((o, i) =>
                  React.createElement("tr", { key: i, style: { backgroundColor: i%2===0?"white":"#FFF5F5" } },
                    React.createElement("td", { style: { ...tdS, fontSize: "0.78rem", color: colors.gold.dark, fontWeight: "600" } }, o.monthKey),
                    React.createElement("td", { style: tdS }, o.clientName),
                    React.createElement("td", { style: tdS }, `${o.treatmentNum} — ${o.treatmentName}`),
                    React.createElement("td", { style: { ...tdS, textAlign: "right", fontWeight: "600" } }, formatCurrency(o.total)),
                    React.createElement("td", { style: { ...tdS, textAlign: "right", color: "#6B7280" } }, o.ivaAmount ? formatCurrency(o.ivaAmount) : "—"),
                    React.createElement("td", { style: { ...tdS, textAlign: "right", color: colors.accent.success, fontWeight: "600" } }, formatCurrency(o.paid)),
                    React.createElement("td", { style: { ...tdS, textAlign: "right", color: colors.accent.danger, fontWeight: "700" } }, formatCurrency(o.balance)),
                    React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, o.paymentTypeLabel),
                    React.createElement("td", { style: tdS },
                      o.status === "finalizado" ? "🏁 Finalizado" :
                      o.status === "completado" ? "✅ Completado" : "🟢 Activo"
                    ),
                    React.createElement("td", { style: { ...tdS, fontSize: "0.8rem" } },
                      o.finalizedAt ? formatDateCR(o.finalizedAt) : "En curso"
                    ),
                  )
                )
              )
            )
          )
      );
    })(),

    // ══════════════ 3. PAYMENT PLAN TRACKER ══════════════
    activeReport === "paymentplans" && (() => {
      const planTypes = ["semanal", "quincenal", "mensual", "personalizado"];
      const activePlans = [];
      records.forEach(r => {
        const clientName = r.form?.nombre || "—";
        const sortedAt = [...(r.additionalTreatments || [])].sort((a,b) => new Date(a.addedAt||0) - new Date(b.addedAt||0));
        const checkPlan = (plan, treatmentNum, treatmentName) => {
          if (!plan) return;
          const pi = plan.paymentInfo || {};
          if (!planTypes.includes(pi.paymentType) && pi.paymentType !== "por_sesion") return;
          const total = plan.totalPrice || 0;
          const paid = (pi.deposits||[]).reduce((s,d)=>s+d.amount,0) + (pi.payments||[]).reduce((s,p)=>s+p.amount,0) + (pi.paymentSchedule||[]).filter(i=>i.status==="pagado"||i.status==="parcial").reduce((s,i)=>s+(i.paidAmount||i.amount),0);
          const balance = Math.max(0, total - paid);
          activePlans.push({
            clientName, treatmentNum, treatmentName,
            paymentType: PAYMENT_TYPES.find(p=>p.value===pi.paymentType)?.label || pi.paymentType,
            nextPaymentDate: pi.nextPaymentDate || "—",
            installmentAmount: pi.installmentAmount || pi.amountPerSession || null,
            planNotes: pi.planNotes || pi.customArrangement || null,
            balance, total, paid, status: plan.status,
          });
        };
        checkPlan(r.treatmentPlan, "T1", r.treatmentPlan?.name || "Principal");
        sortedAt.forEach((at, i) => checkPlan(at, `T${i+2}`, at.treatmentName || `Adicional ${i+2}`));
      });
      return React.createElement("div", null,
        activePlans.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No hay clientes con planes de pago activos.")
          : activePlans.sort((a,b)=>(a.nextPaymentDate||"").localeCompare(b.nextPaymentDate||"")).map((p, i) =>
            React.createElement("div", { key: i, style: { ...card, borderLeft: `4px solid ${p.balance > 0 ? colors.accent.danger : colors.accent.success}` } },
              React.createElement("div", { style: { display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "0.5rem" } },
                React.createElement("div", null,
                  React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark } }, p.clientName),
                  React.createElement("div", { style: { fontSize: "0.82rem", color: colors.gray.text } }, `${p.treatmentNum} — ${p.treatmentName}`),
                  React.createElement("div", { style: { fontSize: "0.82rem", marginTop: "0.25rem" } }, `Plan: `, React.createElement("strong", null, p.paymentType)),
                  p.installmentAmount && React.createElement("div", { style: { fontSize: "0.82rem" } }, `Monto por cuota: `, React.createElement("strong", null, formatCurrency(p.installmentAmount))),
                  p.nextPaymentDate !== "—" && React.createElement("div", { style: { fontSize: "0.82rem", color: "#1D4ED8" } }, `📅 Próximo pago: `, React.createElement("strong", null, formatDateCR(p.nextPaymentDate))),
                  p.planNotes && React.createElement("div", { style: { fontSize: "0.78rem", color: colors.gray.text, fontStyle: "italic", marginTop: "0.25rem" } }, p.planNotes),
                ),
                React.createElement("div", { style: { textAlign: "right" } },
                  React.createElement("div", { style: { fontSize: "0.78rem", color: colors.gray.text } }, "Total tratamiento"),
                  React.createElement("div", { style: { fontWeight: "700" } }, formatCurrency(p.total)),
                  React.createElement("div", { style: { fontSize: "0.78rem", color: colors.accent.success } }, `Cobrado: ${formatCurrency(p.paid)}`),
                  React.createElement("div", { style: { fontSize: "0.9rem", fontWeight: "700", color: p.balance > 0 ? colors.accent.danger : colors.accent.success } }, p.balance > 0 ? `⚠️ Pendiente: ${formatCurrency(p.balance)}` : "✅ Saldado"),
                )
              )
            )
          )
      );
    })(),

    // ══════════════ 4. REVENUE BY TREATMENT TYPE ══════════════
    activeReport === "bytreatment" && (() => {
      const filtered = filterByDate(allPayments, "date");
      const byType = {};
      filtered.forEach(p => {
        const key = p.treatmentName;
        if (!byType[key]) byType[key] = { name: key, total: 0, count: 0 };
        byType[key].total += p.amount;
        byType[key].count++;
      });
      const sorted = Object.values(byType).sort((a,b) => b.total - a.total);
      const grandTotal = sorted.reduce((s, t) => s + t.total, 0);
      const maxVal = sorted[0]?.total || 1;
      // Gold palette shades for bars
      const barColors = ["#B8860B","#DAA520","#F0B429","#F5C842","#F7D87A","#FAE8A0","#FDF3C8"];

      if (sorted.length === 0) return React.createElement("p", { style: { color: colors.gray.text } }, "No hay datos en el período seleccionado.");

      return React.createElement("div", null,
        // Summary card
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0.75rem", marginBottom: "1.5rem" } },
          React.createElement("div", { style: statBox(colors.accent.successLight) },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.accent.success } }, formatCurrency(grandTotal)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Total cobrado")
          ),
          React.createElement("div", { style: statBox(colors.gold.light) },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.gold.dark } }, sorted.length),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Tipos de tratamiento")
          ),
          React.createElement("div", { style: statBox("#EFF6FF") },
            React.createElement("div", { style: { fontSize: "0.9rem", fontWeight: "700", color: "#1D4ED8" } }, sorted[0]?.name || "—"),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Mayor ingreso")
          ),
        ),

        // Bar chart
        React.createElement("div", { style: { ...card, padding: "1.5rem" } },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "1.25rem", fontSize: "0.95rem" } }, "Ingresos por tratamiento"),
          // Bars — horizontal
          sorted.map((t, i) => {
            const pct = Math.round(t.total / maxVal * 100);
            const pctOfTotal = grandTotal > 0 ? Math.round(t.total / grandTotal * 100) : 0;
            const barColor = barColors[Math.min(i, barColors.length - 1)];
            return React.createElement("div", { key: i, style: { marginBottom: "1rem" } },
              // Label row
              React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "0.3rem" } },
                React.createElement("div", { style: { fontSize: "0.82rem", fontWeight: "600", color: colors.gold.dark, maxWidth: "60%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } },
                  `${i+1}. ${t.name}`
                ),
                React.createElement("div", { style: { display: "flex", gap: "0.75rem", alignItems: "baseline" } },
                  React.createElement("span", { style: { fontSize: "0.75rem", color: colors.gray.text } }, `${t.count} pago${t.count !== 1 ? "s" : ""} · ${pctOfTotal}%`),
                  React.createElement("span", { style: { fontWeight: "700", color: colors.accent.success, fontSize: "0.88rem" } }, formatCurrency(t.total)),
                )
              ),
              // Bar track
              React.createElement("div", { style: { height: "22px", backgroundColor: colors.gray.warm, borderRadius: "4px", overflow: "hidden" } },
                React.createElement("div", {
                  style: {
                    height: "100%",
                    width: `${pct}%`,
                    backgroundColor: barColor,
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: pct > 15 ? "0.5rem" : 0,
                    transition: "width 0.3s ease",
                  }
                },
                  pct > 15 && React.createElement("span", { style: { color: "white", fontSize: "0.72rem", fontWeight: "700", whiteSpace: "nowrap" } },
                    formatCurrency(t.total)
                  )
                )
              )
            );
          })
        )
      );
    })(),

    // ══════════════ 5. NEW CLIENTS ══════════════
    activeReport === "newclients" && (() => {
      const filtered = records.filter(r => {
        const d = r.createdAt?.slice(0,10);
        if (dateFrom && d < dateFrom) return false;
        if (dateTo && d > dateTo) return false;
        return true;
      });
      const grouped = {};
      filtered.forEach(r => {
        const d = new Date(r.createdAt);
        const key = `${MESES[d.getMonth()]} ${d.getFullYear()}`;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(r);
      });
      const sortedGroups = Object.entries(grouped).sort((a, b) => {
        const dateA = a[1][0]?.createdAt || "";
        const dateB = b[1][0]?.createdAt || "";
        return dateB.localeCompare(dateA);
      });
      return React.createElement("div", null,
        React.createElement("div", { style: { ...statBox(colors.gold.light), marginBottom: "1rem", display: "flex", justifyContent: "space-between", alignItems: "center" } },
          React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, "Total clientes en período:"),
          React.createElement("span", { style: { fontSize: "1.3rem", fontWeight: "800", color: colors.gold.dark } }, filtered.length)
        ),
        sortedGroups.map(([month, clients]) =>
          React.createElement("div", { key: month, style: card },
            React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.5rem" } },
              React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, month),
              React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, `${clients.length} clientes`)
            ),
            React.createElement("div", { style: { overflowX: "auto" } },
              React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } },
                React.createElement("thead", null, React.createElement("tr", null,
                  React.createElement("th", { style: thS }, "Fecha"),
                  React.createElement("th", { style: thS }, "Cliente"),
                  React.createElement("th", { style: thS }, "Tratamiento"),
                  React.createElement("th", { style: thS }, "Estado"),
                )),
                React.createElement("tbody", null,
                  clients.sort((a,b)=>b.createdAt.localeCompare(a.createdAt)).map((r, i) =>
                    React.createElement("tr", { key: r.id, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                      React.createElement("td", { style: tdS }, formatDateCR(r.createdAt?.slice(0,10))),
                      React.createElement("td", { style: tdS }, r.form?.nombre || "—"),
                      React.createElement("td", { style: tdS }, r.treatmentPlan?.name || r.form?.treatmentType || "—"),
                      React.createElement("td", { style: tdS }, getClientStatus(r).icon + " " + getClientStatus(r).label),
                    )
                  )
                )
              )
            )
          )
        )
      );
    })(),

    // ══════════════ 6. CLIENT TREATMENT HISTORY ══════════════
    activeReport === "clienthistory" && (() => {
      const filtered = records.filter(r => {
        if (!clientSearch) return true;
        const name = (r.form?.nombre || "").toLowerCase();
        const cedula = (r.form?.cedula || "").toLowerCase();
        return name.includes(clientSearch.toLowerCase()) || cedula.includes(clientSearch.toLowerCase());
      });
      return React.createElement("div", null,
        React.createElement("input", { type: "text", placeholder: "Buscar por nombre o cédula...", value: clientSearch, onChange: e => setClientSearch(e.target.value), style: { ...styles.input, marginBottom: "1rem" } }),
        filtered.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No se encontraron clientes.")
          : filtered.map(r => {
            const isOpen = expandedClient === r.id;
            const status = getClientStatus(r);
            const sortedAt = [...(r.additionalTreatments || [])].sort((a,b) => new Date(a.addedAt||0) - new Date(b.addedAt||0));
            const allTreatments = [
              ...(r.treatmentPlan ? [{ num: "T1", name: r.treatmentPlan.name || "Principal", plan: r.treatmentPlan, sessions: r.sessions || [] }] : []),
              ...sortedAt.map((at, i) => ({ num: `T${i+2}`, name: at.treatmentName || `Adicional ${i+2}`, plan: at, sessions: at.sessions || [] })),
            ];
            return React.createElement("div", { key: r.id, style: { ...card, borderLeft: `4px solid ${colors.gold.primary}` } },
              // Client header
              React.createElement("div", { onClick: () => setExpandedClient(isOpen ? null : r.id), style: { display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" } },
                React.createElement("div", null,
                  React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, fontSize: "1rem" } }, r.form?.nombre || "—"),
                  React.createElement("div", { style: { fontSize: "0.78rem", color: colors.gray.text } }, `Cédula: ${r.form?.cedula || "—"} · Tel: ${r.form?.telefono || "—"}`),
                  React.createElement("div", { style: { fontSize: "0.78rem", marginTop: "0.2rem" } }, `${allTreatments.length} tratamiento(s) · `, React.createElement("span", { style: { color: status.badgeStyle?.color || colors.gold.dark } }, status.icon + " " + status.label))
                ),
                React.createElement("span", { style: { color: colors.gray.text, fontSize: "0.85rem" } }, isOpen ? "▲ Cerrar" : "▼ Ver historial")
              ),
              // Expanded treatments
              isOpen && React.createElement("div", { style: { marginTop: "1rem" } },
                allTreatments.map(t => {
                  const tKey = `${r.id}::${t.num}`;
                  const tOpen = expandedTreatment[tKey];
                  const pi = t.plan?.paymentInfo || {};
                  const total = t.plan?.totalPrice || 0;
                  const paid = (pi.deposits||[]).reduce((s,d)=>s+d.amount,0) + (pi.payments||[]).reduce((s,p)=>s+p.amount,0);
                  const balance = Math.max(0, total - paid);
                  return React.createElement("div", { key: t.num, style: { marginBottom: "0.75rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.5rem", overflow: "hidden" } },
                    React.createElement("div", { onClick: () => setExpandedTreatment(prev => ({ ...prev, [tKey]: !tOpen })), style: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0.5rem 0.75rem", backgroundColor: colors.gold.light, cursor: "pointer" } },
                      React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark, fontSize: "0.85rem" } }, `${t.num} — ${t.name}`),
                      React.createElement("div", { style: { display: "flex", gap: "1rem", alignItems: "center" } },
                        React.createElement("span", { style: { fontSize: "0.78rem" } }, `${t.plan?.completedSessions||0}/${t.plan?.totalSessions||0} sesiones`),
                        React.createElement("span", { style: { fontSize: "0.78rem", fontWeight: "700", color: balance > 0 ? colors.accent.danger : colors.accent.success } }, balance > 0 ? `⚠️ ${formatCurrency(balance)}` : "✅ Pagado"),
                        React.createElement("span", { style: { fontSize: "0.75rem", color: colors.gray.text } }, tOpen ? "▲" : "▼")
                      )
                    ),
                    tOpen && React.createElement("div", { style: { padding: "0.75rem" } },
                      React.createElement("div", { style: { fontSize: "0.82rem", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.25rem 1rem", marginBottom: "0.75rem" } },
                        React.createElement("div", null, "Total: ", React.createElement("strong", null, formatCurrency(total))),
                        React.createElement("div", null, "Cobrado: ", React.createElement("strong", { style: { color: colors.accent.success } }, formatCurrency(paid))),
                        React.createElement("div", null, "Saldo: ", React.createElement("strong", { style: { color: balance > 0 ? colors.accent.danger : colors.accent.success } }, formatCurrency(balance))),
                        React.createElement("div", null, "Estado: ", React.createElement("strong", null, t.plan?.status === "finalizado" ? "🏁 Finalizado" : t.plan?.status === "completado" ? "✅ Completado" : "🟢 Activo")),
                      ),
                      t.sessions.length > 0 && React.createElement("div", null,
                        React.createElement("div", { style: { fontWeight: "600", fontSize: "0.82rem", marginBottom: "0.35rem", color: colors.gold.dark } }, "Sesiones:"),
                        React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.78rem" } },
                          React.createElement("thead", null, React.createElement("tr", null,
                            React.createElement("th", { style: thS }, "#"),
                            React.createElement("th", { style: thS }, "Fecha"),
                            React.createElement("th", { style: thS }, "Especialista"),
                          )),
                          React.createElement("tbody", null,
                            t.sessions.map((s, si) => React.createElement("tr", { key: si },
                              React.createElement("td", { style: tdS }, s.number),
                              React.createElement("td", { style: tdS }, formatDateCR(s.date)),
                              React.createElement("td", { style: tdS }, s.specialist || "—"),
                            ))
                          )
                        )
                      )
                    )
                  );
                })
              )
            );
          })
      );
    })(),

    // ══════════════ 8. SESSIONS COMPLETED ══════════════
    activeReport === "sessions" && (() => {
      // Apply client + treatment search filters
      const sessFiltered = filterByDate(allSessions, "date").filter(s => {
        if (sessClientSearch && !s.clientName.toLowerCase().includes(sessClientSearch.toLowerCase())) return false;
        if (sessTreatmentSearch && !s.treatmentName.toLowerCase().includes(sessTreatmentSearch.toLowerCase()) && !s.treatmentNum.toLowerCase().includes(sessTreatmentSearch.toLowerCase())) return false;
        return true;
      });
      // Group by selected period (day/week/month) — uses the session date
      const grouped = groupByPeriod(sessFiltered, "date");
      const total = sessFiltered.length;
      const bySpecialist = {};
      sessFiltered.forEach(s => { bySpecialist[s.specialist] = (bySpecialist[s.specialist] || 0) + 1; });
      const hasFilters = sessClientSearch || sessTreatmentSearch;
      return React.createElement("div", null,
        // Summary cards
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.75rem", marginBottom: "1rem" } },
          React.createElement("div", { style: statBox(colors.gold.light) },
            React.createElement("div", { style: { fontSize: "1.5rem", fontWeight: "800", color: colors.gold.dark } }, total),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Sesiones realizadas")
          ),
          React.createElement("div", { style: statBox("#EFF6FF") },
            React.createElement("div", { style: { fontSize: "0.85rem", fontWeight: "700", color: "#1D4ED8" } },
              Object.entries(bySpecialist).sort((a,b)=>b[1]-a[1]).map(([s,c]) => `${s}: ${c}`).join(" · ") || "—"
            ),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Por especialista")
          )
        ),
        // Search filters
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" } },
          React.createElement("input", { type: "text", placeholder: "🔍 Buscar cliente...", value: sessClientSearch, onChange: e => setSessClientSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
          React.createElement("input", { type: "text", placeholder: "🔍 Buscar tratamiento o T1/T2...", value: sessTreatmentSearch, onChange: e => setSessTreatmentSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
        ),
        hasFilters && React.createElement("button", { onClick: () => { setSessClientSearch(""); setSessTreatmentSearch(""); }, style: { ...styles.buttonOutline, padding: "0.3rem 0.7rem", fontSize: "0.78rem", marginBottom: "1rem" } }, "✕ Limpiar filtros"),
        // Period groups — each group header shows the period (day/week/month)
        grouped.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No hay sesiones con los filtros seleccionados.")
          : grouped.map(([periodKey, sessions]) =>
            React.createElement("div", { key: periodKey, style: card },
              React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.5rem" } },
                React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, periodKey),
                React.createElement("span", { style: { fontWeight: "700", color: colors.gray.text, fontSize: "0.85rem" } }, `${sessions.length} sesión${sessions.length !== 1 ? "es" : ""}`)
              ),
              React.createElement("div", { style: { overflowX: "auto" } },
                React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } },
                  React.createElement("thead", null, React.createElement("tr", null,
                    React.createElement("th", { style: thS }, "Fecha"),
                    React.createElement("th", { style: { ...thS, textAlign: "center" } }, "# Sesión"),
                    React.createElement("th", { style: thS }, "Cliente"),
                    React.createElement("th", { style: thS }, "Tratamiento"),
                    React.createElement("th", { style: thS }, "Especialista"),
                    React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Cobro"),
                  )),
                  React.createElement("tbody", null,
                    sessions.sort((a,b) => (b.date||"").localeCompare(a.date||"")).map((s, i) =>
                      React.createElement("tr", { key: i, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                        React.createElement("td", { style: { ...tdS, whiteSpace: "nowrap" } }, formatDateCR(s.date)),
                        React.createElement("td", { style: { ...tdS, textAlign: "center", fontWeight: "700", color: colors.gold.dark } }, `#${s.sessionNumber}`),
                        React.createElement("td", { style: tdS }, s.clientName),
                        React.createElement("td", { style: tdS }, `${s.treatmentNum} — ${s.treatmentName}`),
                        React.createElement("td", { style: tdS }, s.specialist),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", fontSize: "0.78rem" } },
                          s.cobroAmount
                            ? React.createElement("span", { style: { color: colors.accent.success, fontWeight: "600" } }, `${formatCurrency(s.cobroAmount)}${s.cobroMethod ? " · " + s.cobroMethod : ""}`)
                            : s.paymentPending
                              ? React.createElement("span", { style: { color: colors.accent.warning, fontWeight: "600" } }, "⚠️ Pendiente")
                              : React.createElement("span", { style: { color: colors.gray.text } }, "✅ Incluido en paquete")
                        ),
                      )
                    )
                  )
                )
              )
            )
          )
      );
    })(),

    // ══════════════ 10. MOST POPULAR TREATMENTS ══════════════
    activeReport === "popular" && (() => {
      const counts = {};
      records.forEach(r => {
        const addTreatment = (name) => { counts[name] = (counts[name] || 0) + 1; };
        if (r.treatmentPlan?.name) addTreatment(r.treatmentPlan.name);
        else if (r.form?.treatmentType) addTreatment(r.form.treatmentType);
        (r.additionalTreatments || []).forEach(at => addTreatment(at.treatmentName || at.treatmentType || "Adicional"));
      });
      const sorted = Object.entries(counts).sort((a,b) => b[1]-a[1]);
      const max = sorted[0]?.[1] || 1;
      return React.createElement("div", null,
        sorted.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No hay datos.")
          : sorted.map(([name, count], i) => {
            const pct = Math.round(count / max * 100);
            return React.createElement("div", { key: name, style: { ...card, display: "flex", alignItems: "center", gap: "1rem" } },
              React.createElement("div", { style: { width: "2rem", height: "2rem", borderRadius: "50%", backgroundColor: i === 0 ? "#F59E0B" : i === 1 ? "#9CA3AF" : i === 2 ? "#B45309" : colors.gold.light, color: i < 3 ? "white" : colors.gold.dark, fontWeight: "800", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.85rem", flexShrink: 0 } }, i+1),
              React.createElement("div", { style: { flex: 1 } },
                React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark } }, name),
                React.createElement("div", { style: { height: "8px", backgroundColor: colors.gray.warm, borderRadius: "4px", marginTop: "0.35rem" } },
                  React.createElement("div", { style: { height: "100%", width: `${pct}%`, backgroundColor: i === 0 ? "#F59E0B" : colors.gold.primary, borderRadius: "4px" } })
                )
              ),
              React.createElement("div", { style: { fontWeight: "800", color: colors.gold.dark, fontSize: "1.1rem", flexShrink: 0 } }, `${count}x`)
            );
          })
      );
    })(),

    // ══════════════ 11. AVERAGE TREATMENT VALUE ══════════════
    activeReport === "avgvalue" && (() => {
      const byType = {};
      records.forEach(r => {
        const addValue = (name, price) => {
          if (!price) return;
          if (!byType[name]) byType[name] = { total: 0, count: 0, min: price, max: price };
          byType[name].total += price;
          byType[name].count++;
          if (price < byType[name].min) byType[name].min = price;
          if (price > byType[name].max) byType[name].max = price;
        };
        if (r.treatmentPlan?.totalPrice) addValue(r.treatmentPlan.name || r.form?.treatmentType || "Principal", r.treatmentPlan.totalPrice);
        (r.additionalTreatments || []).forEach(at => { if (at.totalPrice) addValue(at.treatmentName || at.treatmentType || "Adicional", at.totalPrice); });
      });
      const sorted = Object.entries(byType).sort((a,b) => (b[1].total/b[1].count) - (a[1].total/a[1].count));
      return React.createElement("div", null,
        sorted.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No hay datos.")
          : React.createElement("div", { style: { overflowX: "auto" } },
            React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } },
              React.createElement("thead", null, React.createElement("tr", null,
                React.createElement("th", { style: thS }, "Tratamiento"),
                React.createElement("th", { style: thS }, "# Clientes"),
                React.createElement("th", { style: thS }, "Promedio"),
                React.createElement("th", { style: thS }, "Mínimo"),
                React.createElement("th", { style: thS }, "Máximo"),
                React.createElement("th", { style: thS }, "Total generado"),
              )),
              React.createElement("tbody", null,
                sorted.map(([name, d], i) =>
                  React.createElement("tr", { key: name, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                    React.createElement("td", { style: { ...tdS, fontWeight: "600" } }, name),
                    React.createElement("td", { style: { ...tdS, textAlign: "center" } }, d.count),
                    React.createElement("td", { style: { ...tdS, fontWeight: "700", color: colors.gold.dark } }, formatCurrency(Math.round(d.total/d.count))),
                    React.createElement("td", { style: tdS }, formatCurrency(d.min)),
                    React.createElement("td", { style: tdS }, formatCurrency(d.max)),
                    React.createElement("td", { style: { ...tdS, fontWeight: "600", color: colors.accent.success } }, formatCurrency(d.total)),
                  )
                )
              )
            )
          )
      );
    })(),

    // ══════════════ REPORTE FINANCIERO DEL MES ══════════════
    activeReport === "financiero" && (() => {
      const MESES_ES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
      const today = new Date();
      const monthOptions = [];
      for (let i = 0; i < 12; i++) {
        const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        monthOptions.push(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`);
      }
      const monthLabel = (mk) => { const [y,m] = mk.split("-"); return `${MESES_ES[parseInt(m)-1]} ${y}`; };

      // Data for SELECTED month only
      const monthPayments = allPayments.filter(p => p.date && p.date.startsWith(finMonth));
      const totalIngresos = monthPayments.reduce((s, p) => s + (p.amount || 0), 0);
      const totalGastos = gastosData ? gastosData.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0) : 0;
      const neto = totalIngresos - totalGastos;
      const chartMax = Math.max(totalIngresos, totalGastos, 1);
      const ingPct = Math.round(totalIngresos / chartMax * 100);
      const gasPct = Math.round(totalGastos / chartMax * 100);

      return React.createElement("div", null,
        // Month selector
        React.createElement("div", { style: { display: "flex", gap: "0.5rem", alignItems: "center", marginBottom: "1.25rem" } },
          React.createElement("span", { style: { fontWeight: "600", color: colors.gold.dark } }, "Mes:"),
          React.createElement("select", { value: finMonth, onChange: e => setFinMonth(e.target.value), style: { ...styles.input, width: "auto", fontWeight: "700", padding: "0.4rem 0.7rem" } },
            monthOptions.map(mk => React.createElement("option", { key: mk, value: mk }, monthLabel(mk)))
          )
        ),

        // Summary cards
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0.75rem", marginBottom: "1.5rem" } },
          React.createElement("div", { style: { backgroundColor: "#EFF6FF", borderRadius: "0.75rem", padding: "1rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "1.2rem", fontWeight: "800", color: "#1D4ED8" } }, formatCurrency(totalIngresos)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280", marginTop: "0.25rem" } }, "💰 Ganancia de NILA")
          ),
          React.createElement("div", { style: { backgroundColor: "#FEE2E2", borderRadius: "0.75rem", padding: "1rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "1.2rem", fontWeight: "800", color: "#DC2626" } }, formatCurrency(totalGastos)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280", marginTop: "0.25rem" } }, "💸 Total gastos")
          ),
          React.createElement("div", { style: { backgroundColor: neto >= 0 ? "#DCFCE7" : "#FEE2E2", borderRadius: "0.75rem", padding: "1rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "1.2rem", fontWeight: "800", color: neto >= 0 ? "#16A34A" : "#DC2626" } }, (neto >= 0 ? "+" : "") + formatCurrency(neto)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280", marginTop: "0.25rem" } }, neto >= 0 ? "✅ Resultado neto (superávit)" : "⚠️ Resultado neto (déficit)")
          )
        ),

        // Bar chart — Ganancia vs Gastos for selected month
        React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.75rem", padding: "1.25rem", border: `1px solid ${colors.gold.light}`, marginBottom: "1.25rem" } },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "1.25rem" } }, `Ganancia vs Gastos — ${monthLabel(finMonth)}`),
          React.createElement("div", { style: { display: "flex", alignItems: "flex-end", gap: "2rem", height: "220px", justifyContent: "center" } },
            // Ganancia bar
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: "0.35rem", height: "100%", justifyContent: "flex-end", flex: 1, maxWidth: "140px" } },
              React.createElement("div", { style: { fontSize: "0.82rem", fontWeight: "700", color: "#1D4ED8" } }, formatCurrency(totalIngresos)),
              React.createElement("div", { style: { width: "100%", height: `${Math.max(ingPct, 3)}%`, backgroundColor: "#3B82F6", borderRadius: "6px 6px 0 0" } }),
              React.createElement("div", { style: { fontSize: "0.85rem", fontWeight: "600", color: "#1D4ED8" } }, "💰 Ganancia")
            ),
            // Gastos bar
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: "0.35rem", height: "100%", justifyContent: "flex-end", flex: 1, maxWidth: "140px" } },
              React.createElement("div", { style: { fontSize: "0.82rem", fontWeight: "700", color: "#DC2626" } }, formatCurrency(totalGastos)),
              React.createElement("div", { style: { width: "100%", height: `${Math.max(gasPct, 3)}%`, backgroundColor: "#EF4444", borderRadius: "6px 6px 0 0" } }),
              React.createElement("div", { style: { fontSize: "0.85rem", fontWeight: "600", color: "#DC2626" } }, "💸 Gastos")
            ),
          ),
          // Neto line
          React.createElement("div", { style: { marginTop: "1rem", padding: "0.6rem 1rem", backgroundColor: neto >= 0 ? "#DCFCE7" : "#FEE2E2", borderRadius: "0.5rem", display: "flex", justifyContent: "space-between", alignItems: "center" } },
            React.createElement("span", { style: { fontWeight: "600", color: neto >= 0 ? "#16A34A" : "#DC2626" } }, neto >= 0 ? "✅ Superávit del mes:" : "⚠️ Déficit del mes:"),
            React.createElement("span", { style: { fontWeight: "800", fontSize: "1.1rem", color: neto >= 0 ? "#16A34A" : "#DC2626" } }, (neto >= 0 ? "+" : "") + formatCurrency(neto))
          )
        ),

        // ── INGRESOS DEL MES ──
        React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.75rem", padding: "1rem", border: `1px solid ${colors.gold.light}`, marginBottom: "1.25rem" } },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "0.75rem", fontSize: "0.95rem" } }, `💰 Ingresos — ${monthLabel(finMonth)}`),
          // Filters
          React.createElement("div", { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.75rem" } },
            React.createElement("input", { type: "text", placeholder: "🔍 Cliente...", value: finIngClientSearch, onChange: e => setFinIngClientSearch(e.target.value), style: { ...styles.input, flex: 1, minWidth: "140px", padding: "0.35rem 0.6rem", fontSize: "0.8rem" } }),
            React.createElement("select", { value: finIngMethodFilter, onChange: e => setFinIngMethodFilter(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.8rem" } },
              React.createElement("option", { value: "todos" }, "Todos los métodos"),
              PAYMENT_METHODS.map(m => React.createElement("option", { key: m, value: m }, m))
            ),
            React.createElement("select", { value: finIngTipoFilter, onChange: e => setFinIngTipoFilter(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.8rem" } },
              React.createElement("option", { value: "todos" }, "Todos los tipos"),
              React.createElement("option", { value: "Pago completo" }, "Pago completo"),
              React.createElement("option", { value: "Depósito" }, "Depósito"),
              React.createElement("option", { value: "Saldo" }, "Saldo"),
              React.createElement("option", { value: "Sesión" }, "Sesión"),
              React.createElement("option", { value: "Valoración" }, "Valoración / Sin costo"),
              React.createElement("option", { value: "Incluido" }, "Incluido en paquete"),
            ),
            (finIngClientSearch || finIngMethodFilter !== "todos" || finIngTipoFilter !== "todos") && React.createElement("button", { onClick: () => { setFinIngClientSearch(""); setFinIngMethodFilter("todos"); setFinIngTipoFilter("todos"); }, style: { ...styles.buttonOutline, padding: "0.3rem 0.6rem", fontSize: "0.78rem" } }, "✕")
          ),
          (() => {
            const ingFiltered = monthPayments.filter(tx => {
              if (finIngClientSearch && !tx.clientName.toLowerCase().includes(finIngClientSearch.toLowerCase())) return false;
              if (finIngMethodFilter !== "todos" && tx.method !== finIngMethodFilter) return false;
              if (finIngTipoFilter !== "todos") {
                if (finIngTipoFilter === "Sesión" && !tx.type.startsWith("Sesión #")) return false;
                if (finIngTipoFilter !== "Sesión" && !tx.type.includes(finIngTipoFilter)) return false;
              }
              return true;
            });
            const ingTotal = ingFiltered.reduce((s, p) => s + (p.amount || 0), 0);
            return React.createElement("div", null,
              React.createElement("div", { style: { fontSize: "0.82rem", color: "#16A34A", fontWeight: "700", marginBottom: "0.5rem" } }, `${ingFiltered.length} transacciones · Total: ${formatCurrency(ingTotal)}`),
              React.createElement("div", { style: { overflowX: "auto" } },
                React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.79rem" } },
                  React.createElement("thead", null, React.createElement("tr", null,
                    React.createElement("th", { style: thS }, "Fecha cobro"),
                    React.createElement("th", { style: thS }, "Cliente"),
                    React.createElement("th", { style: thS }, "Tratamiento"),
                    React.createElement("th", { style: thS }, "Tipo"),
                    React.createElement("th", { style: thS }, "Método"),
                    React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Ganancia NILA"),
                  )),
                  React.createElement("tbody", null,
                    ingFiltered.sort((a,b) => (b.date||"").localeCompare(a.date||"")).map((tx, i) =>
                      React.createElement("tr", { key: i, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                        React.createElement("td", { style: tdS }, formatDateCR(tx.date)),
                        React.createElement("td", { style: tdS }, tx.clientName),
                        React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, `${tx.treatmentNum} — ${tx.treatmentName}`),
                        React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, tx.type),
                        React.createElement("td", { style: tdS }, tx.method),
                        React.createElement("td", { style: { ...tdS, textAlign: "right", fontWeight: "700", color: "#16A34A" } }, formatCurrency(tx.amount || 0)),
                      )
                    )
                  )
                )
              )
            );
          })()
        ),

        // ── GASTOS DEL MES ──
        React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.75rem", padding: "1rem", border: `1px solid ${colors.gold.light}` } },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "0.75rem", fontSize: "0.95rem" } }, `💸 Gastos — ${monthLabel(finMonth)}`),
          // Filters
          React.createElement("div", { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.75rem" } },
            React.createElement("select", { value: finGastoCatFilter, onChange: e => setFinGastoCatFilter(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.8rem" } },
              ["Todas", "Alquiler","Seguro","Servicios profesionales","Software","Impuestos","Servicios bancarios","Servicios","Marketing","Transporte","Otros"].map(c => React.createElement("option", { key: c, value: c }, c))
            ),
            React.createElement("select", { value: finGastoEstadoFilter, onChange: e => setFinGastoEstadoFilter(e.target.value), style: { ...styles.input, width: "auto", padding: "0.35rem 0.6rem", fontSize: "0.8rem" } },
              React.createElement("option", { value: "todos" }, "Todos los estados"),
              React.createElement("option", { value: "pagado" }, "✅ Pagados"),
              React.createElement("option", { value: "pendiente" }, "⏳ Pendientes"),
            ),
            (finGastoCatFilter !== "Todas" || finGastoEstadoFilter !== "todos") && React.createElement("button", { onClick: () => { setFinGastoCatFilter("Todas"); setFinGastoEstadoFilter("todos"); }, style: { ...styles.buttonOutline, padding: "0.3rem 0.6rem", fontSize: "0.78rem" } }, "✕")
          ),
          !gastosData
            ? React.createElement("p", { style: { color: colors.gray.text, fontStyle: "italic", fontSize: "0.85rem" } }, "No hay gastos registrados para este mes. Ve a la sección Gastos para registrarlos.")
            : (() => {
                const gastosFiltered = gastosData.filter(e => {
                  if (!parseFloat(e.amount)) return false;
                  if (finGastoCatFilter !== "Todas" && e.categoria !== finGastoCatFilter) return false;
                  if (finGastoEstadoFilter === "pagado" && !e.paid) return false;
                  if (finGastoEstadoFilter === "pendiente" && e.paid) return false;
                  return true;
                });
                const gastosTotal = gastosFiltered.reduce((s, e) => s + (parseFloat(e.amount)||0), 0);
                return React.createElement("div", null,
                  React.createElement("div", { style: { fontSize: "0.82rem", color: "#DC2626", fontWeight: "700", marginBottom: "0.5rem" } }, `${gastosFiltered.length} gastos · Total: ${formatCurrency(gastosTotal)}`),
                  React.createElement("div", { style: { overflowX: "auto" } },
                    React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.79rem" } },
                      React.createElement("thead", null, React.createElement("tr", null,
                        React.createElement("th", { style: thS }, "Gasto"),
                        React.createElement("th", { style: thS }, "Categoría"),
                        React.createElement("th", { style: thS }, "Método de pago"),
                        React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Monto"),
                        React.createElement("th", { style: { ...thS, textAlign: "center" } }, "Estado"),
                        React.createElement("th", { style: thS }, "Fecha del pago"),
                      )),
                      React.createElement("tbody", null,
                        gastosFiltered.map((e, i) =>
                          React.createElement("tr", { key: e.id, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                            React.createElement("td", { style: tdS }, e.desc),
                            React.createElement("td", { style: { ...tdS, fontSize: "0.74rem", color: "#6B7280" } }, e.categoria),
                            React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, e.method || "—"),
                            React.createElement("td", { style: { ...tdS, textAlign: "right", fontWeight: "600" } }, formatCurrency(parseFloat(e.amount)||0)),
                            React.createElement("td", { style: { ...tdS, textAlign: "center" } }, e.paid
                              ? React.createElement("span", { style: { color: "#16A34A", fontWeight: "600", fontSize: "0.75rem" } }, "✅ Pagado")
                              : React.createElement("span", { style: { color: "#D97706", fontSize: "0.75rem" } }, "⏳ Pendiente")
                            ),
                            React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, e.paidDate ? formatDateCR(e.paidDate) : "—"),
                          )
                        )
                      )
                    )
                  )
                );
              })()
        ),
      );
    })(),

    // ══════════════ CLIENTES ACTIVOS ══════════════
    activeReport === "activeclients" && (() => {
      // Build rows — one per active treatment per client
      const rows = [];
      records.forEach(r => {
        const clientName = r.form?.nombre || "—";
        const cedula = r.form?.cedula || "—";
        const telefono = r.form?.telefono || "—";
        const correo = r.form?.correo || "—";

        const addRow = (plan, treatmentNum, treatmentName) => {
          if (!plan) return;
          if (plan.status === "finalizado") return; // skip finalized
          const pi = plan.paymentInfo || {};
          const total = plan.totalPrice || 0;
          const paid = (pi.deposits||[]).reduce((s,d)=>s+d.amount,0) + (pi.payments||[]).reduce((s,p)=>s+p.amount,0);
          const pending = Math.max(0, total - paid);
          const paymentTypeLabel = PAYMENT_TYPES.find(p=>p.value===pi.paymentType)?.label || pi.paymentType || "—";
          rows.push({
            clientName, cedula, telefono, correo,
            treatmentNum, treatmentName,
            startDate: plan.startDate || "—",
            completedSessions: plan.completedSessions || 0,
            totalSessions: plan.totalSessions || 0,
            remaining: Math.max(0, (plan.totalSessions||0) - (plan.completedSessions||0)),
            paid, pending, total, paymentTypeLabel,
            status: plan.status,
          });
        };

        addRow(r.treatmentPlan, "T1", r.treatmentPlan?.name || r.form?.treatmentType || "Principal");
        const sortedAt = [...(r.additionalTreatments||[])].sort((a,b)=>new Date(a.addedAt||0)-new Date(b.addedAt||0));
        sortedAt.forEach((at, i) => addRow(at, `T${i+2}`, at.treatmentName || at.treatmentType || `Adicional ${i+2}`));
      });

      // Apply filters
      const filtered = rows.filter(r => {
        if (activeClientSearch && !r.clientName.toLowerCase().includes(activeClientSearch.toLowerCase()) && !r.cedula.includes(activeClientSearch)) return false;
        if (activeTreatmentSearch && !r.treatmentName.toLowerCase().includes(activeTreatmentSearch.toLowerCase()) && !r.treatmentNum.toLowerCase().includes(activeTreatmentSearch.toLowerCase())) return false;
        return true;
      });

      const totalPendiente = filtered.reduce((s, r) => s + r.pending, 0);

      return React.createElement("div", null,
        // Summary
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "0.75rem", marginBottom: "1rem" } },
          React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "1.3rem", fontWeight: "800", color: colors.gold.dark } }, filtered.length),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Tratamientos activos")
          ),
          React.createElement("div", { style: { backgroundColor: "#EFF6FF", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: "#1D4ED8" } }, new Set(filtered.map(r=>r.cedula)).size),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Clientes únicos")
          ),
          React.createElement("div", { style: { backgroundColor: "#FEE2E2", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: "#DC2626" } }, formatCurrency(totalPendiente)),
            React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Total pendiente de cobro")
          ),
        ),

        // Filters
        React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "1rem" } },
          React.createElement("input", { type: "text", placeholder: "🔍 Buscar cliente o cédula...", value: activeClientSearch, onChange: e => setActiveClientSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
          React.createElement("input", { type: "text", placeholder: "🔍 Buscar tratamiento...", value: activeTreatmentSearch, onChange: e => setActiveTreatmentSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
        ),

        // Table
        filtered.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "No hay clientes activos con los filtros seleccionados.")
          : React.createElement("div", { style: { overflowX: "auto" } },
            React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.79rem" } },
              React.createElement("thead", null, React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
                React.createElement("th", { style: thS }, "Cliente"),
                React.createElement("th", { style: thS }, "Cédula"),
                React.createElement("th", { style: thS }, "Teléfono"),
                React.createElement("th", { style: thS }, "Correo"),
                React.createElement("th", { style: thS }, "Tratamiento"),
                React.createElement("th", { style: thS }, "Fecha inicio"),
                React.createElement("th", { style: { ...thS, textAlign: "center" } }, "Sesiones"),
                React.createElement("th", { style: { ...thS, textAlign: "center" } }, "Restantes"),
                React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Cobrado"),
                React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Pendiente"),
                React.createElement("th", { style: thS }, "Tipo de pago"),
              )),
              React.createElement("tbody", null,
                filtered.map((r, i) =>
                  React.createElement("tr", { key: i, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                    React.createElement("td", { style: { ...tdS, fontWeight: "600" } }, r.clientName),
                    React.createElement("td", { style: tdS }, r.cedula),
                    React.createElement("td", { style: tdS }, r.telefono),
                    React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, r.correo),
                    React.createElement("td", { style: tdS }, `${r.treatmentNum} — ${r.treatmentName}`),
                    React.createElement("td", { style: tdS }, r.startDate !== "—" ? formatDateCR(r.startDate) : "—"),
                    React.createElement("td", { style: { ...tdS, textAlign: "center" } }, `${r.completedSessions} / ${r.totalSessions}`),
                    React.createElement("td", { style: { ...tdS, textAlign: "center", fontWeight: "600", color: r.remaining === 0 ? colors.accent.success : colors.gold.dark } }, r.remaining),
                    React.createElement("td", { style: { ...tdS, textAlign: "right", color: colors.accent.success, fontWeight: "600" } }, formatCurrency(r.paid)),
                    React.createElement("td", { style: { ...tdS, textAlign: "right", color: r.pending > 0 ? "#DC2626" : colors.accent.success, fontWeight: r.pending > 0 ? "700" : "400" } }, r.pending > 0 ? formatCurrency(r.pending) : "✅ Saldado"),
                    React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, r.paymentTypeLabel),
                  )
                )
              )
            )
          )
      );
    })(),

    // ══════════════ REGISTROS PENDIENTES DE COMPLETAR ══════════════
    activeReport === "pendientescompletar" && (() => {
      const pending = records.filter(isPendingClientCompletion);
      const missingLabel = (r) => {
        const f = r.form || {};
        const has = (v) => typeof v === "string" ? v.trim().length > 0 : !!v;
        const miss = [];
        if (!has(f.cedula)) miss.push("Cédula");
        if (!has(f.telefono)) miss.push("Teléfono");
        if (!has(f.correo)) miss.push("Correo");
        if (!has(f.fechaNacimiento)) miss.push("Fecha nac.");
        if (!(has(f.firmaCliente) || f._hasFirma === true)) miss.push("Firma");
        return miss.join(", ") || "—";
      };
      return React.createElement("div", null,
        React.createElement("div", { style: { ...statBox(colors.gold.light), marginBottom: "1rem", display: "flex", justifyContent: "space-between", alignItems: "center" } },
          React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, "Registros que faltan completar por el cliente:"),
          React.createElement("span", { style: { fontSize: "1.3rem", fontWeight: "800", color: colors.gold.dark } }, pending.length)
        ),
        pending.length === 0
          ? React.createElement("p", { style: { color: colors.gray.text } }, "✅ Todos los registros están completos.")
          : React.createElement("div", { style: { overflowX: "auto" } },
            React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.82rem" } },
              React.createElement("thead", null, React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
                React.createElement("th", { style: thS }, "Cliente"),
                React.createElement("th", { style: thS }, "Teléfono"),
                React.createElement("th", { style: thS }, "Registrado"),
                React.createElement("th", { style: thS }, "Datos que faltan"),
                React.createElement("th", { style: { ...thS, textAlign: "center" } }, "Enlace"),
              )),
              React.createElement("tbody", null,
                pending.map((r, i) => {
                  const link = buildCompletionLink(r.id);
                  const waText = `Hola${r.form && r.form.nombre ? " " + r.form.nombre : ""}, por favor complete su expediente de Nación Nila Estética en este enlace: ${link}`;
                  const waLink = `https://wa.me/?text=${encodeURIComponent(waText)}`;
                  return React.createElement("tr", { key: r.id, style: { backgroundColor: i%2===0?"white":"#FFFBF0" } },
                    React.createElement("td", { style: { ...tdS, fontWeight: "600" } }, r.form?.nombre || "Cliente sin nombre"),
                    React.createElement("td", { style: tdS }, r.form?.telefono || "—"),
                    React.createElement("td", { style: tdS }, r.createdAt ? formatDateCR(r.createdAt.slice(0,10)) : "—"),
                    React.createElement("td", { style: { ...tdS, fontSize: "0.76rem", color: "#DC2626" } }, missingLabel(r)),
                    React.createElement("td", { style: { ...tdS, textAlign: "center", whiteSpace: "nowrap" } },
                      React.createElement("button", {
                        onClick: () => {
                          try {
                            if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link);
                            else { const ta = document.createElement("textarea"); ta.value = link; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta); }
                            alert("✅ Enlace copiado");
                          } catch (e) { alert(link); }
                        },
                        style: { padding: "0.25rem 0.6rem", backgroundColor: colors.gold.primary, color: "white", border: "none", borderRadius: "1rem", cursor: "pointer", fontSize: "0.72rem", fontWeight: "700", marginRight: "0.3rem" },
                      }, "📋"),
                      React.createElement("a", { href: waLink, target: "_blank", rel: "noopener noreferrer", style: { padding: "0.25rem 0.6rem", backgroundColor: "#25D366", color: "white", borderRadius: "1rem", fontSize: "0.72rem", fontWeight: "700", textDecoration: "none" } }, "💬")
                    ),
                  );
                })
              )
            )
          )
      );
    })(),
  );
}


function UserManagement({ users, setUsers, currentUser }) {
  const isMobile = useIsMobile();
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    nombreCompleto: "",
    username: "",
    role: "recepcion",
    nivel: 1,
    pin: "",
    password: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const roles = [
    { value: "recepcion", label: "Recepción" },
    { value: "especialista", label: "Especialista" },
    { value: "manager", label: "Manager" },
    { value: "owner", label: "Owner" },
  ];
  const roleLabels = {
    recepcion: "Recepción",
    especialista: "Especialista",
    manager: "Manager",
    owner: "Owner",
  };

  const canManageUsers = currentUser.role === "owner" || currentUser.role === "manager";

  const handleSave = async () => {
    setPasswordError("");
    
    if (!formData.nombreCompleto || !formData.username)
      return alert("Complete todos los campos");
    
    if (!editingUser && !formData.password) {
      setPasswordError("La contraseña es obligatoria para nuevos usuarios");
      return;
    }
    
    if (!editingUser && formData.password !== "1234") {
      setPasswordError("La contraseña inicial debe ser 1234");
      return;
    }
    
    const roleInfo = roles.find((r) => r.value === formData.role);
    const pin =
      formData.pin ||
      (formData.role === "recepcion"
        ? "1111"
        : formData.role === "especialista"
        ? "2222"
        : formData.role === "manager"
        ? "3333"
        : "4444");
    
    if (editingUser) {
      const updated = users.map((u) =>
        u.id === editingUser.id
          ? { ...u, ...formData, pin, label: roleInfo.label, password: formData.password || u.password }
          : u
      );
      setUsers(updated);
      const userToSave = updated.find(u => u.id === editingUser.id);
      if (userToSave && userToSave.id !== "admin1") {
        await saveUserToFirestore(userToSave);
      }
      alert(`Usuario ${formData.nombreCompleto} actualizado correctamente`);
    } else {
      const newUser = {
        id: Date.now().toString(),
        nombreCompleto: formData.nombreCompleto,
        username: formData.username,
        role: formData.role,
        nivel: formData.role === "especialista" ? (formData.nivel || 1) : null,
        pin: pin,
        password: "1234",
        label: roleInfo.label,
        activo: true,
      };
      const updatedUsers = [...users, newUser];
      setUsers(updatedUsers);
      await saveUserToFirestore(newUser);
      alert(`Usuario ${formData.nombreCompleto} creado. Contraseña por defecto: 1234`);
    }
    setShowForm(false);
    setEditingUser(null);
    setFormData({
      nombreCompleto: "",
      username: "",
      role: "recepcion",
      pin: "",
      password: "",
    });
    setPasswordError("");
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setFormData({
      nombreCompleto: user.nombreCompleto,
      username: user.username,
      role: user.role,
      nivel: user.nivel || 1,
      pin: user.pin || "",
      password: "",
    });
    setShowForm(true);
  };
  
  const handleDeactivate = async (user) => {
    if (user.username === "admin")
      return alert("No se puede desactivar al administrador principal");
    if (window.confirm(`¿${user.activo ? "Desactivar" : "Activar"} a ${user.nombreCompleto}?`)) {
      const updated = users.map((u) =>
        u.id === user.id ? { ...u, activo: !u.activo } : u
      );
      setUsers(updated);
      if (user.id !== "admin1") {
        await saveUserToFirestore(updated.find(u => u.id === user.id));
      }
      alert(`Usuario ${user.nombreCompleto} ${user.activo ? "desactivado" : "activado"} correctamente`);
    }
  };
  
  const handleReset = async (user) => {
    if (window.confirm(`Resetear contraseña de ${user.nombreCompleto} a "1234"?`)) {
      const updated = users.map((u) =>
        u.id === user.id ? { ...u, password: "1234" } : u
      );
      setUsers(updated);
      if (user.id !== "admin1") {
        await saveUserToFirestore(updated.find(u => u.id === user.id));
      }
      alert(`Contraseña restablecida a 1234 para ${user.nombreCompleto}`);
    }
  };

  const activeUsers = users.filter((u) => u.activo !== false);
  const inactiveUsers = users.filter((u) => u.activo === false && u.username !== "admin");

  return React.createElement(
    "div",
    null,
    React.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
        },
      },
      React.createElement(
        "h2",
        {
          style: {
            fontSize: "1.5rem",
            color: colors.gold.dark,
            fontFamily: "Georgia, serif",
          },
        },
        "Usuarios"
      ),
      canManageUsers &&
        React.createElement(
          "button",
          {
            onClick: () => {
              setEditingUser(null);
              setFormData({
                nombreCompleto: "",
                username: "",
                role: "recepcion",
                pin: "",
                password: "",
              });
              setPasswordError("");
              setShowForm(true);
            },
            style: styles.button,
          },
          "+ Nuevo"
        )
    ),
    showForm &&
      React.createElement(
        "div",
        { style: { ...styles.card, marginBottom: "1rem" } },
        React.createElement(
          "h3",
          null,
          editingUser ? "Editar Usuario" : "Nuevo Usuario"
        ),
        React.createElement(Field, {
          labelText: "Nombre completo",
          value: formData.nombreCompleto,
          onChange: (v) => setFormData({ ...formData, nombreCompleto: v }),
        }),
        React.createElement(Field, {
          labelText: "Usuario",
          value: formData.username,
          onChange: (v) => setFormData({ ...formData, username: v }),
        }),
        React.createElement(SelectField, {
          labelText: "Rol",
          value: formData.role,
          onChange: (v) => setFormData({ ...formData, role: v }),
          options: roles.map((r) => r.value),
        }),
        formData.role === "especialista" && React.createElement(
          "div", { style: { marginBottom: "1rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Nivel de acceso"),
          React.createElement("select", {
            style: styles.input,
            value: formData.nivel || 1,
            onChange: e => setFormData({ ...formData, nivel: parseInt(e.target.value) }),
          },
            React.createElement("option", { value: 1 }, "Nivel 1 — Acceso completo (puede ver Reportes)"),
            React.createElement("option", { value: 2 }, "Nivel 2 — Acceso limitado (no puede ver Reportes)"),
          )
        ),
        React.createElement(Field, {
          labelText: "PIN (opcional)",
          value: formData.pin,
          onChange: (v) =>
            setFormData({ ...formData, pin: onlyNumbers(v).slice(0, 4) }),
          placeholder: "4 dígitos",
        }),
        !editingUser &&
          React.createElement(Field, {
            labelText: "Contraseña inicial",
            value: formData.password,
            onChange: (v) => setFormData({ ...formData, password: v }),
            type: "password",
            placeholder: "Debe ser 1234",
          }),
        passwordError &&
          React.createElement(
            "div",
            { style: { color: colors.accent.danger, marginBottom: "1rem", fontSize: "0.875rem" } },
            passwordError
          ),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
              marginTop: "1rem",
            },
          },
          React.createElement(
            "button",
            {
              onClick: () => {
                setShowForm(false);
                setEditingUser(null);
                setPasswordError("");
              },
              style: styles.buttonOutline,
            },
            "Cancelar"
          ),
          React.createElement(
            "button",
            { onClick: handleSave, style: styles.buttonSuccess },
            "Guardar"
          )
        )
      ),
    React.createElement(
      "div",
      { style: styles.card },
      React.createElement(
        "h3",
        { style: { fontSize: "1.1rem", marginBottom: "0.75rem", color: colors.gold.dark } },
        "Usuarios Activos"
      ),
      isMobile
        ? React.createElement(
            "div",
            { style: { display: "flex", flexDirection: "column", gap: "0.75rem" } },
            activeUsers.map((user) =>
              React.createElement(
                "div",
                {
                  key: user.id,
                  style: {
                    border: `1px solid ${colors.gold.light}`,
                    borderRadius: "0.75rem",
                    padding: "0.875rem",
                    backgroundColor: colors.light.secondary,
                  },
                },
                React.createElement(
                  "div",
                  {
                    style: {
                      fontWeight: "bold",
                      color: colors.gold.dark,
                      fontSize: "1rem",
                      marginBottom: "0.25rem",
                    },
                  },
                  user.nombreCompleto
                ),
                React.createElement(
                  "div",
                  {
                    style: {
                      fontSize: "0.8rem",
                      color: colors.gray.text,
                      marginBottom: "0.125rem",
                    },
                  },
                  "👤 ",
                  user.username
                ),
                React.createElement(
                  "div",
                  {
                    style: {
                      fontSize: "0.8rem",
                      color: colors.gray.text,
                      marginBottom: "0.75rem",
                    },
                  },
                  "🏷️ ",
                  roleLabels[user.role] || user.label,
                  user.role === "especialista" && ` (Nivel ${user.nivel || 1})`
                ),
                React.createElement(
                  "div",
                  {
                    style: {
                      display: "flex",
                      gap: "0.5rem",
                      flexWrap: "wrap",
                    },
                  },
                  canManageUsers &&
                    React.createElement(
                      "button",
                      {
                        onClick: () => handleEdit(user),
                        style: {
                          ...styles.buttonOutline,
                          padding: "0.4rem 0.875rem",
                          fontSize: "0.8rem",
                          flex: 1,
                        },
                      },
                      "✏️ Editar"
                    ),
                  user.username !== "admin" &&
                    React.createElement(
                      "button",
                      {
                        onClick: () => handleReset(user),
                        style: {
                          ...styles.buttonOutline,
                          padding: "0.4rem 0.875rem",
                          fontSize: "0.8rem",
                          flex: 1,
                        },
                      },
                      "🔑 Reset"
                    ),
                  canManageUsers && user.username !== "admin" &&
                    React.createElement(
                      "button",
                      {
                        onClick: () => handleDeactivate(user),
                        style: {
                          ...styles.buttonDanger,
                          padding: "0.4rem 0.875rem",
                          fontSize: "0.8rem",
                          flex: 1,
                        },
                      },
                      user.activo ? "Desactivar" : "Activar"
                    )
                )
              )
            )
          )
        : React.createElement(
            "table",
            { style: { width: "100%", borderCollapse: "collapse" } },
            React.createElement(
              "thead",
              null,
              React.createElement(
                "tr",
                { style: { borderBottom: `2px solid ${colors.gold.primary}` } },
                React.createElement(
                  "th",
                  { style: { textAlign: "left", padding: "0.75rem", color: colors.gold.dark } },
                  "Nombre"
                ),
                React.createElement(
                  "th",
                  { style: { textAlign: "left", padding: "0.75rem", color: colors.gold.dark } },
                  "Usuario"
                ),
                React.createElement(
                  "th",
                  { style: { textAlign: "left", padding: "0.75rem", color: colors.gold.dark } },
                  "Rol"
                ),
                React.createElement(
                  "th",
                  { style: { textAlign: "left", padding: "0.75rem", color: colors.gold.dark } },
                  "Estado"
                ),
                React.createElement(
                  "th",
                  { style: { textAlign: "left", padding: "0.75rem", color: colors.gold.dark } },
                  "Acciones"
                )
              )
            ),
            React.createElement(
              "tbody",
              null,
              activeUsers.map((user) =>
                React.createElement(
                  "tr",
                  {
                    key: user.id,
                    style: { borderBottom: `1px solid ${colors.gray.warm}` },
                  },
                  React.createElement(
                    "td",
                    { style: { padding: "0.75rem" } },
                    user.nombreCompleto
                  ),
                  React.createElement(
                    "td",
                    { style: { padding: "0.75rem" } },
                    user.username
                  ),
                  React.createElement(
                    "td",
                    { style: { padding: "0.75rem" } },
                    roleLabels[user.role] || user.label
                  ),
                  React.createElement(
                    "td",
                    { style: { padding: "0.75rem" } },
                    React.createElement(
                      "span",
                      { style: { ...styles.badge, backgroundColor: colors.accent.successLight, color: colors.accent.success } },
                      "Activo"
                    )
                  ),
                  React.createElement(
                    "td",
                    { style: { padding: "0.75rem" } },
                    React.createElement(
                      "button",
                      {
                        onClick: () => handleEdit(user),
                        style: {
                          ...styles.buttonOutline,
                          padding: "0.25rem 0.5rem",
                          fontSize: "0.75rem",
                          marginRight: "0.5rem",
                        },
                      },
                      "Editar"
                    ),
                    user.username !== "admin" &&
                      React.createElement(
                        "button",
                        {
                          onClick: () => handleReset(user),
                          style: {
                            ...styles.buttonOutline,
                            padding: "0.25rem 0.5rem",
                            fontSize: "0.75rem",
                            marginRight: "0.5rem",
                          },
                        },
                        "Reset"
                      ),
                    canManageUsers && user.username !== "admin" &&
                      React.createElement(
                        "button",
                        {
                          onClick: () => handleDeactivate(user),
                          style: { ...styles.buttonDanger, marginRight: "0.5rem" },
                        },
                        "Desactivar"
                      )
                  )
                )
              )
            )
          )
      ),
      inactiveUsers.length > 0 &&
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            "h3",
            { style: { fontSize: "1.1rem", marginTop: "1.5rem", marginBottom: "0.75rem", color: colors.gray.text } },
            "Usuarios Inactivos"
          ),
          isMobile
            ? React.createElement(
                "div",
                { style: { display: "flex", flexDirection: "column", gap: "0.75rem" } },
                inactiveUsers.map((user) =>
                  React.createElement(
                    "div",
                    {
                      key: user.id,
                      style: {
                        border: `1px solid ${colors.gray.medium}`,
                        borderRadius: "0.75rem",
                        padding: "0.875rem",
                        backgroundColor: colors.gray.light,
                        opacity: 0.7,
                      },
                    },
                    React.createElement(
                      "div",
                      {
                        style: {
                          fontWeight: "bold",
                          color: colors.gray.text,
                          fontSize: "1rem",
                          marginBottom: "0.25rem",
                        },
                      },
                      user.nombreCompleto
                    ),
                    React.createElement(
                      "div",
                      {
                        style: {
                          fontSize: "0.8rem",
                          color: colors.gray.text,
                          marginBottom: "0.125rem",
                        },
                      },
                      "👤 ",
                      user.username
                    ),
                    React.createElement(
                      "div",
                      {
                        style: {
                          fontSize: "0.8rem",
                          color: colors.gray.text,
                          marginBottom: "0.75rem",
                        },
                      },
                      "🏷️ ",
                      roleLabels[user.role] || user.label
                    ),
                    React.createElement(
                      "button",
                      {
                        onClick: () => handleDeactivate(user),
                        style: {
                          ...styles.buttonSuccess,
                          padding: "0.4rem 0.875rem",
                          fontSize: "0.8rem",
                          width: "100%",
                        },
                      },
                      "Activar"
                    )
                  )
                )
              )
            : React.createElement(
                "table",
                { style: { width: "100%", borderCollapse: "collapse", marginTop: "0.5rem" } },
                React.createElement(
                  "thead",
                  null,
                  React.createElement(
                    "tr",
                    { style: { borderBottom: `1px solid ${colors.gray.medium}` } },
                    React.createElement(
                      "th",
                      { style: { textAlign: "left", padding: "0.75rem", color: colors.gray.text } },
                      "Nombre"
                    ),
                    React.createElement(
                      "th",
                      { style: { textAlign: "left", padding: "0.75rem", color: colors.gray.text } },
                      "Usuario"
                    ),
                    React.createElement(
                      "th",
                      { style: { textAlign: "left", padding: "0.75rem", color: colors.gray.text } },
                      "Rol"
                    ),
                    React.createElement(
                      "th",
                      { style: { textAlign: "left", padding: "0.75rem", color: colors.gray.text } },
                      "Acciones"
                    )
                  )
                ),
                React.createElement(
                  "tbody",
                  null,
                  inactiveUsers.map((user) =>
                    React.createElement(
                      "tr",
                      {
                        key: user.id,
                        style: { borderBottom: `1px solid ${colors.gray.warm}`, opacity: 0.7 },
                      },
                      React.createElement(
                        "td",
                        { style: { padding: "0.75rem", color: colors.gray.text } },
                        user.nombreCompleto
                      ),
                      React.createElement(
                        "td",
                        { style: { padding: "0.75rem", color: colors.gray.text } },
                        user.username
                      ),
                      React.createElement(
                        "td",
                        { style: { padding: "0.75rem", color: colors.gray.text } },
                        roleLabels[user.role] || user.label
                      ),
                      React.createElement(
                        "td",
                        { style: { padding: "0.75rem" } },
                        React.createElement(
                          "button",
                          {
                            onClick: () => handleDeactivate(user),
                            style: styles.buttonSuccess,
                          },
                          "Activar"
                        )
                      )
                    )
                  )
                )
              )
        )
    )
}

function PrintForm({ record, onClose }) {
  // The signature is lazy-loaded (stripped from the bulk list for speed),
  // so fetch it here before printing.
  const [loadedSig, setLoadedSig] = useState(record.form?.firmaCliente || "");
  useEffect(() => {
    let alive = true;
    if (!record.form?.firmaCliente && record.form?._hasFirma) {
      fetchSignature(record.id).then(s => { if (alive) setLoadedSig(s); });
    }
    return () => { alive = false; };
  }, [record.id, record.form]);
  const form = { ...record.form, firmaCliente: loadedSig || record.form?.firmaCliente || "" };
  const fechaRegistro = formatDateCR(record.createdAt?.slice(0, 10));

  useEffect(() => {
    const id = "nila-print-styles";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      @media print {
        body * {
          visibility: hidden !important;
        }
        
        .nila-print-overlay,
        .nila-print-overlay *,
        .print-container,
        .print-container * {
          visibility: visible !important;
        }
        
        .nila-print-overlay {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: auto !important;
          background: white !important;
          padding: 0 !important;
          margin: 0 !important;
          overflow: visible !important;
        }
        
        .nila-print-modal-shell {
          box-shadow: none !important;
          border-radius: 0 !important;
          padding: 0 !important;
          margin: 0 !important;
          max-width: none !important;
        }
        
        .nila-print-toolbar {
          display: none !important;
        }
        
        @page {
          size: letter;
          margin: 0.5in;
        }
        
        .registration-page,
        .consent-page {
          display: block !important;
          margin: 0 !important;
          padding: 0 !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }
        
        .registration-page {
          page-break-after: always !important;
          break-after: page !important;
        }
        
        .consent-page {
          page-break-before: always !important;
          break-before: page !important;
        }
        
        .print-container {
          display: block !important;
          width: 100% !important;
          max-width: 100% !important;
        }
        
        .print-section,
        .print-header,
        .print-consent {
          max-width: 100% !important;
          overflow-wrap: break-word !important;
          word-wrap: break-word !important;
        }
        
        .print-container div,
        .print-container span,
        .print-container p {
          color: black !important;
        }
        
        .print-row {
          border-bottom: 1px solid #ccc !important;
        }
        
        .print-section-title {
          border-bottom: 1px solid #000 !important;
        }
        
        .print-signature-line {
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid #000;
        }
        
        .print-signature-section {
          page-break-inside: avoid !important;
          break-inside: avoid !important;
          page-break-before: auto !important;
          break-before: auto !important;
        }
        
        .print-title {
          font-size: 18pt !important;
        }
        
        .print-section-title {
          font-size: 14pt !important;
        }
        
        .print-label,
        .print-value {
          font-size: 12pt !important;
        }
        
        .print-consent {
          font-size: 11pt !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => { const el = document.getElementById(id); if (el) el.remove(); };
  }, []);

  const condicionesMedicas = form.medical?.join(", ") || "Ninguna";

  let tratamientoDetalle = "";
  if (form.treatmentType === "Facial") {
    tratamientoDetalle = form.facialText || "No especificado";
  } else if (form.treatmentType === "Corporal") {
    if (form.bodyCategory === "Moldeo corporal") {
      tratamientoDetalle = `Moldeo corporal: ${form.moldeoText || "No especificado"}`;
    } else if (form.bodyCategory === "Depilación láser") {
      tratamientoDetalle = `Depilación láser: ${form.laserText || "No especificado"}`;
    } else if (form.bodyCategory === "Depilación con cera") {
      tratamientoDetalle = `Depilación con cera: ${form.ceraText || "No especificado"}`;
    } else if (form.bodyCategory === "Masajes") {
      tratamientoDetalle = `Masajes: ${form.massageText || "No especificado"}`;
    } else {
      tratamientoDetalle = form.bodyCategory || "No seleccionado";
    }
  } else if (form.treatmentType === "Pestañas/Cejas") {
    if (form.lashBrowCategory === "Pestañas") {
      tratamientoDetalle = `Pestañas: ${form.pestanasText || "No especificado"}`;
    } else if (form.lashBrowCategory === "Cejas") {
      tratamientoDetalle = `Cejas: ${form.cejasText || "No especificado"}`;
    } else if (form.lashBrowCategory === "Paquete") {
      tratamientoDetalle = `Paquete Pestañas/Cejas: ${form.paquetePCText || "No especificado"}`;
    } else {
      tratamientoDetalle = form.lashBrowCategory || "No seleccionado";
    }
  } else if (form.treatmentType === "Ambos") {
    const parts = [];
    if (form.facialText) parts.push(`Facial: ${form.facialText}`);
    if (form.bodyCategory) {
      if (form.bodyCategory === "Moldeo corporal" && form.moldeoText)
        parts.push(`Moldeo corporal: ${form.moldeoText}`);
      else if (form.bodyCategory === "Depilación láser" && form.laserText)
        parts.push(`Depilación láser: ${form.laserText}`);
      else if (form.bodyCategory === "Depilación con cera" && form.ceraText)
        parts.push(`Depilación con cera: ${form.ceraText}`);
      else if (form.bodyCategory === "Masajes" && form.massageText)
        parts.push(`Masajes: ${form.massageText}`);
      else
        parts.push(form.bodyCategory);
    }
    tratamientoDetalle = parts.join(" | ") || "No especificado";
  }

  return React.createElement(
    "div",
    {
      className: "nila-print-overlay",
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: 2000,
        overflow: "auto",
        padding: "2rem",
      },
    },
    React.createElement(
      "div",
      {
        className: "nila-print-modal-shell",
        style: {
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "1rem",
          boxShadow: "0 25px 50px rgba(0,0,0,0.3)",
        },
      },
      React.createElement(
        "div",
        {
          className: "nila-print-toolbar",
          style: {
            padding: "1rem",
            borderBottom: "1px solid #eee",
            display: "flex",
            justifyContent: "flex-end",
          },
        },
        React.createElement(
          "button",
          {
            onClick: onClose,
            style: { ...styles.buttonDanger, padding: "0.5rem 1rem" },
          },
          "Cerrar"
        ),
        React.createElement(
          "button",
          {
            onClick: () => window.print(),
            style: {
              ...styles.button,
              marginLeft: "1rem",
              padding: "0.5rem 1rem",
            },
          },
          "🖨️ Imprimir"
        )
      ),

      React.createElement(
        "div",
        { className: "print-container" },

      React.createElement(
        "div",
        { className: "registration-page", style: styles.printPage },
        React.createElement(
          "div",
          { style: styles.printHeader },
          React.createElement("div", { style: styles.printTitle }, BRAND.name),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            BRAND.subtitle
          ),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            "Fecha de registro: ",
            fechaRegistro
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "📋 INFORMACIÓN PERSONAL"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Nombre completo:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.nombre || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Cédula:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.cedula || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Fecha de nacimiento:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              formatDateCR(form.fechaNacimiento) || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Edad:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.edad || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Género:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.genero || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Teléfono:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.telefono || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Correo electrónico:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.correo || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Profesión:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.profesion || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Dirección:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.direccion || "—"
            )
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "🚨 CONTACTO DE EMERGENCIA"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Nombre:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaNombre || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Teléfono:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaTelefono || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Correo electrónico:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaCorreo || "—"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Relación:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.emergenciaRelacion || "—"
            )
          )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "💆‍♀️ TRATAMIENTO SELECCIONADO"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Tipo de tratamiento:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.treatmentType || "No seleccionado"
            )
          ),
          form.bodyCategory &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "Categoría corporal:"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.bodyCategory
              )
            ),
          tratamientoDetalle &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "Detalle:"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                tratamientoDetalle
              )
            )
        ),

        React.createElement(
          "div",
          { style: styles.printSection },
          React.createElement(
            "div",
            { style: styles.printSectionTitle },
            "🩺 INFORMACIÓN MÉDICA"
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Condiciones médicas:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              condicionesMedicas
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Medicamentos actuales:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.medicamentosActuales || "No especifica"
            )
          ),
          form.medicamentosActuales === "Sí" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "¿Cuáles?"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.medicamentosCuales || "—"
              )
            ),
          form.genero === "Femenino" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "Anticonceptivos:"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.anticonceptivos || "No especifica"
              )
            ),
          form.genero === "Femenino" &&
            form.anticonceptivos === "Sí" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "¿Qué tipo?"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.anticonceptivosCuales || "—"
              )
            ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Tipo de piel:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.tipoPiel || "No especifica"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Alergias:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.alergiasProductos || "Ninguna"
            )
          ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Procedimientos estéticos recientes:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.procedimientosRecientes || "No"
            )
          ),
          form.procedimientosRecientes === "Sí" &&
            React.createElement(
              "div",
              { style: styles.printRow },
              React.createElement(
                "div",
                { style: styles.printLabel },
                "¿Cuáles?"
              ),
              React.createElement(
                "div",
                { style: styles.printValue },
                form.procedimientosRecientesCuales || "—"
              )
            ),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement(
              "div",
              { style: styles.printLabel },
              "Autoriza uso de imagen:"
            ),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.autorizaImagen === "Sí"
                ? "✓ Sí"
                : form.autorizaImagen === "No"
                ? "✗ No"
                : "No especifica"
            )
          )
        ),

        React.createElement(
          "div",
          { className: "print-signature-section", style: styles.printSection },
          React.createElement("div", { style: styles.printSectionTitle }, "✍️ FIRMA DEL CLIENTE"),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Firma del cliente:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.firmaCliente && form.firmaCliente.startsWith("data:image")
                ? React.createElement("img", {
                    src: form.firmaCliente,
                    alt: "Firma",
                    style: { maxHeight: "80px", border: "1px solid #ccc", padding: "0.25rem", borderRadius: "4px" },
                  })
                : form.firmaCliente || "No firmado"
            )
          )
        ),
        
        React.createElement(
          "div",
          { className: "print-signature-section", style: styles.printSection },
          React.createElement("div", { style: styles.printSectionTitle }, "✍️ CONSENTIMIENTO INFORMADO"),
          React.createElement(
            "div",
            { style: styles.printRow },
            React.createElement("div", { style: styles.printLabel }, "Aceptó el consentimiento:"),
            React.createElement(
              "div",
              { style: styles.printValue },
              form.aceptaConsentimiento ? "✓ Sí, aceptado" : "✗ No"
            )
          )
        )
      ),

      React.createElement(
        "div",
        { className: "consent-page", style: { ...styles.printPage, pageBreakBefore: "always", breakBefore: "page" } },
        React.createElement(
          "div",
          { style: styles.printHeader },
          React.createElement(
            "div",
            { style: styles.printTitle },
            "CONSENTIMIENTO INFORMADO"
          ),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            BRAND.name
          ),
          React.createElement(
            "div",
            { style: styles.printSubtitle },
            "Fecha: ",
            fechaRegistro
          )
        ),
        React.createElement(
          "div",
          { style: styles.printConsent },
          React.createElement(
            "div",
            {
              style: {
                fontWeight: "bold",
                marginBottom: "0.5rem",
                color: colors.gold.dark,
              },
            },
            "Procedimiento"
          ),
          React.createElement(
            "div",
            { style: { marginBottom: "1rem" } },
            treatmentProcedureText.es
          ),
          consentBody.es.split("\n").map((line, i) => {
            if (
              line.startsWith("Información importante") ||
              line.startsWith("Riesgos") ||
              line.startsWith("Recomendaciones") ||
              line.startsWith("Declaración")
            ) {
              return React.createElement(
                "div",
                {
                  key: i,
                  style: {
                    fontWeight: "bold",
                    marginTop: "0.75rem",
                    marginBottom: "0.25rem",
                    color: colors.gold.dark,
                  },
                },
                line
              );
            }
            if (line.trim() === "")
              return React.createElement("div", {
                key: i,
                style: { height: "0.5rem" },
              });
            return React.createElement("div", { key: i }, line);
          })
        ),
        React.createElement(
          "div",
          { style: styles.printSignature },
          form.firmaCliente && form.firmaCliente.startsWith("data:image")
            ? React.createElement(React.Fragment, null,
                React.createElement("div", { style: { marginBottom: "0.25rem", fontSize: "0.85rem", color: "#555" } }, "Firma del cliente:"),
                React.createElement("img", {
                  src: form.firmaCliente,
                  alt: "Firma del cliente",
                  style: { maxHeight: "80px", border: "1px solid #ccc", padding: "0.25rem", borderRadius: "4px", backgroundColor: "white", display: "block", marginBottom: "0.25rem" },
                }),
                React.createElement("div", { style: { fontSize: "0.85rem" } }, form.nombre || "Cliente")
              )
            : React.createElement(React.Fragment, null,
                React.createElement("div", null, "_______________________________"),
                React.createElement("div", null, "Firma del cliente")
              ),
          React.createElement(
            "div",
            { style: { marginTop: "1.5rem" } },
            "_______________________________"
          ),
          React.createElement("div", null, "Firma del especialista")
        )
      )
      )
    )
  );
}

function InfoRow({ label, value }) {
  const isMobile = useIsMobile();
  return React.createElement(
    "div",
    { 
      style: { 
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        padding: "0.75rem 0",
        borderBottom: `1px solid ${colors.gray.warm}`,
        width: "100%"
      } 
    },
    React.createElement(
      "div", 
      { 
        style: { 
          fontWeight: "500", 
          color: colors.gold.dark,
          width: isMobile ? "100%" : "180px",
          marginBottom: isMobile ? "0.25rem" : 0,
          flexShrink: 0
        } 
      }, 
      label, ":"
    ),
    React.createElement(
      "div", 
      { 
        style: { 
          flex: 1, 
          color: colors.dark.primary,
          wordBreak: "break-word",
          fontWeight: "400"
        } 
      }, 
      value || "—"
    )
  );
}

function IvaModal({ onClose, onConfirm, title, message }) {
  return React.createElement(
    "div",
    { style: styles.modalOverlay },
    React.createElement(
      "div",
      { style: styles.modalContainer },
      React.createElement(
        "div",
        { style: styles.modalTitle },
        title || "¿El precio incluye IVA?"
      ),
      React.createElement(
        "p",
        { style: { marginBottom: "1rem", color: colors.gray.text } },
        message || "Seleccione una opción:"
      ),
      React.createElement(
        "div",
        { style: styles.modalButtons },
        React.createElement(
          "button",
          {
            onClick: () => onConfirm(true),
            style: { ...styles.buttonSuccess, padding: "0.5rem 1rem" },
          },
          "✓ Sí, incluye IVA"
        ),
        React.createElement(
          "button",
          {
            onClick: () => onConfirm(false),
            style: { ...styles.buttonDanger, padding: "0.5rem 1rem" },
          },
          "✗ No, no incluye IVA"
        )
      )
    )
  );
}

// ========== PAYMENT MODULE ==========

const PAYMENT_METHODS = ["Efectivo", "SINPE", "SINPE (Jacky)", "Tarjeta de crédito", "Tarjeta de Regalo", "Yuplon"];
const PAYMENT_TYPES = [
  { value: "completo", label: "💰 Pago completo", flag: null },
  { value: "deposito", label: "🔐 Depósito + saldo", flag: null },
  { value: "por_sesion", label: "📅 Por sesión", flag: "💳 Pago por sesión activo" },
  { value: "semanal", label: "🗓️ Plan semanal", flag: "📆 Plan de pago activo" },
  { value: "quincenal", label: "🗓️ Plan quincenal", flag: "📆 Plan de pago activo" },
  { value: "mensual", label: "🗓️ Plan mensual", flag: "📆 Plan de pago activo" },
  { value: "personalizado", label: "✏️ Arreglo personalizado", flag: "📆 Plan de pago activo" },
  { value: "tarjeta_regalo", label: "🎁 Tarjeta de Regalo", flag: null },
  { value: "yuplon", label: "🟡 Yuplon", flag: null },
  { value: "deposito_adelantado", label: "🔗 Aplicar depósito adelantado", flag: null },
];

// Helper — returns flag text if record has an active payment plan
function getPaymentPlanFlag(record) {
  const plans = [];
  const tp = record.treatmentPlan;
  if (tp?.paymentInfo?.paymentType) {
    const pt = PAYMENT_TYPES.find(p => p.value === tp.paymentInfo.paymentType);
    if (pt?.flag) plans.push(pt.flag);
  }
  (record.additionalTreatments || []).forEach(at => {
    if (at.paymentInfo?.paymentType) {
      const pt = PAYMENT_TYPES.find(p => p.value === at.paymentInfo.paymentType);
      if (pt?.flag && !plans.includes(pt.flag)) plans.push(pt.flag);
    }
  });
  // Check for payment pending (por_sesion with unpaid sessions)
  const hasSessionPending = (record.paymentPending || []).length > 0;
  if (hasSessionPending) plans.push("⚠️ Pago sesión pendiente");
  return plans;
}

function generatePaymentSchedule(totalPrice, installmentAmount, frequency, startDate) {
  const schedule = [];
  const numPayments = Math.ceil(totalPrice / installmentAmount);
  let currentDate = new Date(startDate + "T12:00:00");
  for (let i = 0; i < numPayments; i++) {
    const remaining = totalPrice - installmentAmount * i;
    const amount = Math.min(installmentAmount, remaining);
    schedule.push({
      id: `inst_${Date.now()}_${i}`,
      number: i + 1,
      dueDate: currentDate.toISOString().slice(0, 10),
      amount: amount,
      status: "pendiente",
      paidAt: null,
      paidAmount: null,
      paymentMethod: null,
      collectedBy: null,
    });
    if (frequency === "semanal") currentDate = new Date(currentDate.getTime() + 7 * 86400000);
    else if (frequency === "quincenal") currentDate = new Date(currentDate.getTime() + 14 * 86400000);
    else if (frequency === "mensual") {
      const next = new Date(currentDate);
      next.setMonth(next.getMonth() + 1);
      currentDate = next;
    }
  }
  return schedule;
}

// Modal to capture payment setup when creating a treatment
function PaymentSetupModal({ totalPrice, onClose, onSave }) {
  const [paymentType, setPaymentType] = useState("completo");
  const [depositAmount, setDepositAmount] = useState("");
  const [installmentAmount, setInstallmentAmount] = useState("");
  const [amountPerSession, setAmountPerSession] = useState("");
  const [nextPaymentDate, setNextPaymentDate] = useState(new Date().toISOString().slice(0, 10));
  const [planNotes, setPlanNotes] = useState("");
  const [customArrangement, setCustomArrangement] = useState("");
  const [error, setError] = useState("");
  // Tarjeta de Regalo fields
  const [depositMethod, setDepositMethod] = useState("");
  const [depositDate, setDepositDate] = useState(new Date().toISOString().slice(0, 10));
  // Stage 2: active gift cards for redemption dropdown
  const [activeGiftCards, setActiveGiftCards] = useState([]);
  const [selectedGiftCardId, setSelectedGiftCardId] = useState("");
  useEffect(() => {
    loadGiftCardsFromFirestore()
      .then(cards => setActiveGiftCards(cards.filter(c => c.status === "activa" && (c.remainingBalance || 0) > 0)))
      .catch(() => {});
  }, []);
  const selectedGiftCard = activeGiftCards.find(c => c.id === selectedGiftCardId) || null;
  // How much the card covers and what remains for the client to pay
  const gcBalance = selectedGiftCard ? (selectedGiftCard.remainingBalance || 0) : 0;
  const gcIsTypeA = selectedGiftCard ? selectedGiftCard.type === "tratamiento" : false;
  // Type A (specific treatment): card covers the full treatment regardless of price. Client owes ₡0.
  // Type B (fixed amount): money-vs-money balance math.
  const gcCovers = gcIsTypeA ? totalPrice : Math.min(gcBalance, totalPrice);
  const gcClientOwes = gcIsTypeA ? 0 : Math.max(0, totalPrice - gcBalance);
  const gcLeftoverOnCard = gcIsTypeA ? 0 : Math.max(0, gcBalance - totalPrice);
  // Depósito adelantado (pre-registration) — pending deposits for selection
  const [pendingDeposits, setPendingDeposits] = useState([]);
  const [selectedDepositId, setSelectedDepositId] = useState("");
  useEffect(() => {
    loadDepositosFromFirestore()
      .then(list => setPendingDeposits(list.filter(d => d.estado !== "aplicado")))
      .catch(() => {});
  }, []);
  const selectedDeposit = pendingDeposits.find(d => d.id === selectedDepositId) || null;
  // Deposit already collected earlier (already counted as revenue on its own date).
  const depApplied = selectedDeposit ? (selectedDeposit.montoDeposito || 0) : 0;
  const depRemaining = selectedDeposit ? Math.max(0, totalPrice - depApplied) : 0;
  // Yuplon fields
  const [yuplonRef, setYuplonRef] = useState("");
  const [yuplonOfferPrice, setYuplonOfferPrice] = useState("");
  const [yuplonDate, setYuplonDate] = useState(new Date().toISOString().slice(0, 10));

  const isInstallmentPlan = ["semanal","quincenal","mensual","personalizado"].includes(paymentType);
  const depositNum = parseFloat(depositAmount) || 0;
  const remaining = Math.max(0, totalPrice - depositNum);

  const handleSave = () => {
    setError("");
    if (!paymentType) return setError("Seleccione un tipo de pago");
    if (paymentType === "deposito") {
      if (!depositNum || depositNum <= 0) return setError("Ingrese el monto del depósito inicial");
      if (depositNum >= totalPrice) return setError("El depósito no puede ser igual o mayor al total. Use Pago completo.");
      if (!depositMethod) return setError("Seleccione el método de pago del depósito");
    }
    if (paymentType === "por_sesion" && !amountPerSession) return setError("Ingrese el monto acordado por sesión");
    if (isInstallmentPlan && !installmentAmount) return setError("Ingrese el monto por cuota");
    if (paymentType === "personalizado" && !customArrangement.trim()) return setError("Describa el arreglo personalizado");
    if (paymentType === "tarjeta_regalo") {
      if (!selectedGiftCardId) return setError("Seleccione una tarjeta de regalo activa de la lista");
      if (!selectedGiftCard) return setError("La tarjeta seleccionada ya no está disponible");
    }
    if (paymentType === "yuplon") {
      if (!yuplonRef.trim()) return setError("Ingrese el número de voucher de Yuplon");
      if (!yuplonOfferPrice || parseFloat(yuplonOfferPrice) <= 0) return setError("Ingrese el precio de oferta de Yuplon");
    }
    if (paymentType === "deposito_adelantado") {
      if (!selectedDepositId) return setError("Seleccione el depósito adelantado de la lista");
      if (!selectedDeposit) return setError("El depósito seleccionado ya no está disponible");
    }

    let schedule = [];
    if (["semanal","quincenal","mensual"].includes(paymentType) && installmentAmount) {
      schedule = generatePaymentSchedule(totalPrice, parseFloat(installmentAmount), paymentType, nextPaymentDate);
    }

    
    // Yuplon calculations — formula confirmed
    const yuplonOffer = parseFloat(yuplonOfferPrice) || 0;
    const yuplonComision = Math.round(yuplonOffer * 0.20);
    const yuplonIVAComision = Math.round(yuplonComision * 0.13);
    const yuplonComercio = yuplonOffer - yuplonComision - yuplonIVAComision;
    const yuplonIVANila = Math.round(yuplonComercio * 0.13);       // IVA 13% sobre % Comercio
    const yuplonRetBACRenta = Math.round(yuplonOffer * 0.0176);
    const yuplonRetBACIVA = Math.round(yuplonOffer * 0.0531);
    const yuplonGanancia = yuplonComercio - yuplonIVANila - yuplonRetBACRenta - yuplonRetBACIVA;

    const autoPayment = paymentType === "tarjeta_regalo" ? [{
      id: `pay_${Date.now()}`,
      amount: gcCovers,
      method: "Tarjeta de Regalo",
      date: new Date().toISOString().slice(0, 10),
      at: new Date().toISOString(),
      type: "upfront",
      reference: selectedGiftCard ? selectedGiftCard.cardNumber : "",
      giftCardId: selectedGiftCardId,
      giftCardRef: selectedGiftCard ? selectedGiftCard.cardNumber : "",
      giftCardPurchasedBy: selectedGiftCard ? selectedGiftCard.buyerName : "",
      giftCardRecipient: selectedGiftCard ? selectedGiftCard.recipientName : "",
    }] : paymentType === "yuplon" ? [{
      id: `pay_${Date.now()}`,
      amount: yuplonGanancia,
      method: "Yuplon",
      date: yuplonDate,
      at: new Date().toISOString(),
      type: "upfront",
      reference: yuplonRef.trim(),
      yuplonRef: yuplonRef.trim(),
      yuplonOfferPrice: yuplonOffer,
      yuplonComision,
      yuplonIVAComision,
      yuplonComercio,
      yuplonIVANila,
      yuplonRetBACRenta,
      yuplonRetBACIVA,
      yuplonGanancia,
    }] : [];

    // Record the deposit as an actual collected payment entry
    const depositEntry = paymentType === "deposito" && depositNum > 0 ? [{
      id: `dep_${Date.now()}`,
      amount: depositNum,
      method: depositMethod,
      date: depositDate,
      at: new Date().toISOString(),
      collectedBy: "—",
    }] : [];

    // Applied upfront deposit: reduces the treatment balance, but its revenue was
    // ALREADY counted on the deposit's own date. Flag depositoApplied so reports
    // do NOT count it again (no double count).
    const appliedDepositEntry = paymentType === "deposito_adelantado" && selectedDeposit ? [{
      id: `paydep_${Date.now()}`,
      amount: depApplied,
      method: selectedDeposit.payMethod || "Depósito",
      date: selectedDeposit.fecha,
      at: new Date().toISOString(),
      type: "upfront",
      depositoApplied: true,
      depositoId: selectedDeposit.id,
      reference: "Depósito adelantado " + (selectedDeposit.fecha || ""),
    }] : [];

    onSave({
      paymentType,
      depositAmount: paymentType === "deposito" ? depositNum : null,
      amountPerSession: paymentType === "por_sesion" ? parseFloat(amountPerSession) : null,
      deposits: depositEntry,
      payments: [...autoPayment, ...appliedDepositEntry],
      depositoAplicado: paymentType === "deposito_adelantado" && selectedDeposit ? {
        // Store only lightweight reference data. Never embed the whole deposit
        // object — a stale snapshot could overwrite the live Firestore record.
        id: selectedDeposit.id,
        nombre: selectedDeposit.nombre,
        monto: depApplied,
        fecha: selectedDeposit.fecha,
      } : null,
      paymentSchedule: schedule,
      installmentAmount: installmentAmount ? parseFloat(installmentAmount) : null,
      nextPaymentDate: isInstallmentPlan ? nextPaymentDate : null,
      planNotes: planNotes || null,
      customArrangement: paymentType === "personalizado" ? customArrangement.trim() : null,
      // Gift card details
      giftCard: paymentType === "tarjeta_regalo" ? {
        id: selectedGiftCardId,
        ref: selectedGiftCard ? selectedGiftCard.cardNumber : "",
        cardType: selectedGiftCard ? selectedGiftCard.type : null,
        amountCovered: gcCovers,
        clientOwes: gcClientOwes,
        leftoverOnCard: gcLeftoverOnCard,
        purchasedBy: selectedGiftCard ? selectedGiftCard.buyerName : "",
        recipient: selectedGiftCard ? selectedGiftCard.recipientName : "",
      } : null,
      yuplon: paymentType === "yuplon" ? {
        ref: yuplonRef.trim(),
        offerPrice: yuplonOffer,
        comision: yuplonComision,
        ivaComision: yuplonIVAComision,
        comercio: yuplonComercio,
        ivaNila: yuplonIVANila,
        retBACRenta: yuplonRetBACRenta,
        retBACIVA: yuplonRetBACIVA,
        ganancia: yuplonGanancia,
      } : null,
    });
  };

  return React.createElement(
    "div", { style: styles.modalOverlay },
    React.createElement(
      "div", { style: { ...styles.modalContainer, maxWidth: "520px", maxHeight: "92vh", overflowY: "auto", textAlign: "left" } },

      // Header
      React.createElement("div", { style: { ...styles.modalTitle, textAlign: "center" } }, "💳 Acuerdo de pago"),
      React.createElement("div", { style: { textAlign: "center", backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "0.6rem 1rem", marginBottom: "1.25rem", fontWeight: "700", color: colors.gold.dark, fontSize: "1rem" } },
        `Total del tratamiento: ${formatCurrency(totalPrice)}`
      ),

      // Payment type selection
      React.createElement("div", { style: { marginBottom: "1.25rem" } },
        React.createElement("label", { style: { display: "block", fontWeight: "600", color: colors.gold.dark, marginBottom: "0.6rem", fontSize: "0.95rem" } },
          "¿Cómo pagará el cliente este tratamiento? *"
        ),
        PAYMENT_TYPES.map(pt => React.createElement(
          "div", { key: pt.value, style: { marginBottom: "0.5rem", padding: "0.5rem 0.75rem", borderRadius: "0.5rem", backgroundColor: paymentType === pt.value ? colors.gold.light : "transparent", border: `1px solid ${paymentType === pt.value ? colors.gold.primary : "transparent"}` } },
          React.createElement("label", { style: { display: "flex", alignItems: "center", gap: "0.6rem", cursor: "pointer" } },
            React.createElement("input", { type: "radio", name: "paymentType", value: pt.value, checked: paymentType === pt.value, onChange: () => setPaymentType(pt.value) }),
            React.createElement("span", { style: { fontWeight: paymentType === pt.value ? "600" : "400" } }, pt.label)
          )
        ))
      ),

      // Deposit + balance: how much is the initial deposit
      paymentType === "deposito" && React.createElement(
        "div", { style: { backgroundColor: colors.gold.soft, borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem" } },
        React.createElement("div", { style: { fontWeight: "600", color: colors.gold.dark, marginBottom: "0.75rem" } }, "🔐 Detalle del depósito"),
        React.createElement(Field, { labelText: "Monto del depósito inicial (₡)", value: depositAmount, onChange: v => setDepositAmount(onlyNumbers(v)), type: "tel", inputMode: "numeric", required: true, lang: "es" }),
        depositNum > 0 && React.createElement("div", { style: { marginBottom: "0.75rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Método de pago del depósito *"),
          React.createElement("select", { style: styles.input, value: depositMethod, onChange: e => setDepositMethod(e.target.value) },
            React.createElement("option", { value: "" }, "-- Seleccionar --"),
            PAYMENT_METHODS.map(m => React.createElement("option", { key: m, value: m }, m))
          )
        ),
        depositNum > 0 && React.createElement("div", { style: { marginBottom: "0.75rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Fecha de cobro del depósito"),
          React.createElement("input", { type: "date", style: styles.input, value: depositDate, onChange: e => setDepositDate(e.target.value) })
        ),
        depositNum > 0 && React.createElement(
          "div", { style: { backgroundColor: colors.accent.successLight, borderRadius: "0.5rem", padding: "0.5rem 0.75rem", fontSize: "0.875rem", color: colors.accent.success, fontWeight: "600" } },
          `✅ Depósito a registrar: ${formatCurrency(depositNum)}${depositMethod ? " · " + depositMethod : ""} · ${depositDate} · Saldo pendiente: ${formatCurrency(remaining)}`
        )
      ),

      // Installment plan details
      isInstallmentPlan && React.createElement(
        "div", { style: { backgroundColor: "#EFF6FF", borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem" } },
        React.createElement("div", { style: { fontWeight: "600", color: "#1D4ED8", marginBottom: "0.75rem" } }, "📆 Detalles del plan de pagos"),
        React.createElement(Field, {
          labelText: `Monto por ${paymentType === "semanal" ? "semana" : paymentType === "quincenal" ? "quincena" : paymentType === "mensual" ? "mes" : "cuota"} (₡)`,
          value: installmentAmount, onChange: v => setInstallmentAmount(onlyNumbers(v)), type: "tel", inputMode: "numeric", required: true, lang: "es"
        }),
        React.createElement("div", { style: { marginBottom: "0.75rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Fecha del próximo pago"),
          React.createElement("input", { type: "date", style: styles.input, value: nextPaymentDate, onChange: e => setNextPaymentDate(e.target.value) })
        ),
        paymentType === "personalizado" && React.createElement(TextAreaField, { labelText: "Descripción del arreglo *", value: customArrangement, onChange: setCustomArrangement, rows: 3, lang: "es" }),
        React.createElement(TextAreaField, { labelText: "Notas del plan (opcional)", value: planNotes, onChange: setPlanNotes, rows: 2, lang: "es" }),
        installmentAmount && parseFloat(installmentAmount) > 0 && ["semanal","quincenal","mensual"].includes(paymentType) && React.createElement(
          "div", { style: { backgroundColor: "#DBEAFE", borderRadius: "0.5rem", padding: "0.5rem 0.75rem", fontSize: "0.875rem", color: "#1D4ED8", fontWeight: "600", marginTop: "0.5rem" } },
          `Cuotas estimadas: ${Math.ceil(totalPrice / parseFloat(installmentAmount))}`
        )
      ),

      // ── Yuplon fields ──
      paymentType === "yuplon" && React.createElement(
        "div", { style: { backgroundColor: "#FEFCE8", borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem", border: "1px solid #FDE047" } },
        React.createElement("div", { style: { fontWeight: "600", color: "#92400E", marginBottom: "0.75rem" } }, "🟡 Datos de Yuplon"),
        React.createElement(Field, {
          labelText: "Número de voucher Yuplon *",
          value: yuplonRef,
          onChange: setYuplonRef,
          required: true,
          lang: "es",
          placeholder: "Ej: YUP-2026-001234",
        }),
        React.createElement(Field, {
          labelText: "Precio de oferta Yuplon (₡) *",
          value: yuplonOfferPrice,
          onChange: v => setYuplonOfferPrice(onlyNumbers(v)),
          type: "tel",
          inputMode: "numeric",
          required: true,
          lang: "es",
        }),
        React.createElement("div", { style: { marginBottom: "0.75rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Fecha de cobro *"),
          React.createElement("input", { type: "date", style: styles.input, value: yuplonDate, onChange: e => setYuplonDate(e.target.value) })
        ),
        // Auto-calculated breakdown
        yuplonOfferPrice && parseFloat(yuplonOfferPrice) > 0 && (() => {
          const offer = parseFloat(yuplonOfferPrice);
          const comision = Math.round(offer * 0.20);
          const ivaComision = Math.round(comision * 0.13);
          const comercio = offer - comision - ivaComision;
          const ivaNila = Math.round(comercio * 0.13);
          const retBACRenta = Math.round(offer * 0.0176);
          const retBACIVA = Math.round(offer * 0.0531);
          const ganancia = comercio - ivaNila - retBACRenta - retBACIVA;
          return React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.5rem", padding: "0.75rem", fontSize: "0.82rem" } },
            React.createElement("div", { style: { fontWeight: "700", color: "#92400E", marginBottom: "0.5rem" } }, "Desglose automático:"),
            React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.25rem 1rem" } },
              React.createElement("div", { style: { color: "#6B7280" } }, "Comisión Yuplon (20%):"),
              React.createElement("div", { style: { textAlign: "right", fontWeight: "600", color: "#DC2626" } }, `- ${formatCurrency(comision)}`),
              React.createElement("div", { style: { color: "#6B7280" } }, "IVA sobre comisión (13%):"),
              React.createElement("div", { style: { textAlign: "right", fontWeight: "600", color: "#DC2626" } }, `- ${formatCurrency(ivaComision)}`),
              React.createElement("div", { style: { color: "#6B7280", fontWeight: "600" } }, "% Comercio:"),
              React.createElement("div", { style: { textAlign: "right", fontWeight: "600" } }, formatCurrency(comercio)),
              React.createElement("div", { style: { color: "#6B7280" } }, "IVA de NILA (13%):"),
              React.createElement("div", { style: { textAlign: "right", fontWeight: "600", color: "#DC2626" } }, `- ${formatCurrency(ivaNila)}`),
              React.createElement("div", { style: { color: "#6B7280" } }, "Retención BAC Renta (1.76%):"),
              React.createElement("div", { style: { textAlign: "right", fontWeight: "600", color: "#DC2626" } }, `- ${formatCurrency(retBACRenta)}`),
              React.createElement("div", { style: { color: "#6B7280" } }, "Retención BAC IVA Renta (5.31%):"),
              React.createElement("div", { style: { textAlign: "right", fontWeight: "600", color: "#DC2626" } }, `- ${formatCurrency(retBACIVA)}`),
            ),
            React.createElement("div", { style: { borderTop: "2px solid #FDE047", marginTop: "0.5rem", paddingTop: "0.5rem", display: "flex", justifyContent: "space-between" } },
              React.createElement("span", { style: { fontWeight: "700", color: "#065F46" } }, "✅ Ganancia de NILA:"),
              React.createElement("span", { style: { fontWeight: "800", color: "#065F46", fontSize: "1rem" } }, formatCurrency(ganancia))
            )
          );
        })()
      ),

      // ── Aplicar depósito adelantado ──
      paymentType === "deposito_adelantado" && React.createElement(
        "div", { style: { backgroundColor: "#FEF9E7", borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem", border: "1px solid #F5D76E" } },
        React.createElement("div", { style: { fontWeight: "600", color: "#B8860B", marginBottom: "0.75rem" } }, "🔗 Aplicar depósito adelantado"),
        pendingDeposits.length === 0
          ? React.createElement("div", { style: { fontSize: "0.85rem", color: "#92400E", backgroundColor: "#FEF3C7", borderRadius: "0.5rem", padding: "0.6rem 0.85rem" } }, "⚠️ No hay depósitos pendientes. Regístrelos en la pestaña 💵 Depósitos.")
          : React.createElement("div", null,
              React.createElement("label", { style: { display: "block", fontWeight: "500", color: "#B8860B", marginBottom: "0.4rem", fontSize: "0.85rem" } }, "Seleccione el depósito del cliente *"),
              React.createElement("select", {
                value: selectedDepositId,
                onChange: e => setSelectedDepositId(e.target.value),
                style: { ...styles.input, marginBottom: "0.75rem" },
              },
                React.createElement("option", { value: "" }, "— Seleccionar depósito —"),
                pendingDeposits.map(d => React.createElement("option", { key: d.id, value: d.id },
                  `${d.nombre} · ${d.telefono} · ${d.tratamiento} · Depósito: ${formatCurrency(d.montoDeposito)} (${formatDateCR(d.fecha)})`
                ))
              ),
              selectedDeposit && React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.5rem", padding: "0.7rem 0.85rem", fontSize: "0.82rem", color: "#5B4A1A", border: "1px solid #F5D76E" } },
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.2rem" } },
                  React.createElement("span", null, "Precio del tratamiento:"), React.createElement("strong", null, formatCurrency(totalPrice))),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.2rem", color: "#16A34A" } },
                  React.createElement("span", null, "✅ Depósito ya pagado (" + formatDateCR(selectedDeposit.fecha) + "):"), React.createElement("strong", null, formatCurrency(depApplied))),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", color: "#DC2626", fontWeight: "700", borderTop: "1px solid #F5D76E", marginTop: "0.3rem", paddingTop: "0.3rem" } },
                  React.createElement("span", null, "Saldo a cobrar hoy:"), React.createElement("strong", null, formatCurrency(depRemaining))),
                React.createElement("div", { style: { fontSize: "0.72rem", color: "#78350F", marginTop: "0.4rem" } }, "El depósito ya fue registrado como ingreso el día que se cobró — no se cuenta doble. El saldo se cobra normalmente en las sesiones.")
              )
            )
      ),

      // ── Tarjeta de Regalo: redención por dropdown ──
      paymentType === "tarjeta_regalo" && React.createElement(
        "div", { style: { backgroundColor: "#F0FDF4", borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem", border: "1px solid #86EFAC" } },
        React.createElement("div", { style: { fontWeight: "600", color: "#15803D", marginBottom: "0.75rem" } }, "🎁 Canjear Tarjeta de Regalo"),
        activeGiftCards.length === 0
          ? React.createElement("div", { style: { fontSize: "0.85rem", color: "#92400E", backgroundColor: "#FEF3C7", borderRadius: "0.5rem", padding: "0.6rem 0.85rem" } }, "⚠️ No hay tarjetas de regalo activas. Véndalas primero en la pestaña 🎁 Tarjetas de Regalo.")
          : React.createElement("div", null,
              React.createElement("label", { style: { display: "block", fontWeight: "500", color: "#15803D", marginBottom: "0.4rem", fontSize: "0.85rem" } }, "Seleccione la tarjeta activa *"),
              React.createElement("select", {
                value: selectedGiftCardId,
                onChange: e => setSelectedGiftCardId(e.target.value),
                style: { ...styles.input, marginBottom: "0.75rem" },
              },
                React.createElement("option", { value: "" }, "— Seleccionar tarjeta —"),
                activeGiftCards.map(c => React.createElement("option", { key: c.id, value: c.id },
                  `#${c.cardNumber} · ${c.recipientName} (compró: ${c.buyerName}) · Saldo: ${formatCurrency(c.remainingBalance || 0)}${c.type === "tratamiento" ? " · " + c.treatmentName : ""}`
                ))
              ),
              selectedGiftCard && gcIsTypeA && React.createElement("div", { style: { backgroundColor: "#DCFCE7", borderRadius: "0.5rem", padding: "0.85rem", fontSize: "0.85rem", color: "#065F46" } },
                React.createElement("div", { style: { fontWeight: "700", marginBottom: "0.35rem" } }, "🎁 Tarjeta por tratamiento específico"),
                React.createElement("div", { style: { marginBottom: "0.3rem" } }, `Tratamiento del regalo: ${selectedGiftCard.treatmentName || "—"}`),
                React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.4rem", padding: "0.5rem 0.7rem", fontWeight: "700", color: "#15803D" } }, "✅ Esta tarjeta cubre el tratamiento completo. El cliente NO paga nada."),
                React.createElement("div", { style: { fontSize: "0.74rem", color: "#65713D", marginTop: "0.4rem", color: "#4B5563" } }, "El precio del tratamiento no afecta esta tarjeta — ya fue pagada al comprarla. La tarjeta quedará completada.")
              ),
              selectedGiftCard && !gcIsTypeA && React.createElement("div", { style: { backgroundColor: "#DCFCE7", borderRadius: "0.5rem", padding: "0.7rem 0.85rem", fontSize: "0.82rem", color: "#065F46" } },
                React.createElement("div", { style: { fontWeight: "700", marginBottom: "0.35rem" } }, "💰 Tarjeta por monto fijo"),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.2rem" } },
                  React.createElement("span", null, "Precio del tratamiento:"), React.createElement("strong", null, formatCurrency(totalPrice))),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.2rem" } },
                  React.createElement("span", null, "Saldo en la tarjeta:"), React.createElement("strong", null, formatCurrency(gcBalance))),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.2rem", color: "#15803D" } },
                  React.createElement("span", null, "✅ Cubre la tarjeta:"), React.createElement("strong", null, formatCurrency(gcCovers))),
                gcClientOwes > 0 && React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginBottom: "0.2rem", color: "#DC2626", fontWeight: "700", borderTop: "1px solid #86EFAC", marginTop: "0.3rem", paddingTop: "0.3rem" } },
                  React.createElement("span", null, "⚠️ El cliente debe pagar:"), React.createElement("strong", null, formatCurrency(gcClientOwes))),
                gcLeftoverOnCard > 0 && React.createElement("div", { style: { display: "flex", justifyContent: "space-between", color: "#1D4ED8", fontWeight: "700", borderTop: "1px solid #86EFAC", marginTop: "0.3rem", paddingTop: "0.3rem" } },
                  React.createElement("span", null, "💳 Queda en la tarjeta:"), React.createElement("strong", null, formatCurrency(gcLeftoverOnCard))),
                gcClientOwes === 0 && gcLeftoverOnCard === 0 && React.createElement("div", { style: { color: "#15803D", fontWeight: "700", borderTop: "1px solid #86EFAC", marginTop: "0.3rem", paddingTop: "0.3rem" } }, "✅ Tratamiento totalmente cubierto. Tarjeta completada."),
                gcClientOwes > 0 && React.createElement("div", { style: { fontSize: "0.74rem", color: "#92400E", marginTop: "0.4rem" } }, "El cliente paga la diferencia con otro método. La tarjeta quedará completada.")
              )
            )
      ),

      // Per session — amount per session field
      paymentType === "por_sesion" && React.createElement(
        "div", { style: { backgroundColor: "#FEF3C7", borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem" } },
        React.createElement("div", { style: { fontWeight: "600", color: "#92400E", marginBottom: "0.75rem" } }, "📅 Pago por sesión"),
        React.createElement(Field, { labelText: "Monto acordado por sesión (₡) *", value: amountPerSession, onChange: v => setAmountPerSession(onlyNumbers(v)), type: "tel", inputMode: "numeric", required: true, lang: "es" }),
        React.createElement(TextAreaField, { labelText: "Notas del plan (opcional)", value: planNotes, onChange: setPlanNotes, rows: 2, lang: "es" }),
        React.createElement("div", { style: { fontSize: "0.8rem", color: "#92400E", marginTop: "0.5rem" } },
          "⚠️ El sistema recordará al personal cobrar este monto antes de cerrar cada sesión."
        )
      ),

      // Full payment info
      paymentType === "completo" && React.createElement(
        "div", { style: { backgroundColor: colors.accent.successLight, borderRadius: "0.75rem", padding: "0.75rem 1rem", marginBottom: "1rem", fontSize: "0.875rem", color: colors.accent.success } },
        `✅ El cliente pagará ${formatCurrency(totalPrice)} en su totalidad. El cobro se registrará al finalizar o según lo acordado.`
      ),

      error && React.createElement("div", { style: { color: colors.accent.danger, marginBottom: "1rem", fontSize: "0.875rem", fontWeight: "500" } }, "❌ " + error),
      React.createElement(
        "div", { style: { display: "flex", gap: "0.75rem", justifyContent: "flex-end", marginTop: "1rem" } },
        React.createElement("button", { onClick: onClose, style: styles.buttonOutline }, "Cancelar"),
        React.createElement("button", { onClick: handleSave, style: styles.buttonSuccess }, "✓ Confirmar acuerdo de pago")
      )
    )
  );
}

// Modal to collect a payment (upfront, balance, session, or installment)
function CollectPaymentModal({ title, amount, onClose, onSave, allowPartial = false }) {
  const [paidAmount, setPaidAmount] = useState(amount ? String(Math.round(amount)) : "");
  const [method, setMethod] = useState("");
  const [collectedDate, setCollectedDate] = useState(new Date().toISOString().slice(0, 10));
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  const handleSave = () => {
    setError("");
    const num = parseFloat(paidAmount);
    if (!num || num <= 0) return setError("Ingrese el monto recibido");
    if (!method) return setError("Seleccione el método de pago");
    if (!collectedDate) return setError("Ingrese la fecha de cobro");
    onSave({ amount: num, method, date: collectedDate, at: new Date().toISOString(), notes: notes || null });
  };

  return React.createElement(
    "div", { style: styles.modalOverlay },
    React.createElement(
      "div", { style: { ...styles.modalContainer, maxWidth: "420px" } },
      React.createElement("div", { style: styles.modalTitle }, title || "💳 Cobrar pago"),
      amount && React.createElement("div", { style: { marginBottom: "1rem", color: colors.gray.text, fontSize: "0.9rem" } }, `Monto esperado: ${formatCurrency(amount)}`),
      React.createElement(Field, { labelText: "Monto recibido (₡)", value: paidAmount, onChange: v => setPaidAmount(onlyNumbers(v)), type: "tel", inputMode: "numeric", required: true, lang: "es" }),
      React.createElement("div", { style: { marginBottom: "1rem" } },
        React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.5rem" } }, "Método de pago *"),
        React.createElement("select", { style: styles.input, value: method, onChange: e => setMethod(e.target.value) },
          React.createElement("option", { value: "" }, "-- Seleccionar --"),
          PAYMENT_METHODS.map(m => React.createElement("option", { key: m, value: m }, m))
        )
      ),
      React.createElement("div", { style: { marginBottom: "1rem" } },
        React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.5rem" } }, "Fecha de cobro *"),
        React.createElement("input", { type: "date", style: styles.input, value: collectedDate, onChange: e => setCollectedDate(e.target.value) })
      ),
      React.createElement(Field, { labelText: "Notas (opcional)", value: notes, onChange: setNotes, lang: "es" }),
      error && React.createElement("div", { style: { color: colors.accent.danger, marginBottom: "1rem", fontSize: "0.875rem" } }, error),
      React.createElement(
        "div", { style: { display: "flex", gap: "0.75rem", justifyContent: "flex-end" } },
        React.createElement("button", { onClick: onClose, style: styles.buttonOutline }, "Cancelar"),
        React.createElement("button", { onClick: handleSave, style: styles.buttonSuccess }, "✓ Registrar pago")
      )
    )
  );
}

// Payment status summary box shown in RecordDetailView
function PaymentStatusBox({ record, user, onUpdate, canEditPrice, onEditPayment }) {
  const [showCollect, setShowCollect] = useState(false);
  const [collectTarget, setCollectTarget] = useState(null); // { type, installmentId, sessionNum, title, amount }

  const plan = record.treatmentPlan;
  if (!plan) return null;

  const paymentInfo = plan.paymentInfo || {};
  const paymentType = paymentInfo.paymentType || "—";
  const deposits = paymentInfo.deposits || [];
  const payments = paymentInfo.payments || [];
  const schedule = paymentInfo.paymentSchedule || [];

  const totalDeposited = deposits.reduce((s, d) => s + d.amount, 0);
  const totalPaid = payments.reduce((s, p) => s + p.amount, 0) + totalDeposited;
  const totalPrice = plan.totalPrice || 0;
  // For Yuplon: the ganancia stored IS the full payment — compare against it
  const isYuplonPayment = paymentType === "yuplon";
  const yuplonGanancia = paymentInfo.yuplon?.ganancia || 0;
  const effectiveTotal = isYuplonPayment ? yuplonGanancia : totalPrice;
  const outstanding = Math.max(0, effectiveTotal - totalPaid);

  const overdueInstallments = schedule.filter(inst => {
    if (inst.status === "pagado") return false;
    return new Date(inst.dueDate) < new Date();
  });
  const overdueTotal = overdueInstallments.reduce((s, i) => s + (i.amount - (i.paidAmount || 0)), 0);

  const handleCollect = async (paymentData) => {
    const { amount, method, date, at } = paymentData;
    let updated = { ...record };
    const newPayment = {
      id: `pay_${Date.now()}`,
      amount, method, date, at,
      collectedBy: user.nombreCompleto,
      type: collectTarget.type,
      reference: collectTarget.installmentId || collectTarget.sessionNum || null,
    };

    if (collectTarget.type === "balance" || collectTarget.type === "upfront" || collectTarget.type === "session") {
      const updatedPayments = [...(plan.paymentInfo?.payments || []), newPayment];
      updated = {
        ...record,
        treatmentPlan: {
          ...plan,
          paymentInfo: { ...paymentInfo, payments: updatedPayments },
        },
      };
    } else if (collectTarget.type === "installment") {
      const updatedSchedule = schedule.map(inst => {
        if (inst.id !== collectTarget.installmentId) return inst;
        const newPaid = (inst.paidAmount || 0) + amount;
        return {
          ...inst,
          paidAmount: newPaid,
          paymentMethod: method,
          paidAt: at,
          collectedBy: user.nombreCompleto,
          status: newPaid >= inst.amount ? "pagado" : "parcial",
        };
      });
      updated = {
        ...record,
        treatmentPlan: {
          ...plan,
          paymentInfo: { ...paymentInfo, paymentSchedule: updatedSchedule },
        },
      };
    }

    await saveRecordToFirestore(updated);
    onUpdate(updated);
    setShowCollect(false);
    setCollectTarget(null);
  };

  const openCollect = (target) => {
    setCollectTarget(target);
    setShowCollect(true);
  };

  const paymentTypeLabel = PAYMENT_TYPES.find(p => p.value === paymentType)?.label || paymentType;
  const isInstallmentPlan = ["semanal","quincenal","mensual","personalizado"].includes(paymentType);
  const isPerSession = paymentType === "por_sesion";
  const planFlag = PAYMENT_TYPES.find(p => p.value === paymentType)?.flag;
  const pendingPayments = record.paymentPending || [];

  return React.createElement(
    React.Fragment, null,
    showCollect && collectTarget && React.createElement(CollectPaymentModal, {
      title: collectTarget.title,
      amount: collectTarget.amount,
      onClose: () => { setShowCollect(false); setCollectTarget(null); },
      onSave: handleCollect,
    }),
    React.createElement(
      "div", {
        style: {
          backgroundColor: outstanding > 0 ? "#FFF8F0" : colors.accent.successLight,
          border: `1px solid ${outstanding > 0 ? colors.accent.warning : colors.accent.success}`,
          borderRadius: "1rem", padding: "1rem", marginBottom: "1rem",
        }
      },
      React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" } },
        React.createElement("div", { style: { fontWeight: "bold", color: colors.gold.dark, fontSize: "1rem" } }, "💳 ESTADO DE PAGOS"),
        canEditPrice && React.createElement("button", {
          onClick: () => onEditPayment && onEditPayment(null),
          style: { ...styles.buttonOutline, padding: "0.25rem 0.65rem", fontSize: "0.75rem" },
        }, "✏️ Editar plan de pago")
      ),
      // Yuplon banner
      paymentType === "yuplon" && plan.paymentInfo?.yuplon && (() => {
        const y = plan.paymentInfo.yuplon;
        // Recalculate on-the-fly in case fields were saved before new formula
        const yOffer = y.offerPrice || 0;
        const yComision = y.comision || Math.round(yOffer * 0.20);
        const yIvaComision = y.ivaComision || Math.round(yComision * 0.13);
        const yComercio = y.comercio || (yOffer - yComision - yIvaComision);
        const yIvaNila = y.ivaNila || Math.round(yComercio * 0.13);
        const yRetBACRenta = y.retBACRenta || Math.round(yOffer * 0.0176);
        const yRetBACIVA = y.retBACIVA || Math.round(yOffer * 0.0531);
        const yGanancia = yComercio - yIvaNila - yRetBACRenta - yRetBACIVA;
        return React.createElement(
          "div", { style: { backgroundColor: "#FEFCE8", borderRadius: "0.5rem", padding: "0.75rem", marginBottom: "0.75rem", border: "1px solid #FDE047" } },
          React.createElement("div", { style: { fontWeight: "700", color: "#92400E", fontSize: "0.85rem", marginBottom: "0.5rem" } }, "🟡 Yuplon — Desglose"),
          React.createElement("div", { style: { fontSize: "0.78rem", display: "grid", gridTemplateColumns: "1fr auto", gap: "0.2rem 1rem" } },
            React.createElement("div", { style: { color: "#6B7280" } }, "Voucher:"),
            React.createElement("div", { style: { fontWeight: "600", textAlign: "right" } }, y.ref || "—"),
            React.createElement("div", { style: { color: "#6B7280" } }, "Precio oferta (monto al cliente):"),
            React.createElement("div", { style: { textAlign: "right", fontWeight: "600" } }, formatCurrency(yOffer)),
            React.createElement("div", { style: { color: "#DC2626" } }, "Comisión Yuplon (20%):"),
            React.createElement("div", { style: { textAlign: "right", color: "#DC2626", fontWeight: "600" } }, `- ${formatCurrency(yComision)}`),
            React.createElement("div", { style: { color: "#DC2626" } }, "IVA sobre comisión (13%):"),
            React.createElement("div", { style: { textAlign: "right", color: "#DC2626", fontWeight: "600" } }, `- ${formatCurrency(yIvaComision)}`),
            React.createElement("div", { style: { color: "#374151", fontWeight: "600" } }, "% Comercio:"),
            React.createElement("div", { style: { textAlign: "right", fontWeight: "700" } }, formatCurrency(yComercio)),
            React.createElement("div", { style: { color: "#DC2626" } }, "IVA de NILA (13%):"),
            React.createElement("div", { style: { textAlign: "right", color: "#DC2626", fontWeight: "600" } }, `- ${formatCurrency(yIvaNila)}`),
            React.createElement("div", { style: { color: "#DC2626" } }, "Retención BAC Renta (1.76%):"),
            React.createElement("div", { style: { textAlign: "right", color: "#DC2626", fontWeight: "600" } }, `- ${formatCurrency(yRetBACRenta)}`),
            React.createElement("div", { style: { color: "#DC2626" } }, "Retención BAC IVA Renta (5.31%):"),
            React.createElement("div", { style: { textAlign: "right", color: "#DC2626", fontWeight: "600" } }, `- ${formatCurrency(yRetBACIVA)}`),
          ),
          React.createElement("div", { style: { borderTop: "2px solid #FDE047", marginTop: "0.5rem", paddingTop: "0.5rem", display: "flex", justifyContent: "space-between", alignItems: "center" } },
            React.createElement("span", { style: { fontWeight: "700", color: "#065F46", fontSize: "0.85rem" } }, "✅ Ganancia de NILA:"),
            React.createElement("span", { style: { fontWeight: "800", color: "#065F46", fontSize: "1rem" } }, formatCurrency(yGanancia))
          )
        );
      })(),

      // Gift card banner
      paymentType === "tarjeta_regalo" && plan.paymentInfo?.giftCard && React.createElement(
        "div", { style: { backgroundColor: "#F0FDF4", borderRadius: "0.5rem", padding: "0.5rem 0.75rem", marginBottom: "0.75rem", border: "1px solid #86EFAC" } },
        React.createElement("div", { style: { fontWeight: "700", color: "#15803D", fontSize: "0.82rem", marginBottom: "0.2rem" } }, "🎁 Tarjeta de Regalo"),
        React.createElement("div", { style: { fontSize: "0.8rem", color: "#166534" } }, `Ref: ${plan.paymentInfo.giftCard.ref || "—"}`),
        React.createElement("div", { style: { fontSize: "0.8rem", color: "#166534" } }, `Monto: ${formatCurrency(plan.paymentInfo.giftCard.amount || 0)}`),
        React.createElement("div", { style: { fontSize: "0.8rem", color: "#166534" } }, `Comprada por: ${plan.paymentInfo.giftCard.purchasedBy || "—"}`),
      ),
      // Payment plan flag banner
      planFlag && React.createElement(
        "div", { style: { backgroundColor: isPerSession ? "#FEF3C7" : "#DBEAFE", borderRadius: "0.5rem", padding: "0.4rem 0.75rem", marginBottom: "0.75rem", fontSize: "0.8rem", fontWeight: "700", color: isPerSession ? "#92400E" : "#1D4ED8" } },
        planFlag
      ),
      // Payment pending flags
      pendingPayments.length > 0 && React.createElement(
        "div", { style: { backgroundColor: "#FEF3C7", borderRadius: "0.5rem", padding: "0.5rem 0.75rem", marginBottom: "0.75rem", fontSize: "0.8rem", color: "#92400E", fontWeight: "600" } },
        `⚠️ ${pendingPayments.length} pago(s) de sesión pendiente(s) de cobro`
      ),
      React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "0.75rem", fontSize: "0.875rem" } },
        React.createElement("div", null, React.createElement("span", { style: { color: colors.gray.text } }, "Tipo: "), paymentTypeLabel),
        React.createElement("div", null, React.createElement("span", { style: { color: colors.gray.text } }, "Total: "), React.createElement("strong", null, formatCurrency(totalPrice))),
        React.createElement("div", null, React.createElement("span", { style: { color: colors.gray.text } }, "Cobrado: "), React.createElement("strong", { style: { color: colors.accent.success } }, formatCurrency(totalPaid))),
        React.createElement("div", null, React.createElement("span", { style: { color: colors.gray.text } }, "Pendiente: "), React.createElement("strong", { style: { color: outstanding > 0 ? colors.accent.danger : colors.accent.success } }, formatCurrency(outstanding))),
      ),
      // Installment plan details
      isInstallmentPlan && plan.paymentInfo?.nextPaymentDate && React.createElement(
        "div", { style: { backgroundColor: "#DBEAFE", borderRadius: "0.5rem", padding: "0.5rem 0.75rem", marginBottom: "0.75rem", fontSize: "0.8rem" } },
        React.createElement("div", { style: { fontWeight: "600", color: "#1D4ED8", marginBottom: "0.25rem" } }, "📆 Plan de pago activo"),
        React.createElement("div", null, `Próximo pago: ${formatDateCR(plan.paymentInfo.nextPaymentDate)}`),
        plan.paymentInfo.installmentAmount && React.createElement("div", null, `Monto por cuota: ${formatCurrency(plan.paymentInfo.installmentAmount)}`),
        plan.paymentInfo.planNotes && React.createElement("div", { style: { fontStyle: "italic", color: "#374151", marginTop: "0.25rem" } }, plan.paymentInfo.planNotes),
        plan.paymentInfo.customArrangement && React.createElement("div", { style: { fontStyle: "italic", color: "#374151", marginTop: "0.25rem" } }, `Arreglo: ${plan.paymentInfo.customArrangement}`),
      ),
      overdueTotal > 0 && React.createElement(
        "div", { style: { backgroundColor: "#FEE2E2", borderRadius: "0.5rem", padding: "0.5rem 0.75rem", marginBottom: "0.75rem", fontSize: "0.8rem", color: colors.accent.danger, fontWeight: "bold" } },
        `🔴 VENCIDO: ${formatCurrency(overdueTotal)} (${overdueInstallments.length} cuota${overdueInstallments.length > 1 ? "s" : ""})`
      ),
      // Action buttons based on payment type
      (paymentType === "completo" || paymentType === "deposito" || isInstallmentPlan) && outstanding > 0 && paymentType !== "tarjeta_regalo" && React.createElement("button", {
        onClick: () => openCollect({ type: paymentType === "deposito" ? "balance" : "upfront", title: "💳 Registrar cobro", amount: outstanding }),
        style: { ...styles.buttonSuccess, padding: "0.5rem 1rem", fontSize: "0.8rem", marginRight: "0.5rem", marginBottom: "0.5rem" }
      }, `💳 Registrar cobro (saldo: ${formatCurrency(outstanding)})`),
      // Deposit history
      deposits.length > 0 && React.createElement(
        "div", { style: { marginTop: "0.75rem", fontSize: "0.8rem" } },
        React.createElement("div", { style: { fontWeight: "500", color: colors.gold.dark, marginBottom: "0.25rem" } }, "Depósito(s):"),
        deposits.map((d, i) => React.createElement(
          "div", { key: i, style: { backgroundColor: "white", borderRadius: "0.4rem", padding: "0.4rem 0.6rem", marginBottom: "0.25rem" } },
          `${formatCurrency(d.amount)} · ${d.method} · ${formatDateCR(d.date)}`
        ))
      ),
      // Payment schedule
      schedule.length > 0 && React.createElement(
        "div", { style: { marginTop: "0.75rem" } },
        React.createElement("div", { style: { fontWeight: "500", color: colors.gold.dark, marginBottom: "0.5rem", fontSize: "0.875rem" } }, "📅 Calendario de pagos:"),
        schedule.map((inst) => {
          const isOverdue = inst.status !== "pagado" && new Date(inst.dueDate) < new Date();
          const isPaid = inst.status === "pagado";
          const isPartial = inst.status === "parcial";
          return React.createElement(
            "div", {
              key: inst.id,
              style: {
                display: "flex", justifyContent: "space-between", alignItems: "center",
                backgroundColor: isPaid ? colors.accent.successLight : isOverdue ? "#FEE2E2" : "white",
                borderRadius: "0.4rem", padding: "0.4rem 0.6rem", marginBottom: "0.3rem", fontSize: "0.8rem",
                border: `1px solid ${isPaid ? colors.accent.success : isOverdue ? colors.accent.danger : colors.gray.medium}`,
              }
            },
            React.createElement("div", null,
              React.createElement("span", { style: { fontWeight: "500" } }, `Cuota #${inst.number}`),
              ` · ${formatDateCR(inst.dueDate)} · ${formatCurrency(inst.amount)}`,
              isPartial && ` · Pagado: ${formatCurrency(inst.paidAmount)}`,
              React.createElement("span", { style: { marginLeft: "0.4rem" } }, isPaid ? "✅" : isOverdue ? "🔴" : "⏳")
            ),
            !isPaid && React.createElement("button", {
              onClick: () => openCollect({ type: "installment", installmentId: inst.id, title: `💳 Cuota #${inst.number}${isOverdue ? " (VENCIDA)" : ""}`, amount: inst.amount - (inst.paidAmount || 0) }),
              style: { ...styles.buttonSuccess, padding: "0.2rem 0.6rem", fontSize: "0.75rem" }
            }, "Cobrar")
          );
        })
      ),
      // Payment history
      payments.length > 0 && React.createElement(
        "div", { style: { marginTop: "0.75rem", fontSize: "0.8rem" } },
        React.createElement("div", { style: { fontWeight: "500", color: colors.gold.dark, marginBottom: "0.25rem" } }, "Pagos registrados:"),
        payments.map((p, i) => React.createElement(
          "div", { key: i, style: { backgroundColor: "white", borderRadius: "0.4rem", padding: "0.4rem 0.6rem", marginBottom: "0.25rem" } },
          `${formatCurrency(p.amount)} · ${p.method} · ${formatDateCR(p.date)} · ${p.collectedBy || "—"}`
        ))
      )
    )
  );
}

// ========== END PAYMENT MODULE ==========

// ========== PRICE EDITOR MODAL (CORRECTION #1) ==========
function PriceEditorModal({ record, treatmentType, onClose, onSave, user }) {
  const isMobile = useIsMobile();
  const [newPrice, setNewPrice] = useState("");
  const [newSessions, setNewSessions] = useState("");
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [showIvaChoice, setShowIvaChoice] = useState(false);
  const [pendingIvaCallback, setPendingIvaCallback] = useState(null);

  const getCurrentPrice = () => {
    if (treatmentType === "main") {
      return record.treatmentPlan?.totalPrice || 0;
    } else {
      const additional = record.additionalTreatments?.find(t => t.id === treatmentType);
      return additional?.totalPrice || 0;
    }
  };

  const getCurrentSessions = () => {
    if (treatmentType === "main") {
      return record.treatmentPlan?.totalSessions || 0;
    } else {
      const additional = record.additionalTreatments?.find(t => t.id === treatmentType);
      return additional?.totalSessions || 0;
    }
  };
  const getCompletedSessions = () => {
    if (treatmentType === "main") {
      return record.treatmentPlan?.completedSessions || 0;
    } else {
      const additional = record.additionalTreatments?.find(t => t.id === treatmentType);
      return additional?.completedSessions || 0;
    }
  };

  const getCurrentTreatmentName = () => {
    if (treatmentType === "main") {
      return record.treatmentPlan?.name || "Tratamiento principal";
    } else {
      const additional = record.additionalTreatments?.find(t => t.id === treatmentType);
      return additional?.treatmentName || additional?.treatmentType || "Tratamiento adicional";
    }
  };

  const handleSaveClick = () => {
    setError("");
    const priceNum = parseFloat(newPrice);
    if (isNaN(priceNum) || priceNum < 0) {
      setError("Ingrese un precio válido");
      return;
    }
    if (!reason.trim()) {
      setError("Debe ingresar un motivo/razón para el cambio");
      return;
    }
    // Validate sessions if the field was changed
    if (newSessions !== "") {
      const sessNum = parseInt(newSessions);
      if (isNaN(sessNum) || sessNum < 1) {
        setError("El número de sesiones debe ser al menos 1");
        return;
      }
      const completed = getCompletedSessions();
      if (sessNum < completed) {
        setError(`No puede reducir a ${sessNum} sesiones: ya hay ${completed} sesiones realizadas. El mínimo es ${completed}.`);
        return;
      }
    }
    // Show IVA choice before saving
    setShowIvaChoice(true);
  };

  const handleSaveWithIva = async (ivaIncluded) => {
    setShowIvaChoice(false);
    setSaving(true);
    const priceNum = parseFloat(newPrice);
    let basePrice = priceNum;
    let ivaAmount = 0;
    let totalPrice = priceNum;

    if (priceNum > 0) {
      if (ivaIncluded) {
        basePrice = Math.round(priceNum / 1.13);
        ivaAmount = priceNum - basePrice;
        totalPrice = priceNum;
      } else {
        basePrice = priceNum;
        ivaAmount = Math.round(priceNum * 0.13);
        totalPrice = priceNum + ivaAmount;
      }
    }

    const changeRecord = {
      field: "precio del tratamiento",
      before: formatCurrency(getCurrentPrice()),
      after: formatCurrency(totalPrice),
      by: user.nombreCompleto,
      reason: reason.trim(),
      at: new Date().toISOString(),
    };

    if (treatmentType === "main") {
      const prevTotal = record.treatmentPlan?.totalSessions || 0;
      const completed = record.treatmentPlan?.completedSessions || 0;
      const newTotal = newSessions !== "" ? parseInt(newSessions) : prevTotal;
      const updatedPlan = {
        ...record.treatmentPlan,
        packagePrice: basePrice,
        ivaAmount: ivaAmount,
        ivaIncluded: ivaIncluded,
        totalPrice: totalPrice,
        totalSessions: newTotal,
        // If the new total equals completed, the treatment is finished.
        status: completed >= newTotal ? "finalizado" : (record.treatmentPlan?.status === "finalizado" ? "en_curso" : record.treatmentPlan?.status),
      };
      const sessionChangeRecord = (newSessions !== "" && newTotal !== prevTotal) ? [{
        field: "total de sesiones",
        before: `${prevTotal} sesiones`,
        after: `${newTotal} sesiones`,
        by: user.nombreCompleto,
        reason: reason.trim(),
        at: new Date().toISOString(),
      }] : [];
      const updated = {
        ...record,
        treatmentPlan: updatedPlan,
        changeHistory: [...(record.changeHistory || []), changeRecord, ...sessionChangeRecord],
      };
      await saveRecordToFirestore(updated);
      onSave(updated);
    } else {
      const updatedAdditionals = record.additionalTreatments.map(t => {
        if (t.id === treatmentType) {
          const prevTotal = t.totalSessions || 0;
          const completed = t.completedSessions || 0;
          const newTotal = newSessions !== "" ? parseInt(newSessions) : prevTotal;
          return {
            ...t,
            packagePrice: basePrice,
            ivaAmount: ivaAmount,
            ivaIncluded: ivaIncluded,
            totalPrice: totalPrice,
            totalSessions: newTotal,
            status: completed >= newTotal ? "finalizado" : (t.status === "finalizado" ? "en_curso" : t.status),
          };
        }
        return t;
      });
      const updated = {
        ...record,
        additionalTreatments: updatedAdditionals,
        changeHistory: [...(record.changeHistory || []), changeRecord],
      };
      await saveRecordToFirestore(updated);
      onSave(updated);
    }
    setSaving(false);
    onClose();
    alert(`✅ Precio actualizado correctamente\n\n💰 Nuevo total: ${formatCurrency(totalPrice)}\n📝 Motivo: ${reason.trim()}`);
  };

  return React.createElement(
    "div",
    { style: styles.modalOverlay },
    React.createElement(
      "div",
      { style: { ...styles.modalContainer, maxWidth: "450px" } },
      React.createElement(
        "div",
        { style: { ...styles.modalTitle, marginBottom: "0.5rem" } },
        "💰 Editar precio"
      ),
      React.createElement(
        "div",
        { style: { marginBottom: "0.75rem", fontSize: "0.875rem", color: colors.gray.text, textAlign: "center" } },
        getCurrentTreatmentName()
      ),
      React.createElement(
        "div",
        { style: { marginBottom: "1rem", textAlign: "center", fontSize: "0.875rem", fontWeight: "bold", color: colors.gold.dark } },
        "Precio actual: ", formatCurrency(getCurrentPrice())
      ),
      React.createElement(Field, {
        labelText: "Nuevo precio (₡)",
        value: newPrice,
        onChange: (v) => setNewPrice(onlyNumbers(v)),
        type: "tel",
        inputMode: "numeric",
        placeholder: "Ej: 150000",
        lang: "es",
      }),
      // ── Total sessions (optional edit) ──
      React.createElement("div", { style: { marginBottom: "0.25rem", fontSize: "0.8rem", color: colors.gray.text, textAlign: "center" } },
        `Sesiones actuales: ${getCurrentSessions()} · Realizadas: ${getCompletedSessions()}`
      ),
      React.createElement(Field, {
        labelText: "Nuevo total de sesiones (opcional)",
        value: newSessions,
        onChange: (v) => setNewSessions(onlyNumbers(v)),
        type: "tel",
        inputMode: "numeric",
        placeholder: `Dejar vacío para no cambiar (mín: ${getCompletedSessions() || 1})`,
        lang: "es",
      }),
      React.createElement("div", { style: { marginBottom: "1rem", fontSize: "0.72rem", color: colors.gray.text, fontStyle: "italic" } },
        "No se puede reducir por debajo de las sesiones ya realizadas."
      ),
      React.createElement(
        "div",
        { style: { marginBottom: "1rem" } },
        React.createElement(
          "label",
          {
            style: {
              display: "block",
              marginBottom: "0.5rem",
              fontWeight: "500",
              color: colors.gold.dark,
            },
          },
          "Motivo del cambio *"
        ),
        React.createElement("textarea", {
          style: styles.textarea,
          value: reason,
          onChange: (e) => setReason(e.target.value),
          placeholder: "Ej: Error al ingresar el precio, ajuste promocional, etc.",
          rows: 3,
        })
      ),
      error &&
        React.createElement(
          "div",
          { style: { color: colors.accent.danger, marginBottom: "1rem", fontSize: "0.875rem" } },
          error
        ),
      React.createElement(
        "div",
        { style: { display: "flex", gap: "0.75rem", justifyContent: "flex-end", marginTop: "0.5rem" } },
        React.createElement(
          "button",
          { onClick: onClose, style: styles.buttonOutline, disabled: saving },
          "Cancelar"
        ),
        React.createElement(
          "button",
          { onClick: handleSaveClick, style: { ...styles.buttonSuccess }, disabled: saving },
          saving ? "Guardando..." : "✓ Guardar cambio"
        )
      ),
      showIvaChoice && React.createElement(
        "div",
        {
          style: {
            position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 10000, padding: "1rem",
          }
        },
        React.createElement(
          "div",
          {
            style: {
              backgroundColor: "white", borderRadius: "1.25rem",
              padding: "1.75rem", maxWidth: "400px", width: "100%",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
            }
          },
          React.createElement("div", { style: { fontFamily: "Georgia, serif", color: colors.gold.dark, fontSize: "1.1rem", fontWeight: "bold", marginBottom: "0.75rem" } },
            "💰 Información de IVA"
          ),
          React.createElement("p", { style: { color: colors.gray.text, marginBottom: "1.25rem" } },
            "¿El nuevo precio (₡" + (parseFloat(newPrice)||0).toLocaleString("es-CR") + ") INCLUYE el IVA del 13%?"
          ),
          React.createElement(
            "div", { style: { display: "flex", flexDirection: "column", gap: "0.75rem" } },
            React.createElement("button", {
              onClick: () => handleSaveWithIva(true),
              style: { ...styles.buttonSuccess, padding: "0.75rem" },
            }, "✓ Sí, el precio incluye IVA"),
            React.createElement("button", {
              onClick: () => handleSaveWithIva(false),
              style: { ...styles.buttonDanger, padding: "0.75rem" },
            }, "✗ No, agregar IVA al precio"),
            React.createElement("button", {
              onClick: () => setShowIvaChoice(false),
              style: { ...styles.buttonOutline, padding: "0.5rem" },
            }, "Cancelar")
          )
        )
      )
    )
  );
}
// ========== END PRICE EDITOR MODAL ==========

function FormEditor({ record, onSave, onClose, lang }) {
  const t = translations[lang];
  const [form, setForm] = useState(record.form);
  const [errors, setErrors] = useState([]);
  const isMobile = useIsMobile();

  const validateForm = () => {
    const errs = [];
    
    if (!form.nombre.trim()) errs.push(t.requiredFullName);
    if (!hasFirstAndLastName(form.nombre)) errs.push(t.requiredTwoNames);
    if (!form.cedula.trim()) errs.push(t.requiredIdNumber);
    if (form.cedula && !/^\d+$/.test(form.cedula)) errs.push(t.idNumberOnlyNumbers);
    if (!form.fechaNacimiento) errs.push(t.requiredBirthDate);
    if (!isValidBirthYear(form.fechaNacimiento)) errs.push(t.invalidBirthYear);
    if (!isValidBirthDate(form.fechaNacimiento)) errs.push(t.invalidAge);
    if (!form.genero) errs.push(t.requiredGender);
    if (!form.profesion.trim()) errs.push(t.requiredProfession);
    if (!form.correo.trim()) errs.push(t.requiredEmail);
    if (!isValidEmail(form.correo)) errs.push(t.invalidEmail);
    if (!form.telefono.trim()) errs.push(t.requiredPhone);
    if (form.telefono && !/^\d+$/.test(form.telefono)) errs.push(t.phoneOnlyNumbers);
    if (!form.direccion.trim()) errs.push(t.requiredAddress);
    if (!form.emergenciaNombre.trim()) errs.push(t.requiredEmergencyName);
    if (!hasFirstAndLastName(form.emergenciaNombre)) errs.push(t.requiredEmergencyTwoNames);
    if (!form.emergenciaTelefono.trim()) errs.push(t.requiredEmergencyPhone);
    if (form.emergenciaTelefono && !/^\d+$/.test(form.emergenciaTelefono)) errs.push(t.emergencyPhoneOnlyNumbers);
    if (form.emergenciaCorreo.trim() && !isValidEmail(form.emergenciaCorreo)) errs.push(t.invalidEmergencyEmail);
    if (!form.emergenciaRelacion.trim()) errs.push(t.requiredEmergencyRelation);
    if (!form.medicamentosActuales) errs.push(t.requiredMedication);
    if (form.medicamentosActuales === "Sí" && !form.medicamentosCuales.trim()) errs.push(t.requiredWhichMedications);
    if (form.genero === "Femenino") {
      if (!form.anticonceptivos) errs.push(t.requiredBirthControl);
      if (form.anticonceptivos === "Sí" && !form.anticonceptivosCuales.trim()) errs.push(t.requiredBirthControlType);
    }
    if (form.procedimientosRecientes === "Sí" && !form.procedimientosRecientesCuales.trim()) errs.push(t.requiredWhichProcedures);
    if (!form.autorizaImagen) errs.push(t.requiredAuthorizeImage);
    
    setErrors(errs);
    return errs.length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
      onSave(form);
    }
  };

  const handleCedula = (v) => setForm({ ...form, cedula: onlyNumbers(v) });
  const handleTelefono = (v) => setForm({ ...form, telefono: onlyNumbers(v) });
  const handleEmergencyTelefono = (v) => setForm({ ...form, emergenciaTelefono: onlyNumbers(v) });

  const gridStyle = isMobile
    ? { display: "flex", flexDirection: "column", gap: "0.5rem" }
    : { ...styles.gridContainer, gap: "1rem 2rem" };

  const showAnticonceptivos = form.genero === "Femenino";
  const medicalOpts = medicalOptions[lang];

  return React.createElement(
    "div",
    { style: { ...styles.modalOverlay, alignItems: "flex-start", paddingTop: "2rem", overflow: "auto" } },
    React.createElement(
      "div",
      { style: { ...styles.modalContainer, maxWidth: "900px", maxHeight: "90vh", overflow: "auto", width: "95%", margin: "0 auto" } },
      React.createElement(
        "div",
        { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" } },
        React.createElement("div", { style: styles.modalTitle }, lang === "en" ? "✏️ Edit Registration Form" : "✏️ Editar Formulario de Registro"),
        React.createElement(
          "button",
          { onClick: onClose, style: { ...styles.buttonDanger, padding: "0.25rem 0.75rem" } },
          "✖"
        )
      ),
      
      errors.length > 0 &&
        React.createElement(
          "div",
          { style: styles.errorBox },
          React.createElement(
            "div",
            { style: { fontWeight: "bold", marginBottom: "0.5rem" } },
            lang === "en" ? "Please correct the following:" : "Por favor corrige lo siguiente:"
          ),
          React.createElement(
            "ul",
            { style: { paddingLeft: "1.25rem", margin: 0 } },
            errors.map((err, idx) =>
              React.createElement("li", { key: idx, style: { marginBottom: "0.25rem" } }, err)
            )
          )
        ),
      
      // Personal Information Section
      React.createElement(
        "div",
        { style: { ...styles.sectionHeader, marginTop: "0" } },
        lang === "en" ? "📋 PERSONAL INFORMATION" : "📋 INFORMACIÓN PERSONAL"
      ),
      React.createElement(
        "div",
        { style: gridStyle },
        React.createElement(Field, {
          labelText: t.fullName,
          value: form.nombre,
          onChange: (v) => setForm({ ...form, nombre: v }),
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.idNumber,
          value: form.cedula,
          onChange: handleCedula,
          type: "tel",
          inputMode: "numeric",
          required: true,
          lang,
        }),
        React.createElement(DateField, {
          labelText: t.dateOfBirth,
          value: form.fechaNacimiento,
          onChange: (v) => setForm({ ...form, fechaNacimiento: v, edad: calcAge(v) }),
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.age,
          value: form.edad,
          onChange: () => {},
          disabled: true,
          lang,
        }),
        React.createElement(SelectField, {
          labelText: t.gender,
          value: form.genero,
          onChange: (v) => setForm({ ...form, genero: v }),
          options: ["", t.female, t.male],
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.profession,
          value: form.profesion,
          onChange: (v) => setForm({ ...form, profesion: v }),
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.email,
          value: form.correo,
          onChange: (v) => setForm({ ...form, correo: v }),
          type: "email",
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.phoneNumber,
          value: form.telefono,
          onChange: handleTelefono,
          type: "tel",
          inputMode: "numeric",
          required: true,
          lang,
        })
      ),
      React.createElement(Field, {
        labelText: t.addressLabel,
        value: form.direccion,
        onChange: (v) => setForm({ ...form, direccion: v }),
        required: true,
        lang,
      }),
      
      // Emergency Contact Section
      React.createElement(
        "div",
        { style: styles.sectionHeader },
        lang === "en" ? "🚨 EMERGENCY CONTACT" : "🚨 CONTACTO DE EMERGENCIA"
      ),
      React.createElement(
        "div",
        { style: gridStyle },
        React.createElement(Field, {
          labelText: t.emergencyName,
          value: form.emergenciaNombre,
          onChange: (v) => setForm({ ...form, emergenciaNombre: v }),
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.emergencyPhone,
          value: form.emergenciaTelefono,
          onChange: handleEmergencyTelefono,
          type: "tel",
          inputMode: "numeric",
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.emergencyEmail,
          value: form.emergenciaCorreo,
          onChange: (v) => setForm({ ...form, emergenciaCorreo: v }),
          type: "email",
          lang,
        }),
        React.createElement(Field, {
          labelText: t.emergencyRelation,
          value: form.emergenciaRelacion,
          onChange: (v) => setForm({ ...form, emergenciaRelacion: v }),
          required: true,
          lang,
        })
      ),
      
      // Medical Information Section
      React.createElement(
        "div",
        { style: styles.sectionHeader },
        lang === "en" ? "🩺 MEDICAL INFORMATION" : "🩺 INFORMACIÓN MÉDICA"
      ),
      React.createElement(
        "div",
        {
          style: {
            display: "grid",
            // CORRECTION #3: Mobile medical conditions grid - change from 3 columns to 2 columns on mobile
            gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(3, 1fr)",
            gap: "0.75rem",
          },
        },
        medicalOpts.map((item) => {
          const originalItem = lang === "es" ? item :
            item === "Pregnancy" ? "Embarazo" :
            item === "Diabetes" ? "Diabetes" :
            item === "Autoimmune diseases" ? "Enfermedades autoinmunes" :
            item === "Rosacea" ? "Rosácea" :
            item === "Asthma" ? "Asma" :
            item === "Hypertension" ? "Hipertensión" :
            item === "Enlarged pores" ? "Poros dilatados" :
            item === "Epilepsy or seizures" ? "Epilepsia o convulsiones" :
            item === "Skin allergies" ? "Alergias en la piel" :
            item === "Heart disease" ? "Cardiopatía" :
            item === "Sun damage" ? "Daño solar" :
            "Enfermedades de ETS";
          return React.createElement(
            "label",
            {
              key: item,
              style: {
                borderRadius: "1rem",
                border: `1px solid ${colors.gray.medium}`,
                padding: "0.75rem",
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                backgroundColor: "white",
              },
            },
            React.createElement("input", {
              type: "checkbox",
              checked: form.medical?.includes(originalItem) || false,
              onChange: () =>
                setForm({ ...form, medical: toggleArray(originalItem, form.medical || []) }),
            }),
            React.createElement("span", { style: { fontSize: "0.875rem" } }, item)
          );
        })
      ),
      React.createElement(
        "div",
        { style: gridStyle },
        React.createElement(SelectField, {
          labelText: t.takingMedication,
          value: form.medicamentosActuales,
          onChange: (v) => setForm({ ...form, medicamentosActuales: v, medicamentosCuales: v !== "Sí" ? "" : form.medicamentosCuales }),
          options: ["", t.yes, t.no],
          required: true,
          lang,
        }),
        React.createElement(Field, {
          labelText: t.whichMedications,
          value: form.medicamentosCuales,
          onChange: (v) => setForm({ ...form, medicamentosCuales: v }),
          disabled: form.medicamentosActuales !== "Sí",
          lang,
        }),
        showAnticonceptivos &&
          React.createElement(SelectField, {
            labelText: t.birthControl,
            value: form.anticonceptivos,
            onChange: (v) => setForm({ ...form, anticonceptivos: v, anticonceptivosCuales: v !== "Sí" ? "" : form.anticonceptivosCuales }),
            options: ["", t.yes, t.no],
            required: true,
            lang,
          }),
        showAnticonceptivos &&
          React.createElement(Field, {
            labelText: t.birthControlType,
            value: form.anticonceptivosCuales,
            onChange: (v) => setForm({ ...form, anticonceptivosCuales: v }),
            disabled: form.anticonceptivos !== "Sí",
            lang,
          }),
        React.createElement(Field, {
          labelText: t.skinType,
          value: form.tipoPiel,
          onChange: (v) => setForm({ ...form, tipoPiel: v }),
          lang,
        }),
        React.createElement(Field, {
          labelText: t.allergies,
          value: form.alergiasProductos,
          onChange: (v) => setForm({ ...form, alergiasProductos: v }),
          lang,
        })
      ),
      React.createElement(
        "div",
        { style: gridStyle },
        React.createElement(SelectField, {
          labelText: t.recentProcedures,
          value: form.procedimientosRecientes,
          onChange: (v) =>
            setForm({
              ...form,
              procedimientosRecientes: v,
              procedimientosRecientesCuales: v !== "Sí" ? "" : form.procedimientosRecientesCuales,
            }),
          options: ["", t.yes, t.no],
          lang,
        }),
        React.createElement(Field, {
          labelText: t.whichProcedures,
          value: form.procedimientosRecientesCuales,
          onChange: (v) => setForm({ ...form, procedimientosRecientesCuales: v }),
          disabled: form.procedimientosRecientes !== "Sí",
          required: form.procedimientosRecientes === "Sí",
          lang,
        }),
        React.createElement(Field, {
          labelText: t.otherConcerns,
          value: form.otrasPreocupaciones,
          onChange: (v) => setForm({ ...form, otrasPreocupaciones: v }),
          lang,
        })
      ),
      React.createElement(
        "div",
        { style: { marginTop: "1rem" } },
        React.createElement(SelectField, {
          labelText: t.authorizeImage,
          value: form.autorizaImagen,
          onChange: (v) => setForm({ ...form, autorizaImagen: v }),
          options: ["", t.yes, t.no],
          required: true,
          lang,
        })
      ),
      
      React.createElement(
        "div",
        { style: { ...styles.modalButtons, marginTop: "2rem" } },
        React.createElement(
          "button",
          { onClick: onClose, style: styles.buttonOutline },
          lang === "en" ? "Cancel" : "Cancelar"
        ),
        React.createElement(
          "button",
          { onClick: handleSave, style: styles.buttonSuccess },
          lang === "en" ? "✓ Save Changes" : "✓ Guardar Cambios"
        )
      )
    )
  );
}

function RecordDetailView({ user, record, records, onUpdate, onDelete }) {
  const isMobile = useIsMobile();
  const [newNote, setNewNote] = useState("");
  const [showPrint, setShowPrint] = useState(false);
  const [showIvaModal, setShowIvaModal] = useState(false);
  const [pendingAddSessionsData, setPendingAddSessionsData] = useState(null);
  const [showFormEditor, setShowFormEditor] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [sessionDate, setSessionDate] = useState(new Date().toISOString().slice(0, 10));
  const [showPriceEditor, setShowPriceEditor] = useState(false);
  const [priceEditorTarget, setPriceEditorTarget] = useState(null); // "main" or additional treatment id
  const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  const [pendingTreatmentData, setPendingTreatmentData] = useState(null);
  const [showCollectSessionPayment, setShowCollectSessionPayment] = useState(false);
  const [pendingSessionData, setPendingSessionData] = useState(null);
  // Modal-based replacements for prompt() dialogs
  const [showCreateTreatmentModal, setShowCreateTreatmentModal] = useState(false);
  const [createTreatmentForm, setCreateTreatmentForm] = useState({ totalSessions: "5", treatmentName: "", packagePrice: "" });
  const [showAddSessionsModal, setShowAddSessionsModal] = useState(false);
  const [addSessionsForm, setAddSessionsForm] = useState({ additionalSessions: "1", additionalPrice: "0", reason: "Cliente solicitó sesiones adicionales" });
  const [showEditPayment, setShowEditPayment] = useState(false);
  const [editPaymentTarget, setEditPaymentTarget] = useState(null); // null = main plan, at.id = additional
  const [showEditSession, setShowEditSession] = useState(false);
  const [editSessionTarget, setEditSessionTarget] = useState(null); // { sessionNum, isAdditional, atId }

  const [editSessionDate, setEditSessionDate] = useState("");
  const [editSessionSpecialist, setEditSessionSpecialist] = useState("");
  const [editSessionNote, setEditSessionNote] = useState("");
  // Session payment editing (with optional split across two methods)
  const [editSessAmount, setEditSessAmount] = useState("");
  const [editSessMethod, setEditSessMethod] = useState("");
  const [editSessSplit, setEditSessSplit] = useState(false);
  const [editSessAmount2, setEditSessAmount2] = useState("");
  const [editSessMethod2, setEditSessMethod2] = useState("");
  const [showClientInfo, setShowClientInfo] = useState(false); // collapsed by default
  const [showAddTreatmentLocal, setShowAddTreatmentLocal] = useState(false);
  // React state replacement for window.tempIvaCallback
  const [ivaCallback, setIvaCallback] = useState(null);
  const canValidate = ["especialista", "manager", "owner"].includes(user.role);
  const canCreateTreatment = ["especialista", "manager", "owner"].includes(
    user.role
  );
  const canRegisterSession = ["especialista", "manager", "owner", "admin"].includes(
    user.role
  );
  const canAddSessions = ["especialista", "manager", "owner"].includes(
    user.role
  );
  const canFinalize = ["especialista", "manager", "owner"].includes(user.role);
  const canDeleteTreatment = ["owner", "admin"].includes(user.role);
  const canEditForm = user.role !== "recepcion";
  const canEditPrice = ["especialista", "manager", "owner"].includes(user.role);

  const isRecordValidated = record.status === "validado";
  const hasTreatment = !!record.treatmentPlan;
  const isCompleted = record.treatmentPlan?.remainingSessions === 0;
  const isFinalized = record.treatmentPlan?.status === "finalizado";

  const handleValidate = async () => {
    const updated = {
      ...record,
      status: "validado",
      specialistReview: {
        specialistName: user.nombreCompleto,
        signedAt: new Date().toISOString(),
      },
    };
    await saveRecordToFirestore(updated);
    onUpdate(updated);
  };
  const handleEditForm = () => {
    setShowFormEditor(true);
  };

  const handleDeleteRecordClick = () => {
    if (!onDelete) return;
    const sessionCount = (record.sessions || []).length;
    const hasPlan = !!record.treatmentPlan;
    const addlCount = (record.additionalTreatments || []).length;
    let collected = 0;
    const pi = record.treatmentPlan?.paymentInfo;
    if (pi && Array.isArray(pi.payments)) {
      collected = pi.payments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
    }
    (record.sessions || []).forEach((s) => {
      if (s.payment && s.payment.amount) collected += Number(s.payment.amount) || 0;
    });

    const name = record.form?.nombre || "este cliente";
    let warning = `¿Eliminar el expediente de ${name}?\n\nEsta acción NO se puede deshacer.`;
    if (hasPlan || sessionCount > 0 || addlCount > 0 || collected > 0) {
      warning += `\n\nSe eliminarán permanentemente:`;
      if (hasPlan) warning += `\n• El plan de tratamiento`;
      if (addlCount > 0) warning += `\n• ${addlCount} tratamiento(s) adicional(es)`;
      if (sessionCount > 0) warning += `\n• ${sessionCount} sesión(es) registrada(s)`;
      if (collected > 0) warning += `\n• Historial de pagos por ${formatCurrency(collected)}`;
    }
    if (!window.confirm(warning)) return;

    if (collected > 0 || sessionCount > 0) {
      if (!window.confirm(`Confirme una vez más: eliminar el expediente de ${name} y todo su historial. ¿Continuar?`)) return;
    }
    onDelete(record);
  };

  const handleSaveFormEdit = async (updatedForm) => {
    const changeRecord = {
      field: "formulario de registro",
      before: "Datos originales",
      after: "Datos actualizados",
      by: user.nombreCompleto,
      reason: "Corrección de información del cliente",
      at: new Date().toISOString(),
    };
    
    const updated = {
      ...record,
      form: updatedForm,
      changeHistory: [...(record.changeHistory || []), changeRecord],
    };
    
    await saveRecordToFirestore(updated);
    onUpdate(updated);
    setShowFormEditor(false);
  };

  const handleCreateTreatment = () => {
    // Open modal-based form instead of prompt()
    setCreateTreatmentForm({
      totalSessions: "5",
      treatmentName: record.form.bodyCategory || record.form.treatmentType || "Tratamiento",
      packagePrice: "",
    });
    setShowCreateTreatmentModal(true);
  };

  const handleCreateTreatmentSubmit = () => {
    const { totalSessions, treatmentName, packagePrice } = createTreatmentForm;
    if (!totalSessions || !treatmentName) return;
    // Store values and show IVA modal using React state callback
    const handleIvaResponse = async (ivaIncluded) => {
      const priceNum = parseFloat(packagePrice) || 0;
      let ivaAmount = 0;
      let basePrice = priceNum;
      let finalPrice = priceNum;

      if (ivaIncluded) {
        basePrice = Math.round(priceNum / 1.13);
        ivaAmount = priceNum - basePrice;
        finalPrice = priceNum;
      } else {
        basePrice = priceNum;
        ivaAmount = Math.round(priceNum * 0.13);
        finalPrice = priceNum + ivaAmount;
      }

      setPendingTreatmentData({
        treatmentName: treatmentName.trim(),
        totalSessions: parseInt(totalSessions),
        basePrice,
        ivaAmount,
        ivaIncluded,
        finalPrice,
      });
      setShowIvaModal(false);
      setIvaCallback(null);
      setShowPaymentSetup(true);
    };

    setShowCreateTreatmentModal(false);
    setIvaCallback(() => handleIvaResponse);
    setShowIvaModal(true);
  };

  const handlePaymentSetupSave = async (paymentInfo) => {
    if (!pendingTreatmentData) return;
    const { treatmentName, totalSessions, basePrice, ivaAmount, ivaIncluded, finalPrice } = pendingTreatmentData;
    const updated = {
      ...record,
      treatmentPlan: {
        name: treatmentName,
        totalSessions,
        completedSessions: 0,
        remainingSessions: totalSessions,
        startDate: new Date().toISOString().slice(0, 10),
        status: "activo",
        sessionAdditions: [],
        packagePrice: basePrice,
        ivaAmount,
        ivaIncluded,
        totalPrice: finalPrice,
        paymentInfo: paymentInfo,
      },
    };
    await saveRecordToFirestore(updated);
    if (paymentInfo.paymentType === "tarjeta_regalo") {
      await processGiftCardRedemption(paymentInfo, treatmentName);
    }
    if (paymentInfo.paymentType === "deposito_adelantado") {
      await processDepositApplication(paymentInfo, record.form?.nombre);
    }
    onUpdate(updated);
    setPendingTreatmentData(null);
    setShowPaymentSetup(false);
    alert(`✅ TRATAMIENTO CREADO\n\n💰 Total: ${formatCurrency(finalPrice)}\n📅 Sesiones: ${totalSessions}\n💳 Tipo de pago: ${PAYMENT_TYPES.find(p=>p.value===paymentInfo.paymentType)?.label || paymentInfo.paymentType}`);
  };

  const handleFinalize = async () => {
    const plan = record.treatmentPlan;
    const completed = plan?.completedSessions || 0;
    const total = plan?.totalSessions || 0;
    const hasPendingSessions = completed < total;

    // RULE: If there are pending sessions, a note is MANDATORY before finalizing
    if (hasPendingSessions) {
      if (!newNote || newNote.trim() === "") {
        alert(
          `❌ Hay ${total - completed} sesión(es) pendiente(s).\n\n` +
          `Para finalizar antes de completar el tratamiento, debe ingresar una nota explicando el motivo (ej: cliente abandonó el tratamiento).\n\n` +
          `👉 Escriba la nota en el campo "Agregar nota" y luego presione Finalizar.`
        );
        return;
      }
      // Note present — confirm early termination
      if (!window.confirm(
        `⚠️ Quedan ${total - completed} sesión(es) sin completar.\n\n` +
        `¿Confirma que desea finalizar el tratamiento anticipadamente?\n` +
        `La nota ingresada quedará registrada como motivo.`
      )) return;
    }

    // Check outstanding balance — deduct all collected amounts
    const pi = plan?.paymentInfo || {};
    const totalPrice = plan?.totalPrice || 0;
    const totalDeposited = (pi.deposits || []).reduce((s, d) => s + d.amount, 0);
    const totalFromPayments = (pi.payments || []).reduce((s, p) => s + p.amount, 0);
    const totalFromSchedule = (pi.paymentSchedule || [])
      .filter(i => i.status === "pagado" || i.status === "parcial")
      .reduce((s, i) => s + (i.paidAmount || i.amount), 0);
    const totalPaid = totalDeposited + totalFromPayments + totalFromSchedule;
    const outstanding = Math.max(0, totalPrice - totalPaid);

    // Tarjeta de Regalo and Yuplon — already paid in full, skip payment prompt
    const isGiftCard = pi.paymentType === "tarjeta_regalo";
    const isYuplon = pi.paymentType === "yuplon";

    if (!isGiftCard && !isYuplon && outstanding > 0) {
      setPendingSessionData({
        isFinalPayment: true,
        amount: outstanding,
        label: totalPaid > 0
          ? `Saldo pendiente: ${formatCurrency(outstanding)} (ya cobrado: ${formatCurrency(totalPaid)})`
          : `Pago total del tratamiento: ${formatCurrency(outstanding)}`,
      });
      setShowCollectSessionPayment(true);
      return;
    }

    // All clear — finalize
    if (!hasPendingSessions && !window.confirm("¿Finalizar tratamiento? El saldo está completamente pagado.")) return;

    // Save the mandatory note first if there was one
    let updatedRecord = { ...record };
    if (hasPendingSessions && newNote.trim()) {
      const noteEntry = {
        text: `[CIERRE ANTICIPADO] ${newNote.trim()}`,
        by: user.nombreCompleto,
        role: user.label,
        at: new Date().toISOString(),
      };
      updatedRecord = {
        ...updatedRecord,
        notes: [...(record.notes || []), noteEntry],
      };
      setNewNote("");
    }

    const now = new Date().toISOString().slice(0, 10);
    const updated = {
      ...updatedRecord,
      treatmentPlan: { ...plan, status: "finalizado", finalizedAt: now },
    };
    await saveRecordToFirestore(updated);
    onUpdate(updated);
    alert("✅ Tratamiento finalizado");
  };

  const handleFinalPaymentCollected = async (paymentData) => {
    // Called when final payment is collected before finalizing
    const newPayment = {
      id: `pay_${Date.now()}`,
      amount: paymentData.amount,
      method: paymentData.method,
      date: paymentData.date,
      at: paymentData.at,
      collectedBy: user.nombreCompleto,
      type: "balance",
      reference: null,
    };

    let updated;

    if (pendingSessionData?.isAdditionalTreatment && pendingSessionData?.additionalTreatmentId) {
      // Final payment for an additional treatment
      const atId = pendingSessionData.additionalTreatmentId;
      const updatedAdditionals = (record.additionalTreatments || []).map(a => {
        if (a.id !== atId) return a;
        const atPi = a.paymentInfo || {};
        return {
          ...a,
          status: "finalizado",
          finalizedAt: new Date().toISOString().slice(0, 10),
          paymentInfo: {
            ...atPi,
            payments: [...(atPi.payments || []), newPayment],
          },
        };
      });
      updated = { ...record, additionalTreatments: updatedAdditionals };
    } else {
      // Final payment for the main treatment plan
      const plan = record.treatmentPlan;
      const pi = plan?.paymentInfo || {};
      updated = {
        ...record,
        treatmentPlan: {
          ...plan,
          status: "finalizado",
          finalizedAt: new Date().toISOString().slice(0, 10),
          paymentInfo: { ...pi, payments: [...(pi.payments || []), newPayment] },
        },
      };
    }

    await saveRecordToFirestore(updated);
    onUpdate(updated);
    setShowCollectSessionPayment(false);
    setPendingSessionData(null);
    alert("✅ Pago registrado y tratamiento finalizado");
  };

  const handleRegisterSession = async (sessionPaymentData) => {
    if (!isRecordValidated) return alert("❌ Expediente debe estar validado");
    if (!hasTreatment) return alert("❌ No hay plan de tratamiento");
    if (isFinalized) return alert("❌ Tratamiento ya finalizado");
    const completed = record.treatmentPlan.completedSessions || 0;
    const total = record.treatmentPlan.totalSessions;
    if (completed >= total) return alert("❌ No hay más sesiones");
    const nextNum = completed + 1;
    const isLast = nextNum === total;

    const newSession = {
      number: nextNum,
      date: sessionDate,
      specialist: user.nombreCompleto,
      status: "realizada",
    };

    // If per_sesion payment type, attach payment to session
    if (sessionPaymentData) {
      newSession.payment = sessionPaymentData;
    }

    const newSessions = [...(record.sessions || []), newSession];

    // Also add to paymentInfo.payments if per_sesion
    let updatedPaymentInfo = record.treatmentPlan.paymentInfo || {};
    if (sessionPaymentData && updatedPaymentInfo.paymentType === "por_sesion") {
      updatedPaymentInfo = {
        ...updatedPaymentInfo,
        payments: [...(updatedPaymentInfo.payments || []), {
          id: `pay_${Date.now()}`,
          amount: sessionPaymentData.amount,
          method: sessionPaymentData.method,
          date: sessionPaymentData.date,
          at: sessionPaymentData.at,
          collectedBy: user.nombreCompleto,
          type: "session",
          reference: nextNum,
        }],
      };
    }

    const updated = {
      ...record,
      sessions: newSessions,
      treatmentPlan: {
        ...record.treatmentPlan,
        completedSessions: completed + 1,
        remainingSessions: total - (completed + 1),
        status: isLast ? "completado" : "activo",
        paymentInfo: updatedPaymentInfo,
      },
    };
    await saveRecordToFirestore(updated);
    onUpdate(updated);
    setShowSessionModal(false);
    setPendingSessionData(null);
    setShowCollectSessionPayment(false);
    setSessionDate(new Date().toISOString().slice(0, 10));
    alert(
      isLast
        ? `✅ Sesión ${nextNum} registrada.\n👉 Use "Finalizar" para completar`
        : `✅ Sesión ${nextNum} registrada. Restan ${total - (completed + 1)}`
    );
  };

  const initiateRegisterSession = () => {
    if (!isRecordValidated) return alert("❌ Expediente debe estar validado");
    if (!hasTreatment) return alert("❌ No hay plan de tratamiento");
    if (isFinalized) return alert("❌ Tratamiento ya finalizado");
    const completed = record.treatmentPlan.completedSessions || 0;
    const total = record.treatmentPlan.totalSessions;
    if (completed >= total) return alert("❌ No hay más sesiones");
    const paymentType = record.treatmentPlan?.paymentInfo?.paymentType;
    if (paymentType === "por_sesion") {
      // Show payment reminder — pre-fill agreed amount
      const agreedAmount = record.treatmentPlan?.paymentInfo?.amountPerSession || null;
      setPendingSessionData({ collectAfter: true, isSessionPayment: true, agreedAmount });
      setShowCollectSessionPayment(true);
    } else {
      // Tarjeta de Regalo and all other plan types — just log the session, no payment needed
      setShowSessionModal(true);
    }
  };

  const startAddSessions = () => {
    // Open modal-based form instead of prompt()
    setAddSessionsForm({ additionalSessions: "1", additionalPrice: "0", reason: "Cliente solicitó sesiones adicionales" });
    setShowAddSessionsModal(true);
  };

  const handleAddSessionsSubmit = () => {
    const { additionalSessions, additionalPrice, reason, _additionalTreatmentId } = addSessionsForm;
    const sessNum = parseInt(additionalSessions);
    if (isNaN(sessNum) || sessNum <= 0) return;
    if (!reason.trim()) return;
    const priceNum = parseFloat(additionalPrice) || 0;

    if (_additionalTreatmentId) {
      // Additional treatment flow — show IVA modal then apply directly
      const handleIvaForAdditional = async (ivaIncluded) => {
        let extraIva = 0;
        let extraTotal = priceNum;
        if (!ivaIncluded) { extraIva = Math.round(priceNum * 0.13); extraTotal = priceNum + extraIva; }
        const at = (record.additionalTreatments || []).find(a => a.id === _additionalTreatmentId);
        if (!at) return;
        const updatedAt = {
          ...at,
          totalSessions: at.totalSessions + sessNum,
          remainingSessions: at.remainingSessions + sessNum,
          status: "activo",
          packagePrice: (at.packagePrice || 0) + priceNum,
          ivaAmount: (at.ivaAmount || 0) + extraIva,
          totalPrice: (at.totalPrice || 0) + extraTotal,
          sessionAdditions: [...(at.sessionAdditions || []), { date: new Date().toISOString(), addedBy: user.nombreCompleto, extraSessions: sessNum, extraPrice: priceNum, extraIva, extraTotal, reason: reason.trim() }],
        };
        const updatedAdditionals = record.additionalTreatments.map((a) => a.id === _additionalTreatmentId ? updatedAt : a);
        const updated = { ...record, additionalTreatments: updatedAdditionals };
        await saveRecordToFirestore(updated);
        onUpdate(updated);
        setShowIvaModal(false);
        setIvaCallback(null);
        alert(`✅ ${sessNum} sesiones adicionales agregadas`);
      };
      setShowAddSessionsModal(false);
      setIvaCallback(() => handleIvaForAdditional);
      setShowIvaModal(true);
    } else {
      // Main treatment plan flow
      setPendingAddSessionsData({ additionalSessions: sessNum, additionalPrice: priceNum, reason: reason.trim() });
      setShowAddSessionsModal(false);
      setShowIvaModal(true);
    }
  };

  const handleAddSessionsWithIva = async (ivaIncluded) => {
    if (!pendingAddSessionsData) return;

    const { additionalSessions, additionalPrice, reason } =
      pendingAddSessionsData;

    let additionalIva = 0;
    let additionalTotal = additionalPrice;
    if (!ivaIncluded) {
      additionalIva = additionalPrice * 0.13;
      additionalTotal = additionalPrice + additionalIva;
    }

    const currentTotalSessions = record.treatmentPlan.totalSessions;
    const currentCompleted = record.treatmentPlan.completedSessions || 0;
    const currentRemaining = record.treatmentPlan.remainingSessions;
    const currentPackagePrice = record.treatmentPlan.packagePrice || 0;
    const currentIvaAmount = record.treatmentPlan.ivaAmount || 0;
    const currentTotalPrice = record.treatmentPlan.totalPrice || 0;

    const newTotalSessions = currentTotalSessions + additionalSessions;
    const newRemaining = currentRemaining + additionalSessions;
    const newPackagePrice = currentPackagePrice + additionalPrice;
    const newIvaAmount = currentIvaAmount + additionalIva;
    const newTotalPrice = currentTotalPrice + additionalTotal;

    const additionRecord = {
      date: new Date().toISOString(),
      addedBy: user.nombreCompleto,
      additionalSessions: additionalSessions,
      additionalPrice: additionalPrice,
      additionalIva: additionalIva,
      additionalTotal: additionalTotal,
      ivaIncluded: ivaIncluded,
      reason: reason,
      previousTotalSessions: currentTotalSessions,
      newTotalSessions: newTotalSessions,
      previousPackagePrice: currentPackagePrice,
      newPackagePrice: newPackagePrice,
      previousTotalPrice: currentTotalPrice,
      newTotalPrice: newTotalPrice,
    };

    const updatedPlan = {
      ...record.treatmentPlan,
      totalSessions: newTotalSessions,
      remainingSessions: newRemaining,
      status: "activo",
      packagePrice: newPackagePrice,
      ivaAmount: newIvaAmount,
      totalPrice: newTotalPrice,
      sessionAdditions: [
        ...(record.treatmentPlan.sessionAdditions || []),
        additionRecord,
      ],
    };

    const changeRecord = {
      field: "sesiones y precio",
      before: `${currentTotalSessions} sesiones · ${formatCurrency(
        currentPackagePrice
      )}`,
      after: `${newTotalSessions} sesiones · ${formatCurrency(
        newPackagePrice
      )}`,
      by: user.nombreCompleto,
      reason: reason,
      at: new Date().toISOString(),
    };

    const updated = {
      ...record,
      treatmentPlan: updatedPlan,
      changeHistory: [...(record.changeHistory || []), changeRecord],
    };

    await saveRecordToFirestore(updated);
    onUpdate(updated);

    alert(
      `✅ SESIONES ADICIONALES AGREGADAS\n\n` +
        `📊 Sesiones: ${currentTotalSessions} → ${newTotalSessions}\n` +
        `💰 Precio original: ${formatCurrency(currentPackagePrice)}\n` +
        `💰 Nuevo precio (sesiones adicionales): ${formatCurrency(
          additionalPrice
        )}\n` +
        `📋 IVA de las adicionales: ${
          ivaIncluded ? "Incluido" : formatCurrency(additionalIva)
        }\n` +
        `💰 Nuevo total del paquete: ${formatCurrency(newPackagePrice)}\n` +
        `💰 Nuevo total con IVA: ${formatCurrency(newTotalPrice)}\n\n` +
        `📅 Sesiones restantes: ${newRemaining}\n` +
        `👤 Agregado por: ${user.nombreCompleto}\n` +
        `📝 Motivo: ${reason}`
    );

    setShowIvaModal(false);
    setPendingAddSessionsData(null);
  };

  const handleAddNote = async () => {
    if (!newNote.trim()) return alert("Escriba una nota");
    const updated = {
      ...record,
      notes: [
        ...(record.notes || []),
        {
          id: Date.now(),
          text: newNote,
          author: user.nombreCompleto,
          role: user.label,
          date: new Date().toISOString(),
        },
      ],
    };
    await saveRecordToFirestore(updated);
    onUpdate(updated);
    setNewNote("");
  };

  const status = getClientStatus(record);
  const showFinalize = !isFinalized && canFinalize && hasTreatment; // Allow early finalize (requires note if sessions pending)
  // Treatment navigation — all plans for this client
  // Sort additional treatments by addedAt date (oldest first) to preserve insertion order
  const sortedAdditionals = [...(record.additionalTreatments || [])].sort((a, b) => {
    const da = a.addedAt ? new Date(a.addedAt) : 0;
    const db = b.addedAt ? new Date(b.addedAt) : 0;
    return da - db;
  });
  const allTreatments = [
    ...(hasTreatment ? [{ id: "main", label: `T1 - ${record.treatmentPlan?.name || "Plan principal"}`, status: record.treatmentPlan?.status }] : []),
    ...sortedAdditionals.map((at, i) => ({
      id: at.id,
      label: `T${i + 2} - ${at.treatmentName || at.treatmentType || `Tratamiento ${i + 2}`}`,
      status: at.status,
    })),
  ];
  const [activeTreatmentId, setActiveTreatmentId] = useState("main");

  // CORRECTION #2: Helper to display IVA amount always in monetary value
  const formatIvaDisplay = (ivaAmount, ivaIncluded) => {
    if (ivaAmount === undefined || ivaAmount === null) return "—";
    const amountStr = formatCurrency(ivaAmount);
    if (ivaIncluded) {
      return `${amountStr} (incluido en el precio)`;
    }
    return amountStr;
  };

  if (showPaymentSetup && pendingTreatmentData) {
    return React.createElement(PaymentSetupModal, {
      totalPrice: pendingTreatmentData.finalPrice,
      onClose: () => { setShowPaymentSetup(false); setPendingTreatmentData(null); },
      onSave: handlePaymentSetupSave,
    });
  }

  if (showCollectSessionPayment) {
    const closeCollect = () => { setShowCollectSessionPayment(false); setPendingSessionData(null); };

    // ── Final balance before finalization ──
    if (pendingSessionData?.isFinalPayment) {
      return React.createElement(CollectPaymentModal, {
        title: "💰 " + (pendingSessionData.label || "Saldo pendiente"),
        amount: pendingSessionData.amount,
        onClose: closeCollect,
        onSave: handleFinalPaymentCollected,
        allowPartial: false,
      });
    }

    // ── Per-session payment reminder — main treatment ──
    if (pendingSessionData?.isSessionPayment && !pendingSessionData?.isAdditionalTreatment) {
      const completed = record.treatmentPlan?.completedSessions || 0;
      const nextNum = completed + 1;
      const doRegisterWithPayment = (paymentData) => {
        handleRegisterSession(paymentData);
        setShowCollectSessionPayment(false);
        setPendingSessionData(null);
      };
      const doRegisterPending = () => {
        const pendingEntry = { id: `pending_${Date.now()}`, sessionNum: nextNum, addedAt: new Date().toISOString(), note: "Pago de sesión pendiente" };
        handleRegisterSession(null);
        const updatedWithFlag = { ...record, paymentPending: [...(record.paymentPending || []), pendingEntry] };
        saveRecordToFirestore(updatedWithFlag).then(() => onUpdate(updatedWithFlag));
        setShowCollectSessionPayment(false);
        setPendingSessionData(null);
      };
      const agreedAmt = pendingSessionData?.agreedAmount || null;
      return React.createElement("div", { style: styles.modalOverlay },
        React.createElement("div", { style: { ...styles.modalContainer, maxWidth: "500px", textAlign: "left" } },
          React.createElement("div", { style: { backgroundColor: "#FEF3C7", borderRadius: "0.75rem", padding: "0.75rem 1rem", marginBottom: "1rem", color: "#92400E", fontWeight: "600", textAlign: "center" } },
            `⚠️ Plan por sesión activo — Sesión #${nextNum}` + (agreedAmt ? ` — Monto acordado: ${formatCurrency(agreedAmt)}` : "")
          ),
          React.createElement("p", { style: { color: colors.gray.text, marginBottom: "1rem" } },
            "Este cliente tiene un plan de pago por sesión. Por favor registre el pago antes de cerrar la sesión."
          ),
          React.createElement(CollectPaymentModal, { title: `Cobro sesión #${nextNum}`, amount: agreedAmt, onClose: closeCollect, onSave: doRegisterWithPayment, allowPartial: true }),
          React.createElement("button", { onClick: doRegisterPending, style: { ...styles.buttonWarning, width: "100%", marginTop: "0.5rem" } },
            "⏰ Registrar sesión sin cobro — marcar como pago pendiente"
          )
        )
      );
    }

    // ── Per-session payment reminder — additional treatment ──
    if (pendingSessionData?.isAdditionalTreatment && pendingSessionData?.collectAfter) {
      const atHandler = (record.additionalTreatments || []).find(a => a.id === pendingSessionData.additionalTreatmentId);
      if (!atHandler) { closeCollect(); return null; }
      const atNextNum = (atHandler.completedSessions || 0) + 1;
      const atTotal = atHandler.totalSessions;
      const atIsLast = atNextNum === atTotal;
      const saveAtSession = (paymentData, markPending) => {
        const atPi = atHandler.paymentInfo || {};
        const newSess = { number: atNextNum, date: new Date().toISOString().slice(0, 10), specialist: user.nombreCompleto, paymentPending: markPending || false };
        if (paymentData) newSess.payment = paymentData;
        const updatedAtPi = paymentData ? { ...atPi, payments: [...(atPi.payments || []), { id: `pay_${Date.now()}`, amount: paymentData.amount, method: paymentData.method, date: paymentData.date, at: paymentData.at, collectedBy: user.nombreCompleto, type: "session", reference: atNextNum }] } : atPi;
        const updatedAt = { ...atHandler, completedSessions: atNextNum, remainingSessions: atTotal - atNextNum, status: atIsLast ? "completado" : "activo", sessions: [...(atHandler.sessions || []), newSess], paymentInfo: updatedAtPi };
        const updatedAdditionals = record.additionalTreatments.map(a => a.id === atHandler.id ? updatedAt : a);
        let updated = { ...record, additionalTreatments: updatedAdditionals };
        if (markPending) updated = { ...updated, paymentPending: [...(record.paymentPending || []), { id: `pending_${Date.now()}`, treatmentId: atHandler.id, treatmentName: atHandler.treatmentName, sessionNum: atNextNum, addedAt: new Date().toISOString() }] };
        saveRecordToFirestore(updated).then(() => { onUpdate(updated); closeCollect(); alert(atIsLast ? `✅ Sesión ${atNextNum} registrada.
👉 Use "Finalizar"` : `✅ Sesión ${atNextNum} registrada. Restan ${atTotal - atNextNum}`); });
      };
      return React.createElement("div", { style: styles.modalOverlay },
        React.createElement("div", { style: { ...styles.modalContainer, maxWidth: "500px", textAlign: "left" } },
          React.createElement("div", { style: { backgroundColor: "#FEF3C7", borderRadius: "0.75rem", padding: "0.75rem 1rem", marginBottom: "1rem", color: "#92400E", fontWeight: "600", textAlign: "center" } },
            `⚠️ Plan por sesión — ${atHandler.treatmentName} — Sesión #${atNextNum}` +
              (pendingSessionData?.agreedAmount ? ` — Monto: ${formatCurrency(pendingSessionData.agreedAmount)}` : "")
          ),
          React.createElement("p", { style: { color: colors.gray.text, marginBottom: "1rem" } }, "Por favor registre el pago antes de cerrar la sesión."),
          React.createElement(CollectPaymentModal, { title: `Cobro sesión #${atNextNum}`, amount: pendingSessionData?.agreedAmount || null, onClose: closeCollect, onSave: (pd) => saveAtSession(pd, false), allowPartial: true }),
          React.createElement("button", { onClick: () => saveAtSession(null, true), style: { ...styles.buttonWarning, width: "100%", marginTop: "0.5rem" } },
            "⏰ Registrar sesión sin cobro — marcar como pago pendiente"
          )
        )
      );
    }

    // ── Mid-treatment manual payment (from "Registrar pago" button) ──
    if (pendingSessionData?.isAdditionalTreatment) {
      return React.createElement(CollectPaymentModal, {
        title: "💰 " + (pendingSessionData.label || "Pago parcial"),
        amount: pendingSessionData.amount,
        onClose: closeCollect,
        onSave: handleFinalPaymentCollected,
        allowPartial: true,
      });
    }

    // ── Default fallback ──
    const completed = record.treatmentPlan?.completedSessions || 0;
    const nextNum = completed + 1;
    return React.createElement(CollectPaymentModal, {
      title: `💳 Cobrar sesión #${nextNum}`,
      amount: null,
      onClose: () => { setShowCollectSessionPayment(false); setShowSessionModal(false); closeCollect(); },
      onSave: (pd) => handleRegisterSession(pd),
    });
  }

  // ── Edit Session Handler ──
  const handleSaveEditSession = async () => {
    if (!editSessionNote.trim()) return alert("⚠️ Debe agregar una nota explicando el motivo del cambio.");
    if (!editSessionDate) return alert("⚠️ Debe ingresar la fecha correcta.");

    // Build the corrected payment object (single method or 2-way split).
    let newPayment = null;
    const a1 = parseFloat(editSessAmount) || 0;
    if (editSessSplit) {
      const a2 = parseFloat(editSessAmount2) || 0;
      if (a1 <= 0 || a2 <= 0) return alert("⚠️ En un pago dividido, ambos montos deben ser mayores que 0.");
      if (!editSessMethod || !editSessMethod2) return alert("⚠️ Seleccione el método para ambas partes del pago.");
      newPayment = {
        amount: a1 + a2,
        method: `${editSessMethod} + ${editSessMethod2}`,
        splits: [
          { amount: a1, method: editSessMethod },
          { amount: a2, method: editSessMethod2 },
        ],
        date: editSessionDate,
      };
    } else if (a1 > 0) {
      if (!editSessMethod) return alert("⚠️ Seleccione el método de pago.");
      newPayment = { amount: a1, method: editSessMethod, date: editSessionDate };
    }

    const { sessionNum, isAdditional, atId } = editSessionTarget;
    let updated;
    if (isAdditional) {
      const updatedAdditionals = record.additionalTreatments.map(at => {
        if (at.id !== atId) return at;
        const updatedSessions = (at.sessions || []).map(s =>
          s.number === sessionNum ? { ...s, date: editSessionDate, specialist: editSessionSpecialist, payment: newPayment !== null ? newPayment : s.payment, editNote: editSessionNote, editedAt: new Date().toISOString(), editedBy: user.nombreCompleto } : s
        );
        return { ...at, sessions: updatedSessions };
      });
      updated = { ...record, additionalTreatments: updatedAdditionals };
    } else {
      const updatedSessions = (record.sessions || []).map(s =>
        s.number === sessionNum ? { ...s, date: editSessionDate, specialist: editSessionSpecialist, payment: newPayment !== null ? newPayment : s.payment, editNote: editSessionNote, editedAt: new Date().toISOString(), editedBy: user.nombreCompleto } : s
      );
      updated = { ...record, sessions: updatedSessions };
    }
    // Also add the note to the record's notes array so it shows in Notas Adicionales
    const sessionLabel = editSessionTarget.isAdditional ? `T adicional — Sesión #${editSessionTarget.sessionNum}` : `T1 — Sesión #${editSessionTarget.sessionNum}`;
    const noteEntry = {
      id: `note_${Date.now()}`,
      text: `[CORRECCIÓN DE SESIÓN — ${sessionLabel}] ${editSessionNote} (Fecha corregida: ${editSessionDate}, Especialista: ${editSessionSpecialist || "—"})`,
      author: user.nombreCompleto,
      role: user.role,
      createdAt: new Date().toISOString(),
      tag: "CORRECCIÓN",
    };
    updated = { ...updated, notes: [...(updated.notes || []), noteEntry] };

    await saveRecordToFirestore(updated);
    onUpdate(updated);
    setShowEditSession(false);
    setEditSessionTarget(null);
    setEditSessionNote("");
    alert("✅ Sesión actualizada");
  };

  // ── Add Treatment Modal (from within client view) ──
  if (showAddTreatmentLocal) {
    return React.createElement(AddTreatmentModal, {
      user,
      records: records || [record],
      preselectedClient: record,
      onClose: () => setShowAddTreatmentLocal(false),
      onSaved: (updated) => {
        setShowAddTreatmentLocal(false);
        onUpdate(updated);
        // Switch tab to the newly added treatment
        const newAt = updated.additionalTreatments;
        if (newAt && newAt.length > 0) {
          const sortedNew = [...newAt].sort((a,b) => new Date(b.addedAt||0) - new Date(a.addedAt||0));
          setActiveTreatmentId(sortedNew[0].id);
        }
      },
    });
  }

  // ── Edit Session Modal ──
  if (showEditSession && editSessionTarget) {
    return React.createElement("div", { style: styles.modalOverlay },
      React.createElement("div", { style: { ...styles.modalContainer, maxWidth: "450px" } },
        React.createElement("div", { style: styles.modalTitle }, "✏️ Corregir sesión #" + editSessionTarget.sessionNum),
        React.createElement("div", { style: { marginBottom: "1rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Fecha correcta *"),
          React.createElement("input", { type: "date", style: styles.input, value: editSessionDate, onChange: e => setEditSessionDate(e.target.value) })
        ),
        React.createElement("div", { style: { marginBottom: "1rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.gold.dark, marginBottom: "0.4rem" } }, "Especialista"),
          React.createElement("input", { type: "text", style: styles.input, value: editSessionSpecialist, onChange: e => setEditSessionSpecialist(e.target.value), placeholder: "Nombre del especialista" })
        ),

        // ── Payment correction ──
        React.createElement("div", { style: { marginBottom: "1rem", padding: "0.75rem", backgroundColor: colors.gold.light, borderRadius: "0.6rem" } },
          React.createElement("div", { style: { fontWeight: "600", color: colors.gold.dark, marginBottom: "0.5rem", fontSize: "0.9rem" } }, "💳 Cobro de la sesión"),
          !editSessSplit
            ? React.createElement("div", null,
                React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "0.5rem" } },
                  React.createElement("input", { type: "tel", inputMode: "numeric", style: { ...styles.input, padding: "0.45rem 0.6rem" }, value: editSessAmount, onChange: e => setEditSessAmount(onlyNumbers(e.target.value)), placeholder: "Monto (₡)" }),
                  React.createElement("select", { style: { ...styles.input, padding: "0.45rem 0.6rem" }, value: editSessMethod, onChange: e => setEditSessMethod(e.target.value) },
                    React.createElement("option", { value: "" }, "— Método —"),
                    ["Efectivo", "SINPE", "SINPE (Jacky)", "Tarjeta de crédito"].map(m => React.createElement("option", { key: m, value: m }, m))
                  )
                ),
                React.createElement("button", { type: "button", onClick: () => setEditSessSplit(true), style: { background: "none", border: "none", color: colors.gold.dark, fontSize: "0.8rem", cursor: "pointer", textDecoration: "underline", padding: 0 } }, "➕ Dividir en dos métodos de pago")
              )
            : React.createElement("div", null,
                React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text, marginBottom: "0.4rem" } }, "Parte 1:"),
                React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "0.5rem" } },
                  React.createElement("input", { type: "tel", inputMode: "numeric", style: { ...styles.input, padding: "0.45rem 0.6rem" }, value: editSessAmount, onChange: e => setEditSessAmount(onlyNumbers(e.target.value)), placeholder: "Monto (₡)" }),
                  React.createElement("select", { style: { ...styles.input, padding: "0.45rem 0.6rem" }, value: editSessMethod, onChange: e => setEditSessMethod(e.target.value) },
                    React.createElement("option", { value: "" }, "— Método —"),
                    ["Efectivo", "SINPE", "SINPE (Jacky)", "Tarjeta de crédito"].map(m => React.createElement("option", { key: m, value: m }, m))
                  )
                ),
                React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text, marginBottom: "0.4rem" } }, "Parte 2:"),
                React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "0.5rem" } },
                  React.createElement("input", { type: "tel", inputMode: "numeric", style: { ...styles.input, padding: "0.45rem 0.6rem" }, value: editSessAmount2, onChange: e => setEditSessAmount2(onlyNumbers(e.target.value)), placeholder: "Monto (₡)" }),
                  React.createElement("select", { style: { ...styles.input, padding: "0.45rem 0.6rem" }, value: editSessMethod2, onChange: e => setEditSessMethod2(e.target.value) },
                    React.createElement("option", { value: "" }, "— Método —"),
                    ["Efectivo", "SINPE", "SINPE (Jacky)", "Tarjeta de crédito"].map(m => React.createElement("option", { key: m, value: m }, m))
                  )
                ),
                React.createElement("div", { style: { fontSize: "0.8rem", fontWeight: "600", color: colors.gold.dark, marginBottom: "0.4rem" } },
                  "Total: " + formatCurrency((parseFloat(editSessAmount)||0) + (parseFloat(editSessAmount2)||0))
                ),
                React.createElement("button", { type: "button", onClick: () => { setEditSessSplit(false); setEditSessAmount2(""); setEditSessMethod2(""); }, style: { background: "none", border: "none", color: colors.accent.danger, fontSize: "0.8rem", cursor: "pointer", textDecoration: "underline", padding: 0 } }, "✕ Quitar división (un solo método)")
              )
        ),

        React.createElement("div", { style: { marginBottom: "1rem" } },
          React.createElement("label", { style: { display: "block", fontWeight: "500", color: colors.accent.danger, marginBottom: "0.4rem" } }, "⚠️ Nota obligatoria — explique el motivo del cambio *"),
          React.createElement("textarea", { style: { ...styles.input, minHeight: "80px", resize: "vertical" }, value: editSessionNote, onChange: e => setEditSessionNote(e.target.value), placeholder: "Ej: La fecha fue registrada incorrectamente. La sesión se realizó el día..." })
        ),
        React.createElement("div", { style: { display: "flex", gap: "0.75rem", justifyContent: "flex-end" } },
          React.createElement("button", { onClick: () => { setShowEditSession(false); setEditSessionTarget(null); }, style: styles.buttonOutline }, "Cancelar"),
          React.createElement("button", { onClick: handleSaveEditSession, style: styles.buttonSuccess }, "✅ Guardar cambio")
        )
      )
    );
  }

  // ── Edit Payment Plan Modal ──
  if (showEditPayment) {
    const targetPlan = editPaymentTarget
      ? (record.additionalTreatments || []).find(a => a.id === editPaymentTarget)
      : record.treatmentPlan;
    const targetPrice = targetPlan?.totalPrice || 0;
    return React.createElement(PaymentSetupModal, {
      totalPrice: targetPrice,
      onClose: () => { setShowEditPayment(false); setEditPaymentTarget(null); },
      onSave: async (newPaymentInfo) => {
        let updated;
        if (editPaymentTarget) {
          const updatedAdditionals = (record.additionalTreatments || []).map(a =>
            a.id === editPaymentTarget
              ? { ...a, paymentInfo: { ...(a.paymentInfo || {}), ...newPaymentInfo } }
              : a
          );
          updated = { ...record, additionalTreatments: updatedAdditionals };
        } else {
          updated = {
            ...record,
            treatmentPlan: {
              ...record.treatmentPlan,
              paymentInfo: { ...(record.treatmentPlan?.paymentInfo || {}), ...newPaymentInfo },
            },
          };
        }
        await saveRecordToFirestore(updated);
        onUpdate(updated);
        setShowEditPayment(false);
        setEditPaymentTarget(null);
        alert("✅ Plan de pago actualizado");
      },
    });
  }

  if (showIvaModal && ivaCallback) {
    return React.createElement(IvaModal, {
      onClose: () => {
        setShowIvaModal(false);
        setIvaCallback(null);
      },
      onConfirm: (ivaIncluded) => {
        if (ivaCallback) {
          ivaCallback(ivaIncluded);
          setIvaCallback(null);
        }
      },
      title: "Información de IVA",
      message: "¿El precio ingresado INCLUYE el IVA? (13%)",
    });
  }

  // ── Modal: Crear Tratamiento (replaces prompt()) ──
  if (showCreateTreatmentModal) {
    return React.createElement(
      "div", { style: styles.modalOverlay },
      React.createElement(
        "div", { style: { ...styles.modalContainer, maxWidth: "480px", textAlign: "left" } },
        React.createElement("div", { style: styles.modalTitle }, "🩺 Nuevo Plan de Tratamiento"),
        React.createElement(Field, {
          labelText: "Total de sesiones",
          value: createTreatmentForm.totalSessions,
          onChange: (v) => setCreateTreatmentForm({ ...createTreatmentForm, totalSessions: v }),
          type: "number",
          required: true,
        }),
        React.createElement(Field, {
          labelText: "Nombre del tratamiento",
          value: createTreatmentForm.treatmentName,
          onChange: (v) => setCreateTreatmentForm({ ...createTreatmentForm, treatmentName: v }),
          required: true,
        }),
        React.createElement(Field, {
          labelText: "Precio total del paquete (₡)",
          value: createTreatmentForm.packagePrice,
          onChange: (v) => setCreateTreatmentForm({ ...createTreatmentForm, packagePrice: v }),
          type: "number",
        }),
        React.createElement(
          "div", { style: { ...styles.modalButtons, marginTop: "1.5rem" } },
          React.createElement("button", {
            onClick: () => setShowCreateTreatmentModal(false),
            style: styles.buttonOutline,
          }, "Cancelar"),
          React.createElement("button", {
            onClick: handleCreateTreatmentSubmit,
            style: styles.button,
            disabled: !createTreatmentForm.totalSessions || !createTreatmentForm.treatmentName,
          }, "Siguiente →")
        )
      )
    );
  }

  // ── Modal: Agregar Sesiones (replaces prompt()) ──
  if (showAddSessionsModal) {
    return React.createElement(
      "div", { style: styles.modalOverlay },
      React.createElement(
        "div", { style: { ...styles.modalContainer, maxWidth: "480px", textAlign: "left" } },
        React.createElement("div", { style: styles.modalTitle }, "➕ Agregar Sesiones"),
        React.createElement(Field, {
          labelText: "Número de sesiones adicionales",
          value: addSessionsForm.additionalSessions,
          onChange: (v) => setAddSessionsForm({ ...addSessionsForm, additionalSessions: v }),
          type: "number",
          required: true,
        }),
        React.createElement(Field, {
          labelText: "Precio de las sesiones adicionales (₡)",
          value: addSessionsForm.additionalPrice,
          onChange: (v) => setAddSessionsForm({ ...addSessionsForm, additionalPrice: v }),
          type: "number",
        }),
        React.createElement(TextAreaField, {
          labelText: "Motivo de la adición",
          value: addSessionsForm.reason,
          onChange: (v) => setAddSessionsForm({ ...addSessionsForm, reason: v }),
          required: true,
        }),
        React.createElement(
          "div", { style: { ...styles.modalButtons, marginTop: "1.5rem" } },
          React.createElement("button", {
            onClick: () => setShowAddSessionsModal(false),
            style: styles.buttonOutline,
          }, "Cancelar"),
          React.createElement("button", {
            onClick: handleAddSessionsSubmit,
            style: styles.button,
            disabled: !addSessionsForm.additionalSessions || !addSessionsForm.reason,
          }, "Siguiente →")
        )
      )
    );
  }

  if (showPriceEditor && priceEditorTarget) {
    return React.createElement(PriceEditorModal, {
      record: record,
      treatmentType: priceEditorTarget,
      onClose: () => {
        setShowPriceEditor(false);
        setPriceEditorTarget(null);
      },
      onSave: (updated) => {
        onUpdate(updated);
        setShowPriceEditor(false);
        setPriceEditorTarget(null);
      },
      user: user,
    });
  }

  const renderInfoRows = (rows) => {
    return rows.map((row, idx) => 
      React.createElement(InfoRow, { key: idx, label: row.label, value: row.value })
    );
  };

  return React.createElement(
    "div",
    { style: { overflowX: "hidden", width: "100%" } },
    React.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
          flexWrap: "wrap",
          gap: "1rem",
        },
      },
      React.createElement(
        "div",
        null,
        React.createElement(
          "h2",
          {
            style: {
              fontSize: "1.4rem",
              fontFamily: "Georgia, serif",
              marginBottom: "0.15rem",
              color: colors.gold.dark,
            },
          },
          record.form.nombre || "Cliente"
        ),
        // ── CHANGE 4: Show selected treatment title below client name ──
        (() => {
          const selected = allTreatments.find(t => t.id === activeTreatmentId);
          if (!selected) return null;
          return React.createElement(
            "div",
            { style: { fontSize: "0.9rem", color: colors.gray.text, marginBottom: "0.25rem", fontWeight: "600" } },
            selected.label
          );
        })(),
        React.createElement(
          "span",
          { style: { ...styles.badge, ...status.badgeStyle } },
          status.icon,
          " ",
          status.label
        ),
        isPendingClientCompletion(record) && React.createElement(
          "span",
          { style: { ...styles.badge, backgroundColor: colors.gold.light, color: colors.gold.dark, marginLeft: "0.3rem" } },
          "⚡ Datos pendientes"
        )
      ),
      // ── Completion-link banner: send the client a link to fill in their data ──
      isPendingClientCompletion(record) && (() => {
        const link = buildCompletionLink(record.id);
        const waText = `Hola${record.form && record.form.nombre ? " " + record.form.nombre : ""}, por favor complete su expediente de Nación Nila Estética en este enlace: ${link}`;
        const waLink = `https://wa.me/?text=${encodeURIComponent(waText)}`;
        return React.createElement(
          "div",
          { style: { width: "100%", backgroundColor: colors.gold.soft, border: `1px solid ${colors.gold.light}`, borderRadius: "0.6rem", padding: "0.75rem", marginBottom: "0.75rem" } },
          React.createElement("div", { style: { fontSize: "0.82rem", color: colors.gray.text, marginBottom: "0.5rem" } },
            "A este expediente le faltan datos del cliente. Envíele el enlace para que los complete:"
          ),
          React.createElement("div", { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap" } },
            React.createElement("button", {
              onClick: () => {
                try {
                  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link);
                  else { const ta = document.createElement("textarea"); ta.value = link; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta); }
                  alert("✅ Enlace copiado");
                } catch (e) { alert(link); }
              },
              style: { padding: "0.5rem 1rem", backgroundColor: colors.gold.primary, color: "white", border: "none", borderRadius: "2rem", cursor: "pointer", fontSize: "0.82rem", fontWeight: "700" },
            }, "📋 Copiar enlace"),
            React.createElement("a", { href: waLink, target: "_blank", rel: "noopener noreferrer", style: { padding: "0.5rem 1rem", backgroundColor: "#25D366", color: "white", borderRadius: "2rem", cursor: "pointer", fontSize: "0.82rem", fontWeight: "700", textDecoration: "none", display: "inline-block" } }, "💬 WhatsApp")
          )
        );
      })(),
      // ── Treatment navigation tabs (only shown when multiple treatments exist) ──
      allTreatments.length > 1 && React.createElement(
        "div",
        { style: { display: "flex", gap: "0.4rem", flexWrap: "wrap", marginBottom: "0.75rem", padding: "0.5rem", backgroundColor: colors.gray.warm, borderRadius: "0.75rem" } },
        allTreatments.map(t => React.createElement(
          "button",
          {
            key: t.id,
            onClick: () => setActiveTreatmentId(t.id),
            style: {
              padding: "0.3rem 0.75rem",
              borderRadius: "1rem",
              border: "none",
              fontSize: "0.78rem",
              fontWeight: activeTreatmentId === t.id ? "700" : "400",
              cursor: "pointer",
              backgroundColor: activeTreatmentId === t.id ? colors.gold.primary : "white",
              color: activeTreatmentId === t.id ? "white" : colors.gray.text,
              whiteSpace: "nowrap",
            },
          },
          (t.status === "finalizado" ? "🏁 " : t.status === "completado" ? "✅ " : "🟢 ") + t.label
        ))
      ),

      React.createElement(
        "div",
        { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap" } },
        React.createElement(
          "button",
          {
            onClick: () => setShowPrint(true),
            style: { ...styles.buttonOutline },
          },
          "🖨️ Imprimir formulario"
        ),
        (user.role === "admin" || user.role === "owner") && onDelete &&
          React.createElement(
            "button",
            {
              onClick: handleDeleteRecordClick,
              style: { ...styles.buttonOutline, backgroundColor: "#FEF2F2", borderColor: "#DC2626", color: "#DC2626" },
            },
            "🗑️ Eliminar expediente"
          ),
        canEditForm &&
          React.createElement(
            "button",
            {
              onClick: handleEditForm,
              style: { ...styles.buttonOutline, backgroundColor: colors.gold.light, borderColor: colors.gold.primary },
            },
            "✏️ Editar formulario"
          ),
        canValidate &&
          record.status !== "validado" &&
          React.createElement(
            "button",
            { onClick: handleValidate, style: styles.buttonSuccess },
            "✓ Validar"
          ),
        !hasTreatment &&
          canCreateTreatment &&
          isRecordValidated &&
          React.createElement(
            "button",
            { onClick: handleCreateTreatment, style: styles.button },
            "+ Tratamiento"
          ),
        // ── Agregar tratamiento adicional — available any time the record is validated ──
        isRecordValidated &&
          canCreateTreatment &&
          React.createElement(
            "button",
            {
              onClick: () => setShowAddTreatmentLocal(true),
              style: { ...styles.button, backgroundColor: colors.gold.dark },
            },
            "➕ Agregar tratamiento"
          ),

        hasTreatment &&
          canRegisterSession &&
          !isFinalized &&
          activeTreatmentId === "main" &&
          React.createElement(
            "button",
            { onClick: initiateRegisterSession, style: styles.button },
            `📝 Sesión (${record.treatmentPlan.completedSessions}/${record.treatmentPlan.totalSessions})`
          ),
        // ── CHANGE 3: Session button for selected additional treatment ──
        activeTreatmentId !== "main" && (() => {
          const selAt = (record.additionalTreatments || []).find(a => a.id === activeTreatmentId);
          if (!selAt) return null;
          const atCompleted = selAt.completedSessions || 0;
          const atTotal = selAt.totalSessions || 0;
          const atDone = atCompleted >= atTotal && atTotal > 0;
          if (atDone) return React.createElement(
            "span",
            { style: { fontSize: "0.8rem", color: colors.accent.success, fontWeight: "600", padding: "0.4rem 0.75rem" } },
            `✅ Sesiones completadas (${atCompleted}/${atTotal})`
          );
          // Safety: if totalSessions is 0 or undefined, don't show button
          if (!atTotal) return null;
          const handleAtSession = () => {
            const atPaymentType = selAt.paymentInfo?.paymentType;
            if (atPaymentType === "por_sesion" && selAt.paymentInfo) {
              setPendingSessionData({ collectAfter: true, isAdditionalTreatment: true, isSessionPayment: true, additionalTreatmentId: selAt.id, agreedAmount: selAt.paymentInfo?.amountPerSession || null });
              setShowCollectSessionPayment(true);
            } else {
              // Direct session log
              const nextNum = atCompleted + 1;
              const isLast = nextNum === atTotal;
              const updatedAt = { ...selAt, completedSessions: nextNum, remainingSessions: atTotal - nextNum, status: isLast ? "completado" : "activo", sessions: [...(selAt.sessions || []), { number: nextNum, date: new Date().toISOString().slice(0, 10), specialist: user.nombreCompleto }] };
              const updatedAdditionals = record.additionalTreatments.map(a => a.id === selAt.id ? updatedAt : a);
              const updated = { ...record, additionalTreatments: updatedAdditionals };
              saveRecordToFirestore(updated).then(() => { onUpdate(updated); alert(isLast ? `✅ Sesión ${nextNum} registrada.
👉 Use "Finalizar" para completar` : `✅ Sesión ${nextNum} registrada. Restan ${atTotal - nextNum}`); });
            }
          };
          return React.createElement("button", { onClick: handleAtSession, style: styles.button }, `📝 Sesión (${atCompleted}/${atTotal})`);
        })(),
        showSessionModal &&
          React.createElement(
            "div",
            {
              style: {
                position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex", alignItems: "center", justifyContent: "center",
                zIndex: 1000,
              },
              onClick: () => setShowSessionModal(false),
            },
            React.createElement(
              "div",
              {
                style: {
                  backgroundColor: "white",
                  borderRadius: "1rem",
                  padding: "2rem",
                  minWidth: "300px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                },
                onClick: (e) => e.stopPropagation(),
              },
              React.createElement(
                "h3",
                { style: { margin: 0, fontFamily: "Georgia, serif", color: colors.gold.dark } },
                "📅 Fecha de la sesión"
              ),
              React.createElement(
                "p",
                { style: { margin: 0, color: colors.gray.text, fontSize: "0.9rem" } },
                "Seleccione la fecha en que se realizó la sesión:"
              ),
              React.createElement("input", {
                type: "date",
                value: sessionDate,
                max: new Date().toISOString().slice(0, 10),
                onChange: (e) => setSessionDate(e.target.value),
                style: {
                  padding: "0.75rem 1rem",
                  borderRadius: "0.5rem",
                  border: `1px solid ${colors.gold.primary}`,
                  fontSize: "1rem",
                  width: "100%",
                  cursor: "pointer",
                },
              }),
              React.createElement(
                "div",
                { style: { display: "flex", gap: "0.75rem", justifyContent: "flex-end" } },
                React.createElement(
                  "button",
                  {
                    onClick: () => setShowSessionModal(false),
                    style: { ...styles.buttonOutline, padding: "0.6rem 1.25rem" },
                  },
                  "Cancelar"
                ),
                React.createElement(
                  "button",
                  {
                    onClick: () => {
                      const paymentType = record.treatmentPlan?.paymentInfo?.paymentType;
                      if (paymentType === "por_sesion") {
                        setShowSessionModal(false);
                        setShowCollectSessionPayment(true);
                      } else {
                        handleRegisterSession(null);
                      }
                    },
                    style: { ...styles.button, padding: "0.6rem 1.25rem" },
                  },
                  "✅ Confirmar sesión"
                )
              )
            )
          ),
        hasTreatment &&
          canAddSessions &&
          React.createElement(
            "button",
            { onClick: startAddSessions, style: styles.buttonWarning },
            "➕ Agregar sesiones"
          ),
        showFinalize &&
          React.createElement(
            "button",
            { onClick: handleFinalize, style: styles.buttonSuccess },
            "🏁 Finalizar"
          ),
        // Backfill: main treatment is finalized but has no finalizedAt date
        isFinalized && !record.treatmentPlan?.finalizedAt && canFinalize &&
          React.createElement("button", {
            onClick: async () => {
              const dateInput = window.prompt("¿Cuándo se finalizó este tratamiento? (YYYY-MM-DD)", new Date().toISOString().slice(0,10));
              if (!dateInput || !/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) return alert("Formato inválido. Use YYYY-MM-DD");
              const updated = { ...record, treatmentPlan: { ...record.treatmentPlan, finalizedAt: dateInput } };
              await saveRecordToFirestore(updated);
              onUpdate(updated);
              alert("✅ Fecha de finalización guardada");
            },
            style: { ...styles.buttonOutline, fontSize: "0.78rem", padding: "0.3rem 0.65rem", borderColor: colors.accent.warning, color: colors.accent.warning },
          }, "📅 Registrar fecha finalización")
      )
    ),
    showPrint &&
      React.createElement(PrintForm, {
        record,
        onClose: () => setShowPrint(false),
      }),

    showIvaModal &&
      pendingAddSessionsData &&
      React.createElement(IvaModal, {
        onClose: () => {
          setShowIvaModal(false);
          setPendingAddSessionsData(null);
        },
        onConfirm: handleAddSessionsWithIva,
        title: "Información de IVA",
        message:
          "¿El precio ingresado para las sesiones adicionales INCLUYE el IVA? (13%)",
      }),

    record.specialistReview &&
      React.createElement(
        "div",
        {
          style: {
            backgroundColor: colors.accent.successLight,
            padding: "0.5rem",
            borderRadius: "0.5rem",
            marginBottom: "1rem",
            color: colors.accent.success,
          },
        },
        "✓ Validado por ",
        record.specialistReview.specialistName
      ),

    hasTreatment &&
      activeTreatmentId === "main" &&
      record.treatmentPlan.packagePrice !== undefined &&
      React.createElement(
        "div",
        {
          style: {
            backgroundColor: colors.gold.light,
            padding: "0.75rem",
            borderRadius: "0.5rem",
            marginBottom: "1rem",
            border: `1px solid ${colors.gold.primary}`,
          },
        },
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "0.5rem",
            },
          },
          React.createElement(
            "div",
            { style: { fontWeight: "bold", color: colors.gold.dark } },
            "💰 INFORMACIÓN DE PAGO"
          ),
          canEditPrice && React.createElement(
            "button",
            {
              onClick: () => {
                setPriceEditorTarget("main");
                setShowPriceEditor(true);
              },
              style: { ...styles.buttonOutline, padding: "0.25rem 0.75rem", fontSize: "0.75rem" },
            },
            "✏️ Editar precio"
          ),
          canDeleteTreatment && React.createElement(
            "button",
            {
              onClick: async () => {
                if (!window.confirm(`¿Eliminar el tratamiento "${record.treatmentPlan?.name || "Plan principal"}"?

Esta acción no se puede deshacer.`)) return;
                const updated = { ...record, treatmentPlan: null, sessions: [] };
                await saveRecordToFirestore(updated);
                onUpdate(updated);
                setActiveTreatmentId("main");
                alert("✅ Tratamiento eliminado");
              },
              style: { ...styles.buttonOutline, padding: "0.25rem 0.75rem", fontSize: "0.75rem", borderColor: colors.accent.danger, color: colors.accent.danger },
            },
            "🗑️ Eliminar"
          )
        ),
        React.createElement(
          "div",
          null,
          "Precio del paquete (sin IVA): ",
          formatCurrency(record.treatmentPlan.packagePrice)
        ),
        React.createElement(
          "div",
          null,
          // CORRECTION #2: Always show IVA amount in colones
          "IVA (13%): ",
          formatIvaDisplay(record.treatmentPlan.ivaAmount, record.treatmentPlan.ivaIncluded)
        ),
        React.createElement(
          "div",
          {
            style: {
              fontWeight: "bold",
              marginTop: "0.25rem",
              color: colors.gold.dark,
            },
          },
          "Total a pagar: ",
          formatCurrency(record.treatmentPlan.totalPrice)
        ),
        React.createElement(
          "div",
          null,
          "Total de sesiones: ",
          record.treatmentPlan.totalSessions
        )
      ),

    // ── Collapsible client registration info ──
    React.createElement(
      "div",
      {
        onClick: () => setShowClientInfo(v => !v),
        style: { ...styles.sectionHeader, cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", userSelect: "none" },
      },
      React.createElement("span", null, "📋 INFORMACIÓN DEL CLIENTE"),
      React.createElement("span", { style: { fontSize: "0.85rem", color: colors.gray.text } }, showClientInfo ? "▲ Minimizar" : "▼ Ver datos")
    ),
    showClientInfo && React.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column", width: "100%" } },
      renderInfoRows([
        { label: "Nombre completo", value: record.form.nombre },
        { label: "Cédula", value: record.form.cedula },
        { label: "Fecha de nacimiento", value: formatDateCR(record.form.fechaNacimiento) },
        { label: "Edad", value: record.form.edad },
        { label: "Género", value: record.form.genero },
        { label: "Teléfono", value: record.form.telefono },
        { label: "Correo electrónico", value: record.form.correo },
        { label: "Profesión", value: record.form.profesion },
        { label: "Dirección", value: record.form.direccion }
      ])
    ),

    showClientInfo && React.createElement(
      "div",
      { style: styles.sectionHeader },
      "🚨 CONTACTO DE EMERGENCIA"
    ),
    showClientInfo && React.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column", width: "100%" } },
      renderInfoRows([
        { label: "Nombre", value: record.form.emergenciaNombre },
        { label: "Teléfono", value: record.form.emergenciaTelefono },
        { label: "Correo electrónico", value: record.form.emergenciaCorreo },
        { label: "Relación", value: record.form.emergenciaRelacion }
      ])
    ),

    showClientInfo && React.createElement(
      "div",
      { style: styles.sectionHeader },
      "💆‍♀️ DETALLE DEL TRATAMIENTO"
    ),
    showClientInfo && React.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column", width: "100%" } },
      renderInfoRows([
        { label: "Tipo de tratamiento", value: record.form.treatmentType || "No seleccionado" },
        ...(record.form.bodyCategory ? [{ label: "Categoría corporal", value: record.form.bodyCategory }] : []),
        ...(record.form.moldeoText ? [{ label: "Moldeo corporal", value: record.form.moldeoText }] : []),
        ...(record.form.laserText ? [{ label: "Depilación láser", value: record.form.laserText }] : []),
        ...(record.form.ceraText ? [{ label: "Depilación con cera", value: record.form.ceraText }] : []),
        ...(record.form.massageText ? [{ label: "Masajes", value: record.form.massageText }] : []),
        ...(record.form.pestanasText ? [{ label: "Pestañas", value: record.form.pestanasText }] : []),
        ...(record.form.cejasText ? [{ label: "Cejas", value: record.form.cejasText }] : []),
        ...(record.form.paquetePCText ? [{ label: "Paquete Pestañas/Cejas", value: record.form.paquetePCText }] : []),
        ...(record.form.facialText ? [{ label: "Tratamiento facial", value: record.form.facialText }] : [])
      ])
    ),

    showClientInfo && React.createElement(
      "div",
      { style: styles.sectionHeader },
      "🩺 INFORMACIÓN MÉDICA"
    ),
    showClientInfo && React.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column", width: "100%" } },
      renderInfoRows([
        { label: "Condiciones médicas", value: record.form.medical?.join(", ") || "Ninguna" },
        { label: "Medicamentos actuales", value: record.form.medicamentosActuales || "No especifica" },
        ...(record.form.medicamentosActuales === "Sí" ? [{ label: "¿Cuáles?", value: record.form.medicamentosCuales }] : []),
        ...(record.form.genero === "Femenino" ? [{ label: "Anticonceptivos", value: record.form.anticonceptivos || "No especifica" }] : []),
        ...(record.form.genero === "Femenino" && record.form.anticonceptivos === "Sí" ? [{ label: "¿Qué tipo?", value: record.form.anticonceptivosCuales }] : []),
        { label: "Tipo de piel", value: record.form.tipoPiel || "No especifica" },
        { label: "Alergias", value: record.form.alergiasProductos || "Ninguna" },
        { label: "Procedimientos estéticos recientes", value: record.form.procedimientosRecientes || "No" },
        ...(record.form.procedimientosRecientes === "Sí" ? [{ label: "¿Cuáles?", value: record.form.procedimientosRecientesCuales }] : []),
        { label: "Otras preocupaciones", value: record.form.otrasPreocupaciones || "Ninguna" },
        { label: "Autoriza uso de imagen", value: record.form.autorizaImagen === "Sí" ? "✓ Sí" : record.form.autorizaImagen === "No" ? "✗ No" : "No especifica" }
      ])
    ),

    showClientInfo && React.createElement(
      "div",
      { style: styles.sectionHeader },
      "📄 CONSENTIMIENTO Y FIRMA"
    ),
    showClientInfo && React.createElement(
      "div",
      { style: { display: "flex", flexDirection: "column", width: "100%" } },
      renderInfoRows([
        { label: "Aceptó consentimiento", value: record.form.aceptaConsentimiento ? "✓ Sí" : "✗ No" },
        { label: "Fecha de registro", value: formatDateCR(record.createdAt?.slice(0, 10)) }
      ])
    ),
    
    activeTreatmentId === "main" && React.createElement(SignatureBlock, {
      recordId: record.id,
      hasFirma: !!(record.form._hasFirma || record.form.firmaCliente),
      inlineSrc: record.form.firmaCliente || "",
      isMobile,
      labelText: "Firma del cliente:",
    }),

    record.form.firmaConsentimiento && record.form.firmaConsentimiento.startsWith("data:image") && React.createElement(
      "div",
      { style: { marginTop: "0.5rem", marginBottom: "1rem", width: "100%" } },
      React.createElement(
        "div",
        {
          style: {
            backgroundColor: "#F9F9F9",
            borderRadius: "0.75rem",
            padding: "0.75rem",
            border: `1px solid ${colors.gold.light}`,
          }
        },
        React.createElement(
          "div",
          {
            style: {
              fontSize: "0.75rem",
              color: colors.gold.dark,
              marginBottom: "0.5rem",
              fontWeight: "500",
            }
          },
          "Firma del consentimiento:"
        ),
        React.createElement(
          "img",
          {
            src: record.form.firmaConsentimiento,
            alt: "Firma del consentimiento",
            style: {
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              maxHeight: isMobile ? "80px" : "100px",
              objectFit: "contain",
              border: `1px solid ${colors.gray.medium}`,
              borderRadius: "0.5rem",
              backgroundColor: "white",
              display: "block",
            },
          }
        )
      )
    ),

    hasTreatment && activeTreatmentId === "main" &&
      React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "div",
          { style: styles.sectionHeader },
          "📅 PLAN DE TRATAMIENTO"
        ),
        React.createElement(
          "div",
          { style: { display: "flex", flexDirection: "column", width: "100%" } },
          renderInfoRows([
            { label: "Tratamiento", value: record.treatmentPlan.name },
            { label: "Fecha inicio", value: formatDateCR(record.treatmentPlan.startDate) },
            { label: "Total de sesiones", value: String(record.treatmentPlan.totalSessions) },
            { label: "Sesiones realizadas", value: String(record.treatmentPlan.completedSessions) },
            { label: "Sesiones restantes", value: String(record.treatmentPlan.remainingSessions) },
            { label: "Estado", value: record.treatmentPlan.status === "activo" ? "🟢 En curso" : record.treatmentPlan.status === "completado" ? "✅ Completado" : "🏁 Finalizado" }
          ])
        ),
        activeTreatmentId === "main" && React.createElement(PaymentStatusBox, { record, user, onUpdate, canEditPrice, onEditPayment: (atId) => { setEditPaymentTarget(atId); setShowEditPayment(true); } })
      ),

    hasTreatment &&
      React.createElement(
        React.Fragment,
        null,
        activeTreatmentId === "main" && React.createElement(
          "div",
          { style: styles.sectionHeader },
          "📝 HISTORIAL DE SESIONES"
        ),
        activeTreatmentId === "main" && React.createElement(
          "div",
          {
            style: {
              backgroundColor: colors.gray.warm,
              borderRadius: "1rem",
              padding: "1rem",
              overflowX: "auto",
            },
          },
          React.createElement(
            "table",
            {
              style: {
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.875rem",
              },
            },
            React.createElement(
              "thead",
              null,
              React.createElement(
                "tr",
                {
                  style: {
                    backgroundColor: colors.gold.light,
                    borderBottom: `2px solid ${colors.gold.primary}`,
                  },
                },
                React.createElement(
                  "th",
                  {
                    style: {
                      padding: "0.5rem 0.75rem",
                      textAlign: "left",
                      color: colors.gold.dark,
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                  },
                  "Sesión"
                ),
                React.createElement(
                  "th",
                  {
                    style: {
                      padding: "0.5rem 0.75rem",
                      textAlign: "left",
                      color: colors.gold.dark,
                      fontWeight: "bold",
                      whiteSpace: "nowrap",
                    },
                  },
                  "Fecha"
                ),
                React.createElement(
                  "th",
                  {
                    style: {
                      padding: "0.5rem 0.75rem",
                      textAlign: "left",
                      color: colors.gold.dark,
                      fontWeight: "bold",
                    },
                  },
                  "Especialista"
                ),
                React.createElement(
                  "th",
                  {
                    style: {
                      padding: "0.5rem 0.75rem",
                      textAlign: "center",
                      color: colors.gold.dark,
                      fontWeight: "bold",
                    },
                  },
                  "Estado"
                ),
                React.createElement("th", { style: { padding: "0.5rem 0.75rem", color: colors.gold.dark, fontWeight: "bold" } }, "Cobro")
              )
            ),
            React.createElement(
              "tbody",
              null,
              Array.from({ length: record.treatmentPlan.totalSessions }, (_, i) => {
                const sessionNum = i + 1;
                const done = (record.sessions || []).find(s => s.number === sessionNum);
                const sessionPayment = done?.payment || (record.treatmentPlan?.paymentInfo?.payments || []).find(p => p.type === "session" && p.reference === sessionNum);
                return React.createElement(
                  "tr",
                  {
                    key: sessionNum,
                    style: {
                      backgroundColor: done ? colors.accent.successLight : "white",
                      borderBottom: `1px solid ${colors.gray.warm}`,
                    },
                  },
                  React.createElement(
                    "td",
                    {
                      style: {
                        padding: "0.5rem 0.75rem",
                        fontWeight: "bold",
                        color: colors.gold.dark,
                        whiteSpace: "nowrap",
                      },
                    },
                    `#${sessionNum}`
                  ),
                  React.createElement(
                    "td",
                    {
                      style: {
                        padding: "0.5rem 0.75rem",
                        whiteSpace: "nowrap",
                      },
                    },
                    done ? formatDateCR(done.date) : "—"
                  ),
                  React.createElement(
                    "td",
                    {
                      style: {
                        padding: "0.5rem 0.75rem",
                        color: colors.gray.text,
                      },
                    },
                    done ? done.specialist : "—"
                  ),
                  React.createElement(
                    "td",
                    {
                      style: {
                        padding: "0.5rem 0.75rem",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                      },
                    },
                    done
                      ? React.createElement(
                          "span",
                          {
                            style: {
                              backgroundColor: colors.accent.success,
                              color: "white",
                              borderRadius: "1rem",
                              padding: "0.2rem 0.6rem",
                              fontSize: "0.75rem",
                              fontWeight: "bold",
                            },
                          },
                          "✓ Realizada"
                        )
                      : React.createElement(
                          "span",
                          {
                            style: {
                              backgroundColor: colors.gray.warm,
                              color: colors.gray.text,
                              borderRadius: "1rem",
                              padding: "0.2rem 0.6rem",
                              fontSize: "0.75rem",
                            },
                          },
                          "Pendiente"
                        )
                  ),
                  // Cobro cell
                  React.createElement("td", { style: { padding: "0.5rem 0.75rem", fontSize: "0.8rem" } },
                    sessionPayment
                      ? React.createElement("span", { style: { color: colors.accent.success } },
                          `${formatCurrency(sessionPayment.amount)} · ${sessionPayment.method || "—"}`
                        )
                      : done?.paymentPending
                        ? React.createElement("span", { style: { color: colors.accent.warning, fontWeight: "600" } }, "⚠️ Pendiente")
                        : React.createElement("span", { style: { color: colors.gray.text } }, "—")
                  ),
                  // Edit button — owner/admin only, completed sessions only
                  React.createElement("td", { style: { padding: "0.4rem 0.5rem", textAlign: "center" } },
                    done && canDeleteTreatment && React.createElement("button", {
                      onClick: () => {
                        setEditSessionTarget({ sessionNum, isAdditional: false, atId: null });
                        setEditSessionDate(done.date || "");
                        setEditSessionSpecialist(done.specialist || "");
                        setEditSessionNote("");
                        // load existing payment (supports split if already stored)
                        if (done.payment && Array.isArray(done.payment.splits) && done.payment.splits.length === 2) {
                          setEditSessSplit(true);
                          setEditSessAmount(String(done.payment.splits[0].amount || ""));
                          setEditSessMethod(done.payment.splits[0].method || "");
                          setEditSessAmount2(String(done.payment.splits[1].amount || ""));
                          setEditSessMethod2(done.payment.splits[1].method || "");
                        } else {
                          setEditSessSplit(false);
                          setEditSessAmount(done.payment ? String(done.payment.amount || "") : "");
                          setEditSessMethod(done.payment ? (done.payment.method || "") : "");
                          setEditSessAmount2(""); setEditSessMethod2("");
                        }
                        setShowEditSession(true);
                      },
                      style: { background: "none", border: `1px solid ${colors.gold.primary}`, borderRadius: "0.4rem", padding: "0.15rem 0.45rem", cursor: "pointer", fontSize: "0.72rem", color: colors.gold.dark }
                    }, "✏️")
                  )
                );
              })
            )
          )
        )
      ),

    record.additionalTreatments?.length > 0 &&
      record.additionalTreatments
      .filter(at => {
        if (allTreatments.length <= 1) return true;      // only one treatment — show it
        if (activeTreatmentId === "main") return false;  // main tab selected — hide all additionals
        return at.id === activeTreatmentId;              // specific tab selected — show only that one
      })
      .map((at, idx) => {
        const atIsFinalized = at.status === "finalizado";
        const atIsCompleted = at.remainingSessions === 0;
        const atShowFinalize = !atIsFinalized && canFinalize; // Allow early finalize (requires note if sessions pending)

        const handleRegisterAdditionalSession = async () => {
          const completed = at.completedSessions || 0;
          const total = at.totalSessions || 0;
          if (total === 0) return alert("❌ Este tratamiento no tiene sesiones configuradas.");
          if (completed >= total) return alert(`❌ Todas las sesiones ya fueron completadas (${completed}/${total}).`);

          const atPaymentType = at.paymentInfo?.paymentType;
          // Only route through payment modal if explicitly set to por_sesion AND has paymentInfo
          if (atPaymentType === "por_sesion" && at.paymentInfo) {
            const agreedAmount = at.paymentInfo?.amountPerSession || null;
            setPendingSessionData({
              collectAfter: true,
              isAdditionalTreatment: true,
              isSessionPayment: true,
              additionalTreatmentId: at.id,
              agreedAmount,
            });
            setShowCollectSessionPayment(true);
            return;
          }

          // All other plan types (or old treatments without paymentInfo) — log the session directly
          const nextNum = completed + 1;
          const isLast = nextNum === total;
          const updatedAt = {
            ...at,
            completedSessions: nextNum,
            remainingSessions: total - nextNum,
            status: isLast ? "completado" : "activo",
            sessions: [
              ...(at.sessions || []),
              { number: nextNum, date: new Date().toISOString().slice(0, 10), specialist: user.nombreCompleto },
            ],
          };
          const updatedAdditionals = record.additionalTreatments.map((a) => a.id === at.id ? updatedAt : a);
          const updated = { ...record, additionalTreatments: updatedAdditionals };
          await saveRecordToFirestore(updated);
          onUpdate(updated);
          alert(isLast
            ? `✅ Sesión ${nextNum} registrada.
👉 Use "Finalizar" para completar`
            : `✅ Sesión ${nextNum} registrada. Restan ${total - nextNum}`
          );
        };

        const handleFinalizeAdditional = async () => {
          const atCompleted = at.completedSessions || 0;
          const atTotal = at.totalSessions || 0;
          const atHasPending = atCompleted < atTotal;

          // RULE: Pending sessions require a mandatory note before finalizing
          if (atHasPending) {
            if (!newNote || newNote.trim() === "") {
              alert(
                `❌ Hay ${atTotal - atCompleted} sesión(es) pendiente(s) en "${at.treatmentName}".\n\n` +
                `Para finalizar anticipadamente, debe ingresar una nota explicando el motivo.\n\n` +
                `👉 Escriba la nota en el campo "Agregar nota" y luego presione Finalizar.`
              );
              return;
            }
            if (!window.confirm(
              `⚠️ Quedan ${atTotal - atCompleted} sesión(es) sin completar en "${at.treatmentName}".\n\n` +
              `¿Confirma que desea finalizar anticipadamente?\n` +
              `La nota ingresada quedará registrada como motivo.`
            )) return;
          }

          // Check outstanding balance
          const atPi = at.paymentInfo || {};
          const atTotalPrice = at.totalPrice || 0;
          const atDeposited = (atPi.deposits || []).reduce((s, d) => s + d.amount, 0);
          const atPaid = (atPi.payments || []).reduce((s, p) => s + p.amount, 0) + atDeposited;
          const atOutstanding = Math.max(0, atTotalPrice - atPaid);
          const atIsGiftCard = atPi.paymentType === "tarjeta_regalo";
          const atIsYuplon = atPi.paymentType === "yuplon";

          if (!atIsGiftCard && !atIsYuplon && atOutstanding > 0) {
            setPendingSessionData({
              isFinalPayment: true,
              isAdditionalTreatment: true,
              additionalTreatmentId: at.id,
              amount: atOutstanding,
              label: atDeposited > 0
                ? `Saldo pendiente — ${at.treatmentName} (depósito recibido: ${formatCurrency(atDeposited)})`
                : `Pago total — ${at.treatmentName}`,
            });
            setShowCollectSessionPayment(true);
            return;
          }

          // All clear — finalize
          if (!atHasPending && !window.confirm(`¿Finalizar el tratamiento "${at.treatmentName}"? El saldo está completamente pagado.`)) return;

          // Save mandatory note if early termination
          let updatedRecord = { ...record };
          if (atHasPending && newNote.trim()) {
            const noteEntry = {
              text: `[CIERRE ANTICIPADO — ${at.treatmentName}] ${newNote.trim()}`,
              by: user.nombreCompleto,
              role: user.label,
              at: new Date().toISOString(),
            };
            updatedRecord = {
              ...updatedRecord,
              notes: [...(record.notes || []), noteEntry],
            };
            setNewNote("");
          }

          const updatedAt = { ...at, status: "finalizado", finalizedAt: new Date().toISOString().slice(0, 10) };
          const updatedAdditionals = updatedRecord.additionalTreatments.map((a) => a.id === at.id ? updatedAt : a);
          const updated = { ...updatedRecord, additionalTreatments: updatedAdditionals };
          await saveRecordToFirestore(updated);
          onUpdate(updated);
          alert("✅ Tratamiento finalizado");
        };

        const handleAddAdditionalSessions = () => {
          // Reuse the addSessionsModal state, tagging which additional treatment we are editing
          setAddSessionsForm({ additionalSessions: "1", additionalPrice: "0", reason: "Cliente solicitó sesiones adicionales", _additionalTreatmentId: at.id });
          setShowAddSessionsModal(true);
        };

        const atStatus = at.status === "activo" ? "🟢 En curso" : at.status === "completado" ? "✅ Completado" : "🏁 Finalizado";

        return React.createElement(
          React.Fragment,
          { key: at.id || idx },

          // Section header with treatment name and action buttons — use actual position in sortedAdditionals
          (() => {
            const actualIdx = sortedAdditionals.findIndex(a => a.id === at.id);
            const treatmentNum = actualIdx + 2; // +2 because T1 is main plan
            return React.createElement(
              "div",
              { style: { ...styles.sectionHeader, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "0.5rem" } },
              React.createElement("span", null, `💆‍♀️ T${treatmentNum} — ${at.treatmentName || at.treatmentType}`),
            React.createElement(
              "div",
              { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap" } },
              canEditPrice && React.createElement(
                "button",
                {
                  onClick: () => {
                    setPriceEditorTarget(at.id);
                    setShowPriceEditor(true);
                  },
                  style: { ...styles.buttonOutline, padding: "0.25rem 0.75rem", fontSize: "0.75rem" },
                },
                "✏️ Editar precio"
              ),
              canRegisterSession && !atIsFinalized && !atIsCompleted && React.createElement(
                "button",
                { onClick: handleRegisterAdditionalSession, style: { ...styles.button, padding: "0.35rem 0.85rem", fontSize: "0.8rem" } },
                `📝 Sesión (${at.completedSessions || 0}/${at.totalSessions})`
              ),
              canRegisterSession && !atIsFinalized && atIsCompleted && React.createElement(
                "span",
                { style: { fontSize: "0.75rem", color: colors.accent.success, fontWeight: "600", padding: "0.35rem 0.5rem" } },
                `✅ Sesiones completadas (${at.completedSessions || 0}/${at.totalSessions})`
              ),
              canAddSessions && React.createElement(
                "button",
                { onClick: handleAddAdditionalSessions, style: { ...styles.buttonWarning, padding: "0.35rem 0.85rem", fontSize: "0.8rem" } },
                "➕ Sesiones"
              ),
              atShowFinalize && React.createElement(
                "button",
                { onClick: handleFinalizeAdditional, style: { ...styles.buttonSuccess, padding: "0.35rem 0.85rem", fontSize: "0.8rem" } },
                "🏁 Finalizar"
              ),
              // Backfill: additional treatment is finalized but has no finalizedAt
              atIsFinalized && !at.finalizedAt && canFinalize && React.createElement("button", {
                onClick: async () => {
                  const dateInput = window.prompt("¿Cuándo se finalizó este tratamiento? (YYYY-MM-DD)", new Date().toISOString().slice(0,10));
                  if (!dateInput || !/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) return alert("Formato inválido. Use YYYY-MM-DD");
                  const updatedAdditionals = record.additionalTreatments.map(a => a.id === at.id ? { ...a, finalizedAt: dateInput } : a);
                  const updated = { ...record, additionalTreatments: updatedAdditionals };
                  await saveRecordToFirestore(updated);
                  onUpdate(updated);
                  alert("✅ Fecha de finalización guardada");
                },
                style: { ...styles.buttonOutline, fontSize: "0.72rem", padding: "0.2rem 0.5rem", borderColor: colors.accent.warning, color: colors.accent.warning },
              }, "📅 Registrar fecha"),
              // Delete button — always visible to owner/admin, independent of finalization status
              canDeleteTreatment && React.createElement("button", {
                onClick: async () => {
                  if (!window.confirm(`¿Eliminar el tratamiento "${at.treatmentName || at.treatmentType}"?

Esta acción no se puede deshacer. Se eliminarán todas las sesiones y pagos asociados.`)) return;
                  const updatedAdditionals = record.additionalTreatments.filter(a => a.id !== at.id);
                  const updated = { ...record, additionalTreatments: updatedAdditionals };
                  await saveRecordToFirestore(updated);
                  onUpdate(updated);
                  setActiveTreatmentId("main");
                  alert("✅ Tratamiento eliminado");
                },
                style: { ...styles.buttonOutline, fontSize: "0.72rem", padding: "0.2rem 0.5rem", borderColor: colors.accent.danger, color: colors.accent.danger },
              }, "🗑️ Eliminar"),
            )
          );
          })(),

          // Treatment detail (type/category/description)
          React.createElement(
            "div",
            { style: { display: "flex", flexDirection: "column", width: "100%", marginBottom: "0.75rem" } },
            React.createElement(InfoRow, { label: "Tipo de tratamiento", value: at.treatmentType }),
            at.bodyCategory && React.createElement(InfoRow, { label: "Categoría", value: at.bodyCategory }),
            at.facialText && React.createElement(InfoRow, { label: "Tratamiento solicitado", value: at.facialText }),
            at.moldeoText && React.createElement(InfoRow, { label: "Moldeo corporal", value: at.moldeoText }),
            at.laserText && React.createElement(InfoRow, { label: "Depilación láser", value: at.laserText }),
            at.ceraText && React.createElement(InfoRow, { label: "Depilación con cera", value: at.ceraText }),
            at.massageText && React.createElement(InfoRow, { label: "Masaje", value: at.massageText }),
            at.notes && React.createElement(InfoRow, { label: "Notas internas", value: at.notes }),
            React.createElement(InfoRow, { label: "Agregado por", value: `${at.addedBy} · ${at.addedByRole} · ${formatDateCR(at.addedAt?.slice(0, 10))}` }),
          ),

          // Full payment status box for additional treatment
          at.packagePrice !== undefined && (() => {
            const atPi = at.paymentInfo || {};
            const atPaymentType = atPi.paymentType || "—";
            const atDeposits = atPi.deposits || [];
            const atPayments = atPi.payments || [];
            const atSchedule = atPi.paymentSchedule || [];
            const atDeposited = atDeposits.reduce((s, d) => s + d.amount, 0);
            const atPaidPayments = atPayments.reduce((s, p) => s + p.amount, 0);
            const atPaidSchedule = atSchedule.filter(i => i.status === "pagado" || i.status === "parcial").reduce((s, i) => s + (i.paidAmount || i.amount), 0);
            const atTotalPaid = atDeposited + atPaidPayments + atPaidSchedule;
            const atOutstanding = Math.max(0, (at.totalPrice || 0) - atTotalPaid);
            const atPaymentTypeLabel = PAYMENT_TYPES.find(p => p.value === atPaymentType)?.label || atPaymentType;

            return React.createElement(
              "div",
              {
                style: {
                  backgroundColor: atOutstanding > 0 ? "#FFF8F0" : colors.accent.successLight,
                  padding: "0.75rem",
                  borderRadius: "0.5rem",
                  marginBottom: "0.75rem",
                  border: `1px solid ${atOutstanding > 0 ? colors.accent.warning : colors.accent.success}`,
                },
              },
              React.createElement("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" } },
              React.createElement("div", { style: { fontWeight: "bold", color: colors.gold.dark } }, "💰 INFORMACIÓN DE PAGO"),
              canEditPrice && React.createElement("button", {
                onClick: () => { setEditPaymentTarget(at.id); setShowEditPayment(true); },
                style: { ...styles.buttonOutline, padding: "0.2rem 0.55rem", fontSize: "0.7rem" },
              }, "✏️ Editar")
            ),
              React.createElement("div", null, "Precio base (sin IVA): ", formatCurrency(at.packagePrice)),
              React.createElement("div", null, "IVA (13%): ", formatIvaDisplay(at.ivaAmount, at.ivaIncluded)),
              React.createElement("div", { style: { fontWeight: "bold", color: colors.gold.dark } }, "Total: ", formatCurrency(at.totalPrice)),
              React.createElement("div", null, "Tipo de pago: ", PAYMENT_TYPES.find(p => p.value === at.paymentInfo?.paymentType)?.label || at.paymentInfo?.paymentType || "—"),
              React.createElement("div", { style: { color: colors.accent.success, fontWeight: "600" } }, "Total cobrado: ", formatCurrency(atTotalPaid)),
              React.createElement("div", { style: { color: atOutstanding > 0 ? colors.accent.danger : colors.accent.success, fontWeight: "bold" } },
                atOutstanding > 0 ? `⚠️ Saldo pendiente: ${formatCurrency(atOutstanding)}` : "✅ Saldo completamente pagado"
              ),
              // Show individual payments collected
              (atDeposits.length > 0 || atPayments.length > 0 || atSchedule.some(i => i.status === "pagado" || i.status === "parcial")) && React.createElement(
                "div", { style: { marginTop: "0.5rem", fontSize: "0.8rem", color: colors.gray.text } },
                React.createElement("div", { style: { fontWeight: "600", marginBottom: "0.25rem" } }, "Pagos registrados:"),
                atDeposits.map((d, i) => React.createElement("div", { key: "dep"+i }, `• Depósito (${d.method || "—"}): ${formatCurrency(d.amount)} — ${formatDateCR(d.date)}`)),
                atPayments.map((p, i) => React.createElement("div", { key: "pay"+i },
                  `• ${p.type === "balance" ? "Saldo" : p.type === "upfront" ? "Pago completo" : "Pago"} (${p.method || "—"}): ${formatCurrency(p.amount)} — ${formatDateCR(p.date)}`
                )),
                atSchedule.filter(i => i.status === "pagado" || i.status === "parcial").map((inst, i) =>
                  React.createElement("div", { key: "inst"+i }, `• Cuota #${inst.number} (${inst.paymentMethod || "—"}): ${formatCurrency(inst.paidAmount || inst.amount)} — ${formatDateCR(inst.paidAt?.slice(0,10) || inst.dueDate)}`)
                ),
              ),
              // Collect balance button if outstanding
              atOutstanding > 0 && ["especialista","manager","owner"].includes(user.role) && React.createElement("button", {
                onClick: () => {
                  setPendingSessionData({
                    isFinalPayment: false,
                    isAdditionalTreatment: true,
                    additionalTreatmentId: at.id,
                    amount: atOutstanding,
                    label: `Cobro parcial — ${at.treatmentName}`,
                  });
                  setShowCollectSessionPayment(true);
                },
                style: { ...styles.button, marginTop: "0.5rem", padding: "0.4rem 0.85rem", fontSize: "0.8rem" },
              }, "💳 Registrar pago")
            );
          })(),

          // Plan info rows
          React.createElement(
            "div",
            { style: { display: "flex", flexDirection: "column", width: "100%", marginBottom: "0.75rem" } },
            React.createElement(InfoRow, { label: "Fecha inicio", value: formatDateCR(at.startDate) }),
            React.createElement(InfoRow, { label: "Total de sesiones", value: String(at.totalSessions) }),
            React.createElement(InfoRow, { label: "Sesiones realizadas", value: String(at.completedSessions || 0) }),
            React.createElement(InfoRow, { label: "Sesiones restantes", value: String(at.remainingSessions) }),
            React.createElement(InfoRow, { label: "Estado", value: atStatus }),
          ),

          // Session history for this additional treatment
          React.createElement(
            React.Fragment,
            null,
            React.createElement("div", { style: { fontSize: "0.85rem", fontWeight: "600", color: colors.gold.dark, marginBottom: "0.5rem" } }, "📋 Historial de sesiones"),
            React.createElement(
              "div",
              { style: { backgroundColor: colors.gray.warm, borderRadius: "0.75rem", padding: "0.75rem", marginBottom: "0.75rem", overflowX: "auto" } },
              React.createElement(
                "table",
                { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.85rem" } },
                React.createElement(
                  "thead",
                  null,
                  React.createElement(
                    "tr",
                    { style: { backgroundColor: colors.gold.light, borderBottom: `2px solid ${colors.gold.primary}` } },
                    React.createElement("th", { style: { padding: "0.4rem 0.6rem", textAlign: "left", color: colors.gold.dark, fontWeight: "bold", whiteSpace: "nowrap" } }, "Sesión"),
                    React.createElement("th", { style: { padding: "0.4rem 0.6rem", textAlign: "left", color: colors.gold.dark, fontWeight: "bold", whiteSpace: "nowrap" } }, "Fecha"),
                    React.createElement("th", { style: { padding: "0.4rem 0.6rem", textAlign: "left", color: colors.gold.dark, fontWeight: "bold" } }, "Especialista"),
                    React.createElement("th", { style: { padding: "0.4rem 0.6rem", textAlign: "center", color: colors.gold.dark, fontWeight: "bold" } }, "Estado"),
                    React.createElement("th", { style: { padding: "0.4rem 0.6rem", textAlign: "center", color: colors.gold.dark, fontWeight: "bold" } }, "Acción")
                  )
                ),
                React.createElement(
                  "tbody",
                  null,
                  Array.from({ length: at.totalSessions }, (_, i) => {
                    const sessionNum = i + 1;
                    const done = (at.sessions || []).find(s => s.number === sessionNum);
                    return React.createElement(
                      "tr",
                      { key: sessionNum, style: { backgroundColor: done ? colors.accent.successLight : "white", borderBottom: `1px solid ${colors.gray.warm}` } },
                      React.createElement("td", { style: { padding: "0.4rem 0.6rem", fontWeight: "bold", color: colors.gold.dark, whiteSpace: "nowrap" } }, `#${sessionNum}`),
                      React.createElement("td", { style: { padding: "0.4rem 0.6rem", whiteSpace: "nowrap" } }, done ? formatDateCR(done.date) : "—"),
                      React.createElement("td", { style: { padding: "0.4rem 0.6rem", color: colors.gray.text } }, done ? done.specialist : "—"),
                      React.createElement(
                        "td",
                        { style: { padding: "0.4rem 0.6rem", textAlign: "center" } },
                        done
                          ? React.createElement("span", { style: { backgroundColor: colors.accent.success, color: "white", borderRadius: "1rem", padding: "0.15rem 0.5rem", fontSize: "0.75rem", fontWeight: "bold" } }, "✓ Realizada")
                          : React.createElement("span", { style: { backgroundColor: colors.gray.warm, color: colors.gray.text, borderRadius: "1rem", padding: "0.15rem 0.5rem", fontSize: "0.75rem" } }, "Pendiente")
                      ),
                      // Acción — Realizar button only on next pending session
                      React.createElement(
                        "td",
                        { style: { padding: "0.4rem 0.6rem", textAlign: "center" } },
                        !done && sessionNum === (at.completedSessions || 0) + 1 && canRegisterSession
                          ? React.createElement("button", {
                              onClick: handleRegisterAdditionalSession,
                              style: { backgroundColor: colors.gold.primary, color: "white", border: "none", borderRadius: "0.5rem", padding: "0.2rem 0.6rem", fontSize: "0.75rem", cursor: "pointer", fontWeight: "600" },
                            }, "▶ Realizar")
                          : null
                      ),
                      React.createElement("td", { style: { padding: "0.3rem 0.4rem", textAlign: "center" } },
                        done && canDeleteTreatment && React.createElement("button", {
                          onClick: () => {
                            setEditSessionTarget({ sessionNum, isAdditional: true, atId: at.id });
                            setEditSessionDate(done.date || "");
                            setEditSessionSpecialist(done.specialist || "");
                            setEditSessionNote("");
                            if (done.payment && Array.isArray(done.payment.splits) && done.payment.splits.length === 2) {
                              setEditSessSplit(true);
                              setEditSessAmount(String(done.payment.splits[0].amount || ""));
                              setEditSessMethod(done.payment.splits[0].method || "");
                              setEditSessAmount2(String(done.payment.splits[1].amount || ""));
                              setEditSessMethod2(done.payment.splits[1].method || "");
                            } else {
                              setEditSessSplit(false);
                              setEditSessAmount(done.payment ? String(done.payment.amount || "") : "");
                              setEditSessMethod(done.payment ? (done.payment.method || "") : "");
                              setEditSessAmount2(""); setEditSessMethod2("");
                            }
                            setShowEditSession(true);
                          },
                          style: { background: "none", border: `1px solid ${colors.gold.primary}`, borderRadius: "0.4rem", padding: "0.15rem 0.45rem", cursor: "pointer", fontSize: "0.72rem", color: colors.gold.dark }
                        }, "✏️")
                      )
                    );
                  })
                )
              )
            )
          ),

          // Divider between additional treatments
          idx < record.additionalTreatments.length - 1 && React.createElement(
            "div",
            { style: { borderTop: `2px dashed ${colors.gold.light}`, margin: "0.5rem 0 1rem 0" } }
          )
        );
      }),

    React.createElement(
      "div",
      { style: styles.sectionHeader },
      "📝 NOTAS ADICIONALES"
    ),
    React.createElement(TextAreaField, {
      labelText: "Agregar nota",
      value: newNote,
      onChange: setNewNote,
      placeholder: "Observaciones importantes...",
      rows: 3,
    }),
    React.createElement(
      "button",
      {
        onClick: handleAddNote,
        style: { ...styles.button, marginTop: "0.5rem" },
      },
      "+ Agregar nota"
    ),

    record.notes?.length > 0 &&
      React.createElement(
        "div",
        { style: { marginTop: "1rem" } },
        record.notes.map((n) =>
          React.createElement(
            "div",
            { key: n.id, style: styles.noteItem },
            React.createElement(
              "strong",
              { style: { color: colors.gold.dark } },
              n.author,
              " (",
              n.role,
              ")"
            ),
            React.createElement(
              "div",
              { style: { fontSize: "0.75rem", color: colors.gray.text } },
              formatDateTime(n.date)
            ),
            React.createElement("div", null, n.text)
          )
        )
      ),

    record.changeHistory?.length > 0 &&
      ["owner", "manager"].includes(user.role) &&
      React.createElement(
        React.Fragment,
        null,
        React.createElement(
          "div",
          { style: styles.sectionHeader },
          "📜 HISTORIAL DE CAMBIOS"
        ),
        React.createElement(
          "div",
          {
            style: {
              backgroundColor: colors.gray.warm,
              borderRadius: "1rem",
              padding: "1rem",
              fontSize: "0.875rem",
            },
          },
          record.changeHistory.map((c, i) =>
            React.createElement(
              "div",
              {
                key: i,
                style: {
                  borderBottom: `1px solid ${colors.gray.warm}`,
                  padding: "0.5rem 0",
                },
              },
              React.createElement("strong", null, c.field),
              ": ",
              c.before || "—",
              " → ",
              c.after || "—",
              React.createElement("br", null),
              React.createElement(
                "span",
                { style: { color: colors.gray.text } },
                c.by,
                " · ",
                formatDateTime(c.at)
              ),
              c.reason &&
                React.createElement(
                  "div",
                  { style: { fontSize: "0.75rem" } },
                  "Motivo: ",
                  c.reason
                )
            )
          )
        )
      ),
    showFormEditor &&
      React.createElement(FormEditor, {
        record: record,
        onSave: handleSaveFormEdit,
        onClose: () => setShowFormEditor(false),
        lang: "es",
      })
  );
}

// ========== ADD TREATMENT TO EXISTING CLIENT MODAL ==========
function AddTreatmentModal({ user, records, onClose, onSaved, preselectedClient = null }) {
  const isMobile = useIsMobile();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedClient, setSelectedClient] = useState(preselectedClient || null);
  const [treatmentType, setTreatmentType] = useState(""); // "Facial" | "Corporal" | "Ambos"
  const [bodyCategory, setBodyCategory] = useState("");
  const [facialText, setFacialText] = useState("");
  const [moldeoText, setMoldeoText] = useState("");
  const [laserText, setLaserText] = useState("");
  const [ceraText, setCeraText] = useState("");
  const [massageText, setMassageText] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [step, setStep] = useState(preselectedClient ? "form" : "search"); // "search" | "form"
  const [totalSessions, setTotalSessions] = useState("");
  const [treatmentName, setTreatmentName] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [ivaIncluded, setIvaIncluded] = useState(null); // null | true | false
  const [showIvaChoice, setShowIvaChoice] = useState(false);
  const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  const [pendingPricingData, setPendingPricingData] = useState(null);

  const bodyCats = ["Moldeo corporal", "Depilación láser", "Depilación con cera", "Masajes"];

  const filteredClients = useMemo(() => {
    if (!searchTerm || searchTerm.length < 2) return [];
    const term = searchTerm.toLowerCase();
    return records.filter(
      (r) =>
        r.form?.nombre?.toLowerCase().includes(term) ||
        r.form?.cedula?.includes(term) ||
        r.form?.telefono?.includes(term)
    ).slice(0, 8);
  }, [records, searchTerm]);

  const handleSelectClient = (r) => {
    setSelectedClient(r);
    setSearchTerm(r.form?.nombre || "");
    setStep("form");
    setError("");
  };

  const validateForm = () => {
    if (!treatmentType) { setError("Debes seleccionar el tipo de tratamiento."); return false; }
    if ((treatmentType === "Facial" || treatmentType === "Ambos") && !facialText.trim()) {
      setError("Describe el tratamiento facial."); return false;
    }
    if ((treatmentType === "Corporal" || treatmentType === "Ambos") && !bodyCategory) {
      setError("Selecciona la categoría corporal."); return false;
    }
    if (bodyCategory === "Moldeo corporal" && !moldeoText.trim()) {
      setError("Describe el tratamiento de moldeo."); return false;
    }
    if (bodyCategory === "Depilación láser" && !laserText.trim()) {
      setError("Indica las zonas a depilar."); return false;
    }
    if (bodyCategory === "Depilación con cera" && !ceraText.trim()) {
      setError("Indica las zonas a depilar con cera."); return false;
    }
    if (bodyCategory === "Masajes" && !massageText.trim()) {
      setError("Describe el tipo de masaje."); return false;
    }
    if (!treatmentName.trim()) { setError("Ingresa el nombre del tratamiento."); return false; }
    const sessNum = parseInt(totalSessions);
    if (!totalSessions || isNaN(sessNum) || sessNum <= 0) {
      setError("Ingresa un número válido de sesiones."); return false;
    }
    return true;
  };

  const handleSave = () => {
    setError("");
    if (!validateForm()) return;
    // Show IVA choice before saving
    setShowIvaChoice(true);
  };

  const handleSaveWithIva = async (ivaChoice) => {
    setShowIvaChoice(false);
    setSaving(true);
    const sessNum = parseInt(totalSessions);
    const priceNum = parseFloat(packagePrice) || 0;
    let basePrice = priceNum;
    let ivaAmount = 0;
    let totalPrice = priceNum;

    if (priceNum > 0) {
      if (ivaChoice) {
        // IVA included: split out
        basePrice = Math.round(priceNum / 1.13);
        ivaAmount = priceNum - basePrice;
        totalPrice = priceNum;
      } else {
        // IVA not included: add on top
        basePrice = priceNum;
        ivaAmount = Math.round(priceNum * 0.13);
        totalPrice = priceNum + ivaAmount;
      }
    }

    // Store pricing, then show PaymentSetupModal before saving
    setPendingPricingData({ basePrice, ivaAmount, ivaChoice, totalPrice, sessNum });
    setSaving(false);
    setShowPaymentSetup(true);
  };

  const handlePaymentSetupSave = async (paymentInfo) => {
    if (!pendingPricingData) return;
    const { basePrice, ivaAmount, ivaChoice, totalPrice, sessNum } = pendingPricingData;

    const newTreatmentEntry = {
      id: Date.now(),
      addedAt: new Date().toISOString(),
      startDate: new Date().toISOString().slice(0, 10),
      addedBy: user.nombreCompleto,
      addedByRole: user.label,
      treatmentType,
      treatmentName: treatmentName.trim(),
      totalSessions: sessNum,
      completedSessions: 0,
      remainingSessions: sessNum,
      status: "activo",
      packagePrice: basePrice,
      ivaAmount: ivaAmount,
      ivaIncluded: ivaChoice,
      totalPrice: totalPrice,
      paymentInfo: paymentInfo,
      sessionAdditions: [],
      sessions: [],
      bodyCategory: bodyCategory || null,
      facialText: facialText || null,
      moldeoText: moldeoText || null,
      laserText: laserText || null,
      ceraText: ceraText || null,
      massageText: massageText || null,
      notes: notes || null,
    };

    const updated = {
      ...selectedClient,
      additionalTreatments: [
        ...(selectedClient.additionalTreatments || []),
        newTreatmentEntry,
      ],
    };

    await saveRecordToFirestore(updated);
    if (paymentInfo.paymentType === "tarjeta_regalo") {
      await processGiftCardRedemption(paymentInfo, treatmentName.trim());
    }
    if (paymentInfo.paymentType === "deposito_adelantado") {
      await processDepositApplication(paymentInfo, selectedClient.form?.nombre);
    }
    onSaved(updated);
    setShowPaymentSetup(false);
    setPendingPricingData(null);
    onClose();
    alert(
      `✅ Tratamiento agregado a ${selectedClient.form?.nombre}\n\n` +
      `📦 Precio base (sin IVA): ${formatCurrency(basePrice)}\n` +
      `📋 IVA (13%): ${formatCurrency(ivaAmount)}\n` +
      `💰 Total: ${formatCurrency(totalPrice)}\n` +
      `📅 Sesiones: ${sessNum}\n` +
      `💳 Tipo de pago: ${PAYMENT_TYPES.find(p=>p.value===paymentInfo.paymentType)?.label || paymentInfo.paymentType}`
    );
  };

  const overlayStyle = {
    position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.55)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 9999, padding: "1rem",
  };
  const modalStyle = {
    backgroundColor: "white", borderRadius: "1.25rem",
    padding: isMobile ? "1.25rem" : "2rem",
    width: "100%", maxWidth: "560px",
    maxHeight: "90vh", overflowY: "auto",
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
  };
  const sectionTitle = {
    fontFamily: "Georgia, serif", color: colors.gold.dark,
    fontSize: "1rem", fontWeight: "bold",
    marginBottom: "0.75rem", marginTop: "1rem",
    borderBottom: `1px solid ${colors.gold.light}`,
    paddingBottom: "0.25rem",
  };
  const typeBtn = (label, emoji) => React.createElement(
    "button",
    {
      onClick: () => { setTreatmentType(label); setBodyCategory(""); },
      style: {
        padding: "0.75rem 1rem", borderRadius: "0.75rem", cursor: "pointer",
        border: `2px solid ${treatmentType === label ? colors.gold.primary : colors.gray.medium}`,
        backgroundColor: treatmentType === label ? colors.gold.light : "white",
        color: colors.gold.dark, fontWeight: "600", fontSize: "0.95rem",
        flex: 1,
      },
    },
    emoji + " " + label
  );

  const bodyCatBtn = (cat) => React.createElement(
    "button",
    {
      onClick: () => setBodyCategory(cat),
      style: {
        padding: "0.6rem 0.9rem", borderRadius: "0.75rem", cursor: "pointer",
        border: `2px solid ${bodyCategory === cat ? colors.gold.primary : colors.gray.medium}`,
        backgroundColor: bodyCategory === cat ? colors.gold.light : "white",
        color: colors.gold.dark, fontWeight: "500", fontSize: "0.875rem",
        flex: 1,
      },
    },
    cat
  );

  return React.createElement(
    "div", { style: overlayStyle },
    React.createElement(
      "div", { style: modalStyle },
      // Header
      React.createElement(
        "div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" } },
        React.createElement("h2", { style: { fontFamily: "Georgia, serif", color: colors.gold.dark, fontSize: "1.25rem", margin: 0 } },
          "💆‍♀️ Agregar Tratamiento"
        ),
        React.createElement("button", {
          onClick: onClose,
          style: { background: "none", border: "none", fontSize: "1.4rem", cursor: "pointer", color: colors.gray.text, lineHeight: 1 }
        }, "×")
      ),

      // STEP 1: Search
      React.createElement("div", { style: sectionTitle }, "🔍 Buscar cliente"),
      React.createElement("input", {
        type: "text",
        placeholder: "Nombre, teléfono o cédula...",
        value: searchTerm,
        onChange: (e) => { setSearchTerm(e.target.value); setSelectedClient(null); setStep("search"); },
        style: { ...styles.input, marginBottom: "0.5rem" },
      }),
      step === "search" && filteredClients.length > 0 && React.createElement(
        "div", {
          style: {
            border: `1px solid ${colors.gold.light}`, borderRadius: "0.75rem",
            overflow: "hidden", marginBottom: "1rem",
          }
        },
        filteredClients.map((r, idx) => React.createElement(
          "div", {
            key: r.id,
            onClick: () => handleSelectClient(r),
            style: {
              padding: "0.75rem 1rem", cursor: "pointer",
              backgroundColor: idx % 2 === 0 ? "white" : colors.gray.warm,
              borderBottom: idx < filteredClients.length - 1 ? `1px solid ${colors.gold.light}` : "none",
              display: "flex", flexDirection: "column", gap: "0.15rem",
            },
          },
          React.createElement("span", { style: { fontWeight: "600", color: colors.gold.dark } }, r.form?.nombre),
          React.createElement("span", { style: { fontSize: "0.8rem", color: colors.gray.text } },
            `Cédula: ${r.form?.cedula || "—"} · Tel: ${r.form?.telefono || "—"}`
          ),
          React.createElement("span", { style: { fontSize: "0.75rem", color: colors.gray.text } },
            `Trat. actual: ${r.form?.treatmentType || "No especificado"}`
          )
        ))
      ),
      step === "search" && searchTerm.length >= 2 && filteredClients.length === 0 && React.createElement(
        "div", { style: { color: colors.accent.danger, fontSize: "0.875rem", marginBottom: "0.75rem" } },
        "No se encontraron clientes con ese criterio."
      ),

      // STEP 2: Treatment form
      selectedClient && step === "form" && React.createElement(
        React.Fragment, null,
        React.createElement("div", {
          style: {
            backgroundColor: colors.gold.light, borderRadius: "0.75rem",
            padding: "0.75rem 1rem", marginBottom: "1rem",
            border: `1px solid ${colors.gold.primary}`,
          }
        },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark } }, selectedClient.form?.nombre),
          React.createElement("div", { style: { fontSize: "0.8rem", color: colors.gray.text } },
            `Cédula: ${selectedClient.form?.cedula || "—"} · Tel: ${selectedClient.form?.telefono || "—"}`
          )
        ),

        React.createElement("div", { style: sectionTitle }, "🎯 Tipo de tratamiento"),
        React.createElement(
          "div", { style: { display: "flex", gap: "0.5rem", marginBottom: "1rem" } },
          typeBtn("Facial", "✨"),
          typeBtn("Corporal", "💪"),
          typeBtn("Ambos", "🌿"),
        ),

        // Facial fields
        (treatmentType === "Facial" || treatmentType === "Ambos") && React.createElement(
          React.Fragment, null,
          React.createElement("div", { style: sectionTitle }, "✨ Tratamiento solicitado por el cliente"),
          React.createElement("textarea", {
            value: facialText,
            onChange: (e) => setFacialText(e.target.value),
            placeholder: "¿Qué tratamiento facial le interesa? ¿Cuál es su preocupación principal?",
            rows: 3,
            style: { ...styles.input, resize: "vertical" },
          })
        ),

        // Corporal fields
        (treatmentType === "Corporal" || treatmentType === "Ambos") && React.createElement(
          React.Fragment, null,
          React.createElement("div", { style: sectionTitle }, "💪 Categoría corporal"),
          React.createElement(
            "div", { style: { display: "flex", gap: "0.5rem", flexWrap: "wrap", marginBottom: "0.75rem" } },
            bodyCats.map((c) => bodyCatBtn(c))
          ),
          bodyCategory === "Moldeo corporal" && React.createElement("textarea", {
            value: moldeoText, onChange: (e) => setMoldeoText(e.target.value),
            placeholder: "¿Qué áreas desea tratar? Ej: abdomen, glúteos, celulitis...",
            rows: 3, style: { ...styles.input, resize: "vertical" },
          }),
          bodyCategory === "Depilación láser" && React.createElement("textarea", {
            value: laserText, onChange: (e) => setLaserText(e.target.value),
            placeholder: "¿Qué zonas desea depilar? Ej: axilas, piernas, bikini...",
            rows: 3, style: { ...styles.input, resize: "vertical" },
          }),
          bodyCategory === "Depilación con cera" && React.createElement("textarea", {
            value: ceraText, onChange: (e) => setCeraText(e.target.value),
            placeholder: "¿Qué zonas desea depilar? Ej: axilas, media pierna, bikini, cejas...",
            rows: 3, style: { ...styles.input, resize: "vertical" },
          }),
          bodyCategory === "Masajes" && React.createElement("textarea", {
            value: massageText, onChange: (e) => setMassageText(e.target.value),
            placeholder: "¿Qué tipo de masaje? ¿Cuál es su molestia o preocupación?",
            rows: 3, style: { ...styles.input, resize: "vertical" },
          }),
        ),

        React.createElement("div", { style: sectionTitle }, "📋 Información del paquete"),
        React.createElement("label", { style: { display: "block", fontSize: "0.85rem", color: colors.gold.dark, marginBottom: "0.25rem", fontWeight: "500" } }, "Nombre del tratamiento *"),
        React.createElement("input", {
          type: "text",
          value: treatmentName,
          onChange: (e) => setTreatmentName(e.target.value),
          placeholder: "Ej: Depilación láser axilas, Moldeo corporal básico...",
          style: { ...styles.input, marginBottom: "0.75rem" },
        }),
        React.createElement(
          "div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem", marginBottom: "0.75rem" } },
          React.createElement("div", null,
            React.createElement("label", { style: { display: "block", fontSize: "0.85rem", color: colors.gold.dark, marginBottom: "0.25rem", fontWeight: "500" } }, "Número de sesiones *"),
            React.createElement("input", {
              type: "number", min: "1",
              value: totalSessions,
              onChange: (e) => setTotalSessions(e.target.value),
              placeholder: "Ej: 5",
              style: styles.input,
            })
          ),
          React.createElement("div", null,
            React.createElement("label", { style: { display: "block", fontSize: "0.85rem", color: colors.gold.dark, marginBottom: "0.25rem", fontWeight: "500" } }, "Precio del paquete (₡)"),
            React.createElement("input", {
              type: "number", min: "0",
              value: packagePrice,
              onChange: (e) => setPackagePrice(e.target.value),
              placeholder: "Ej: 150000",
              style: styles.input,
            })
          )
        ),
        packagePrice && parseFloat(packagePrice) > 0 && React.createElement(
          "div", {
            style: {
              backgroundColor: colors.gold.soft || "#FDF8F0",
              border: `1px solid ${colors.gold.light}`,
              borderRadius: "0.75rem",
              padding: "0.75rem",
              marginBottom: "0.75rem",
              fontSize: "0.85rem",
            }
          },
          React.createElement("div", { style: { fontWeight: "600", color: colors.gold.dark, marginBottom: "0.4rem" } }, "💰 Vista previa IVA (13%)"),
          React.createElement("div", null, "Si IVA incluido → Base: ", React.createElement("strong", null, formatCurrency(Math.round(parseFloat(packagePrice) / 1.13))), " + IVA: ", React.createElement("strong", null, formatCurrency(parseFloat(packagePrice) - Math.round(parseFloat(packagePrice) / 1.13)))),
          React.createElement("div", null, "Si IVA NO incluido → Total: ", React.createElement("strong", null, formatCurrency(parseFloat(packagePrice) + Math.round(parseFloat(packagePrice) * 0.13))))
        ),

        React.createElement("div", { style: sectionTitle }, "📝 Notas internas (opcional)"),
        React.createElement("textarea", {
          value: notes, onChange: (e) => setNotes(e.target.value),
          placeholder: "Observaciones del especialista...",
          rows: 2, style: { ...styles.input, resize: "vertical" },
        }),

        error && React.createElement(
          "div", { style: { color: colors.accent.danger, fontSize: "0.875rem", marginBottom: "0.75rem", marginTop: "0.5rem" } },
          "⚠️ " + error
        ),

        React.createElement(
          "div", { style: { display: "flex", gap: "0.75rem", marginTop: "1.25rem" } },
          React.createElement("button", { onClick: onClose, style: styles.buttonOutline }, "Cancelar"),
          React.createElement("button", {
            onClick: handleSave,
            style: { ...styles.buttonSuccess, flex: 1 },
            disabled: saving,
          }, saving ? "Guardando..." : "✓ Guardar tratamiento")
        )
      ),

      // PaymentSetup modal inside AddTreatmentModal
      showPaymentSetup && pendingPricingData && React.createElement(PaymentSetupModal, {
        totalPrice: pendingPricingData.totalPrice,
        onClose: () => { setShowPaymentSetup(false); setPendingPricingData(null); },
        onSave: handlePaymentSetupSave,
      }),

      // IVA choice modal inside AddTreatmentModal
      showIvaChoice && React.createElement(
        "div", {
          style: {
            position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 10000, padding: "1rem",
          }
        },
        React.createElement(
          "div", {
            style: {
              backgroundColor: "white", borderRadius: "1.25rem",
              padding: "1.75rem", maxWidth: "400px", width: "100%",
              boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
            }
          },
          React.createElement("div", { style: { fontFamily: "Georgia, serif", color: colors.gold.dark, fontSize: "1.1rem", fontWeight: "bold", marginBottom: "0.75rem" } },
            "💰 Información de IVA"
          ),
          React.createElement("p", { style: { color: colors.gray.text, marginBottom: "1.25rem" } },
            "¿El precio ingresado (₡" + (parseFloat(packagePrice)||0).toLocaleString("es-CR") + ") INCLUYE el IVA del 13%?"
          ),
          React.createElement(
            "div", { style: { display: "flex", flexDirection: "column", gap: "0.75rem" } },
            React.createElement("button", {
              onClick: () => handleSaveWithIva(true),
              style: { ...styles.buttonSuccess, padding: "0.75rem" },
            }, "✓ Sí, el precio incluye IVA"),
            React.createElement("button", {
              onClick: () => handleSaveWithIva(false),
              style: { ...styles.buttonDanger, padding: "0.75rem" },
            }, "✗ No, agregar IVA al precio"),
            React.createElement("button", {
              onClick: () => setShowIvaChoice(false),
              style: { ...styles.buttonOutline, padding: "0.5rem" },
            }, "Cancelar")
          )
        )
      )
    )
  );
}

// ══════════════════════════════════════════════════════
// NACION NILA — SERVICES MENU DATA
// ══════════════════════════════════════════════════════
const NILA_SERVICES = [
  {
    category: "Tratamientos Faciales",
    items: [
      { name: "Limpieza facial Profunda", sessions: 1, totalPrice: 35000 },
      { name: "Limpieza facial Express", sessions: 1, totalPrice: 25000 },
      { name: "Facial Koreano", sessions: 1, totalPrice: 40000 },
      { name: "Facial con punto diamante", sessions: 1, totalPrice: 32000 },
      { name: "Facial con ADN de salmón", sessions: 1, totalPrice: 35000 },
      { name: "Peeling Facial", sessions: 1, totalPrice: 35000 },
      { name: "Hidratación facial", sessions: 1, totalPrice: 30000 },
      { name: "Hidrolips (babylips)", sessions: 1, totalPrice: 25000 },
      { name: "Lifting facial con radiofrecuencia", sessions: 1, totalPrice: 30000 },
      { name: "Hollywood peeling", sessions: 1, totalPrice: 40000 },
      { name: "Dermapen - Tratamiento regenerador con microagujas", sessions: 1, totalPrice: 35000 },
      { name: "Dermapen con ácido hialurónico", sessions: 1, totalPrice: 30000 },
      { name: "Dermapen con vitamina C", sessions: 1, totalPrice: 35000 },
      { name: "Dermapen con Células madre", sessions: 1, totalPrice: 50000 },
      { name: "FULL FACE rejuvenecimiento facial", sessions: 5, totalPrice: 190000 },
      { name: "Tratamiento de ACNÉ", sessions: 5, totalPrice: 165000 },
      { name: "PIGMENT - Tratamiento para manchas", sessions: 5, totalPrice: 165000 },
    ]
  },
  {
    category: "Tratamientos Corporales",
    items: [
      { name: "Tratamiento de EMS zero", sessions: 1, totalPrice: 30000 },
      { name: "Tratamiento Reductivo (Brazos)", sessions: 5, totalPrice: 150000 },
      { name: "Tratamiento Reductivo (Piernas)", sessions: 5, totalPrice: 200000 },
      { name: "Tratamiento reductivo Básico (Abdomen)", sessions: 5, totalPrice: 130000 },
      { name: "Tratamiento reductivo Premium (Abdomen)", sessions: 5, totalPrice: 175000 },
      { name: "Tratamiento Reductivo VIP (Abdomen)", sessions: 5, totalPrice: 250000 },
      { name: "Tratamiento de glúteos", sessions: 5, totalPrice: 200000 },
      { name: "Tratamiento de Celulitis", sessions: 5, totalPrice: 200000 },
      { name: "Carboxiterapia", sessions: 5, totalPrice: 175000 },
      { name: "Mesoterapia", sessions: 5, totalPrice: 250000 },
    ]
  },
  {
    category: "Depilación Definitiva Soprano",
    items: [
      { name: "Zonas muy pequeñas (Bigote, Mentón, Pezón, Entrecejo)", sessions: 5, totalPrice: 75000 },
      { name: "Zonas pequeñas (Barba, Cuello, Axilas, Bikini lineal)", sessions: 5, totalPrice: 100000 },
      { name: "Zonas medianas (Bikini completo, Media Piernas, Brazos)", sessions: 5, totalPrice: 150000 },
      { name: "Zonas grandes (Piernas completas, Espalda, Pecho, Abdomen, Glúteos)", sessions: 5, totalPrice: 200000 },
    ]
  },
  {
    category: "Paquetes de Depilación",
    note: "Se aplica un 20% de descuento por cada zona incluida en el paquete",
    items: [
      { name: "Paquete 1: Axilas + Mentón + Bigote", sessions: 5, totalPrice: 112500 },
      { name: "Paquete 2: Media Piernas + Bikini completo + Axilas", sessions: 5, totalPrice: 300000 },
      { name: "Paquete 3: Full Body Mujer (Piernas, Bikini, Brazos, Axilas, Bigote, Mentón)", sessions: 5, totalPrice: 562500 },
      { name: "Paquete 4: Full Body Hombre (Piernas, Bikini, Espalda, Brazos, Axilas, Glúteos)", sessions: 5, totalPrice: 600000 },
      { name: "Paquete 5: Rostro completo Mujer (Entrecejo, Bigote, Mentón, Mejillas)", sessions: 5, totalPrice: 225000 },
      { name: "Paquete 6: Rostro completo Hombre (Barba, Bigote, Mentón, Cuello)", sessions: 5, totalPrice: 262500 },
    ]
  },
  {
    category: "Masajes",
    items: [
      { name: "Masaje Relajante con Aromaterapia", sessions: 1, totalPrice: 30000 },
      { name: "Masaje Relajante con piedras calientes", sessions: 1, totalPrice: 35000 },
      { name: "Masajes Descontracturantes", sessions: 1, totalPrice: 40000 },
      { name: "Masaje nervio ciático", sessions: 1, totalPrice: 25000 },
      { name: "Masaje Piernas cansadas", sessions: 1, totalPrice: 20000 },
      { name: "Masaje drenaje linfático", sessions: 1, totalPrice: 45000 },
      { name: "Masaje Espalda y Cuello", sessions: 1, totalPrice: 20000 },
      { name: "Masaje reductor manual", sessions: 1, totalPrice: 20000 },
      { name: "Masaje reductor con maderoterapia", sessions: 1, totalPrice: 25000 },
      { name: "Masaje deportivo", sessions: 1, totalPrice: 35000 },
    ]
  },
  {
    category: "Pestañas",
    items: [
      { name: "Pestañas Clásicas", sessions: 1, totalPrice: 24500 },
      { name: "Pestañas Efecto Mojado", sessions: 1, totalPrice: 25500 },
      { name: "Pestañas Híbridas", sessions: 1, totalPrice: 26500 },
      { name: "Pestañas Efecto Rímel", sessions: 1, totalPrice: 25500 },
      { name: "Pestañas Voluminosas (Volumen Tecnológico)", sessions: 1, totalPrice: 32500 },
      { name: "Pestañas Volumen MEGA (Volumen Tecnológico)", sessions: 1, totalPrice: 35500 },
      { name: "Lifting de Pestañas con tinte", sessions: 1, totalPrice: 21500 },
      { name: "Pestañas Hawaianas", sessions: 1, totalPrice: 25500 },
      { name: "Retiro de pestañas", sessions: 1, totalPrice: 5000 },
    ]
  },
  {
    category: "Cejas",
    items: [
      { name: "Laminado de Cejas", sessions: 1, totalPrice: 15500 },
      { name: "Diseño de Cejas con Henna", sessions: 1, totalPrice: 15500 },
      { name: "Diseño con depilación con hilo", sessions: 1, totalPrice: 12500 },
      { name: "Diseño con depilación con Cera", sessions: 1, totalPrice: 12000 },
    ]
  },
  {
    category: "Paquetes de Pestañas y Cejas",
    items: [
      { name: "Pestañas Híbridas + Laminado de Cejas", sessions: 1, totalPrice: 34500 },
      { name: "Pestañas Efecto Hawaiano + Laminado de Cejas", sessions: 1, totalPrice: 35500 },
      { name: "Lifting de pestañas + Laminado de Cejas", sessions: 1, totalPrice: 31500 },
      { name: "Pestañas Voluminosas + Hydralips", sessions: 1, totalPrice: 44500 },
    ]
  },
  {
    category: "Depilación con Cera",
    items: [
      { name: "Bozo", sessions: 1, totalPrice: 5000, subcategory: "Rostro" },
      { name: "Mentón", sessions: 1, totalPrice: 5000, subcategory: "Rostro" },
      { name: "Cejas", sessions: 1, totalPrice: 8000, subcategory: "Rostro" },
      { name: "Rostro completo", sessions: 1, totalPrice: 15000, subcategory: "Rostro" },
      { name: "Axilas", sessions: 1, totalPrice: 9900, subcategory: "Cuerpo" },
      { name: "Medio brazo", sessions: 1, totalPrice: 13900, subcategory: "Cuerpo" },
      { name: "Brazos completos", sessions: 1, totalPrice: 16900, subcategory: "Cuerpo" },
      { name: "Abdomen", sessions: 1, totalPrice: 6000, subcategory: "Cuerpo" },
      { name: "Media pierna", sessions: 1, totalPrice: 19900, subcategory: "Piernas" },
      { name: "Pierna completa", sessions: 1, totalPrice: 27900, subcategory: "Piernas" },
      { name: "Bikini lineal (básico)", sessions: 1, totalPrice: 18000, subcategory: "Bikini" },
      { name: "Bikini completo", sessions: 1, totalPrice: 25000, subcategory: "Bikini" },
      { name: "Axilas + Bikini lineal (básico)", sessions: 1, totalPrice: 22900, subcategory: "Paquetes especiales" },
      { name: "Axilas + Bikini completo", sessions: 1, totalPrice: 28900, subcategory: "Paquetes especiales" },
      { name: "Axilas + Media pierna", sessions: 1, totalPrice: 25900, subcategory: "Paquetes especiales" },
      { name: "Bikini lineal (básico) + Media pierna", sessions: 1, totalPrice: 32900, subcategory: "Paquetes especiales" },
      { name: "Pierna completa + Axilas + Bikini lineal (básico)", sessions: 1, totalPrice: 47900, subcategory: "Paquetes especiales" },
    ]
  },
];


const SEYTU_PRODUCTS = [
  { codigo: "9519035", descripcion: "ESPUMA LIMPIADORA FACIAL", categoria: "Los Más Vendidos", precioSugerido: 14300, precioNila: 17875 },
  { codigo: "9501146", descripcion: "OMNIPLUS GEL PREMIUM", categoria: "Los Más Vendidos", precioSugerido: 12500, precioNila: 15625 },
  { codigo: "9501142", descripcion: "CREMA ANTIBACTERIAL SANDÍA - MELÓN", categoria: "Los Más Vendidos", precioSugerido: 2700, precioNila: 3375 },
  { codigo: "9501145", descripcion: "SUERO FACIAL HIDRATACION PROFUNDA C", categoria: "Los Más Vendidos", precioSugerido: 15300, precioNila: 19125 },
  { codigo: "9501140", descripcion: "CREMA DE MANOS ANTIBACTERIAL MANZANA-PERA", categoria: "Los Más Vendidos", precioSugerido: 2700, precioNila: 3375 },
  { codigo: "9501094", descripcion: "SUERO P/CONTORNO OJOS HIDRATACION P", categoria: "Los Más Vendidos", precioSugerido: 8200, precioNila: 10250 },
  { codigo: "9504041", descripcion: "SHAMPOO D/CUIDADO ESPECIAL P/CABELLO", categoria: "Los Más Vendidos", precioSugerido: 13000, precioNila: 16250 },
  { codigo: "5705956", descripcion: "SUPLEMENTO SYSTEM T-SPECIALIST", categoria: "Línea System", precioSugerido: 32000, precioNila: 40000 },
  { codigo: "9501174", descripcion: "CREMA PARA CONTORNO DE OJOS TIME SYSTEM", categoria: "Línea System", precioSugerido: 19400, precioNila: 24250 },
  { codigo: "9501178", descripcion: "CREMA DE DÍA FPS 30 TIME SYSTEM", categoria: "Línea System", precioSugerido: 30000, precioNila: 37500 },
  { codigo: "9501179", descripcion: "SUERO DE NOCHE TIME SYSTEM", categoria: "Línea System", precioSugerido: 32200, precioNila: 40250 },
  { codigo: "6105921", descripcion: "SYSTEM-H SPECIALIST SEYTU", categoria: "Línea System", precioSugerido: 42500, precioNila: 53125 },
  { codigo: "9501181", descripcion: "LOCION CAPILAR FORTIFICANTE", categoria: "Línea System", precioSugerido: 28400, precioNila: 35500 },
  { codigo: "9504024", descripcion: "SHAMPOO FORTIFICANTE", categoria: "Línea System", precioSugerido: 22100, precioNila: 27625 },
  { codigo: "9501197", descripcion: "GEL ANTI-MANCHAS", categoria: "Línea System", precioSugerido: 25800, precioNila: 32250 },
  { codigo: "9501200", descripcion: "CREMA PARA MANOS CUELLO Y ESCOTE", categoria: "Línea System", precioSugerido: 23600, precioNila: 29500 },
  { codigo: "9501206", descripcion: "CREMA LIMPIADORA FACIAL", categoria: "Cuidado de la Piel - Facial / Limpieza", precioSugerido: 13200, precioNila: 16500 },
  { codigo: "9501203", descripcion: "TONICO HIDRATANTE", categoria: "Cuidado de la Piel - Facial / Limpieza", precioSugerido: 23400, precioNila: 29250 },
  { codigo: "9501192", descripcion: "DESMAQUILLANTE PARA OJOS 80 ml", categoria: "Cuidado de la Piel - Facial / Limpieza", precioSugerido: 11600, precioNila: 14500 },
  { codigo: "9501191", descripcion: "MASCARILLA FACIAL", categoria: "Cuidado de la Piel - Facial / Limpieza", precioSugerido: 16100, precioNila: 20125 },
  { codigo: "9501071", descripcion: "EXFOLIANTE FACIAL CON EXTRACTO DE GINSENG", categoria: "Cuidado de la Piel - Facial / Limpieza", precioSugerido: 16000, precioNila: 20000 },
  { codigo: "9501144", descripcion: "CREMA ACLARADORA FACIAL", categoria: "Cuidado de la Piel - Facial / Control de Manchas", precioSugerido: 16900, precioNila: 21125 },
  { codigo: "9501170", descripcion: "CREMA HIDRATANTE DE NOCHE", categoria: "Cuidado de la Piel - Facial / Cutis Normal", precioSugerido: 17700, precioNila: 22125 },
  { codigo: "9501171", descripcion: "CREMA HIDRATANTE DE DÍA FPS20", categoria: "Cuidado de la Piel - Facial / Cutis Normal", precioSugerido: 17700, precioNila: 22125 },
  { codigo: "9501078", descripcion: "CREMA CORPORAL PARA PIEL DE NARANJA", categoria: "Cuidado de la Piel - Facial / Cutis Normal", precioSugerido: 23000, precioNila: 28750 },
  { codigo: "9501186", descripcion: "GEL-CREMA PARA ESTRIAS 150gr", categoria: "Cuidado de la Piel - Facial / Cutis Normal", precioSugerido: 20600, precioNila: 25750 },
  { codigo: "9501151", descripcion: "CREMA PROTECTORA SOLAR FPS 50", categoria: "Cuidado de la Piel - Facial / Cuidado Solar", precioSugerido: 21200, precioNila: 26500 },
  { codigo: "9501214", descripcion: "PROTECTOR SOLAR FACIAL FPS 50+", categoria: "Cuidado de la Piel - Facial / Cuidado Solar", precioSugerido: 15500, precioNila: 19375 },
  { codigo: "9501215", descripcion: "PROTECTOR SOLAR CORPORAL FPS 50+", categoria: "Cuidado de la Piel - Facial / Cuidado Solar", precioSugerido: 22500, precioNila: 28125 },
  { codigo: "9501141", descripcion: "CREMA DE MANOS ANTIBACTERIAL VAINILLA", categoria: "Cuidado Personal", precioSugerido: 2700, precioNila: 3375 },
  { codigo: "9501134", descripcion: "BALSAMO LABIAL OMNIPLUS FPS 15", categoria: "Omniplus", precioSugerido: 12400, precioNila: 15500 },
  { codigo: "9510029", descripcion: "FRAGANCIA FOR HER", categoria: "Fragancias", precioSugerido: 29800, precioNila: 37250 },
  { codigo: "9510028", descripcion: "FRAGANCIA FOR HIM", categoria: "Fragancias", precioSugerido: 29800, precioNila: 37250 },
  { codigo: "8916007", descripcion: "CREMA MANOS COCO VAINILLA", categoria: "Línea Coco Vainilla", precioSugerido: 3750, precioNila: 4688 },
  { codigo: "8916010", descripcion: "LOCION CORPORAL COCO VAINILLA", categoria: "Línea Coco Vainilla", precioSugerido: 11800, precioNila: 14750 },
  { codigo: "8916013", descripcion: "JABON LIQUIDO EXFOLIANTE COCO VAINILLA", categoria: "Línea Coco Vainilla", precioSugerido: 10900, precioNila: 13625 },
  { codigo: "8916009", descripcion: "CREMA MANOS FRUTOS ROJOS", categoria: "Línea Frutos Rojos", precioSugerido: 3750, precioNila: 4688 },
  { codigo: "8916012", descripcion: "LOCION CORPORAL FRUTOS ROJOS", categoria: "Línea Frutos Rojos", precioSugerido: 11800, precioNila: 14750 },
  { codigo: "8916015", descripcion: "JABON CORPORAL FRUTOS ROJOS", categoria: "Línea Frutos Rojos", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9508037", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G FAIR", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508038", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G L SAND", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508039", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G S HONEY", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508040", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G NAT BEIGE", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508041", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G W BEIGE", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508042", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G C NATURAL", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508043", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G SUN BEIGE", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508044", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G CARAMEL", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9508045", descripcion: "MAQUILLAJE LIQ UP+ FPS15 40G COCOA", categoria: "Maquillaje / Bases", precioSugerido: 22400, precioNila: 28000 },
  { codigo: "9511029", descripcion: "MAQUILLAJE COMPACTO 2EN1 FAIR", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511030", descripcion: "MAQUILLAJE COMPACTO 2EN1 LIGHT SAND", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511031", descripcion: "MAQUILLAJE COMPACTO 2EN1 SOFT HONEY", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511032", descripcion: "MAQUILLAJE COMPACTO 2EN1 NATURAL BEIGE", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511033", descripcion: "MAQUILLAJE COMPACTO 2EN1 W BEIGE", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511034", descripcion: "MAQUILLAJE COMPACTO 2EN1 CREAMY NATURAL", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511035", descripcion: "MAQUILLAJE COMPACTO 2EN1 SUN BEIGE", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9511036", descripcion: "MAQUILLAJE COMPACTO 2EN1 CARAMEL", categoria: "Maquillaje / 2 en 1", precioSugerido: 20500, precioNila: 25625 },
  { codigo: "9501161", descripcion: "CORRECTOR LIQUIDO FAIR", categoria: "Maquillaje / Corrector Líquido", precioSugerido: 9700, precioNila: 12125 },
  { codigo: "9501162", descripcion: "CORRECTOR LIQUIDO LIGHT", categoria: "Maquillaje / Corrector Líquido", precioSugerido: 9700, precioNila: 12125 },
  { codigo: "9501163", descripcion: "CORRECTOR LIQUIDO MEDIUM", categoria: "Maquillaje / Corrector Líquido", precioSugerido: 9700, precioNila: 12125 },
  { codigo: "9501164", descripcion: "CORRECTOR LIQUIDO DEEP", categoria: "Maquillaje / Corrector Líquido", precioSugerido: 9700, precioNila: 12125 },
  { codigo: "8911501", descripcion: "POLVO TRASLUCIDO", categoria: "Maquillaje / Polvo Traslúcido", precioSugerido: 12900, precioNila: 16125 },
  { codigo: "8901101", descripcion: "POLVO ILUMINADOR DESERT SUNSET", categoria: "Maquillaje / Polvo Iluminador", precioSugerido: 8000, precioNila: 10000 },
  { codigo: "8901102", descripcion: "POLVO ILUMINADOR DESERT ROSE", categoria: "Maquillaje / Polvo Iluminador", precioSugerido: 8000, precioNila: 10000 },
  { codigo: "8901103", descripcion: "POLVO ILUMINADOR DESERT SAND", categoria: "Maquillaje / Polvo Iluminador", precioSugerido: 8000, precioNila: 10000 },
  { codigo: "9509015", descripcion: "RUBOR COMPACTO APRICOT", categoria: "Maquillaje / Rubor Compacto", precioSugerido: 11300, precioNila: 14125 },
  { codigo: "9509016", descripcion: "RUBOR COMPACTO PEACH", categoria: "Maquillaje / Rubor Compacto", precioSugerido: 11300, precioNila: 14125 },
  { codigo: "9509017", descripcion: "RUBOR COMPACTO PLUM", categoria: "Maquillaje / Rubor Compacto", precioSugerido: 11300, precioNila: 14125 },
  { codigo: "9506013", descripcion: "DELINEADOR PARA OJOS PENLINER", categoria: "Maquillaje / Delineador Líquido", precioSugerido: 9800, precioNila: 12250 },
  { codigo: "9506014", descripcion: "DELINEADOR LIQUIDO PARA OJOS", categoria: "Maquillaje / Delineador Líquido", precioSugerido: 11300, precioNila: 14125 },
  { codigo: "9512023", descripcion: "MASCARA PARA PESTAÑAS", categoria: "Maquillaje / Rímel", precioSugerido: 14100, precioNila: 17625 },
  { codigo: "9506015", descripcion: "SET DELINEADOR COMPACTO DE CEJAS", categoria: "Maquillaje / Cejas", precioSugerido: 18400, precioNila: 23000 },
  { codigo: "9517524", descripcion: "LABIAL HIDRATANTE HOT PINK FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517525", descripcion: "LABIAL HIDRATANTE LIGHT PINK FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517526", descripcion: "LABIAL HIDRATANTE SAND NUDE FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517527", descripcion: "LABIAL HIDRATANTE ROSE NUDE FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517528", descripcion: "LABIAL HIDRATANTE FLAME CORAL FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517529", descripcion: "LABIAL HIDRATANTE SWEET CORAL FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517530", descripcion: "LABIAL HIDRATANTE SEYTÚ RED FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517531", descripcion: "LABIAL HIDRATANTE FLASH RED FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517532", descripcion: "LABIAL HIDRATANTE CANDY RED FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517533", descripcion: "LABIAL HIDRATANTE ICON VIOLET FPS15", categoria: "Maquillaje / Labial Hidratante", precioSugerido: 10500, precioNila: 13125 },
  { codigo: "9517518", descripcion: "BRILLO LABIAL OPALO", categoria: "Maquillaje / Brillo", precioSugerido: 14000, precioNila: 17500 },
  { codigo: "9517519", descripcion: "BRILLO LABIAL AMBAR", categoria: "Maquillaje / Brillo", precioSugerido: 14000, precioNila: 17500 },
  { codigo: "9517520", descripcion: "BRILLO LABIAL TOPAZ", categoria: "Maquillaje / Brillo", precioSugerido: 14000, precioNila: 17500 },
  { codigo: "9517521", descripcion: "BRILLO LABIAL AGATA", categoria: "Maquillaje / Brillo", precioSugerido: 14000, precioNila: 17500 },
  { codigo: "9517522", descripcion: "BRILLO LABIAL ZAFIRO", categoria: "Maquillaje / Brillo", precioSugerido: 14000, precioNila: 17500 },
  { codigo: "9517523", descripcion: "BRILLO LABIAL RUBI", categoria: "Maquillaje / Brillo", precioSugerido: 14000, precioNila: 17500 },
  { codigo: "8905002", descripcion: "LAPIZ PARA CEJAS UNIVERSAL", categoria: "Maquillaje / Edición Limitada", precioSugerido: 8000, precioNila: 10000 },
  { codigo: "8905003", descripcion: "LAPIZ PARA CEJAS BROWN", categoria: "Maquillaje / Edición Limitada", precioSugerido: 8000, precioNila: 10000 },
  { codigo: "9501158", descripcion: "SHAMPOO CON EXTRACTOS HERBALES", categoria: "Cuidado Capilar / Cuidado Diario", precioSugerido: 9500, precioNila: 11875 },
  { codigo: "9504033", descripcion: "ACONDICIONADOR CON EXTRACTOS HERBALES", categoria: "Cuidado Capilar / Cuidado Diario", precioSugerido: 8800, precioNila: 11000 },
  { codigo: "9504042", descripcion: "SHAMPOO COLOR PROTECT", categoria: "Cuidado Capilar / Cuidado Diario", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9504045", descripcion: "GEL FIJADOR PARA EL CABELLO", categoria: "Cuidado Capilar / Cuidado Diario", precioSugerido: 7800, precioNila: 9750 },
  { codigo: "9504044", descripcion: "COMPLEJO MULTIVITAMÍNICO CAPILAR", categoria: "Cuidado Capilar / Cuidado Intensivo", precioSugerido: 23300, precioNila: 29125 },
  { codigo: "9501154", descripcion: "MASCARILLA REPARADORA CAPILAR", categoria: "Cuidado Capilar / Cuidado Intensivo", precioSugerido: 13200, precioNila: 16500 },
  { codigo: "9518039", descripcion: "TINTE PERMANENTE CASTAÑO OSCURO", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9518040", descripcion: "TINTE PERMANENTE CASTAÑO CLARO", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9518041", descripcion: "TINTE PERMANENTE NEGRO NATURAL", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9518043", descripcion: "TINTE PERMANENTE ROJO", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9518046", descripcion: "TINTE PERMANENTE RUBIO EXTRA CLARO / 9", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9518047", descripcion: "TINTE PERMANENTE MOKA / 6.34", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9518048", descripcion: "TINTE PERMANENTE RUBIO CLARO / 7", categoria: "Cuidado Capilar / Color", precioSugerido: 15100, precioNila: 18875 },
  { codigo: "9503087", descripcion: "ESMALTE PARA UÑAS GODDESS MOOD", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9517534", descripcion: "LABIAL LIQUIDO MATE GODDESS KISS", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9514099", descripcion: "PALETA DE SOMBRAS MARRONES 2023", categoria: "KV", precioSugerido: 27100, precioNila: 33875 },
  { codigo: "9514100", descripcion: "PALETA DE SOMBRAS ROSAS 2023", categoria: "KV", precioSugerido: 27100, precioNila: 33875 },
  { codigo: "9503073", descripcion: "ESMALTE PARA UÑAS ACUARIO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503074", descripcion: "ESMALTE PARA UÑAS ARIES", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503075", descripcion: "ESMALTE PARA UÑAS CANCER", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503076", descripcion: "ESMALTE PARA UÑAS CAPRICORNIO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503077", descripcion: "ESMALTE PARA UÑAS TAURO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503078", descripcion: "ESMALTE PARA UÑAS VIRGO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503079", descripcion: "ESMALTE PARA UÑAS ORION", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503081", descripcion: "ESMALTE PARA UÑAS ESCORPIO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503082", descripcion: "ESMALTE PARA UÑAS GEMINIS", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503083", descripcion: "ESMALTE PARA UÑAS SAGITARIO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503084", descripcion: "ESMALTE PARA UÑAS LIBRA", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503085", descripcion: "ESMALTE PARA UÑAS PISCIS", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9503086", descripcion: "ESMALTE PARA UÑAS LEO", categoria: "KV", precioSugerido: 7700, precioNila: 9625 },
  { codigo: "9517052", descripcion: "LABIAL LIQUIDO MATE KALAHARI", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517537", descripcion: "LABIAL LIQUIDO MATE MASAI", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517538", descripcion: "LABIAL LIQUIDO MATE SAHARA", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517540", descripcion: "LABIAL LIQUIDO MATE NAIROBI", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517541", descripcion: "LABIAL LIQUIDO MATE SAMBURU", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517063", descripcion: "LABIAL LIQUIDO MATE WIFEY", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517064", descripcion: "LABIAL LIQUIDO MATE THIRTIES", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9517065", descripcion: "LABIAL LIQUIDO MATE 90'S BABY", categoria: "KV", precioSugerido: 13100, precioNila: 16375 },
  { codigo: "9522075", descripcion: "BROCHA MAQUILLAJE LIQUIDO", categoria: "Complementos", precioSugerido: 6900, precioNila: 8625 },
  { codigo: "9522077", descripcion: "SET DE BROCHAS ROSTRO", categoria: "Complementos", precioSugerido: 18000, precioNila: 22500 },
  { codigo: "9522078", descripcion: "SET DE BROCHAS OJOS Y LABIOS", categoria: "Complementos", precioSugerido: 16900, precioNila: 21125 },
  { codigo: "9705036", descripcion: "ESPONJA PARA MAQUILLAJE", categoria: "Complementos", precioSugerido: 6200, precioNila: 7750 },
  { codigo: "9704963", descripcion: "SHAKER BOTTLE SEYTÚ", categoria: "Complementos", precioSugerido: 6800, precioNila: 8500 },
  { codigo: "9506021", descripcion: "SET DE PRUEBAS MAQ LIQ UP+ FPS 15", categoria: "Complementos", precioSugerido: 40000, precioNila: 50000 },
];

function ServicesPanel() {
  const isMobile = useIsMobile();
  const [serviceView, setServiceView] = useState("tratamientos"); // "tratamientos" | "seytu"
  const [selectedCategory, setSelectedCategory] = useState("Todas");
  const [searchTerm, setSearchTerm] = useState("");
  const [discount, setDiscount] = useState("");
  const [customSessions, setCustomSessions] = useState({});
  // Seytú filter states
  const [seytuCat, setSeytuCat] = useState("Todas");
  const [seytuCodigo, setSeytuCodigo] = useState("");
  const [seytuDesc, setSeytuDesc] = useState("");
  const seytuCategories = ["Todas", ...Array.from(new Set(SEYTU_PRODUCTS.map(p => p.categoria)))];
  const seytuFiltered = SEYTU_PRODUCTS.filter(p =>
    (seytuCat === "Todas" || p.categoria === seytuCat) &&
    (!seytuCodigo || p.codigo.includes(seytuCodigo)) &&
    (!seytuDesc || p.descripcion.toLowerCase().includes(seytuDesc.toLowerCase()))
  );

  const categories = ["Todas", ...NILA_SERVICES.map(c => c.category)];
  const discountPct = Math.min(100, Math.max(0, parseFloat(discount) || 0));

  const filteredServices = NILA_SERVICES.filter(cat =>
    selectedCategory === "Todas" || cat.category === selectedCategory
  ).map(cat => ({
    ...cat,
    items: cat.items.filter(item =>
      !searchTerm || item.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(cat => cat.items.length > 0);

  const calcPrice = (basePrice, disc) => Math.round(basePrice * (1 - disc / 100));

  return React.createElement("div", { style: { padding: "1rem" } },
    // Header
    React.createElement("h2", { style: { fontSize: "1.4rem", fontFamily: "Georgia, serif", color: colors.gold.dark, marginBottom: "0.25rem" } }, "💆‍♀️ Menú de Servicios"),
    React.createElement("p", { style: { color: colors.gray.text, fontSize: "0.85rem", marginBottom: "1.25rem" } }, "Nación Nila Estética — Solo consulta interna"),

    // View switcher: Tratamientos | Seytú
    React.createElement("div", { style: { display: "flex", gap: "0.5rem", marginBottom: "1.25rem" } },
      React.createElement("button", {
        onClick: () => setServiceView("tratamientos"),
        style: {
          padding: "0.5rem 1.25rem", borderRadius: "2rem", border: "none", cursor: "pointer",
          fontSize: "0.85rem", fontWeight: serviceView === "tratamientos" ? "700" : "500",
          backgroundColor: serviceView === "tratamientos" ? colors.gold.primary : colors.gray.warm,
          color: serviceView === "tratamientos" ? "white" : colors.gray.text,
        }
      }, "💆‍♀️ Tratamientos"),
      React.createElement("button", {
        onClick: () => setServiceView("seytu"),
        style: {
          padding: "0.5rem 1.25rem", borderRadius: "2rem", border: "none", cursor: "pointer",
          fontSize: "0.85rem", fontWeight: serviceView === "seytu" ? "700" : "500",
          backgroundColor: serviceView === "seytu" ? colors.gold.primary : colors.gray.warm,
          color: serviceView === "seytu" ? "white" : colors.gray.text,
        }
      }, "💄 Seytú"),
    ),

    // ══════ SEYTÚ PRODUCTS VIEW ══════
    serviceView === "seytu" && React.createElement("div", null,
      React.createElement("div", { style: { display: isMobile ? "flex" : "grid", flexDirection: "column", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.6rem", marginBottom: "1.25rem" } },
        React.createElement("select", {
          value: seytuCat, onChange: e => setSeytuCat(e.target.value),
          style: { ...styles.input, padding: "0.45rem 0.75rem", fontSize: "0.82rem" },
        }, seytuCategories.map(c => React.createElement("option", { key: c, value: c }, c))),
        React.createElement("input", {
          type: "text", placeholder: "🔍 Código...", value: seytuCodigo,
          onChange: e => setSeytuCodigo(e.target.value),
          style: { ...styles.input, padding: "0.45rem 0.75rem", fontSize: "0.82rem" },
        }),
        React.createElement("input", {
          type: "text", placeholder: "🔍 Descripción...", value: seytuDesc,
          onChange: e => setSeytuDesc(e.target.value),
          style: { ...styles.input, padding: "0.45rem 0.75rem", fontSize: "0.82rem" },
        }),
      ),
      React.createElement("div", { style: { fontSize: "0.8rem", color: colors.gray.text, marginBottom: "0.5rem" } }, `${seytuFiltered.length} productos`),
      // Seytú table / cards
      isMobile
        ? React.createElement("div", null,
            seytuFiltered.map((p, i) => React.createElement("div", {
              key: p.codigo + i,
              style: { border: `1px solid ${colors.gold.light}`, borderRadius: "0.5rem", padding: "0.75rem", marginBottom: "0.5rem", backgroundColor: i % 2 === 0 ? "white" : "#FAFAFA" }
            },
              React.createElement("div", { style: { fontWeight: "600", color: colors.gold.dark, fontSize: "0.85rem", marginBottom: "0.25rem" } }, p.descripcion),
              React.createElement("div", { style: { fontSize: "0.72rem", color: colors.gray.text, marginBottom: "0.35rem" } }, `Código: ${p.codigo} · ${p.categoria}`),
              React.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontSize: "0.8rem" } },
                React.createElement("span", { style: { color: colors.gray.text } }, `Sugerido: ${formatCurrency(p.precioSugerido)}`),
                React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, `Nila: ${formatCurrency(p.precioNila)}`),
              )
            ))
          )
        : React.createElement("div", { style: { overflowX: "auto" } },
            React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.82rem" } },
              React.createElement("thead", null, React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
                React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "left", color: colors.gold.dark, fontWeight: "600" } }, "Código"),
                React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "left", color: colors.gold.dark, fontWeight: "600" } }, "Descripción"),
                React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "left", color: colors.gold.dark, fontWeight: "600" } }, "Categoría"),
                React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.gold.dark, fontWeight: "600" } }, "Precio Sugerido"),
                React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.gold.dark, fontWeight: "600" } }, "Precio de Nila"),
              )),
              React.createElement("tbody", null,
                seytuFiltered.map((p, i) => React.createElement("tr", { key: p.codigo + i, style: { backgroundColor: i % 2 === 0 ? "white" : "#FAFAFA" } },
                  React.createElement("td", { style: { padding: "0.5rem 0.75rem", fontFamily: "monospace", fontSize: "0.78rem" } }, p.codigo),
                  React.createElement("td", { style: { padding: "0.5rem 0.75rem", fontWeight: "500" } }, p.descripcion),
                  React.createElement("td", { style: { padding: "0.5rem 0.75rem", fontSize: "0.75rem", color: colors.gray.text } }, p.categoria),
                  React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.gray.text } }, formatCurrency(p.precioSugerido)),
                  React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "right", fontWeight: "700", color: colors.gold.dark } }, formatCurrency(p.precioNila)),
                ))
              )
            )
          )
    ),

    // ══════ TRATAMIENTOS VIEW (existing) ══════
    serviceView === "tratamientos" && React.createElement("div", null,
    // Category tabs
    React.createElement("div", { style: { display: "flex", gap: "0.4rem", flexWrap: "wrap", marginBottom: "1rem" } },
      categories.map(cat => React.createElement("button", {
        key: cat,
        onClick: () => setSelectedCategory(cat),
        style: {
          padding: "0.35rem 0.75rem", borderRadius: "2rem", border: "none", cursor: "pointer",
          fontSize: "0.78rem", fontWeight: selectedCategory === cat ? "700" : "400",
          backgroundColor: selectedCategory === cat ? colors.gold.primary : colors.gray.warm,
          color: selectedCategory === cat ? "white" : colors.gray.text, whiteSpace: "nowrap",
        }
      }, cat))
    ),

    // Search + Discount row
    React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "0.6rem", marginBottom: "1.25rem" } },
      React.createElement("input", {
        type: "text",
        placeholder: "🔍 Buscar servicio...",
        value: searchTerm,
        onChange: e => setSearchTerm(e.target.value),
        style: { ...styles.input, padding: "0.45rem 0.75rem", fontSize: "0.85rem" },
      }),
      React.createElement("div", { style: { display: "flex", alignItems: "center", gap: "0.5rem", backgroundColor: colors.gold.light, padding: "0.5rem 0.75rem", borderRadius: "0.75rem" } },
        React.createElement("span", { style: { fontSize: "0.85rem", color: colors.gold.dark, fontWeight: "600" } }, "% Descuento:"),
        React.createElement("input", {
          type: "number", min: "0", max: "100",
          value: discount,
          onChange: e => setDiscount(e.target.value),
          placeholder: "0",
          style: { width: "70px", padding: "0.35rem 0.5rem", borderRadius: "0.5rem", border: `1px solid ${colors.gold.primary}`, fontSize: "0.9rem", textAlign: "center" },
        }),
        React.createElement("span", { style: { fontSize: "0.85rem", color: colors.gold.dark } }, "%"),
        discountPct > 0 && React.createElement("button", {
          onClick: () => setDiscount(""),
          style: { background: "none", border: "none", cursor: "pointer", color: colors.accent.danger, fontSize: "0.9rem", marginLeft: "0.25rem" }
        }, "✕ Limpiar")
      )
    ),

    // Services by category
    filteredServices.length === 0
      ? React.createElement("p", { style: { color: colors.gray.text } }, "No se encontraron servicios.")
      : filteredServices.map(cat => React.createElement("div", { key: cat.category, style: { marginBottom: "1.5rem" } },
        // Category header
        React.createElement("div", { style: { backgroundColor: colors.gold.primary, borderRadius: "0.75rem 0.75rem 0 0", padding: "0.6rem 1rem", display: "flex", justifyContent: "space-between", alignItems: "center" } },
          React.createElement("span", { style: { fontWeight: "700", color: "white", fontSize: "0.95rem" } }, cat.category),
          cat.note && React.createElement("span", { style: { fontSize: "0.72rem", color: colors.gold.light, fontStyle: "italic" } }, cat.note)
        ),
        // Items — cards on mobile, table on desktop
        React.createElement("div", { style: { border: `1px solid ${colors.gold.light}`, borderTop: "none", borderRadius: "0 0 0.75rem 0.75rem", overflow: "hidden" } },
          isMobile
            ? cat.items.map((item, idx) => {
                const sessKey = `${cat.category}::${item.name}`;
                const customSess = customSessions[sessKey] ? parseInt(customSessions[sessKey]) : null;
                const sessions = customSess || item.sessions;
                const pricePerSession = Math.round(item.totalPrice / item.sessions);
                const totalForSessions = pricePerSession * sessions;
                const discountedTotal = calcPrice(totalForSessions, discountPct);
                const discountedPerSession = Math.round(discountedTotal / sessions);
                return React.createElement("div", { key: item.name, style: { padding: "0.85rem 1rem", borderBottom: `1px solid ${colors.gold.light}`, backgroundColor: idx % 2 === 0 ? "white" : "#FAFAFA" } },
                  React.createElement("div", { style: { fontWeight: "600", color: colors.gold.dark, marginBottom: "0.5rem", fontSize: "0.88rem" } }, item.name),
                  React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.4rem", fontSize: "0.82rem" } },
                    React.createElement("div", null,
                      React.createElement("span", { style: { color: colors.gray.text } }, "Sesiones: "),
                      React.createElement("input", {
                        type: "number", min: "1",
                        value: customSessions[sessKey] || item.sessions,
                        onChange: e => setCustomSessions(prev => ({ ...prev, [sessKey]: e.target.value })),
                        style: { width: "48px", textAlign: "center", padding: "0.15rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.3rem", fontSize: "0.82rem", marginLeft: "0.25rem" },
                      }),
                      customSess && customSess !== item.sessions && React.createElement("button", {
                        onClick: () => setCustomSessions(prev => { const n = {...prev}; delete n[sessKey]; return n; }),
                        style: { background: "none", border: "none", cursor: "pointer", color: colors.accent.danger, fontSize: "0.75rem", marginLeft: "0.2rem" }
                      }, "↺")
                    ),
                    React.createElement("div", { style: { textAlign: "right" } },
                      React.createElement("span", { style: { color: colors.gray.text } }, "Por sesión: "),
                      React.createElement("strong", null, formatCurrency(pricePerSession))
                    ),
                    React.createElement("div", null,
                      React.createElement("span", { style: { color: colors.gray.text } }, "Total: "),
                      React.createElement("strong", { style: { color: colors.gold.dark } }, formatCurrency(totalForSessions))
                    ),
                    item.maintenance && React.createElement("div", { style: { textAlign: "right" } },
                      React.createElement("span", { style: { color: colors.gray.text } }, "Mant.: "),
                      React.createElement("strong", { style: { color: "#7C3AED" } }, formatCurrency(item.maintenance))
                    ),
                    discountPct > 0 && React.createElement("div", { style: { gridColumn: "1 / -1", backgroundColor: "#FEF2F2", borderRadius: "0.4rem", padding: "0.35rem 0.5rem", marginTop: "0.25rem" } },
                      React.createElement("span", { style: { color: colors.gray.text } }, `Con ${discountPct}% desc.: `),
                      React.createElement("strong", { style: { color: colors.accent.danger } }, formatCurrency(discountedTotal)),
                      React.createElement("span", { style: { color: colors.gray.text, fontSize: "0.75rem" } }, ` (₡${formatCurrency(discountedPerSession)}/sesión)`)
                    ),
                  )
                );
              })
            : React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.82rem" } },
              React.createElement("thead", null,
                React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
                  React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "left", color: colors.gold.dark, fontWeight: "600" } }, "Servicio"),
                  React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "center", color: colors.gold.dark, fontWeight: "600", whiteSpace: "nowrap" } }, "# Sesiones"),
                  React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.gold.dark, fontWeight: "600", whiteSpace: "nowrap" } }, "Precio / sesión"),
                  React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.gold.dark, fontWeight: "600", whiteSpace: "nowrap" } }, "Precio total"),
                  discountPct > 0 && React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.accent.danger, fontWeight: "600", whiteSpace: "nowrap" } }, `Con ${discountPct}% desc.`),
                  cat.items.some(i => i.maintenance) && React.createElement("th", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: "#7C3AED", fontWeight: "600", whiteSpace: "nowrap" } }, "Mantenimiento"),
                )
              ),
              React.createElement("tbody", null,
                cat.items.map((item, idx) => {
                  const sessKey = `${cat.category}::${item.name}`;
                  const customSess = customSessions[sessKey] ? parseInt(customSessions[sessKey]) : null;
                  const sessions = customSess || item.sessions;
                  const pricePerSession = Math.round(item.totalPrice / item.sessions);
                  const totalForSessions = pricePerSession * sessions;
                  const discountedTotal = calcPrice(totalForSessions, discountPct);
                  const discountedPerSession = Math.round(discountedTotal / sessions);
                  return React.createElement("tr", { key: item.name, style: { backgroundColor: idx % 2 === 0 ? "white" : "#FAFAFA", verticalAlign: "middle" } },
                    React.createElement("td", { style: { padding: "0.5rem 0.75rem" } },
                      React.createElement("div", { style: { fontWeight: "500" } }, item.name)
                    ),
                    React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "center" } },
                      React.createElement("div", { style: { display: "flex", alignItems: "center", justifyContent: "center", gap: "0.35rem" } },
                        React.createElement("input", {
                          type: "number", min: "1",
                          value: customSessions[sessKey] || item.sessions,
                          onChange: e => setCustomSessions(prev => ({ ...prev, [sessKey]: e.target.value })),
                          style: { width: "52px", textAlign: "center", padding: "0.2rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.4rem", fontSize: "0.82rem" },
                        }),
                        customSess && customSess !== item.sessions && React.createElement("button", {
                          onClick: () => setCustomSessions(prev => { const n = {...prev}; delete n[sessKey]; return n; }),
                          style: { background: "none", border: "none", cursor: "pointer", color: colors.gray.text, fontSize: "0.7rem" }
                        }, "↺")
                      )
                    ),
                    React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: colors.gray.text } },
                      formatCurrency(pricePerSession)
                    ),
                    React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "right", fontWeight: "700", color: colors.gold.dark } },
                      formatCurrency(totalForSessions),
                      customSess && customSess !== item.sessions && React.createElement("div", { style: { fontSize: "0.7rem", color: colors.gray.text, fontWeight: "400" } }, `(base: ${formatCurrency(item.totalPrice)})`)
                    ),
                    discountPct > 0 && React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "right" } },
                      React.createElement("div", { style: { fontWeight: "700", color: colors.accent.danger } }, formatCurrency(discountedTotal)),
                      React.createElement("div", { style: { fontSize: "0.72rem", color: colors.gray.text } }, `₡${formatCurrency(discountedPerSession)}/sesión`)
                    ),
                    cat.items.some(i => i.maintenance) && React.createElement("td", { style: { padding: "0.5rem 0.75rem", textAlign: "right", color: "#7C3AED" } },
                      item.maintenance ? formatCurrency(item.maintenance) : "—"
                    ),
                  );
                })
              )
            )
        )
      ))
    )
  );
}

// ========== END ADD TREATMENT MODAL ==========
// ========== GASTOS PANEL ==========
const STANDARD_EXPENSES = [
  // Fixed — pre-loaded amount
  { id: "alquiler", desc: "Pago del alquiler al local en Santa Ana Centro", categoria: "Alquiler", amount: 383290, dueDay: 1, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "comision_local", desc: "Pago de comisión al pago del local", categoria: "Alquiler", amount: 1500, dueDay: 1, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "trabajador_ind", desc: "Nila - Trabajador Independiente (Reynald)", categoria: "Seguro", amount: 36341, dueDay: 4, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "contador", desc: "Pago al contador por el mes", categoria: "Servicios profesionales", amount: 20000, dueDay: 20, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "canva", desc: "Pago de Canva", categoria: "Software", amount: 4200, dueDay: 14, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "canva_iva", desc: "Pago de Canva IVA", categoria: "Impuestos", amount: 551, dueDay: 14, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "datafono", desc: "Costo del datáfono de Nila", categoria: "Servicios bancarios", amount: 14000, dueDay: 14, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  { id: "ccss", desc: "Pago de CCSS (Jaqueline)", categoria: "Seguro", amount: 69542, dueDay: 15, method: "Banco Nacional (Nila - Colones)", isFixed: true },
  // Variable — amount blank
  { id: "electricidad", desc: "Pago de la electricidad del local", categoria: "Servicios", amount: null, dueDay: null, method: "", isFixed: false },
  { id: "anuncios", desc: "Pago de anuncios", categoria: "Marketing", amount: null, dueDay: null, method: "Chase Bank", isFixed: false },
  { id: "gasolina", desc: "Gasolina", categoria: "Transporte", amount: null, dueDay: null, method: "", isFixed: false },
];

const EXPENSE_CATEGORIES = ["Alquiler", "Seguro", "Servicios profesionales", "Software", "Impuestos", "Servicios bancarios", "Servicios", "Marketing", "Transporte", "Otros"];
const PAYMENT_METHODS_GASTOS = ["Banco Nacional (Nila - Colones)", "Chase Bank", "American Express", "Scotia Bank", "Efectivo", "Tarjeta de crédito", "SINPE", "Otro"];

// ========== GIFT CARDS PANEL (Stage 1) ==========
// ========== DEPÓSITOS PANEL ==========
function DepositosPanel({ user, records }) {
  const isMobile = useIsMobile();
  const [deps, setDeps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [view, setView] = useState("pendientes"); // pendientes | aplicados
  const [search, setSearch] = useState("");
  const [treatmentFilter, setTreatmentFilter] = useState("");

  // Form state
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [tratamiento, setTratamiento] = useState("");
  const [precio, setPrecio] = useState("");
  const [montoDep, setMontoDep] = useState("");
  const [ivaIncluded, setIvaIncluded] = useState(true);
  const [payMethod, setPayMethod] = useState("");
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0,10));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    loadDepositosFromFirestore().then(setDeps).finally(() => setLoading(false));
  }, []);

  const resetForm = () => {
    setNombre(""); setTelefono(""); setTratamiento(""); setPrecio(""); setMontoDep("");
    setIvaIncluded(true); setPayMethod(""); setFecha(new Date().toISOString().slice(0,10)); setError("");
  };

  const depNum = parseFloat(montoDep) || 0;
  const depBase = depNum > 0 ? (ivaIncluded ? Math.round(depNum / 1.13) : depNum) : 0;
  const depIva = depNum > 0 ? (ivaIncluded ? (depNum - depBase) : Math.round(depNum * 0.13)) : 0;
  const depTotal = ivaIncluded ? depNum : depNum + depIva;
  const precioNum = parseFloat(precio) || 0;

  const handleSave = async () => {
    setError("");
    if (!nombre.trim()) return setError("Ingrese el nombre del cliente");
    if (!telefono.trim()) return setError("Ingrese el teléfono");
    if (!tratamiento.trim()) return setError("Ingrese el tratamiento");
    if (!precioNum || precioNum <= 0) return setError("Ingrese el precio del tratamiento");
    if (!depNum || depNum <= 0) return setError("Ingrese el monto del depósito");
    if (depTotal > precioNum) return setError("El depósito no puede ser mayor que el precio del tratamiento");
    if (!payMethod) return setError("Seleccione el método de pago");
    setSaving(true);
    const dep = {
      nombre: nombre.trim(),
      telefono: telefono.trim(),
      tratamiento: tratamiento.trim(),
      precioTratamiento: precioNum,
      montoDeposito: depTotal,
      base: depBase,
      iva: depIva,
      saldoPendiente: Math.max(0, precioNum - depTotal),
      payMethod,
      fecha,
      estado: "pendiente",
      createdAt: new Date().toISOString(),
      createdBy: user.nombreCompleto,
    };
    const saved = await saveDepositoToFirestore(dep);
    setDeps(prev => [...prev, saved]);
    setSaving(false);
    setShowForm(false);
    resetForm();
    alert(`✅ Depósito registrado\n\nCliente: ${dep.nombre}\nDepósito: ${formatCurrency(dep.montoDeposito)}\nSaldo pendiente: ${formatCurrency(dep.saldoPendiente)}`);
  };

  const handleDelete = async (dep) => {
    if (dep.estado === "aplicado") { alert("Este depósito ya fue aplicado a un cliente y no se puede eliminar."); return; }
    if (!window.confirm(`¿Eliminar el depósito de ${dep.nombre}?`)) return;
    await deleteDepositoFromFirestore(dep.id);
    setDeps(prev => prev.filter(d => d.id !== dep.id));
  };

  const allTreatments = Array.from(new Set(deps.map(d => d.tratamiento))).sort();

  const filtered = deps.filter(d => {
    // Safety: treat anything that is NOT explicitly "aplicado" as pending, so a
    // deposit with a missing/corrupt estado can never disappear from both tabs.
    const isApplied = d.estado === "aplicado";
    const matchView = view === "pendientes" ? !isApplied : isApplied;
    const s = search.toLowerCase();
    const matchSearch = !search || (d.nombre||"").toLowerCase().includes(s) || (d.telefono||"").includes(search);
    const matchTreatment = !treatmentFilter || d.tratamiento === treatmentFilter;
    return matchView && matchSearch && matchTreatment;
  });

  const countPend = deps.filter(d => d.estado !== "aplicado").length;
  const totalPend = deps.filter(d => d.estado !== "aplicado").reduce((s,d) => s + (d.montoDeposito||0), 0);
  const countApl = deps.filter(d => d.estado === "aplicado").length;

  const thS = { padding: "0.5rem 0.7rem", color: colors.gold.dark, fontWeight: "600", borderBottom: `2px solid ${colors.gold.primary}`, fontSize: "0.76rem", textAlign: "left" };
  const tdS = { padding: "0.45rem 0.6rem", borderBottom: `1px solid ${colors.gray.warm}`, fontSize: "0.79rem" };

  return React.createElement("div", { style: { padding: "0.5rem" } },
    React.createElement("h2", { style: { fontSize: "1.4rem", fontFamily: "Georgia, serif", color: colors.gold.dark, marginBottom: "0.25rem" } }, "💵 Depósitos"),
    React.createElement("p", { style: { color: colors.gray.text, fontSize: "0.85rem", marginBottom: "1.25rem" } }, "Depósitos adelantados (antes de registrar al cliente)"),

    // Summary
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "0.75rem", marginBottom: "1rem" } },
      React.createElement("div", { style: { backgroundColor: "#FEF3C7", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.3rem", fontWeight: "800", color: "#D97706" } }, countPend),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Depósitos pendientes")
      ),
      React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.gold.dark } }, formatCurrency(totalPend)),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Total en depósitos pendientes")
      ),
      React.createElement("div", { style: { backgroundColor: "#DCFCE7", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.3rem", fontWeight: "800", color: "#16A34A" } }, countApl),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Aplicados")
      ),
    ),

    !showForm && React.createElement("button", { onClick: () => { resetForm(); setShowForm(true); }, style: { ...styles.button, marginBottom: "1rem" } }, "➕ Registrar depósito"),

    // Form
    showForm && React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "1.25rem", marginBottom: "1.25rem" } },
      React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "0.75rem", fontSize: "1rem" } }, "Nuevo depósito"),
      React.createElement("div", { style: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.6rem", marginBottom: "0.6rem" } },
        React.createElement("input", { type: "text", placeholder: "Nombre del cliente *", value: nombre, onChange: e => setNombre(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
        React.createElement("input", { type: "text", placeholder: "Teléfono *", value: telefono, onChange: e => setTelefono(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
      ),
      React.createElement("input", { type: "text", placeholder: "Tratamiento *", value: tratamiento, onChange: e => setTratamiento(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem", width: "100%", marginBottom: "0.6rem" } }),
      React.createElement("div", { style: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.6rem", marginBottom: "0.6rem" } },
        React.createElement("input", { type: "number", placeholder: "Precio del tratamiento (₡) *", value: precio, onChange: e => setPrecio(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
        React.createElement("input", { type: "number", placeholder: "Monto del depósito (₡) *", value: montoDep, onChange: e => setMontoDep(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
      ),
      React.createElement("div", { style: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.6rem", marginBottom: "0.6rem" } },
        React.createElement("input", { type: "date", value: fecha, onChange: e => setFecha(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
        React.createElement("select", { value: payMethod, onChange: e => setPayMethod(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } },
          React.createElement("option", { value: "" }, "— Método de pago —"),
          ["Efectivo", "SINPE", "SINPE (Jacky)", "Tarjeta de crédito"].map(m => React.createElement("option", { key: m, value: m }, m))
        ),
      ),
      // IVA prompt
      React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.5rem", padding: "0.7rem", marginBottom: "0.6rem", border: `1px solid ${colors.gold.light}` } },
        React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, fontSize: "0.82rem", marginBottom: "0.4rem" } }, "💵 ¿El monto del depósito incluye el IVA?"),
        React.createElement("label", { style: { display: "flex", alignItems: "center", gap: "0.4rem", cursor: "pointer", fontSize: "0.8rem", marginBottom: "0.25rem" } },
          React.createElement("input", { type: "radio", name: "depIva", checked: ivaIncluded, onChange: () => setIvaIncluded(true) }), "Sí, ya incluye IVA (se divide entre 1.13)"),
        React.createElement("label", { style: { display: "flex", alignItems: "center", gap: "0.4rem", cursor: "pointer", fontSize: "0.8rem" } },
          React.createElement("input", { type: "radio", name: "depIva", checked: !ivaIncluded, onChange: () => setIvaIncluded(false) }), "No, agregar 13% al monto"),
      ),
      depNum > 0 && React.createElement("div", { style: { backgroundColor: "white", border: `1px solid ${colors.gold.light}`, borderRadius: "0.5rem", padding: "0.6rem 0.85rem", marginBottom: "0.6rem", fontSize: "0.82rem" } },
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("span", null, "Base del depósito:"), React.createElement("strong", null, formatCurrency(depBase))),
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("span", null, "IVA (13%):"), React.createElement("strong", null, formatCurrency(depIva))),
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between", borderTop: `1px solid ${colors.gold.light}`, marginTop: "0.3rem", paddingTop: "0.3rem" } }, React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, "Depósito total:"), React.createElement("strong", { style: { color: colors.gold.dark } }, formatCurrency(depTotal))),
        precioNum > 0 && React.createElement("div", { style: { display: "flex", justifyContent: "space-between", marginTop: "0.3rem", color: "#DC2626", fontWeight: "700" } }, React.createElement("span", null, "Saldo pendiente:"), React.createElement("strong", null, formatCurrency(Math.max(0, precioNum - depTotal)))),
      ),
      error && React.createElement("div", { style: { color: colors.accent.danger, fontSize: "0.82rem", marginBottom: "0.6rem", fontWeight: "500" } }, "❌ " + error),
      React.createElement("div", { style: { display: "flex", gap: "0.6rem" } },
        React.createElement("button", { onClick: handleSave, disabled: saving, style: styles.buttonSuccess }, saving ? "Guardando..." : "✅ Registrar depósito"),
        React.createElement("button", { onClick: () => { setShowForm(false); resetForm(); }, style: styles.buttonOutline }, "Cancelar"),
      )
    ),

    // View toggle + filters
    React.createElement("div", { style: { display: "flex", gap: "0.5rem", marginBottom: "0.85rem", flexWrap: "wrap", alignItems: "center" } },
      React.createElement("button", { onClick: () => setView("pendientes"), style: { padding: "0.4rem 1rem", borderRadius: "2rem", border: "none", cursor: "pointer", fontWeight: view==="pendientes"?"700":"400", backgroundColor: view==="pendientes"?colors.gold.primary:colors.gray.warm, color: view==="pendientes"?"white":colors.gray.text, fontSize: "0.82rem" } }, "🟡 Pendientes"),
      React.createElement("button", { onClick: () => setView("aplicados"), style: { padding: "0.4rem 1rem", borderRadius: "2rem", border: "none", cursor: "pointer", fontWeight: view==="aplicados"?"700":"400", backgroundColor: view==="aplicados"?colors.gold.primary:colors.gray.warm, color: view==="aplicados"?"white":colors.gray.text, fontSize: "0.82rem" } }, "✅ Aplicados"),
    ),
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "2fr 1fr", gap: "0.5rem", marginBottom: "1rem" } },
      React.createElement("input", { type: "text", placeholder: "🔍 Buscar nombre o teléfono...", value: search, onChange: e => setSearch(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
      React.createElement("select", { value: treatmentFilter, onChange: e => setTreatmentFilter(e.target.value), style: { ...styles.input, padding: "0.4rem 0.7rem", fontSize: "0.82rem" } },
        React.createElement("option", { value: "" }, "Todos los tratamientos"),
        allTreatments.map(t => React.createElement("option", { key: t, value: t }, t))
      ),
    ),

    // Table
    loading
      ? React.createElement("p", { style: { color: colors.gray.text } }, "Cargando...")
      : filtered.length === 0
        ? React.createElement("p", { style: { color: colors.gray.text, fontStyle: "italic" } }, view === "pendientes" ? "No hay depósitos pendientes." : "No hay depósitos aplicados.")
        : React.createElement("div", { style: { overflowX: "auto" } },
          React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.79rem" } },
            React.createElement("thead", null, React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
              React.createElement("th", { style: thS }, "Nombre"),
              React.createElement("th", { style: thS }, "Teléfono"),
              React.createElement("th", { style: thS }, "Tratamiento"),
              React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Precio"),
              React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Depósito"),
              React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Saldo"),
              React.createElement("th", { style: thS }, "Fecha"),
              React.createElement("th", { style: thS }, "Método"),
              view === "aplicados" && React.createElement("th", { style: thS }, "Aplicado a"),
              view === "pendientes" && React.createElement("th", { style: { ...thS, textAlign: "center" } }, ""),
            )),
            React.createElement("tbody", null,
              filtered.map((d, i) =>
                React.createElement("tr", { key: d.id, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                  React.createElement("td", { style: { ...tdS, fontWeight: "600" } }, d.nombre),
                  React.createElement("td", { style: tdS }, d.telefono),
                  React.createElement("td", { style: tdS }, d.tratamiento),
                  React.createElement("td", { style: { ...tdS, textAlign: "right" } }, formatCurrency(d.precioTratamiento)),
                  React.createElement("td", { style: { ...tdS, textAlign: "right", fontWeight: "700", color: "#16A34A" } }, formatCurrency(d.montoDeposito)),
                  React.createElement("td", { style: { ...tdS, textAlign: "right", color: "#DC2626" } }, formatCurrency(d.saldoPendiente)),
                  React.createElement("td", { style: tdS }, formatDateCR(d.fecha)),
                  React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, d.payMethod),
                  view === "aplicados" && React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, d.appliedToClientName || "—"),
                  view === "pendientes" && React.createElement("td", { style: { ...tdS, textAlign: "center" } },
                    React.createElement("button", { onClick: () => handleDelete(d), style: { background: "none", border: "none", cursor: "pointer", color: "#DC2626", fontSize: "0.85rem" } }, "🗑️")
                  ),
                )
              )
            )
          )
        )
  );
}
// ========== END DEPÓSITOS PANEL ==========

function GiftCardsPanel({ user, records }) {
  const isMobile = useIsMobile();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showSell, setShowSell] = useState(false);
  const [view, setView] = useState("activas"); // activas | completadas
  const [search, setSearch] = useState("");

  // Sale form state
  const [gcType, setGcType] = useState("monto"); // "monto" | "tratamiento"
  const [cardNumber, setCardNumber] = useState("");
  const [buyerName, setBuyerName] = useState("");
  const [buyerClientId, setBuyerClientId] = useState(null);
  const [buyerSearchFocused, setBuyerSearchFocused] = useState(false);
  const [recipientName, setRecipientName] = useState("");
  const [treatmentName, setTreatmentName] = useState("");
  const [priceInput, setPriceInput] = useState("");
  const [ivaIncluded, setIvaIncluded] = useState(true);
  const [saleDate, setSaleDate] = useState(new Date().toISOString().slice(0,10));
  const [payMethod, setPayMethod] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    loadGiftCardsFromFirestore().then(setCards).finally(() => setLoading(false));
  }, []);

  const resetForm = () => {
    setGcType("monto"); setCardNumber(""); setBuyerName(""); setBuyerClientId(null); setRecipientName("");
    setTreatmentName(""); setPriceInput(""); setIvaIncluded(true);
    setSaleDate(new Date().toISOString().slice(0,10)); setPayMethod(""); setError("");
  };

  const priceNum = parseFloat(priceInput) || 0;
  const baseCalc = priceNum > 0 ? (ivaIncluded ? Math.round(priceNum / 1.13) : priceNum) : 0;
  const ivaCalc = priceNum > 0 ? (ivaIncluded ? (priceNum - baseCalc) : Math.round(priceNum * 0.13)) : 0;
  const totalCalc = ivaIncluded ? priceNum : priceNum + ivaCalc;

  const handleSell = async () => {
    setError("");
    if (!cardNumber.trim()) return setError("Ingrese el número de la tarjeta");
    if (!buyerName.trim()) return setError("Ingrese el nombre de quien compra (Persona X)");
    if (!recipientName.trim()) return setError("Ingrese el nombre de quien recibe (Persona Y)");
    if (gcType === "tratamiento" && !treatmentName.trim()) return setError("Ingrese el tratamiento del regalo");
    if (!priceNum || priceNum <= 0) return setError("Ingrese el precio / monto");
    if (!payMethod) return setError("Seleccione el método de pago");

    // Check duplicate active card number
    if (cards.some(c => c.cardNumber === cardNumber.trim() && c.status === "activa")) {
      return setError("Ya existe una tarjeta activa con ese número");
    }

    setSaving(true);
    const card = {
      cardNumber: cardNumber.trim(),
      buyerName: buyerName.trim(),
      buyerClientId: buyerClientId || null,
      recipientName: recipientName.trim(),
      type: gcType, // "monto" or "tratamiento"
      treatmentName: gcType === "tratamiento" ? treatmentName.trim() : null,
      originalAmount: totalCalc,
      remainingBalance: totalCalc,
      base: baseCalc,
      iva: ivaCalc,
      payMethod,
      saleDate,
      status: "activa",
      redemptions: [],
      createdAt: new Date().toISOString(),
      createdBy: user.nombreCompleto,
    };
    const saved = await saveGiftCardToFirestore(card);
    setCards(prev => [...prev, saved]);
    setSaving(false);
    setShowSell(false);
    resetForm();
    alert("✅ Tarjeta de regalo registrada");
  };

  const filtered = cards.filter(c => {
    const matchView = view === "activas" ? c.status === "activa" : c.status === "completada";
    const s = search.toLowerCase();
    const matchSearch = !search || (c.cardNumber||"").toLowerCase().includes(s) || (c.buyerName||"").toLowerCase().includes(s) || (c.recipientName||"").toLowerCase().includes(s);
    return matchView && matchSearch;
  });

  const totalActive = cards.filter(c => c.status === "activa").reduce((s,c) => s + (c.remainingBalance||0), 0);
  const countActive = cards.filter(c => c.status === "activa").length;
  const countCompleted = cards.filter(c => c.status === "completada").length;

  const thS = { padding: "0.5rem 0.75rem", color: colors.gold.dark, fontWeight: "600", borderBottom: `2px solid ${colors.gold.primary}`, fontSize: "0.78rem", textAlign: "left" };
  const tdS = { padding: "0.45rem 0.6rem", borderBottom: `1px solid ${colors.gray.warm}`, fontSize: "0.8rem" };

  return React.createElement("div", { style: { padding: "0.5rem" } },
    React.createElement("h2", { style: { fontSize: "1.4rem", fontFamily: "Georgia, serif", color: colors.gold.dark, marginBottom: "0.25rem" } }, "🎁 Tarjetas de Regalo"),
    React.createElement("p", { style: { color: colors.gray.text, fontSize: "0.85rem", marginBottom: "1.25rem" } }, "Venta y control de tarjetas de regalo"),

    // Summary cards
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "0.75rem", marginBottom: "1rem" } },
      React.createElement("div", { style: { backgroundColor: "#DCFCE7", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.3rem", fontWeight: "800", color: "#16A34A" } }, countActive),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Tarjetas activas")
      ),
      React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: colors.gold.dark } }, formatCurrency(totalActive)),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Saldo activo total")
      ),
      React.createElement("div", { style: { backgroundColor: "#E0E7FF", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.3rem", fontWeight: "800", color: "#4338CA" } }, countCompleted),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text } }, "Completadas")
      ),
    ),

    // Sell button
    !showSell && React.createElement("button", { onClick: () => { resetForm(); setShowSell(true); }, style: { ...styles.button, marginBottom: "1rem" } }, "➕ Vender tarjeta de regalo"),

    // Sell form
    showSell && React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "1.25rem", marginBottom: "1.25rem" } },
      React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "0.75rem", fontSize: "1rem" } }, "Nueva tarjeta de regalo"),

      // Type toggle
      React.createElement("div", { style: { display: "flex", gap: "0.5rem", marginBottom: "0.85rem" } },
        React.createElement("button", { onClick: () => setGcType("monto"), style: { flex: 1, padding: "0.5rem", borderRadius: "0.5rem", border: "none", cursor: "pointer", fontWeight: gcType==="monto"?"700":"400", backgroundColor: gcType==="monto"?colors.gold.primary:"white", color: gcType==="monto"?"white":colors.gray.text } }, "💰 Por monto fijo"),
        React.createElement("button", { onClick: () => setGcType("tratamiento"), style: { flex: 1, padding: "0.5rem", borderRadius: "0.5rem", border: "none", cursor: "pointer", fontWeight: gcType==="tratamiento"?"700":"400", backgroundColor: gcType==="tratamiento"?colors.gold.primary:"white", color: gcType==="tratamiento"?"white":colors.gray.text } }, "💆 Por tratamiento"),
      ),

      React.createElement("div", { style: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.6rem", marginBottom: "0.6rem" } },
        React.createElement("input", { type: "text", placeholder: "Número de tarjeta *", value: cardNumber, onChange: e => setCardNumber(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
        React.createElement("input", { type: "date", value: saleDate, onChange: e => setSaleDate(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
      ),

      // ── Buyer (Persona X): search existing client OR type new name ──
      React.createElement("div", { style: { position: "relative", marginBottom: "0.6rem" } },
        React.createElement("input", {
          type: "text",
          placeholder: "Comprado por (Persona X) — busque un cliente o escriba un nombre nuevo *",
          value: buyerName,
          onChange: e => { setBuyerName(e.target.value); setBuyerClientId(null); },
          onFocus: () => setBuyerSearchFocused(true),
          onBlur: () => setTimeout(() => setBuyerSearchFocused(false), 200),
          style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem", width: "100%" },
        }),
        buyerSearchFocused && buyerName.trim().length >= 2 && (() => {
          const matches = (records || [])
            .filter(r => (r.form?.nombre || "").toLowerCase().includes(buyerName.trim().toLowerCase()))
            .slice(0, 6);
          if (matches.length === 0) return null;
          return React.createElement("div", { style: { position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "white", border: `1px solid ${colors.gold.primary}`, borderRadius: "0.5rem", marginTop: "0.2rem", zIndex: 20, boxShadow: "0 4px 12px rgba(0,0,0,0.12)", maxHeight: "220px", overflowY: "auto" } },
            React.createElement("div", { style: { fontSize: "0.7rem", color: colors.gray.text, padding: "0.4rem 0.7rem", borderBottom: `1px solid ${colors.gold.light}` } }, "Clientes existentes:"),
            matches.map(r => React.createElement("div", {
              key: r.id,
              onMouseDown: () => { setBuyerName(r.form?.nombre || ""); setBuyerClientId(r.id); setBuyerSearchFocused(false); },
              style: { padding: "0.5rem 0.7rem", cursor: "pointer", fontSize: "0.82rem", borderBottom: `1px solid ${colors.gray.warm}` },
              onMouseEnter: e => e.currentTarget.style.backgroundColor = colors.gold.light,
              onMouseLeave: e => e.currentTarget.style.backgroundColor = "white",
            },
              React.createElement("div", { style: { fontWeight: "600" } }, r.form?.nombre || "—"),
              r.form?.cedula && React.createElement("div", { style: { fontSize: "0.72rem", color: colors.gray.text } }, `Cédula: ${r.form.cedula}`)
            ))
          );
        })()
      ),

      React.createElement("input", { type: "text", placeholder: "Para (Persona Y) *", value: recipientName, onChange: e => setRecipientName(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem", width: "100%", marginBottom: "0.6rem" } }),

      gcType === "tratamiento" && React.createElement("input", { type: "text", placeholder: "Nombre del tratamiento *", value: treatmentName, onChange: e => setTreatmentName(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem", marginBottom: "0.6rem", width: "100%" } }),

      React.createElement("div", { style: { display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "0.6rem", marginBottom: "0.6rem" } },
        React.createElement("input", { type: "number", placeholder: gcType === "monto" ? "Monto (₡) *" : "Precio del tratamiento (₡) *", value: priceInput, onChange: e => setPriceInput(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } }),
        React.createElement("select", { value: payMethod, onChange: e => setPayMethod(e.target.value), style: { ...styles.input, padding: "0.45rem 0.7rem", fontSize: "0.85rem" } },
          React.createElement("option", { value: "" }, "— Método de pago —"),
          ["Efectivo", "SINPE", "SINPE (Jacky)", "Tarjeta de crédito"].map(m => React.createElement("option", { key: m, value: m }, m))
        ),
      ),

      // ── IVA prompt (clearer) ──
      React.createElement("div", { style: { backgroundColor: "white", borderRadius: "0.6rem", padding: "0.85rem", marginBottom: "0.75rem", border: `1px solid ${colors.gold.light}` } },
        React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, fontSize: "0.85rem", marginBottom: "0.5rem" } }, "💵 ¿El precio que ingresó incluye el IVA?"),
        React.createElement("div", { style: { fontSize: "0.75rem", color: colors.gray.text, marginBottom: "0.6rem", lineHeight: "1.3" } }, "Seleccione una opción para calcular correctamente el IVA del 13%."),
        React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "0.4rem" } },
          React.createElement("label", { style: { display: "flex", alignItems: "flex-start", gap: "0.5rem", cursor: "pointer", padding: "0.5rem 0.6rem", borderRadius: "0.45rem", border: `1px solid ${ivaIncluded ? colors.gold.primary : colors.gray.warm}`, backgroundColor: ivaIncluded ? colors.gold.light : "transparent" } },
            React.createElement("input", { type: "radio", name: "gcIva", checked: ivaIncluded, onChange: () => setIvaIncluded(true), style: { marginTop: "0.15rem" } }),
            React.createElement("div", null,
              React.createElement("div", { style: { fontWeight: "600", fontSize: "0.82rem", color: colors.gold.dark } }, "Sí, el IVA ya está incluido"),
              React.createElement("div", { style: { fontSize: "0.72rem", color: colors.gray.text } }, "El monto ingresado es el total final. El IVA se calcula dividiendo entre 1.13.")
            )
          ),
          React.createElement("label", { style: { display: "flex", alignItems: "flex-start", gap: "0.5rem", cursor: "pointer", padding: "0.5rem 0.6rem", borderRadius: "0.45rem", border: `1px solid ${!ivaIncluded ? colors.gold.primary : colors.gray.warm}`, backgroundColor: !ivaIncluded ? colors.gold.light : "transparent" } },
            React.createElement("input", { type: "radio", name: "gcIva", checked: !ivaIncluded, onChange: () => setIvaIncluded(false), style: { marginTop: "0.15rem" } }),
            React.createElement("div", null,
              React.createElement("div", { style: { fontWeight: "600", fontSize: "0.82rem", color: colors.gold.dark } }, "No, agregar el IVA al precio"),
              React.createElement("div", { style: { fontSize: "0.72rem", color: colors.gray.text } }, "El monto ingresado es la base. Se le suma un 13% de IVA encima.")
            )
          ),
        )
      ),

      priceNum > 0 && React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.5rem", padding: "0.7rem 0.85rem", marginBottom: "0.75rem", fontSize: "0.82rem" } },
        React.createElement("div", { style: { fontSize: "0.72rem", color: colors.gray.text, marginBottom: "0.4rem", fontWeight: "600" } }, ivaIncluded ? "Desglose (IVA incluido en el precio):" : "Desglose (IVA agregado al precio):"),
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("span", { style: { color: colors.gray.text } }, "Base (Ganancia de Nila):"), React.createElement("strong", null, formatCurrency(baseCalc))),
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between" } }, React.createElement("span", { style: { color: colors.gray.text } }, "IVA (13%):"), React.createElement("strong", null, formatCurrency(ivaCalc))),
        React.createElement("div", { style: { display: "flex", justifyContent: "space-between", borderTop: `1px solid ${colors.gold.primary}`, marginTop: "0.3rem", paddingTop: "0.3rem" } }, React.createElement("span", { style: { fontWeight: "700", color: colors.gold.dark } }, "Total a cobrar:"), React.createElement("strong", { style: { color: colors.gold.dark } }, formatCurrency(totalCalc))),
      ),

      error && React.createElement("div", { style: { color: colors.accent.danger, fontSize: "0.82rem", marginBottom: "0.6rem", fontWeight: "500" } }, "❌ " + error),

      React.createElement("div", { style: { display: "flex", gap: "0.6rem" } },
        React.createElement("button", { onClick: handleSell, disabled: saving, style: styles.buttonSuccess }, saving ? "Guardando..." : "✅ Registrar venta"),
        React.createElement("button", { onClick: () => { setShowSell(false); resetForm(); }, style: styles.buttonOutline }, "Cancelar"),
      )
    ),

    // View toggle + search
    React.createElement("div", { style: { display: "flex", gap: "0.5rem", marginBottom: "0.85rem", flexWrap: "wrap", alignItems: "center" } },
      React.createElement("button", { onClick: () => setView("activas"), style: { padding: "0.4rem 1rem", borderRadius: "2rem", border: "none", cursor: "pointer", fontWeight: view==="activas"?"700":"400", backgroundColor: view==="activas"?colors.gold.primary:colors.gray.warm, color: view==="activas"?"white":colors.gray.text, fontSize: "0.82rem" } }, "🟢 Activas"),
      React.createElement("button", { onClick: () => setView("completadas"), style: { padding: "0.4rem 1rem", borderRadius: "2rem", border: "none", cursor: "pointer", fontWeight: view==="completadas"?"700":"400", backgroundColor: view==="completadas"?colors.gold.primary:colors.gray.warm, color: view==="completadas"?"white":colors.gray.text, fontSize: "0.82rem" } }, "✅ Completadas"),
      React.createElement("input", { type: "text", placeholder: "🔍 Buscar tarjeta, comprador o destinatario...", value: search, onChange: e => setSearch(e.target.value), style: { ...styles.input, flex: 1, minWidth: "200px", padding: "0.4rem 0.7rem", fontSize: "0.82rem" } }),
    ),

    // Table
    loading
      ? React.createElement("p", { style: { color: colors.gray.text } }, "Cargando...")
      : filtered.length === 0
        ? React.createElement("p", { style: { color: colors.gray.text, fontStyle: "italic" } }, view === "activas" ? "No hay tarjetas activas." : "No hay tarjetas completadas.")
        : React.createElement("div", { style: { overflowX: "auto" } },
          React.createElement("table", { style: { width: "100%", borderCollapse: "collapse", fontSize: "0.8rem" } },
            React.createElement("thead", null, React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
              React.createElement("th", { style: thS }, "Tarjeta #"),
              React.createElement("th", { style: thS }, "Comprado por"),
              React.createElement("th", { style: thS }, "Para"),
              React.createElement("th", { style: thS }, "Tipo"),
              React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Monto original"),
              React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Saldo restante"),
              React.createElement("th", { style: thS }, "Fecha venta"),
              view === "completadas" && React.createElement("th", { style: thS }, "Última redención"),
            )),
            React.createElement("tbody", null,
              filtered.map((c, i) => {
                const lastRedemption = (c.redemptions && c.redemptions.length > 0) ? c.redemptions[c.redemptions.length-1].date : null;
                return React.createElement("tr", { key: c.id, style: { backgroundColor: i%2===0?"white":"#FAFAFA" } },
                  React.createElement("td", { style: { ...tdS, fontFamily: "monospace", fontWeight: "600" } }, c.cardNumber),
                  React.createElement("td", { style: tdS }, c.buyerName),
                  React.createElement("td", { style: tdS }, c.recipientName),
                  React.createElement("td", { style: { ...tdS, fontSize: "0.74rem" } }, c.type === "tratamiento" ? `Tratamiento: ${c.treatmentName}` : "Monto fijo"),
                  React.createElement("td", { style: { ...tdS, textAlign: "right" } }, formatCurrency(c.originalAmount)),
                  React.createElement("td", { style: { ...tdS, textAlign: "right", fontWeight: "700", color: c.remainingBalance > 0 ? "#16A34A" : colors.gray.text } }, formatCurrency(c.remainingBalance)),
                  React.createElement("td", { style: tdS }, formatDateCR(c.saleDate)),
                  view === "completadas" && React.createElement("td", { style: tdS }, lastRedemption ? formatDateCR(lastRedemption) : "—"),
                );
              })
            )
          )
        )
  );
}
// ========== END GIFT CARDS PANEL ==========

function GastosPanel({ user }) {
  const today = new Date();
  const currentMonthKey = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,"0")}`;
  const MESES_ES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

  const [selectedMonth, setSelectedMonth] = useState(currentMonthKey);
  const [expenses, setExpenses] = useState({});
  const [categoryFilter, setCategoryFilter] = useState("Todas");
  const [paidFilter, setPaidFilter] = useState("todos");
  const [showAddExtra, setShowAddExtra] = useState(false);
  const [newExtra, setNewExtra] = useState({ desc: "", categoria: "", amount: "", method: "", dueDate: "", paid: false, paidDate: "" });
  const [saving, setSaving] = useState(false);

  const monthLabel = (mk) => {
    const [y, m] = mk.split("-");
    return `${MESES_ES[parseInt(m)-1]} ${y}`;
  };

  // Generate month options (last 12 months)
  const monthOptions = [];
  for (let i = 0; i < 12; i++) {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    const mk = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
    monthOptions.push(mk);
  }

  // Initialize expenses for a month if not yet loaded
  const getMonthExpenses = (mk) => {
    if (expenses[mk]) return expenses[mk];
    return STANDARD_EXPENSES.map(e => ({
      id: `${mk}_${e.id}`,
      stdId: e.id,
      desc: e.desc,
      categoria: e.categoria,
      amount: e.isFixed ? e.amount : "",
      dueDay: e.dueDay,
      dueDate: e.dueDay ? `${mk}-${String(e.dueDay).padStart(2,"0")}` : "",
      method: e.method,
      paid: false,
      paidDate: "",
      isFixed: e.isFixed,
      isStandard: true,
      extra: false,
    }));
  };

  const monthExpenses = getMonthExpenses(selectedMonth);

  const saveExpenses = async (mk, list) => {
    setSaving(true);
    setExpenses(prev => ({ ...prev, [mk]: list }));
    try {
      await setDoc(doc(db, "nila_gastos", mk), { expenses: list, updatedAt: new Date().toISOString() });
    } catch(e) { console.error("Error saving gastos:", e); }
    setSaving(false);
  };

  const updateExpense = (idx, field, value) => {
    const list = [...monthExpenses];
    list[idx] = { ...list[idx], [field]: value };
    saveExpenses(selectedMonth, list);
  };

  const addExtraExpense = () => {
    if (!newExtra.desc.trim()) return alert("Ingrese la descripción del gasto");
    if (!newExtra.amount || parseFloat(newExtra.amount) <= 0) return alert("Ingrese el monto");
    if (!newExtra.categoria) return alert("Seleccione una categoría");
    const list = [...monthExpenses, {
      id: `${selectedMonth}_extra_${Date.now()}`,
      stdId: null,
      desc: newExtra.desc,
      categoria: newExtra.categoria,
      amount: parseFloat(newExtra.amount),
      dueDay: null,
      dueDate: newExtra.dueDate || "",
      method: newExtra.method,
      paid: false,
      paidDate: "",
      isFixed: false,
      isStandard: false,
      extra: true,
    }];
    saveExpenses(selectedMonth, list);
    setNewExtra({ desc: "", categoria: "Otros", amount: "", method: "", dueDay: "", paid: false, paidDate: "" });
    setShowAddExtra(false);
  };

  const deleteExtra = (idx) => {
    if (!window.confirm("¿Eliminar este gasto?")) return;
    const list = monthExpenses.filter((_, i) => i !== idx);
    saveExpenses(selectedMonth, list);
  };

  // Load from Firestore on mount and month change
  React.useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, "nila_gastos", selectedMonth));
        if (snap.exists()) {
          setExpenses(prev => ({ ...prev, [selectedMonth]: snap.data().expenses }));
        }
      } catch(e) { console.error("Error loading gastos:", e); }
    };
    load();
  }, [selectedMonth]);

  // Filtered list
  const filtered = monthExpenses.filter(e => {
    if (categoryFilter !== "Todas" && e.categoria !== categoryFilter) return false;
    if (paidFilter === "pagado" && !e.paid) return false;
    if (paidFilter === "pendiente" && e.paid) return false;
    return true;
  });

  const totalExpenses = monthExpenses.reduce((s, e) => s + (parseFloat(e.amount) || 0), 0);
  const totalPaid = monthExpenses.filter(e => e.paid).reduce((s, e) => s + (parseFloat(e.amount) || 0), 0);
  const totalPending = totalExpenses - totalPaid;

  const thS = { padding: "0.5rem 0.75rem", color: colors.gold.dark, fontWeight: "600", borderBottom: `2px solid ${colors.gold.primary}`, fontSize: "0.78rem", textAlign: "left" };
  const tdS = { padding: "0.45rem 0.6rem", borderBottom: `1px solid ${colors.gray.warm}`, fontSize: "0.8rem", verticalAlign: "middle" };

  return React.createElement("div", { style: { padding: "0.5rem" } },
    React.createElement("h2", { style: { fontSize: "1.4rem", fontFamily: "Georgia, serif", color: colors.gold.dark, marginBottom: "0.25rem" } }, "💸 Gastos — Nación Nila"),
    React.createElement("p", { style: { color: colors.gray.text, fontSize: "0.85rem", marginBottom: "1.25rem" } }, "Control de gastos mensuales"),

    // Month selector + filters
    React.createElement("div", { style: { display: "flex", gap: "0.6rem", flexWrap: "wrap", alignItems: "center", marginBottom: "1rem" } },
      React.createElement("select", { value: selectedMonth, onChange: e => setSelectedMonth(e.target.value), style: { ...styles.input, width: "auto", fontWeight: "700", color: colors.gold.dark, padding: "0.4rem 0.7rem", fontSize: "0.85rem" } },
        monthOptions.map(mk => React.createElement("option", { key: mk, value: mk }, monthLabel(mk)))
      ),
      React.createElement("select", { value: categoryFilter, onChange: e => setCategoryFilter(e.target.value), style: { ...styles.input, width: "auto", padding: "0.4rem 0.7rem", fontSize: "0.82rem" } },
        ["Todas", ...EXPENSE_CATEGORIES].map(c => React.createElement("option", { key: c, value: c }, c))
      ),
      React.createElement("select", { value: paidFilter, onChange: e => setPaidFilter(e.target.value), style: { ...styles.input, width: "auto", padding: "0.4rem 0.7rem", fontSize: "0.82rem" } },
        React.createElement("option", { value: "todos" }, "Todos"),
        React.createElement("option", { value: "pagado" }, "✅ Pagados"),
        React.createElement("option", { value: "pendiente" }, "⏳ Pendientes"),
      ),
      saving && React.createElement("span", { style: { fontSize: "0.78rem", color: colors.gray.text } }, "Guardando...")
    ),

    // Summary cards
    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0.75rem", marginBottom: "1.25rem" } },
      React.createElement("div", { style: { backgroundColor: "#FEE2E2", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: "#DC2626" } }, formatCurrency(totalExpenses)),
        React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280" } }, "Total gastos del mes")
      ),
      React.createElement("div", { style: { backgroundColor: "#DCFCE7", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: "#16A34A" } }, formatCurrency(totalPaid)),
        React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280" } }, "Pagado")
      ),
      React.createElement("div", { style: { backgroundColor: "#FEF3C7", borderRadius: "0.75rem", padding: "0.85rem 1rem", textAlign: "center" } },
        React.createElement("div", { style: { fontSize: "1.1rem", fontWeight: "800", color: "#D97706" } }, formatCurrency(totalPending)),
        React.createElement("div", { style: { fontSize: "0.75rem", color: "#6B7280" } }, "Pendiente de pago")
      ),
    ),

    // Expenses table
    React.createElement("div", { style: { overflowX: "auto", marginBottom: "1rem" } },
      React.createElement("table", { style: { width: "100%", borderCollapse: "collapse" } },
        React.createElement("thead", null, React.createElement("tr", { style: { backgroundColor: colors.gold.light } },
          React.createElement("th", { style: thS }, "Gasto"),
          React.createElement("th", { style: thS }, "Categoría"),
          React.createElement("th", { style: { ...thS, textAlign: "right" } }, "Monto (₡)"),
          React.createElement("th", { style: thS }, "Vencimiento"),
          React.createElement("th", { style: thS }, "Método de pago"),
          React.createElement("th", { style: { ...thS, textAlign: "center" } }, "Pagado"),
          React.createElement("th", { style: thS }, "Fecha del pago"),
          React.createElement("th", { style: { ...thS, textAlign: "center" } }, ""),
        )),
        React.createElement("tbody", null,
          filtered.map((e, idx) => {
            const realIdx = monthExpenses.findIndex(x => x.id === e.id);
            const isOverdue = !e.paid && e.dueDate && e.dueDate < new Date().toISOString().slice(0,10);
            return React.createElement("tr", { key: e.id, style: { backgroundColor: e.paid ? "#F0FDF4" : isOverdue ? "#FFF5F5" : idx % 2 === 0 ? "white" : "#FAFAFA" } },
              // Description
              React.createElement("td", { style: tdS },
                React.createElement("div", { style: { fontWeight: e.isStandard ? "500" : "400", fontSize: "0.82rem" } }, e.desc),
                e.extra && React.createElement("span", { style: { fontSize: "0.68rem", color: colors.gold.dark, backgroundColor: colors.gold.light, borderRadius: "0.3rem", padding: "0.05rem 0.3rem" } }, "Extra")
              ),
              // Category
              React.createElement("td", { style: tdS },
                React.createElement("select", {
                  value: e.categoria || "",
                  onChange: ev => updateExpense(realIdx, "categoria", ev.target.value),
                  style: { fontSize: "0.78rem", padding: "0.2rem 0.4rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.35rem", backgroundColor: "white", color: "#6B7280" },
                },
                  EXPENSE_CATEGORIES.map(c => React.createElement("option", { key: c, value: c }, c))
                )
              ),
              // Amount
              React.createElement("td", { style: { ...tdS, textAlign: "right" } },
                React.createElement("input", {
                  type: "number",
                  value: e.amount || "",
                  onChange: ev => updateExpense(realIdx, "amount", parseFloat(ev.target.value) || ""),
                  style: { width: "110px", textAlign: "right", padding: "0.2rem 0.4rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.35rem", fontSize: "0.82rem" },
                })
              ),
              // Due date — date picker
              React.createElement("td", { style: { ...tdS } },
                React.createElement("input", {
                  type: "date",
                  value: e.dueDate || "",
                  onChange: ev => updateExpense(realIdx, "dueDate", ev.target.value),
                  style: { fontSize: "0.78rem", padding: "0.2rem 0.4rem", border: `1px solid ${isOverdue ? "#DC2626" : colors.gold.light}`, borderRadius: "0.35rem", color: isOverdue ? "#DC2626" : "inherit" },
                })
              ),
              // Method
              React.createElement("td", { style: tdS },
                React.createElement("select", {
                  value: e.method || "",
                  onChange: ev => updateExpense(realIdx, "method", ev.target.value),
                  style: { fontSize: "0.78rem", padding: "0.2rem 0.4rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.35rem", backgroundColor: "white", maxWidth: "160px" },
                },
                  React.createElement("option", { value: "" }, "— Seleccionar —"),
                  PAYMENT_METHODS_GASTOS.map(m => React.createElement("option", { key: m, value: m }, m))
                )
              ),
              // Paid checkbox
              React.createElement("td", { style: { ...tdS, textAlign: "center" } },
                React.createElement("input", {
                  type: "checkbox",
                  checked: e.paid || false,
                  onChange: ev => {
                    const list = [...monthExpenses];
                    list[realIdx] = { ...list[realIdx], paid: ev.target.checked, paidDate: ev.target.checked ? new Date().toISOString().slice(0,10) : "" };
                    saveExpenses(selectedMonth, list);
                  },
                  style: { width: "1.1rem", height: "1.1rem", cursor: "pointer" },
                })
              ),
              // Paid date
              React.createElement("td", { style: tdS },
                React.createElement("input", {
                  type: "date",
                  value: e.paidDate || "",
                  onChange: ev => updateExpense(realIdx, "paidDate", ev.target.value),
                  style: { fontSize: "0.78rem", padding: "0.2rem 0.4rem", border: `1px solid ${colors.gold.light}`, borderRadius: "0.35rem" },
                })
              ),
              // Delete (extra only)
              React.createElement("td", { style: { ...tdS, textAlign: "center" } },
                e.extra && React.createElement("button", {
                  onClick: () => deleteExtra(realIdx),
                  style: { background: "none", border: "none", cursor: "pointer", color: "#DC2626", fontSize: "0.85rem" }
                }, "🗑️")
              )
            );
          })
        )
      )
    ),

    // Add extra expense
    !showAddExtra
      ? React.createElement("button", { onClick: () => setShowAddExtra(true), style: { ...styles.button, marginBottom: "1rem" } }, "➕ Agregar gasto extra")
      : React.createElement("div", { style: { backgroundColor: colors.gold.light, borderRadius: "0.75rem", padding: "1rem", marginBottom: "1rem" } },
          React.createElement("div", { style: { fontWeight: "700", color: colors.gold.dark, marginBottom: "0.75rem" } }, "Nuevo gasto extra"),
          React.createElement("div", { style: { display: "grid", gridTemplateColumns: "2fr 1fr 1fr", gap: "0.5rem", marginBottom: "0.5rem" } },
            React.createElement("input", { type: "text", placeholder: "Descripción *", value: newExtra.desc, onChange: e => setNewExtra(p => ({...p, desc: e.target.value})), style: { ...styles.input, padding: "0.4rem 0.6rem", fontSize: "0.82rem" } }),
            React.createElement("input", { type: "number", placeholder: "Monto (₡) *", value: newExtra.amount, onChange: e => setNewExtra(p => ({...p, amount: e.target.value})), style: { ...styles.input, padding: "0.4rem 0.6rem", fontSize: "0.82rem" } }),
            React.createElement("input", { type: "date", value: newExtra.dueDate || "", onChange: e => setNewExtra(p => ({...p, dueDate: e.target.value})), style: { ...styles.input, padding: "0.4rem 0.6rem", fontSize: "0.82rem" } }),
          ),
          React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginBottom: "0.75rem" } },
            React.createElement("select", { value: newExtra.categoria, onChange: e => setNewExtra(p => ({...p, categoria: e.target.value})), style: { ...styles.input, padding: "0.4rem 0.6rem", fontSize: "0.82rem" } },
              React.createElement("option", { value: "" }, "— Categoría —"),
              EXPENSE_CATEGORIES.map(c => React.createElement("option", { key: c, value: c }, c))
            ),
            React.createElement("select", { value: newExtra.method, onChange: e => setNewExtra(p => ({...p, method: e.target.value})), style: { ...styles.input, padding: "0.4rem 0.6rem", fontSize: "0.82rem" } },
              React.createElement("option", { value: "" }, "— Método de pago —"),
              PAYMENT_METHODS_GASTOS.map(m => React.createElement("option", { key: m, value: m }, m))
            ),
          ),
          React.createElement("div", { style: { display: "flex", gap: "0.5rem" } },
            React.createElement("button", { onClick: addExtraExpense, style: styles.buttonSuccess }, "✅ Agregar"),
            React.createElement("button", { onClick: () => setShowAddExtra(false), style: styles.buttonOutline }, "Cancelar"),
          )
        )
  );
}
// ========== END GASTOS PANEL ==========

// ========== QUICK RECORD OVERLAY ==========
// Staff-only: create a bare record on the spot (nothing required) so a payment
// can be attached immediately, then hand the client a link to complete their
// own details later. Reuses the normal IntakeWizard in quickMode.
function QuickRecordOverlay({ lang, records, creatorName, onClose, onCreated }) {
  const isMobile = useIsMobile();
  const [createdRecord, setCreatedRecord] = useState(null);
  const [copied, setCopied] = useState(false);

  const link = createdRecord ? buildCompletionLink(createdRecord.id) : "";
  const copyLink = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) await navigator.clipboard.writeText(link);
      else { const ta = document.createElement("textarea"); ta.value = link; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta); }
      setCopied(true); setTimeout(() => setCopied(false), 2000);
    } catch (e) { setCopied(false); }
  };
  const waLink = createdRecord
    ? `https://wa.me/?text=${encodeURIComponent(`Hola${createdRecord.form && createdRecord.form.nombre ? " " + createdRecord.form.nombre : ""}, por favor complete su expediente de Nación Nila Estética en este enlace: ${link}`)}`
    : "";

  return React.createElement(
    "div",
    { style: { ...styles.modalOverlay, alignItems: "flex-start", overflowY: "auto", zIndex: 1000 } },
    React.createElement(
      "div",
      { style: { backgroundColor: colors.light.background, width: "100%", minHeight: "100vh" } },
      React.createElement(
        "div",
        { style: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: isMobile ? "0.75rem 1rem" : "1rem 1.5rem", backgroundColor: colors.gold.primary } },
        React.createElement("div", { style: { color: "white", fontWeight: "700", fontSize: isMobile ? "1rem" : "1.15rem" } }, "⚡ Registro rápido"),
        React.createElement("button", { onClick: onClose, style: { padding: "0.4rem 0.9rem", backgroundColor: "rgba(255,255,255,0.25)", color: "white", border: "none", borderRadius: "2rem", cursor: "pointer", fontSize: "0.85rem" } }, "✕ Cerrar")
      ),
      !createdRecord
        ? React.createElement(
            "div",
            null,
            React.createElement("div", { style: { padding: isMobile ? "0.75rem 1rem 0" : "1rem 1.5rem 0", color: colors.gray.text, fontSize: "0.85rem", fontStyle: "italic" } },
              "Complete lo que tenga (nombre, teléfono, tratamiento). Ningún campo es obligatorio — puede guardar en cualquier momento con el botón ⚡ Guardar registro."
            ),
            React.createElement(IntakeWizard, {
              key: "quick_create",
              quickMode: true,
              quickCreatorName: creatorName,
              existingRecords: records,
              lang: lang || "es",
              onExit: onClose,
              onSubmit: (saved) => {
                if (!saved || !saved.id || String(saved.id).startsWith("temp_")) {
                  alert("⚠️ No se pudo guardar el registro en la nube. Revise su conexión e intente de nuevo.");
                  return;
                }
                setCreatedRecord(saved);
                if (onCreated) onCreated(saved);
              },
            })
          )
        : React.createElement(
            "div",
            { style: { maxWidth: "36rem", margin: "0 auto", padding: isMobile ? "1.5rem 1rem" : "2.5rem 1.5rem", textAlign: "center" } },
            React.createElement("div", { style: { fontSize: "3rem", marginBottom: "0.75rem", color: colors.accent.success } }, "✓"),
            React.createElement("h2", { style: { fontFamily: "Georgia, serif", color: colors.gold.dark, fontSize: "1.5rem", marginBottom: "0.5rem" } }, "Registro creado"),
            React.createElement("p", { style: { color: colors.gray.text, marginBottom: "0.5rem" } },
              (createdRecord.form && createdRecord.form.nombre ? createdRecord.form.nombre : "Cliente") + " ya está registrado. Ya puede cobrar y agregar sesiones."
            ),
            React.createElement("p", { style: { color: colors.gray.text, marginBottom: "1.25rem", fontSize: "0.9rem" } }, "Envíe este enlace al cliente para que complete sus datos cuando pueda:"),
            React.createElement("div", { style: { backgroundColor: "white", border: `1px solid ${colors.gold.light}`, borderRadius: "0.6rem", padding: "0.75rem", marginBottom: "1rem", wordBreak: "break-all", fontSize: "0.8rem", color: colors.gray.text } }, link),
            React.createElement(
              "div",
              { style: { display: "flex", gap: "0.6rem", justifyContent: "center", flexWrap: "wrap", marginBottom: "1.25rem" } },
              React.createElement("button", { onClick: copyLink, style: { padding: "0.65rem 1.25rem", backgroundColor: colors.gold.primary, color: "white", border: "none", borderRadius: "2rem", cursor: "pointer", fontWeight: "700", fontSize: "0.9rem" } }, copied ? "✓ Copiado" : "📋 Copiar enlace"),
              React.createElement("a", { href: waLink, target: "_blank", rel: "noopener noreferrer", style: { padding: "0.65rem 1.25rem", backgroundColor: "#25D366", color: "white", border: "none", borderRadius: "2rem", cursor: "pointer", fontWeight: "700", fontSize: "0.9rem", textDecoration: "none", display: "inline-block" } }, "💬 Enviar por WhatsApp")
            ),
            React.createElement("button", { onClick: onClose, style: { padding: "0.6rem 1.5rem", backgroundColor: "transparent", color: colors.gold.dark, border: `1px solid ${colors.gold.primary}`, borderRadius: "2rem", cursor: "pointer", fontSize: "0.9rem" } }, "Listo")
          )
    )
  );
}
// ========== END QUICK RECORD OVERLAY ==========

function Dashboard({ user, records, setRecords, onLogout }) {
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState("clientes");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("todos");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showAddTreatment, setShowAddTreatment] = useState(false);
  const canAddTreatment = ["especialista", "manager", "owner"].includes(user.role);
  const [showQuickRecord, setShowQuickRecord] = useState(false);
  const canQuickRecord = ["especialista", "manager", "owner", "admin"].includes(user.role);

  useEffect(() => {
    loadUsersFromFirestore().then(setUsers);

    const q = query(collection(db, RECORDS_COLLECTION), orderBy("createdAt", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const recordsData = [];
      snapshot.forEach((doc) => {
        const data = doc.data();
        // PERFORMANCE: the signature is a large base64 PNG (~30-80KB each).
        // Downloading all of them on every load made startup very slow.
        // Keep a flag here; the actual image is fetched on demand when a
        // client is opened (see fetchSignature / SignatureBlock).
        if (data.form && data.form.firmaCliente) {
          data.form = { ...data.form, firmaCliente: "", _hasFirma: true };
        }
        recordsData.push({ id: doc.id, ...data });
      });
      setRecords(recordsData);
      setLoading(false);
    }, (error) => {
      console.error("Firestore error:", error);
      // Firestore is the source of truth. If it errors, keep whatever is
      // already in memory rather than overwriting from (now-unused) local cache.
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleChangePassword = async () => {
    setPasswordError("");
    
    if (!oldPassword || !newPassword || !confirmPassword) {
      setPasswordError("Todos los campos son obligatorios");
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setPasswordError("Las contraseñas nuevas no coinciden");
      return;
    }
    
    if (newPassword.length < 4) {
      setPasswordError("La contraseña debe tener al menos 4 caracteres");
      return;
    }
    
    if (user.password !== oldPassword) {
      setPasswordError("Contraseña actual incorrecta");
      return;
    }
    
    const updatedUser = { ...user, password: newPassword };
    await saveUserToFirestore(updatedUser);
    
    const updatedUsers = users.map(u => u.id === user.id ? updatedUser : u);
    setUsers(updatedUsers);
    
    setShowChangePassword(false);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    
    alert("Contraseña cambiada exitosamente");
  };

  const filteredRecords = useMemo(() => {
    let filtered = records;
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (r) =>
          r.form?.nombre?.toLowerCase().includes(term) ||
          r.form?.cedula?.includes(term) ||
          r.form?.telefono?.includes(term)
      );
    }
    if (filterStatus !== "todos") {
      filtered = filtered.filter((r) => {
        const status = getClientStatus(r).label.toLowerCase();
        if (filterStatus === "pendientes") return status === "pendiente";
        if (filterStatus === "validados") return status === "validado";
        if (filterStatus === "activos") return status === "activo";
        if (filterStatus === "finalizados") return status === "finalizado";
        return true;
      });
    }
    return filtered;
  }, [records, searchTerm, filterStatus]);

  const stats = {
    total: records.length,
    pendientes: records.filter((r) => getClientStatus(r).label === "Pendiente")
      .length,
    validados: records.filter((r) => getClientStatus(r).label === "Validado")
      .length,
    activos: records.filter((r) => getClientStatus(r).label === "Activo")
      .length,
    finalizados: records.filter(
      (r) => getClientStatus(r).label === "Finalizado"
    ).length,
  };

  const canManageUsers = user.role === "owner" || user.role === "manager";
  const canSeeReports = user.role !== "recepcion" && (user.role !== "especialista" || (user.nivel || 1) === 1);

  const handleUpdateRecord = async (updatedRecord) => {
    await saveRecordToFirestore(updatedRecord);
    setSelectedRecord(updatedRecord);
    setRecords(prev => prev.map(r => r.id === updatedRecord.id ? updatedRecord : r));
  };

  const handleDeleteRecord = async (recordToDelete) => {
    // Hard safety gate: only owner/admin may delete an entire client record.
    if (user.role !== "admin" && user.role !== "owner") {
      alert("Solo un administrador puede eliminar expedientes.");
      return;
    }
    await deleteRecordFromFirestore(recordToDelete.id);
    setRecords(prev => prev.filter(r => r.id !== recordToDelete.id));
    setSelectedRecord(null);
  };

  if (loading) {
    return React.createElement("div", { style: styles.container },
      React.createElement("div", { style: { textAlign: "center", padding: "2rem" } }, "Cargando datos...")
    );
  }

  return React.createElement(
    "div",
    { style: styles.container },
    showAddTreatment && canAddTreatment && React.createElement(AddTreatmentModal, {
      user: user,
      records: records,
      onClose: () => setShowAddTreatment(false),
      onSaved: (updated) => {
        setRecords(prev => prev.map(r => r.id === updated.id ? updated : r));
        setSelectedRecord(updated);
      },
    }),
    showQuickRecord && canQuickRecord && React.createElement(QuickRecordOverlay, {
      lang: "es",
      records: records,
      creatorName: user.nombreCompleto,
      onClose: () => setShowQuickRecord(false),
      onCreated: (saved) => {
        setRecords(prev => {
          const exists = prev.some(r => r.id === saved.id);
          return exists ? prev.map(r => r.id === saved.id ? saved : r) : [saved, ...prev];
        });
      },
    }),
    showChangePassword && React.createElement(
      "div",
      { style: styles.modalOverlay },
      React.createElement(
        "div",
        { style: styles.modalContainer },
        React.createElement("div", { style: styles.modalTitle }, "Cambiar contraseña"),
        React.createElement(Field, {
          labelText: "Contraseña actual",
          value: oldPassword,
          onChange: setOldPassword,
          type: "password",
        }),
        React.createElement(Field, {
          labelText: "Nueva contraseña",
          value: newPassword,
          onChange: setNewPassword,
          type: "password",
        }),
        React.createElement(Field, {
          labelText: "Confirmar nueva contraseña",
          value: confirmPassword,
          onChange: setConfirmPassword,
          type: "password",
        }),
        passwordError && React.createElement(
          "div",
          { style: { color: colors.accent.danger, marginBottom: "1rem", fontSize: "0.875rem" } },
          passwordError
        ),
        React.createElement(
          "div",
          { style: styles.modalButtons },
          React.createElement(
            "button",
            { onClick: () => setShowChangePassword(false), style: styles.buttonOutline },
            "Cancelar"
          ),
          React.createElement(
            "button",
            { onClick: handleChangePassword, style: styles.buttonSuccess },
            "Cambiar"
          )
        )
      )
    ),
    React.createElement(
      "div",
      { style: { maxWidth: "72rem", margin: "0 auto" } },
      React.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            marginBottom: "1rem",
          },
        },
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "0.5rem",
            },
          },
          React.createElement(
            "div",
            { style: { minWidth: 0, flex: 1 } },
            React.createElement(
              "div",
              { style: { fontSize: "0.875rem", color: colors.gold.dark } },
              user.nombreCompleto,
              " · ",
              user.label
            ),
            React.createElement(
              "h1",
              {
                style: {
                  fontSize: isMobile ? "1.4rem" : "2rem",
                  fontFamily: "Georgia, serif",
                  color: colors.gold.dark,
                  margin: 0,
                  whiteSpace: isMobile ? "normal" : "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },
              },
              "Panel ",
              BRAND.name
            )
          ),
          React.createElement(
            "button",
            { onClick: onLogout, style: { ...styles.buttonSecondary, flexShrink: 0 } },
            "Salir"
          )
        ),
        isMobile && React.createElement(
          "button",
          {
            onClick: () => setShowChangePassword(true),
            style: {
              ...styles.buttonOutline,
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              width: "100%",
            }
          },
          "🔑 Cambiar contraseña"
        ),
        isMobile && canAddTreatment && React.createElement(
          "button",
          {
            onClick: () => setShowAddTreatment(true),
            style: {
              ...styles.button,
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              width: "100%",
            }
          },
          "💆‍♀️ Agregar tratamiento"
        ),
        !isMobile && React.createElement(
          "button",
          {
            onClick: () => setShowChangePassword(true),
            style: {
              ...styles.buttonOutline,
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              alignSelf: "flex-start",
            }
          },
          "🔑 Cambiar contraseña"
        ),
        !isMobile && canAddTreatment && React.createElement(
          "button",
          {
            onClick: () => setShowAddTreatment(true),
            style: {
              ...styles.button,
              padding: "0.5rem 1rem",
              fontSize: "0.875rem",
              alignSelf: "flex-start",
            }
          },
          "💆‍♀️ Agregar tratamiento"
        )
      ),
      React.createElement(
        "div",
        {
          style: {
            display: isMobile ? "grid" : "flex",
            gridTemplateColumns: isMobile ? "1fr 1fr" : undefined,
            flexDirection: isMobile ? undefined : "row",
            gap: isMobile ? "0.5rem" : "1rem",
            marginBottom: "1rem",
            borderBottom: isMobile ? "none" : `1px solid ${colors.gold.light}`,
          },
        },
        React.createElement(
          "button",
          {
            onClick: () => setActiveTab("clientes"),
            style: {
              ...styles.tabButton,
              width: isMobile ? "100%" : "auto",
              backgroundColor: activeTab === "clientes" ? colors.gold.primary : "transparent",
              color: activeTab === "clientes" ? "white" : colors.gold.dark,
              borderRadius: "2rem",
              padding: isMobile ? "0.75rem" : "0.5rem 1rem",
              textAlign: "center",
            },
          },
          "📋 Clientes"
        ),
        canSeeReports && React.createElement(
          "button",
          {
            onClick: () => setActiveTab("reportes"),
            style: {
              ...styles.tabButton,
              width: isMobile ? "100%" : "auto",
              backgroundColor: activeTab === "reportes" ? colors.gold.primary : "transparent",
              color: activeTab === "reportes" ? "white" : colors.gold.dark,
              borderRadius: "2rem",
              padding: isMobile ? "0.75rem" : "0.5rem 1rem",
              textAlign: "center",
            },
          },
          "📊 Reportes"
        ),
        canManageUsers &&
          React.createElement(
            "button",
            {
              onClick: () => setActiveTab("usuarios"),
              style: {
                ...styles.tabButton,
                width: isMobile ? "100%" : "auto",
                backgroundColor: activeTab === "usuarios" ? colors.gold.primary : "transparent",
                color: activeTab === "usuarios" ? "white" : colors.gold.dark,
                borderRadius: "2rem",
                padding: isMobile ? "0.75rem" : "0.5rem 1rem",
                textAlign: "center",
              },
            },
            "👥 Usuarios"
          ),
          React.createElement(
            "button",
            {
              onClick: () => setActiveTab("servicios"),
              style: {
                ...styles.tabButton,
                width: isMobile ? "100%" : "auto",
                backgroundColor: activeTab === "servicios" ? colors.gold.primary : "transparent",
                color: activeTab === "servicios" ? "white" : colors.gold.dark,
                borderRadius: "2rem",
                padding: isMobile ? "0.75rem" : "0.5rem 1rem",
                textAlign: "center",
              },
            },
            "💆‍♀️ Servicios"
          ),
          canSeeReports && React.createElement("button", {
            onClick: () => setActiveTab("gastos"),
            style: { ...styles.tabButton, width: isMobile ? "100%" : "auto", backgroundColor: activeTab === "gastos" ? colors.gold.primary : "transparent", color: activeTab === "gastos" ? "white" : colors.gold.dark, borderRadius: "2rem", padding: isMobile ? "0.75rem" : "0.5rem 1rem", textAlign: "center" },
          }, "💸 Gastos"),
          React.createElement("button", {
            onClick: () => setActiveTab("giftcards"),
            style: { ...styles.tabButton, width: isMobile ? "100%" : "auto", backgroundColor: activeTab === "giftcards" ? colors.gold.primary : "transparent", color: activeTab === "giftcards" ? "white" : colors.gold.dark, borderRadius: "2rem", padding: isMobile ? "0.75rem" : "0.5rem 1rem", textAlign: "center" },
          }, "🎁 Tarjetas de Regalo"),
          canSeeReports && React.createElement("button", {
            onClick: () => setActiveTab("depositos"),
            style: { ...styles.tabButton, width: isMobile ? "100%" : "auto", backgroundColor: activeTab === "depositos" ? colors.gold.primary : "transparent", color: activeTab === "depositos" ? "white" : colors.gold.dark, borderRadius: "2rem", padding: isMobile ? "0.75rem" : "0.5rem 1rem", textAlign: "center" },
          }, "💵 Depósitos")
      ),
      activeTab === "clientes" &&
        React.createElement(
          "div",
          null,
          canQuickRecord && React.createElement(
            "div",
            { style: { marginBottom: "1rem", display: "flex", justifyContent: "flex-end" } },
            React.createElement(
              "button",
              {
                onClick: () => setShowQuickRecord(true),
                style: {
                  padding: isMobile ? "0.7rem 1rem" : "0.6rem 1.25rem",
                  backgroundColor: colors.gold.primary,
                  color: "white",
                  border: "none",
                  borderRadius: "2rem",
                  cursor: "pointer",
                  fontWeight: "700",
                  fontSize: isMobile ? "0.85rem" : "0.9rem",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                },
              },
              "⚡ Registro rápido"
            )
          ),
          React.createElement(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: isMobile ? "repeat(2,1fr)" : "repeat(5,1fr)",
                gap: isMobile ? "0.5rem" : "1rem",
                marginBottom: "1rem",
              },
            },
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("todos");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  padding: isMobile ? "0.6rem 0.5rem" : styles.card.padding,
                  backgroundColor:
                    filterStatus === "todos"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "todos"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: isMobile ? "1.4rem" : "2rem",
                    fontWeight: "bold",
                    color: colors.gold.dark,
                  },
                },
                stats.total
              ),
              React.createElement("div", { style: { fontSize: isMobile ? "0.7rem" : "0.875rem" } }, "Total Clientes")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("pendientes");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  padding: isMobile ? "0.6rem 0.5rem" : styles.card.padding,
                  backgroundColor:
                    filterStatus === "pendientes"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "pendientes"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: isMobile ? "1.4rem" : "2rem",
                    fontWeight: "bold",
                    color: colors.gold.dark,
                  },
                },
                stats.pendientes
              ),
              React.createElement("div", { style: { fontSize: isMobile ? "0.7rem" : "0.875rem" } }, "⏳ Pendientes")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("validados");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  padding: isMobile ? "0.6rem 0.5rem" : styles.card.padding,
                  backgroundColor:
                    filterStatus === "validados"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "validados"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: isMobile ? "1.4rem" : "2rem",
                    fontWeight: "bold",
                    color: "#2C5282",
                  },
                },
                stats.validados
              ),
              React.createElement("div", { style: { fontSize: isMobile ? "0.7rem" : "0.875rem" } }, "✅ Validados")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("activos");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  padding: isMobile ? "0.6rem 0.5rem" : styles.card.padding,
                  backgroundColor:
                    filterStatus === "activos"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "activos"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: isMobile ? "1.4rem" : "2rem",
                    fontWeight: "bold",
                    color: colors.accent.success,
                  },
                },
                stats.activos
              ),
              React.createElement("div", { style: { fontSize: isMobile ? "0.7rem" : "0.875rem" } }, "🟢 Activos")
            ),
            React.createElement(
              "div",
              {
                onClick: () => {
                  setFilterStatus("finalizados");
                  setSearchTerm("");
                },
                style: {
                  ...styles.card,
                  cursor: "pointer",
                  padding: isMobile ? "0.6rem 0.5rem" : styles.card.padding,
                  backgroundColor:
                    filterStatus === "finalizados"
                      ? colors.gold.light
                      : "rgba(255,255,255,0.95)",
                  border:
                    filterStatus === "finalizados"
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gold.light}`,
                },
              },
              React.createElement(
                "div",
                {
                  style: {
                    fontSize: isMobile ? "1.4rem" : "2rem",
                    fontWeight: "bold",
                    color: colors.gray.text,
                  },
                },
                stats.finalizados
              ),
              React.createElement("div", { style: { fontSize: isMobile ? "0.7rem" : "0.875rem" } }, "🏁 Finalizados")
            )
          ),

          React.createElement(
            "div",
            { style: { marginBottom: "1rem" } },
            React.createElement("input", {
              type: "text",
              placeholder: "🔍 Buscar por nombre, cédula o teléfono...",
              value: searchTerm,
              onChange: (e) => setSearchTerm(e.target.value),
              style: styles.input,
            })
          ),

          filterStatus !== "todos" &&
            React.createElement(
              "div",
              {
                style: {
                  marginBottom: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                },
              },
              React.createElement(
                "span",
                {
                  style: {
                    backgroundColor: colors.gold.light,
                    padding: "0.25rem 0.75rem",
                    borderRadius: "2rem",
                    fontSize: "0.75rem",
                    color: colors.gold.dark,
                  },
                },
                "Filtro activo:"
              ),
              React.createElement(
                "span",
                { style: { fontWeight: "bold", color: colors.gold.dark } },
                filterStatus === "pendientes"
                  ? "⏳ Pendientes"
                  : filterStatus === "validados"
                  ? "✅ Validados"
                  : filterStatus === "activos"
                  ? "🟢 Activos"
                  : "🏁 Finalizados"
              ),
              React.createElement(
                "button",
                {
                  onClick: () => {
                    setFilterStatus("todos");
                    setSearchTerm("");
                  },
                  style: {
                    ...styles.buttonOutline,
                    padding: "0.25rem 0.75rem",
                    fontSize: "0.75rem",
                  },
                },
                "Limpiar filtro"
              )
            ),

          React.createElement(
            "div",
            {
              style: {
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "300px 1fr",
                gap: "1rem",
              },
            },
            React.createElement(
              "div",
              {
                style: {
                  ...styles.card,
                  maxHeight: isMobile ? (selectedRecord ? "260px" : "500px") : "500px",
                  overflowY: "auto",
                },
              },
              filteredRecords.length === 0
                ? React.createElement(
                    "p",
                    {
                      style: {
                        textAlign: "center",
                        padding: "2rem",
                        color: colors.gray.text,
                      },
                    },
                    filterStatus !== "todos"
                      ? `No hay clientes ${
                          filterStatus === "pendientes"
                            ? "pendientes"
                            : filterStatus === "validados"
                            ? "validados"
                            : filterStatus === "activos"
                            ? "activos"
                            : "finalizados"
                        }`
                      : "No hay clientes registrados"
                  )
                : filteredRecords.map((r) =>
                    React.createElement(
                      "div",
                      {
                        key: r.id,
                        onClick: () => setSelectedRecord(r),
                        style: {
                          padding: "0.75rem",
                          borderBottom: `1px solid ${colors.gray.warm}`,
                          cursor: "pointer",
                          backgroundColor:
                            selectedRecord?.id === r.id
                              ? colors.gold.light
                              : "transparent",
                        },
                      },
                      React.createElement(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            color: colors.gold.dark,
                          },
                        },
                        r.form?.nombre || "Cliente"
                      ),
                      React.createElement(
                        "div",
                        {
                          style: {
                            fontSize: "0.75rem",
                            color: colors.gray.text,
                          },
                        },
                        r.form?.cedula
                      ),
                      React.createElement(
                        "span",
                        {
                          style: {
                            ...styles.badge,
                            ...getClientStatus(r).badgeStyle,
                          },
                        },
                        getClientStatus(r).icon,
                        " ",
                        getClientStatus(r).label
                      ),
                      isPendingClientCompletion(r) && React.createElement(
                        "span",
                        { style: { ...styles.badge, backgroundColor: colors.gold.light, color: colors.gold.dark, marginLeft: "0.3rem", fontSize: "0.65rem" } },
                        "⚡ Datos pend."
                      ),
                      // Payment plan flags
                      ...getPaymentPlanFlag(r).map((flag, fi) =>
                        React.createElement(
                          "span",
                          {
                            key: fi,
                            style: {
                              ...styles.badge,
                              backgroundColor: flag.includes("pendiente") ? "#FEF3C7" : "#DBEAFE",
                              color: flag.includes("pendiente") ? "#92400E" : "#1D4ED8",
                              display: "block",
                              marginTop: "0.2rem",
                              fontSize: "0.65rem",
                            },
                          },
                          flag
                        )
                      )
                    )
                  )
            ),
            React.createElement(
              "div",
              { style: styles.card },
              selectedRecord
                ? React.createElement(RecordDetailView, {
                    user,
                    record: selectedRecord,
                    records,
                    onUpdate: handleUpdateRecord,
                    onDelete: handleDeleteRecord,
                  })
                : React.createElement(
                    "div",
                    {
                      style: {
                        textAlign: "center",
                        padding: "3rem",
                        color: colors.gray.text,
                      },
                    },
                    "👈 Selecciona un cliente"
                  )
            )
          )
        ),
      activeTab === "reportes" && canSeeReports &&
        React.createElement(ReportsPanel, { records }),
      activeTab === "servicios" &&
        React.createElement(ServicesPanel, null),

      activeTab === "gastos" && canSeeReports &&
        React.createElement(GastosPanel, { user }),

      activeTab === "giftcards" &&
        React.createElement(GiftCardsPanel, { user, records }),

      activeTab === "depositos" && canSeeReports &&
        React.createElement(DepositosPanel, { user, records }),

      activeTab === "usuarios" &&
        canManageUsers &&
        React.createElement(UserManagement, {
          users,
          setUsers,
          currentUser: user,
        })
    )
  );
}

function TreatmentSelectionStep({ form, setForm, lang }) {
  const isMobile = useIsMobile();
  const t = translations[lang];
  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: t.selectTreatment, lang }),
    React.createElement(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: "1rem",
        },
      },
      [t.facial, t.body, t.both, t.lashesBrows].map((item) => {
        const originalValue =
          item === t.facial ? "Facial" :
          item === t.body ? "Corporal" :
          item === t.both ? "Ambos" :
          "Pestañas/Cejas";
        return React.createElement(
          "button",
          {
            key: item,
            onClick: () => setForm({
              ...form,
              treatmentType: originalValue,
              // Reset all treatment detail fields when switching type
              bodyCategory: "",
              facialText: "",
              moldeoText: "",
              laserText: "",
              ceraText: "",
              massageText: "",
              lashBrowCategory: "",
              pestanasText: "",
              cejasText: "",
              paquetePCText: "",
            }),
            style: {
              borderRadius: "1rem",
              border:
                form.treatmentType === originalValue
                  ? `2px solid ${colors.gold.primary}`
                  : `1px solid ${colors.gray.medium}`,
              padding: "1rem",
              backgroundColor:
                form.treatmentType === originalValue ? colors.gold.light : "white",
              cursor: "pointer",
              transition: "all 0.2s",
            },
          },
          item
        );
      })
    )
  );
}

function ClientStep({ form, setForm, lang }) {
  const isMobile = useIsMobile();
  const t = translations[lang];
  const handleCedula = (v) => setForm({ ...form, cedula: onlyNumbers(v) });
  const handleTelefono = (v) => setForm({ ...form, telefono: onlyNumbers(v) });
  const gridStyle = isMobile
    ? { display: "flex", flexDirection: "column", gap: "0.5rem" }
    : { ...styles.gridContainer, gap: "1rem 2rem" };

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, {
      title: t.fullName + " / " + t.idNumber,
      subtitle: lang === "en" ? "All fields are required" : "Todos los campos son obligatorios",
      lang,
    }),
    React.createElement(
      "div",
      { style: gridStyle },
      React.createElement(Field, {
        labelText: t.fullName,
        value: form.nombre,
        onChange: (v) => setForm({ ...form, nombre: v }),
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.idNumber,
        value: form.cedula,
        onChange: handleCedula,
        type: "tel",
        inputMode: "numeric",
        required: true,
        lang,
      }),
      React.createElement(DateField, {
        labelText: t.dateOfBirth,
        value: form.fechaNacimiento,
        onChange: (v) => setForm({ ...form, fechaNacimiento: v }),
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.age,
        value: form.edad,
        onChange: () => {},
        disabled: true,
        lang,
      }),
      React.createElement(SelectField, {
        labelText: t.gender,
        value: form.genero,
        onChange: (v) => setForm({ ...form, genero: v }),
        options: ["", t.female, t.male],
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.profession,
        value: form.profesion,
        onChange: (v) => setForm({ ...form, profesion: v }),
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.email,
        value: form.correo,
        onChange: (v) => setForm({ ...form, correo: v }),
        type: "email",
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.phoneNumber,
        value: form.telefono,
        onChange: handleTelefono,
        type: "tel",
        inputMode: "numeric",
        required: true,
        lang,
      })
    ),
    React.createElement(Field, {
      labelText: t.addressLabel,
      value: form.direccion,
      onChange: (v) => setForm({ ...form, direccion: v }),
      required: true,
      lang,
    })
  );
}

function EmergencyStep({ form, setForm, lang }) {
  const isMobile = useIsMobile();
  const t = translations[lang];
  const handleTelefono = (v) =>
    setForm({ ...form, emergenciaTelefono: onlyNumbers(v) });
  const gridStyle = isMobile
    ? { display: "flex", flexDirection: "column", gap: "0.5rem" }
    : { ...styles.gridContainer, gap: "1rem 2rem" };

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, {
      title: t.emergencyContact,
      subtitle: lang === "en" ? "Fields marked with * are required" : "Los campos marcados con * son obligatorios",
      lang,
    }),
    React.createElement(
      "div",
      { style: gridStyle },
      React.createElement(Field, {
        labelText: t.emergencyName,
        value: form.emergenciaNombre,
        onChange: (v) => setForm({ ...form, emergenciaNombre: v }),
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.emergencyPhone,
        value: form.emergenciaTelefono,
        onChange: handleTelefono,
        type: "tel",
        inputMode: "numeric",
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.emergencyEmail,
        value: form.emergenciaCorreo,
        onChange: (v) => setForm({ ...form, emergenciaCorreo: v }),
        type: "email",
        lang,
      }),
      React.createElement(Field, {
        labelText: t.emergencyRelation,
        value: form.emergenciaRelacion,
        onChange: (v) => setForm({ ...form, emergenciaRelacion: v }),
        required: true,
        lang,
      })
    )
  );
}

function TreatmentDetailStep({ form, setForm, lang }) {
  const t = translations[lang];
  const showFacial = form.treatmentType === "Facial" || form.treatmentType === "Ambos";
  const showCorporal = form.treatmentType === "Corporal" || form.treatmentType === "Ambos";
  const showLashBrow = form.treatmentType === "Pestañas/Cejas";
  const lashBrowList = lashBrowCategories[lang];
  const bodyCatList = bodyCategories[lang];

  return React.createElement(
    "div",
    null,
    showFacial &&
      React.createElement(
        "div",
        { style: form.treatmentType === "Ambos" ? { marginBottom: "2rem" } : null },
        form.treatmentType === "Ambos" &&
          React.createElement(
            "div",
            {
              style: {
                fontWeight: "bold",
                color: colors.gold.dark,
                marginBottom: "0.75rem",
                fontSize: "1.1rem",
                borderBottom: `1px solid ${colors.gold.light}`,
                paddingBottom: "0.5rem",
              },
            },
            lang === "en" ? "💆‍♀️ Facial Treatment" : "💆‍♀️ Tratamiento Facial"
          ),
        React.createElement(TextAreaField, {
          labelText: t.facialQuestion,
          value: form.facialText,
          onChange: (v) => setForm({ ...form, facialText: v }),
          required: true,
          placeholder: t.facialPlaceholder,
          rows: 4,
          lang,
        })
      ),
    showCorporal &&
      React.createElement(
        "div",
        null,
        form.treatmentType === "Ambos" &&
          React.createElement(
            "div",
            {
              style: {
                fontWeight: "bold",
                color: colors.gold.dark,
                marginBottom: "0.75rem",
                fontSize: "1.1rem",
                borderBottom: `1px solid ${colors.gold.light}`,
                paddingBottom: "0.5rem",
              },
            },
            lang === "en" ? "💪 Body Treatment" : "💪 Tratamiento Corporal"
          ),
        React.createElement(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: "repeat(2,1fr)",
              gap: "0.5rem",
              marginBottom: "1rem",
            },
          },
          bodyCatList.map((cat) => {
            // Map displayed label (any language) to canonical Spanish stored value
            const originalValue =
              cat === "Moldeo corporal" || cat === "Body Contouring" ? "Moldeo corporal" :
              cat === "Depilación láser" || cat === "Laser Hair Removal" ? "Depilación láser" :
              cat === "Depilación con cera" || cat === "Waxing" ? "Depilación con cera" :
              "Masajes";
            return React.createElement(
              "button",
              {
                key: cat,
                type: "button",
                onClick: () =>
                  setForm({
                    ...form,
                    bodyCategory: originalValue,
                    moldeoText: "",
                    laserText: "",
                    ceraText: "",
                    massageText: "",
                  }),
                style: {
                  padding: "0.5rem",
                  borderRadius: "1rem",
                  border:
                    form.bodyCategory === originalValue
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gray.medium}`,
                  backgroundColor:
                    form.bodyCategory === originalValue ? colors.gold.light : "white",
                  cursor: "pointer",
                },
              },
              cat
            );
          })
        ),
        form.bodyCategory === "Moldeo corporal" &&
          React.createElement(TextAreaField, {
            labelText: t.bodyQuestion,
            value: form.moldeoText,
            onChange: (v) => setForm({ ...form, moldeoText: v }),
            required: true,
            placeholder: t.bodyPlaceholder,
            rows: 4,
            lang,
          }),
        form.bodyCategory === "Depilación láser" &&
          React.createElement(TextAreaField, {
            labelText: t.laserQuestion,
            value: form.laserText,
            onChange: (v) => setForm({ ...form, laserText: v }),
            required: true,
            placeholder: t.laserPlaceholder,
            rows: 4,
            lang,
          }),
        form.bodyCategory === "Depilación con cera" &&
          React.createElement(TextAreaField, {
            labelText: t.ceraQuestion,
            value: form.ceraText,
            onChange: (v) => setForm({ ...form, ceraText: v }),
            required: true,
            placeholder: t.ceraPlaceholder,
            rows: 4,
            lang,
          }),
        form.bodyCategory === "Masajes" &&
          React.createElement(TextAreaField, {
            labelText: t.massageQuestion,
            value: form.massageText,
            onChange: (v) => setForm({ ...form, massageText: v }),
            required: true,
            placeholder: t.massagePlaceholder,
            rows: 4,
            lang,
          })
      ),

    // ══════ PESTAÑAS / CEJAS ══════
    showLashBrow &&
      React.createElement(
        "div",
        { style: { marginBottom: "1.5rem" } },
        React.createElement(SectionTitle, { title: t.lashesBrows, lang }),
        React.createElement(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: "0.5rem",
              marginBottom: "1rem",
            },
          },
          lashBrowList.map((cat) => {
            // Map displayed label (any language) to canonical Spanish stored value
            const originalValue =
              cat === "Pestañas" || cat === "Lashes" ? "Pestañas" :
              cat === "Cejas" || cat === "Brows" ? "Cejas" :
              "Paquete";
            return React.createElement(
              "button",
              {
                key: cat,
                type: "button",
                onClick: () =>
                  setForm({
                    ...form,
                    lashBrowCategory: originalValue,
                    pestanasText: "",
                    cejasText: "",
                    paquetePCText: "",
                  }),
                style: {
                  padding: "0.5rem",
                  borderRadius: "1rem",
                  border:
                    form.lashBrowCategory === originalValue
                      ? `2px solid ${colors.gold.primary}`
                      : `1px solid ${colors.gray.medium}`,
                  backgroundColor:
                    form.lashBrowCategory === originalValue ? colors.gold.light : "white",
                  cursor: "pointer",
                },
              },
              cat
            );
          })
        ),
        form.lashBrowCategory === "Pestañas" &&
          React.createElement(TextAreaField, {
            labelText: t.pestanasQuestion,
            value: form.pestanasText,
            onChange: (v) => setForm({ ...form, pestanasText: v }),
            required: true,
            placeholder: t.pestanasPlaceholder,
            rows: 4,
            lang,
          }),
        form.lashBrowCategory === "Cejas" &&
          React.createElement(TextAreaField, {
            labelText: t.cejasQuestion,
            value: form.cejasText,
            onChange: (v) => setForm({ ...form, cejasText: v }),
            required: true,
            placeholder: t.cejasPlaceholder,
            rows: 4,
            lang,
          }),
        form.lashBrowCategory === "Paquete" &&
          React.createElement(TextAreaField, {
            labelText: t.paquetePCQuestion,
            value: form.paquetePCText,
            onChange: (v) => setForm({ ...form, paquetePCText: v }),
            required: true,
            placeholder: t.paquetePCPlaceholder,
            rows: 4,
            lang,
          })
      )
  );
}

function MedicalStep({ form, setForm, lang }) {
  const t = translations[lang];
  const showAnticonceptivos = form.genero === "Femenino";
  const medicalOpts = medicalOptions[lang];
  const isMobile = useIsMobile();

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: t.medicalInfo, lang }),
    React.createElement(
      "div",
      {
        style: {
          // CORRECTION #3: Mobile medical conditions grid - change from 3 columns to 2 columns on mobile
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(3, 1fr)",
          gap: "0.75rem",
        },
      },
      medicalOpts.map((item) => {
        const originalItem = lang === "es" ? item :
                              item === "Pregnancy" ? "Embarazo" :
                              item === "Diabetes" ? "Diabetes" :
                              item === "Autoimmune diseases" ? "Enfermedades autoinmunes" :
                              item === "Rosacea" ? "Rosácea" :
                              item === "Asthma" ? "Asma" :
                              item === "Hypertension" ? "Hipertensión" :
                              item === "Enlarged pores" ? "Poros dilatados" :
                              item === "Epilepsy or seizures" ? "Epilepsia o convulsiones" :
                              item === "Skin allergies" ? "Alergias en la piel" :
                              item === "Heart disease" ? "Cardiopatía" :
                              item === "Sun damage" ? "Daño solar" :
                              "Enfermedades de ETS";
        return React.createElement(
          "label",
          {
            key: item,
            style: {
              borderRadius: "1rem",
              border: `1px solid ${colors.gray.medium}`,
              padding: "1rem",
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              backgroundColor: "white",
            },
          },
          React.createElement("input", {
            type: "checkbox",
            checked: form.medical.includes(originalItem),
            onChange: () =>
              setForm({ ...form, medical: toggleArray(originalItem, form.medical) }),
          }),
          React.createElement("span", null, item)
        );
      })
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(SelectField, {
        labelText: t.takingMedication,
        value: form.medicamentosActuales,
        onChange: (v) => setForm({ ...form, medicamentosActuales: v }),
        options: ["", t.yes, t.no],
        required: true,
        lang,
      }),
      React.createElement(Field, {
        labelText: t.whichMedications,
        value: form.medicamentosCuales,
        onChange: (v) => setForm({ ...form, medicamentosCuales: v }),
        lang,
      }),
      showAnticonceptivos &&
        React.createElement(SelectField, {
          labelText: t.birthControl,
          value: form.anticonceptivos,
          onChange: (v) => setForm({ ...form, anticonceptivos: v }),
          options: ["", t.yes, t.no],
          required: true,
          lang,
        }),
      showAnticonceptivos &&
        React.createElement(Field, {
          labelText: t.birthControlType,
          value: form.anticonceptivosCuales,
          onChange: (v) => setForm({ ...form, anticonceptivosCuales: v }),
          lang,
        }),
      React.createElement(Field, {
        labelText: t.skinType,
        value: form.tipoPiel,
        onChange: (v) => setForm({ ...form, tipoPiel: v }),
        lang,
      }),
      React.createElement(Field, {
        labelText: t.allergies,
        value: form.alergiasProductos,
        onChange: (v) => setForm({ ...form, alergiasProductos: v }),
        lang,
      })
    ),
    React.createElement(
      "div",
      { style: styles.gridContainer },
      React.createElement(SelectField, {
        labelText: t.recentProcedures,
        value: form.procedimientosRecientes,
        onChange: (v) =>
          setForm({
            ...form,
            procedimientosRecientes: v,
            procedimientosRecientesCuales: "",
          }),
        options: ["", t.yes, t.no],
        lang,
      }),
      form.procedimientosRecientes === "Sí" &&
        React.createElement(Field, {
          labelText: t.whichProcedures,
          value: form.procedimientosRecientesCuales,
          onChange: (v) =>
            setForm({ ...form, procedimientosRecientesCuales: v }),
          required: true,
          lang,
        }),
      React.createElement(Field, {
        labelText: t.otherConcerns,
        value: form.otrasPreocupaciones,
        onChange: (v) => setForm({ ...form, otrasPreocupaciones: v }),
        lang,
      })
    ),
    React.createElement(
      "div",
      { style: { marginTop: "1rem" } },
      React.createElement(SelectField, {
        labelText: t.authorizeImage,
        value: form.autorizaImagen,
        onChange: (v) => setForm({ ...form, autorizaImagen: v }),
        options: ["", t.yes, t.no],
        required: true,
        lang,
      })
    )
  );
}

function ConsentStep({ form, setForm, lang }) {
  const t = translations[lang];
  const formattedConsentBody = (lang === "en" ? consentBody.en : consentBody.es).split("\n").map((line, i) => {
    if (
      (lang === "en" && (line.startsWith("Important information") || line.startsWith("Risks") || line.startsWith("General recommendations") || line.startsWith("Client Declaration"))) ||
      (lang === "es" && (line.startsWith("Información importante") || line.startsWith("Riesgos") || line.startsWith("Recomendaciones") || line.startsWith("Declaración")))
    ) {
      return React.createElement(
        "div",
        {
          key: i,
          style: {
            fontWeight: "bold",
            marginTop: "0.75rem",
            marginBottom: "0.25rem",
            color: colors.gold.dark,
          },
        },
        line
      );
    }
    if (line.trim() === "")
      return React.createElement("div", {
        key: i,
        style: { height: "0.5rem" },
      });
    return React.createElement("div", { key: i }, line);
  });

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: t.consentTitle, lang }),
    React.createElement(
      "div",
      {
        style: {
          borderRadius: "1.5rem",
          border: `1px solid ${colors.gold.light}`,
          backgroundColor: colors.light.background,
          padding: "1.25rem",
          minHeight: "320px",
          whiteSpace: "pre-wrap",
          lineHeight: "1.75",
          color: colors.dark.primary,
        },
      },
      React.createElement(
        "div",
        {
          style: {
            fontWeight: "bold",
            marginBottom: "1rem",
            color: colors.gold.dark,
          },
        },
        t.procedure
      ),
      React.createElement(
        "div",
        { style: { marginBottom: "1.25rem" } },
        lang === "en" ? treatmentProcedureText.en : treatmentProcedureText.es
      ),
      formattedConsentBody
    ),
    React.createElement(
      "label",
      {
        style: {
          marginTop: "1rem",
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
          borderRadius: "1rem",
          border: `1px solid ${colors.gold.light}`,
          padding: "1rem",
          backgroundColor: "white",
        },
      },
      React.createElement("input", {
        type: "checkbox",
        checked: form.aceptaConsentimiento,
        onChange: (e) =>
          setForm({ ...form, aceptaConsentimiento: e.target.checked }),
      }),
      t.acceptConsent
    )
  );
}

function SignatureStep({ form, setForm, lang }) {
  const t = translations[lang];
  const [signaturePad, setSignaturePad] = useState(null);
  const isMobile = useIsMobile();

  const clearSignature = () => {
    if (signaturePad) {
      signaturePad.clear();
      setForm({ ...form, firmaCliente: "" });
    }
  };

  const saveSignature = () => {
    if (signaturePad && !signaturePad.isEmpty()) {
      const signatureData = signaturePad.toDataURL();
      setForm({ ...form, firmaCliente: signatureData });
      alert(t.signatureSaved);
    } else {
      alert(lang === "en" ? "Please sign in the signature area before saving" : "Por favor firme en el área de firma antes de guardar");
    }
  };

  return React.createElement(
    "div",
    null,
    React.createElement(SectionTitle, { title: t.signatureTitle, lang }),
    React.createElement(
      "div",
      { style: { marginBottom: "1rem" } },
      React.createElement(
        "label",
        {
          style: {
            display: "block",
            marginBottom: "0.5rem",
            fontWeight: "500",
            color: colors.gold.dark,
          },
        },
        t.signatureInstruction,
        React.createElement(
          "span",
          { style: { color: colors.accent.danger, marginLeft: "0.25rem" } },
          "*"
        )
      ),
      React.createElement(
        "div",
        {
          style: {
            border: `2px solid ${colors.gold.primary}`,
            borderRadius: "1rem",
            backgroundColor: "white",
            width: "100%",
            height: isMobile ? "200px" : "250px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          },
        },
        React.createElement(SignatureCanvas, {
          ref: (ref) => setSignaturePad(ref),
          canvasProps: {
            style: {
              width: "100%",
              height: "100%",
              borderRadius: "0.75rem",
              cursor: "crosshair",
            },
          },
          penColor: colors.gold.dark,
          backgroundColor: "#FFFFFF",
          velocityFilterWeight: 0.7,
          minWidth: 1,
          maxWidth: 2.5,
        })
      ),
      React.createElement(
        "div",
        {
          style: {
            display: "flex",
            gap: "1rem",
            marginTop: "0.75rem",
            justifyContent: "flex-end",
          },
        },
        React.createElement(
          "button",
          {
            onClick: clearSignature,
            style: { ...styles.buttonOutline, padding: "0.5rem 1rem", fontSize: "0.875rem" },
          },
          `🗑️ ${t.clearSignature}`
        ),
        React.createElement(
          "button",
          {
            onClick: saveSignature,
            style: { ...styles.buttonSuccess, padding: "0.5rem 1rem", fontSize: "0.875rem" },
          },
          `✓ ${t.saveSignature}`
        )
      )
    ),
    form.firmaCliente &&
      form.firmaCliente.startsWith("data:image") && (
        React.createElement(
          "div",
          { 
            style: { 
              marginTop: "1rem", 
              padding: "1rem", 
              backgroundColor: colors.accent.successLight, 
              borderRadius: "0.75rem",
              border: `1px solid ${colors.accent.success}`,
            } 
          },
          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                marginBottom: "0.5rem",
                fontWeight: "500",
                color: colors.accent.success,
              },
            },
            "✓ " + (lang === "en" ? "Signature saved successfully" : "Firma guardada correctamente")
          ),
          React.createElement(
            "img",
            {
              src: form.firmaCliente,
              alt: "Client Signature",
              style: {
                border: `1px solid ${colors.gold.light}`,
                borderRadius: "0.5rem",
                padding: "0.5rem",
                maxWidth: "100%",
                height: "80px",
                backgroundColor: "white",
              },
            }
          )
        )
      ),
    React.createElement(
      "div",
      { style: { marginTop: "1rem" } },
      React.createElement(
        "label",
        {
          style: {
            display: "block",
            marginBottom: "0.5rem",
            fontWeight: "500",
            color: colors.gold.dark,
          },
        },
        t.date
      ),
      React.createElement(
        "div",
        { style: { ...styles.input, backgroundColor: colors.gray.warm } },
        formatDateCR(new Date().toISOString().slice(0, 10))
      )
    )
  );
}

function IntakeWizard({ onSubmit, existingRecords, onExit, lang, prefillRecord, quickMode, quickCreatorName }) {
  const isMobile = useIsMobile();
  const t = translations[lang];
  // When completing an existing (rápido) record via link, start from its saved form.
  const [form, setForm] = useState(
    prefillRecord && prefillRecord.form
      ? { ...initialForm, ...prefillRecord.form }
      : initialForm
  );
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState([]);
  const [showExit, setShowExit] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm((f) => ({ ...f, edad: calcAge(f.fechaNacimiento) }));
  }, [form.fechaNacimiento]);

  const isCedulaUnique = (ced) =>
    !existingRecords.some((r) => r.form?.cedula === ced);
  const steps = [t.selectTreatment, t.facialQuestion, t.fullName, t.emergencyContact, t.medicalInfo, t.consentTitle, t.signatureTitle];

  const validateStep = () => {
    const errs = [];

    // Staff quick-create: nothing required, allow clicking straight through and saving.
    if (quickMode) {
      setErrors([]);
      return true;
    }

    if (step === 0) {
      if (!form.treatmentType)
        errs.push(t.requiredTreatment);
    }

    if (step === 1) {
      const isFacial = form.treatmentType === "Facial" || form.treatmentType === "Ambos";
      const isCorporal = form.treatmentType === "Corporal" || form.treatmentType === "Ambos";
      if (isFacial && !form.facialText.trim())
        errs.push(t.requiredFacial);
      if (isCorporal) {
        if (!form.bodyCategory)
          errs.push(t.requiredBodyCategory);
        if (form.bodyCategory === "Moldeo corporal" && !form.moldeoText.trim())
          errs.push(t.requiredBodyAreas);
        if (form.bodyCategory === "Depilación láser" && !form.laserText.trim())
          errs.push(t.requiredLaserZones);
        if (form.bodyCategory === "Depilación con cera" && !(form.ceraText || "").trim())
          errs.push(t.requiredLaserZones);
        if (form.bodyCategory === "Masajes" && !form.massageText.trim())
          errs.push(t.requiredMassageType);
      }
      const isLashBrow = form.treatmentType === "Pestañas/Cejas";
      if (isLashBrow) {
        if (!form.lashBrowCategory)
          errs.push(t.requiredBodyCategory);
        if (form.lashBrowCategory === "Pestañas" && !(form.pestanasText || "").trim())
          errs.push(t.requiredBodyAreas);
        if (form.lashBrowCategory === "Cejas" && !(form.cejasText || "").trim())
          errs.push(t.requiredBodyAreas);
        if (form.lashBrowCategory === "Paquete" && !(form.paquetePCText || "").trim())
          errs.push(t.requiredBodyAreas);
      }
    }

    if (step === 2) {
      if (!form.nombre.trim()) errs.push(t.requiredFullName);
      if (!hasFirstAndLastName(form.nombre))
        errs.push(t.requiredTwoNames);
      if (!form.cedula.trim()) errs.push(t.requiredIdNumber);
      if (form.cedula && !/^\d+$/.test(form.cedula))
        errs.push(t.idNumberOnlyNumbers);
      if (!isCedulaUnique(form.cedula))
        errs.push(t.idAlreadyExists);
      if (!form.fechaNacimiento)
        errs.push(t.requiredBirthDate);
      if (!isValidBirthYear(form.fechaNacimiento))
        errs.push(t.invalidBirthYear);
      if (!isValidBirthDate(form.fechaNacimiento))
        errs.push(t.invalidAge);
      if (!form.genero)
        errs.push(t.requiredGender);
      if (!form.profesion.trim()) errs.push(t.requiredProfession);
      if (!form.correo.trim()) errs.push(t.requiredEmail);
      if (!isValidEmail(form.correo))
        errs.push(t.invalidEmail);
      if (!form.telefono.trim()) errs.push(t.requiredPhone);
      if (form.telefono && !/^\d+$/.test(form.telefono))
        errs.push(t.phoneOnlyNumbers);
      if (!form.direccion.trim()) errs.push(t.requiredAddress);
    }

    if (step === 3) {
      if (!form.emergenciaNombre.trim())
        errs.push(t.requiredEmergencyName);
      if (!hasFirstAndLastName(form.emergenciaNombre))
        errs.push(t.requiredEmergencyTwoNames);
      if (!form.emergenciaTelefono.trim())
        errs.push(t.requiredEmergencyPhone);
      if (form.emergenciaTelefono && !/^\d+$/.test(form.emergenciaTelefono))
        errs.push(t.emergencyPhoneOnlyNumbers);
      if (form.emergenciaCorreo.trim() && !isValidEmail(form.emergenciaCorreo))
        errs.push(t.invalidEmergencyEmail);
      if (!form.emergenciaRelacion.trim())
        errs.push(t.requiredEmergencyRelation);
    }

    if (step === 4) {
      if (!form.medicamentosActuales)
        errs.push(t.requiredMedication);
      if (form.medicamentosActuales === "Sí" && !form.medicamentosCuales.trim())
        errs.push(t.requiredWhichMedications);
      if (form.genero === "Femenino") {
        if (!form.anticonceptivos)
          errs.push(t.requiredBirthControl);
        if (form.anticonceptivos === "Sí" && !form.anticonceptivosCuales.trim())
          errs.push(t.requiredBirthControlType);
      }
      if (
        form.procedimientosRecientes === "Sí" &&
        !form.procedimientosRecientesCuales.trim()
      )
        errs.push(t.requiredWhichProcedures);
      if (!form.autorizaImagen)
        errs.push(t.requiredAuthorizeImage);
    }

    if (step === 5) {
      if (!form.aceptaConsentimiento)
        errs.push(t.requiredAcceptConsent);
    }

    if (step === 6) {
      if (!form.firmaCliente || !form.firmaCliente.startsWith("data:image"))
        errs.push(t.requiredSignature);
    }

    setErrors(errs);
    return errs.length === 0;
  };

  const next = () => {
    if (!validateStep()) return;
    setStep((s) => Math.min(s + 1, steps.length - 1));
  };

  const back = () => setStep((s) => Math.max(s - 1, 0));

  const submit = async () => {
    if (!validateStep()) return;

    // Cédula uniqueness only matters for brand-new non-quick records. Completing
    // an existing record keeps its own cédula; quick records may have none.
    if (!prefillRecord && !quickMode && !isCedulaUnique(form.cedula)) {
      setErrors([t.idAlreadyExists]);
      return;
    }

    setSaving(true);

    // Ensure a name is always present so saveRecordToFirestore never blocks the
    // write (it refuses records with an empty form.nombre).
    let safeForm = { ...form };
    if (!safeForm.nombre || !safeForm.nombre.trim()) {
      const d = new Date();
      const label = `${d.getDate().toString().padStart(2,"0")}/${(d.getMonth()+1).toString().padStart(2,"0")}`;
      safeForm.nombre = `Cliente ${label}`;
    }

    let record;
    if (prefillRecord) {
      // Completing an existing (rápido) record: update in place, preserving
      // payments, sessions, treatment plan, status and history.
      record = {
        ...prefillRecord,
        form: safeForm,
        completedByClientAt: new Date().toISOString(),
      };
    } else if (quickMode) {
      // Staff quick-create: born validated so payment/sessions work immediately —
      // the staff member creating it in person IS the review step.
      record = {
        id: `temp_${Date.now()}`,
        status: "validado",
        createdAt: new Date().toISOString(),
        form: safeForm,
        specialistReview: { specialistName: quickCreatorName || "Registro rápido", signedAt: new Date().toISOString(), quick: true },
        sessions: [],
        treatmentPlan: null,
        changeHistory: [],
        notes: [],
        createdVia: "specialist_quick",
      };
    } else {
      record = {
        id: `temp_${Date.now()}`,
        status: "pendiente_revision",
        createdAt: new Date().toISOString(),
        form: safeForm,
        specialistReview: null,
        sessions: [],
        treatmentPlan: null,
        changeHistory: [],
        notes: [],
      };
    }
    const savedRecord = await saveRecordToFirestore(record);
    onSubmit(savedRecord);
    setSaving(false);
  };

  const treatmentDisplay = form.treatmentType
    ? React.createElement(
        "div",
        { style: styles.selectedTreatmentBadge },
        lang === "en" ? "Selected treatment: " : "Tratamiento seleccionado: ",
        form.treatmentType === "Facial" ? (lang === "en" ? "💆‍♀️ Facial" : "💆‍♀️ Facial") : form.treatmentType === "Corporal" ? (lang === "en" ? "💪 Body" : "💪 Corporal") : (lang === "en" ? "💆‍♀️💪 Facial & Body" : "💆‍♀️💪 Facial y Corporal")
      )
    : null;

  return React.createElement(
    "div",
    { style: { ...styles.container, position: "relative", padding: isMobile ? "1rem" : "2rem" } },
    React.createElement(
      "button",
      { onClick: () => setShowExit(true), style: styles.exitButton },
      "✖️ " + (lang === "en" ? "Exit" : "Salir")
    ),
    showExit &&
      React.createElement(
        "div",
        {
          style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          },
        },
        React.createElement(
          "div",
          {
            style: {
              backgroundColor: "white",
              borderRadius: "1.5rem",
              padding: "2rem",
              maxWidth: "400px",
              textAlign: "center",
            },
          },
          React.createElement(
            "h3",
            { style: { color: colors.gold.dark } },
            t.exitTitle
          ),
          React.createElement("p", null, t.exitMessage),
          React.createElement(
            "div",
            {
              style: {
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                marginTop: "1rem",
              },
            },
            React.createElement(
              "button",
              {
                onClick: () => setShowExit(false),
                style: styles.buttonOutline,
              },
              t.continueButton
            ),
            React.createElement(
              "button",
              {
                onClick: () => {
                  setShowExit(false);
                  onExit();
                },
                style: styles.buttonDanger,
              },
              t.exitButton
            )
          )
        )
      ),
    React.createElement(
      "div",
      { style: { maxWidth: "56rem", margin: "0 auto" } },
      treatmentDisplay,
      React.createElement(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          },
        },
        React.createElement(
          "div",
          null,
          React.createElement(
            "div",
            { style: { fontSize: "0.875rem", color: colors.gray.text } },
            BRAND.subtitle
          ),
          React.createElement(
            "h1",
            {
              style: {
                fontSize: "1.875rem",
                fontFamily: "Georgia, serif",
                color: colors.gold.dark,
              },
            },
            lang === "en" ? BRAND.nameEn : BRAND.name
          )
        ),
        React.createElement(
          "div",
          { style: { fontSize: "0.875rem", color: colors.gray.text } },
          lang === "en" ? "Step " : "Paso ",
          step + 1,
          " " + (lang === "en" ? "of " : "de "),
          steps.length
        )
      ),
      React.createElement(
        "div",
        { style: styles.card },
        errors.length > 0 &&
          React.createElement(
            "div",
            { style: styles.errorBox },
            React.createElement(
              "div",
              { style: { fontWeight: "bold", marginBottom: "0.5rem" } },
              lang === "en" ? "Complete the following to continue:" : "Completa lo siguiente para continuar:"
            ),
            React.createElement(
              "ul",
              { style: { paddingLeft: "1.25rem", margin: 0 } },
              errors.map((err, idx) =>
                React.createElement(
                  "li",
                  { key: idx, style: { marginBottom: "0.25rem" } },
                  err
                )
              )
            )
          ),
        step === 0 &&
          React.createElement(TreatmentSelectionStep, { form, setForm, lang }),
        step === 1 &&
          form.treatmentType &&
          React.createElement(TreatmentDetailStep, { form, setForm, lang }),
        step === 2 && React.createElement(ClientStep, { form, setForm, lang }),
        step === 3 && React.createElement(EmergencyStep, { form, setForm, lang }),
        step === 4 && React.createElement(MedicalStep, { form, setForm, lang }),
        step === 5 && React.createElement(ConsentStep, { form, setForm, lang }),
        step === 6 && React.createElement(SignatureStep, { form, setForm, lang }),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2rem",
            },
          },
          React.createElement(
            "button",
            {
              onClick: back,
              disabled: step === 0,
              style: {
                borderRadius: "1rem",
                border: `1px solid ${colors.gray.medium}`,
                padding: "0.75rem 1.25rem",
                backgroundColor: "white",
                cursor: step === 0 ? "not-allowed" : "pointer",
                opacity: step === 0 ? 0.4 : 1,
              },
            },
            `← ${t.back}`
          ),
          React.createElement(
            "div",
            { style: { display: "flex", gap: "0.5rem" } },
            quickMode && React.createElement(
              "button",
              {
                onClick: submit,
                disabled: saving,
                style: { backgroundColor: colors.gold.primary, ...styles.button, padding: "0.75rem 1.25rem" },
              },
              saving ? t.saving : "⚡ Guardar registro"
            ),
            step < steps.length - 1
              ? React.createElement(
                  "button",
                  { onClick: next, style: styles.button },
                  `${t.next} →`
                )
              : React.createElement(
                  "button",
                  {
                    onClick: submit,
                    style: {
                      backgroundColor: colors.accent.success,
                      ...styles.button,
                      padding: "0.75rem 1.25rem",
                    },
                    disabled: saving,
                  },
                  saving ? t.saving : `${t.save} ✓`
                )
          )
        )
      )
    )
  );
}

function setupMultiDeviceSync(setRecords, setUsers) {
  try {
    const channel = new BroadcastChannel("nila_sync_channel");
    channel.onmessage = (event) => {
      const { type, data } = event.data;
      if (type === "RECORDS_UPDATE") {
        setRecords(data);
      } else if (type === "USERS_UPDATE") {
        setUsers(data);
      }
    };
    return channel;
  } catch (e) {
    console.warn("BroadcastChannel not supported", e);
    return null;
  }
}

function MobileStyles() {
  useEffect(() => {
    const id = "nila-mobile-styles";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      @media (max-width: 640px) {
        body { overflow-x: hidden; }
        * { max-width: 100%; box-sizing: border-box; }
        .nila-container { padding: 1rem !important; }
        .nila-grid-2col {
          grid-template-columns: 1fr !important;
          gap: 0.75rem !important;
        }
        .nila-card { padding: 1.25rem !important; border-radius: 1rem !important; }
        input, select, textarea {
          font-size: 16px !important;
          padding: 0.875rem 1rem !important;
          border-radius: 0.75rem !important;
        }
        .nila-btn-row {
          flex-direction: column !important;
          gap: 0.75rem !important;
        }
        .nila-btn-row button {
          width: 100% !important;
        }
        .nila-wizard-header {
          flex-direction: column !important;
          gap: 0.5rem !important;
          align-items: flex-start !important;
        }
        .nila-treatment-grid {
          grid-template-columns: 1fr !important;
        }
        .nila-medical-grid {
          grid-template-columns: 1fr 1fr !important;
        }
        h1 { font-size: 2rem !important; }
        .nila-welcome-grid {
          grid-template-columns: 1fr !important;
          gap: 2rem !important;
          min-height: unset !important;
        }
        .nila-logo-circle { display: none !important; }
        .nila-stats-grid {
          grid-template-columns: 1fr 1fr !important;
        }
        .nila-body-cat-grid {
          grid-template-columns: 1fr !important;
        }
        .nila-note-item { padding: 0.5rem !important; }
        .nila-exit-btn {
          top: 0.5rem !important;
          right: 0.5rem !important;
          padding: 0.4rem 0.75rem !important;
          font-size: 0.8rem !important;
        }
        .nila-step-indicator { font-size: 0.75rem !important; }
      }
    `;
    document.head.appendChild(style);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);
  return null;
}

// ========== ERROR BOUNDARY (diagnostic) ==========
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    this.setState({ error, info });
  }
  render() {
    if (this.state.hasError) {
      const err = this.state.error;
      const stack = (this.state.info && this.state.info.componentStack) || "";
      return React.createElement("div", {
        style: { padding: "1.5rem", fontFamily: "monospace", fontSize: "0.8rem", color: "#111", backgroundColor: "#FFF5F5", minHeight: "100vh", wordBreak: "break-word", whiteSpace: "pre-wrap" }
      },
        React.createElement("h2", { style: { color: "#DC2626", fontSize: "1.1rem", marginBottom: "0.75rem" } }, "⚠️ Error detectado"),
        React.createElement("p", { style: { marginBottom: "0.5rem", fontWeight: "bold" } }, "Mensaje:"),
        React.createElement("div", { style: { backgroundColor: "white", padding: "0.6rem", borderRadius: "0.4rem", marginBottom: "0.75rem", border: "1px solid #FCA5A5" } }, (err && err.toString()) || "Error desconocido"),
        React.createElement("p", { style: { marginBottom: "0.5rem", fontWeight: "bold" } }, "Detalle:"),
        React.createElement("div", { style: { backgroundColor: "white", padding: "0.6rem", borderRadius: "0.4rem", fontSize: "0.7rem", border: "1px solid #FCA5A5" } }, (err && err.stack ? err.stack.slice(0, 1500) : "") + "\n" + stack.slice(0, 1000)),
        React.createElement("button", { onClick: () => { try { localStorage.clear(); } catch(e){} window.location.reload(); }, style: { marginTop: "1rem", padding: "0.6rem 1rem", backgroundColor: "#DC2626", color: "white", border: "none", borderRadius: "0.5rem", fontSize: "0.85rem" } }, "Limpiar y recargar")
      );
    }
    return this.props.children;
  }
}

function ExperienciaNilaAppInner() {
  const [user, setUser] = useState(() => loadLS("nila_user", null));
  const [view, setView] = useState(() => loadLS("nila_user", null) ? "dashboard" : "home");
  const [intakeKey, setIntakeKey] = useState(0);
  const [records, setRecords] = useState([]);
  const [users, setUsers] = useState([]);
  const [intakeLang, setIntakeLang] = useState(() => loadLS("nila_lang", "es"));

  // Client completion link: ?mode=client&record=<id> loads that record so the
  // client lands on the form pre-filled and completes the blanks.
  const [linkRecord, setLinkRecord] = useState(null);
  const [linkRecordState, setLinkRecordState] = useState(
    getClientRecordId() ? "loading" : "none"
  );
  useEffect(() => {
    const rid = getClientRecordId();
    if (!rid) return;
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, RECORDS_COLLECTION, rid));
        if (cancelled) return;
        if (snap.exists()) {
          setLinkRecord({ id: snap.id, ...snap.data() });
          setLinkRecordState("ready");
        } else {
          setLinkRecordState("notfound");
        }
      } catch (e) {
        if (!cancelled) setLinkRecordState("notfound");
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // One-time cleanup: remove the oversized records blob that older versions
  // stored in localStorage (the cause of the iOS QuotaExceededError crash).
  useEffect(() => {
    try { localStorage.removeItem("nila_records"); } catch (e) {}
  }, []);

  useEffect(() => saveLS("nila_records", records), [records]); // no-op now (saveLS skips this key)
  useEffect(() => saveLS("nila_user", user), [user]);
  useEffect(() => saveLS("nila_users", users), [users]);

  useEffect(() => {
    const channel = setupMultiDeviceSync(setRecords, setUsers);
    return () => {
      if (channel) {
        try {
          channel.close();
        } catch (e) {}
      }
    };
  }, []);

  useEffect(() => {
    const id = "nila-mobile-styles-root";
    if (document.getElementById(id)) return;
    const style = document.createElement("style");
    style.id = id;
    style.textContent = `
      @media (max-width: 640px) {
        body { overflow-x: hidden; }
        * { max-width: 100%; box-sizing: border-box; }
        .nila-welcome-grid {
          grid-template-columns: 1fr !important;
          gap: 2rem !important;
          min-height: unset !important;
        }
        [class*="nila-wizard"] { padding: 0.75rem !important; }
        input[type="text"], input[type="email"], input[type="tel"],
        input[type="date"], input[type="password"], select, textarea {
          font-size: 16px !important;
          padding: 0.875rem 1rem !important;
          box-sizing: border-box !important;
          width: 100% !important;
        }
        .nila-form-grid {
          grid-template-columns: 1fr !important;
          gap: 0 !important;
        }
        .nila-treatment-select {
          grid-template-columns: 1fr !important;
          gap: 0.75rem !important;
        }
        .nila-nav-btns button {
          padding: 0.875rem 1rem !important;
          font-size: 0.95rem !important;
        }
      }
    `;
    document.head.appendChild(style);
  }, []);

  // Client completion link (?mode=client&record=<id>): load the existing record
  // and drop the client straight into the pre-filled form.
  if (linkRecordState !== "none" && view !== "thankyou") {
    if (linkRecordState === "loading") {
      return React.createElement("div",
        { style: { ...styles.container, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh", textAlign: "center" } },
        React.createElement("div", { style: { color: colors.gold.dark, fontSize: "1.1rem" } }, "Cargando su expediente…")
      );
    }
    if (linkRecordState === "notfound") {
      return React.createElement("div",
        { style: { ...styles.container, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh", textAlign: "center", padding: "2rem" } },
        React.createElement("div", { style: { maxWidth: "28rem" } },
          React.createElement("div", { style: { fontSize: "2.5rem", marginBottom: "0.75rem" } }, "🔍"),
          React.createElement("h2", { style: { color: colors.gold.dark, fontSize: "1.3rem", marginBottom: "0.5rem", fontFamily: "Georgia, serif" } }, "Enlace no válido"),
          React.createElement("p", { style: { color: colors.gray.text, fontSize: "0.95rem" } }, "No pudimos encontrar este expediente. Por favor contacte a Nación Nila Estética para recibir un nuevo enlace.")
        )
      );
    }
    if (linkRecordState === "ready" && linkRecord) {
      return React.createElement(IntakeWizard, {
        key: `link_${linkRecord.id}`,
        prefillRecord: linkRecord,
        onSubmit: () => { setView("thankyou"); },
        existingRecords: records,
        onExit: () => {},
        lang: intakeLang,
      });
    }
  }

  if (view === "home")
    return React.createElement(WelcomeScreen, {
      onStart: (lang) => {
        setIntakeLang(lang);
        setIntakeKey(k => k + 1); // force IntakeWizard remount with clean state
        setView("intake");
      },
      onLoginClick: () => setView("login"),
      hideStaffAccess: isClientMode(),
    });
  if (view === "intake")
    return React.createElement(IntakeWizard, {
      key: intakeKey,
      onSubmit: (r) => {
        setView("thankyou");
      },
      existingRecords: records,
      onExit: () => setView("home"),
      lang: intakeLang,
    });
  if (view === "thankyou") {
    const t = translations[intakeLang];
    return React.createElement(
      "div",
      { style: styles.container },
      React.createElement(
        "div",
        {
          style: {
            maxWidth: "36rem",
            margin: "0 auto",
            ...styles.card,
            textAlign: "center",
          },
        },
        React.createElement(
          "div",
          {
            style: {
              fontSize: "3rem",
              marginBottom: "1rem",
              color: colors.accent.success,
            },
          },
          "✓"
        ),
        React.createElement(
          "h1",
          {
            style: {
              fontSize: "2.25rem",
              fontFamily: "Georgia, serif",
              marginBottom: "0.75rem",
              color: colors.gold.dark,
            },
          },
          t.thankYouTitle
        ),
        React.createElement(
          "p",
          { style: { color: colors.gray.text, marginBottom: "1.5rem" } },
          t.thankYouMessage
        ),
        React.createElement(
          "div",
          {
            style: {
              display: "flex",
              gap: "0.75rem",
              justifyContent: "center",
            },
          },
          React.createElement(
            "button",
            {
              onClick: () => setView("home"),
              style: {
                borderRadius: "1rem",
                border: `1px solid ${colors.gray.medium}`,
                padding: "0.75rem 1.25rem",
                backgroundColor: "white",
                cursor: "pointer",
              },
            },
            t.backToHome
          ),
          !isClientMode() && React.createElement(
            "button",
            { onClick: () => setView("login"), style: styles.buttonSecondary },
            t.internalAccess
          )
        )
      )
    );
  }
  if (view === "login")
    return React.createElement(LoginPanel, {
      onLogin: (u) => {
        setUser(u);
        setView("dashboard");
      },
      onBack: () => setView("home"),
    });
  return React.createElement(Dashboard, {
    user,
    records,
    setRecords,
    onLogout: () => {
      setUser(null);
      setView("home");
    },
  });
}

export default function ExperienciaNilaApp() {
  return React.createElement(AppErrorBoundary, null, React.createElement(ExperienciaNilaAppInner, null));
}
